(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-faq-pro"] && !Shopify.designMode) return;
  try {
    
  class AffiliateFaq extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.panelAnimations ||= new Map();
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.panelAnimations?.forEach((animation) => animation.cancel());
      this.panelAnimations?.clear();
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-affiliate-faq-button]');
      if (!button || !this.contains(button)) return;

      const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
      if (!panel) return;

      const isOpen = button.getAttribute('aria-expanded') === 'true';
      if (!this.classList.contains('affiliate-faq-pro--legacy-rs')) {
        button.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        return;
      }

      this.toggleLegacyPanel(button, panel, !isOpen);
    }

    cancelPanelAnimation(panel) {
      const animation = this.panelAnimations?.get(panel);
      if (!animation) return;

      const currentStyle = window.getComputedStyle(panel);
      const currentHeight = panel.getBoundingClientRect().height;
      panel.style.height = `${currentHeight}px`;
      panel.style.marginTop = currentStyle.marginTop;
      panel.style.marginBottom = currentStyle.marginBottom;
      animation.cancel();
      this.panelAnimations.delete(panel);
    }

    toggleLegacyPanel(button, panel, shouldOpen) {
      this.cancelPanelAnimation(panel);
      button.setAttribute('aria-expanded', String(shouldOpen));

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        panel.hidden = !shouldOpen;
        panel.style.height = '';
        return;
      }

      if (shouldOpen) {
        const wasHidden = panel.hidden;
        panel.hidden = false;
        const targetStyle = window.getComputedStyle(panel);
        const targetMarginTop = targetStyle.marginTop;
        const targetMarginBottom = targetStyle.marginBottom;
        const targetHeight = panel.scrollHeight;
        const currentHeight = wasHidden ? 0 : panel.getBoundingClientRect().height;
        const currentMarginTop = wasHidden ? '0px' : targetStyle.marginTop;
        const currentMarginBottom = wasHidden ? '0px' : targetStyle.marginBottom;
        panel.style.height = `${currentHeight}px`;
        panel.style.marginTop = currentMarginTop;
        panel.style.marginBottom = currentMarginBottom;
        const animation = panel.animate(
          [
            { height: `${currentHeight}px`, marginTop: currentMarginTop, marginBottom: currentMarginBottom },
            { height: `${targetHeight}px`, marginTop: targetMarginTop, marginBottom: targetMarginBottom }
          ],
          { duration: 400, easing: 'ease' }
        );
        this.panelAnimations.set(panel, animation);
        animation.finished.then(() => {
          if (this.panelAnimations.get(panel) !== animation) return;
          panel.style.height = '';
          panel.style.marginTop = '';
          panel.style.marginBottom = '';
          this.panelAnimations.delete(panel);
        }).catch(() => {});
        return;
      }

      const currentHeight = panel.getBoundingClientRect().height;
      const currentStyle = window.getComputedStyle(panel);
      const animation = panel.animate(
        [
          { height: `${currentHeight}px`, marginTop: currentStyle.marginTop, marginBottom: currentStyle.marginBottom },
          { height: '0px', marginTop: '0px', marginBottom: '0px' }
        ],
        { duration: 400, easing: 'ease' }
      );
      this.panelAnimations.set(panel, animation);
      animation.finished.then(() => {
        if (this.panelAnimations.get(panel) !== animation) return;
        panel.hidden = true;
        panel.style.height = '';
        panel.style.marginTop = '';
        panel.style.marginBottom = '';
        this.panelAnimations.delete(panel);
      }).catch(() => {});
    }
  }

  if (!customElements.get('affiliate-faq')) {
    customElements.define('affiliate-faq', AffiliateFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story-hero"] && !Shopify.designMode) return;
  try {
    
  class BrandStoryHero extends HTMLElement {
    connectedCallback() {
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.connection = navigator.connection;
      this.downlink = Number(this.connection?.downlink);
      this.rtt = Number(this.connection?.rtt);
      this.constrainedNetwork =
        this.connection?.saveData === true ||
        ['slow-2g', '2g', '3g'].includes(this.connection?.effectiveType) ||
        (Number.isFinite(this.downlink) && this.downlink <= 2.5) ||
        (Number.isFinite(this.rtt) && this.rtt >= 250);
      this.loadMobileVideo = this.dataset.loadMobileVideo === 'true';
      this.canLoadVideo = false;
      this.isVisible = false;
      this.videoScheduled = false;
      this.waitingForLoad = false;
      this.loadActiveVideo = this.loadActiveVideo.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleMediaChange = this.handleMediaChange.bind(this);
      this.scheduleVideo = this.scheduleVideo.bind(this);
      this.mediaQuery.addEventListener('change', this.handleMediaChange);

      this.observer = new IntersectionObserver(this.handleIntersection, { rootMargin: '300px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.handleMediaChange);
      this.observer?.disconnect();
      window.removeEventListener('load', this.scheduleVideo);
      if (this.idleId && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.idleId);
      window.clearTimeout(this.startTimer);
      this.querySelectorAll('[data-brand-story-video]').forEach((video) => video.pause());
    }

    handleIntersection(entries) {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.isVisible = true;
      this.scheduleVideo();
      this.observer?.disconnect();
    }

    scheduleVideo() {
      // Mobile motion is opt-in per migrated Section. It still waits until after
      // the initial render and never starts on reduced-motion or weak networks.
      if (document.readyState === 'complete') this.waitingForLoad = false;
      if (
        this.videoScheduled ||
        this.canLoadVideo ||
        !this.isVisible ||
        (!this.mediaQuery.matches && !this.loadMobileVideo) ||
        this.reducedMotion ||
        this.constrainedNetwork
      ) return;

      if (document.readyState !== 'complete') {
        if (!this.waitingForLoad) {
          this.waitingForLoad = true;
          window.addEventListener('load', this.scheduleVideo, { once: true });
        }
        return;
      }

      this.videoScheduled = true;
      const start = () => {
        this.videoScheduled = false;
        this.canLoadVideo = true;
        this.loadActiveVideo();
      };

      if ('requestIdleCallback' in window) {
        this.idleId = window.requestIdleCallback(start, { timeout: 2000 });
      } else {
        this.startTimer = window.setTimeout(start, 300);
      }
    }

    handleMediaChange() {
      this.querySelectorAll('[data-brand-story-video]').forEach((video) => video.pause());
      if (this.videoScheduled) {
        if (this.idleId && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.idleId);
        window.clearTimeout(this.startTimer);
        this.videoScheduled = false;
      }
      if (!this.mediaQuery.matches && !this.loadMobileVideo) return;
      if (this.canLoadVideo) this.loadActiveVideo();
      else this.scheduleVideo();
    }

    loadActiveVideo() {
      const sharedVideo = this.querySelector('.brand-story-hero__video--shared');
      const modifier = this.mediaQuery.matches ? '--desktop' : '--mobile';
      const video = sharedVideo || this.querySelector(`.brand-story-hero__video${modifier}`);
      if (!video) return;

      if (video.dataset.loaded === 'true') {
        video.play().catch(() => {});
        return;
      }

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.addEventListener('canplay', () => {
        video.classList.add('is-ready');
        video.play().catch(() => {});
      }, { once: true });
      video.dataset.loaded = 'true';
      video.load();
    }
  }

  if (!customElements.get('brand-story-hero')) {
    customElements.define('brand-story-hero', BrandStoryHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story-video"] && !Shopify.designMode) return;
  try {
    
  class BrandStoryVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.playButton = this.querySelector('.brand-story-video__play');
      this.nativeVideo = this.querySelector('.brand-story-video__native-media');
      this.frame = this.querySelector('.brand-story-video__frame');
      this.play = this.play.bind(this);
      if (this.playButton) this.playButton.addEventListener('click', this.play);
      if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.play();
            this.observer?.disconnect();
          }
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.playButton) this.playButton.removeEventListener('click', this.play);
      this.nativeVideo?.pause();
      this.initialized = false;
    }

    play() {
      if (this.classList.contains('is-playing')) return;
      if (this.nativeVideo) {
        this.nativeVideo.play().then(() => this.classList.add('is-playing')).catch(() => {});
        return;
      }

      const source = this.externalSource();
      if (!source) return;
      const frame = document.createElement('iframe');
      frame.className = 'brand-story-video__media';
      frame.src = source;
      frame.title = this.playButton?.getAttribute('aria-label') || 'Video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      this.frame.append(frame);
      this.classList.add('is-playing');
    }

    externalSource() {
      const provider = this.dataset.videoProvider;
      const id = this.dataset.videoId;
      if (provider === 'youtube' && id) return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
      if (provider === 'vimeo' && id) return `https://player.vimeo.com/video/${id}?autoplay=1&playsinline=1`;
      const url = this.dataset.videoUrl || '';
      const youtube = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
      if (youtube) return `https://www.youtube.com/embed/${youtube[1]}?autoplay=1&rel=0&playsinline=1`;
      const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&playsinline=1`;
      return '';
    }
  }
  if (!customElements.get('brand-story-video')) customElements.define('brand-story-video', BrandStoryVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-twoblocks"] && !Shopify.designMode) return;
  try {
    
  class BrandEndorsement extends HTMLElement {
    constructor() {
      super();
      this.handlePopupClick = this.handlePopupClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handlePopupClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handlePopupClick);
    }

    handlePopupClick(event) {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('[data-brand-popup]');
      if (!trigger || !this.contains(trigger)) return;

      const url = trigger.dataset.url;
      if (!url) return;

      const popup = window.open(url, '_blank', 'width=800,height=600');
      if (popup) popup.opener = null;
    }
  }

  if (!customElements.get('brand-endorsement')) {
    customElements.define('brand-endorsement', BrandEndorsement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.section = this.dataset.section;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.syncNodes();
      this.initializeDiscountIntegration();
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cd-close]')) { e.preventDefault(); this.close(); return; }
        if (e.target.closest('[data-cd-discount-remove]')) { e.preventDefault(); this.updateNativeDiscount(''); return; }
        const b = e.target.closest('[data-change]');
        if (b) { this.change(b.closest('.cditem').dataset.key, parseInt(b.dataset.change, 10)); return; }
      }, { signal });
      this.addEventListener('submit', (e) => {
        const discountForm = e.target.closest('[data-cd-discount-form]');
        if (discountForm) { this.applyNativeDiscount(e, discountForm); return; }
        const form = e.target.closest('[data-cd-add]');
        if (form) this.addRecommendation(e, form);
      }, { signal });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) this.change(e.target.closest('.cditem').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
      }, { signal });
      document.addEventListener('cart:updated', (e) => {
        if (e.detail?.source === 'drawer') return;
        this.refresh();
        if (e.detail?.source === 'product') this.open();
      }, { signal });
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href$="/cart"]');
        if (a && !a.hasAttribute('data-no-drawer') && !e.metaKey && !e.ctrlKey) { e.preventDefault(); this.refresh(); this.open(); }
      }, { signal });
      document.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.discountRequestController?.abort();
      this.unmountDiscountProvider();
      window.clearTimeout(this.closeTimer);
      if (this.classList.contains('is-open') || this.classList.contains('is-closing')) window.MetryScrollLock?.unlock();
      this.initialized = false;
    }
    syncNodes() {
      this.panel = this.querySelector('[data-cd-panel]');
    }
    getDiscountContext() {
      const context = this.querySelector('[data-cd-discount-context]');
      return {
        originalTotal: Number.parseInt(context?.dataset.originalTotal || '0', 10),
        totalPrice: Number.parseInt(context?.dataset.totalPrice || '0', 10),
        totalDiscount: Number.parseInt(context?.dataset.totalDiscount || '0', 10),
        refresh: (cart = null) => this.refreshFromDiscountProvider(cart)
      };
    }
    initializeDiscountIntegration() {
      if (this.dataset.discountMode !== 'app') return;
      if (this.discountProvider) { this.mountDiscountProvider(); return; }
      const container = this.querySelector('[data-cd-discount-app]');
      if (!container) return;
      /* App adapters listen for this event and call detail.register({ id, mount, unmount }); mount receives a Shopify-state refresh callback. */
      this.dispatchEvent(new CustomEvent('mt:cart-discount:discover', {
        bubbles: true,
        composed: true,
        detail: {
          version: 1,
          drawer: this,
          container,
          cart: this.getDiscountContext(),
          register: (provider) => this.registerDiscountProvider(provider)
        }
      }));
    }
    registerDiscountProvider(provider) {
      if (this.dataset.discountMode !== 'app' || !provider || typeof provider.mount !== 'function') return false;
      if (this.discountProvider && this.discountProvider !== provider) return false;
      this.unmountDiscountProvider();
      this.discountProvider = provider;
      return this.mountDiscountProvider();
    }
    mountDiscountProvider() {
      const container = this.querySelector('[data-cd-discount-app]');
      if (!container || !this.discountProvider) return false;
      try {
        this.discountProvider.mount(container, this.getDiscountContext());
        container.hidden = false;
        container.dataset.provider = String(this.discountProvider.id || 'registered');
        return true;
      } catch (error) {
        container.hidden = true;
        delete container.dataset.provider;
        return false;
      }
    }
    unmountDiscountProvider() {
      if (!this.discountProvider) return;
      try { this.discountProvider.unmount?.(); } catch (error) { /* Provider cleanup is isolated from drawer state. */ }
    }
    async refreshFromDiscountProvider(cart = null) {
      if (this.dataset.discountMode !== 'app') return false;
      const refreshed = await this.refresh();
      if (refreshed) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer', integration: 'discount-app', cart } }));
      return refreshed;
    }
    open() {
      if (this.classList.contains('is-open')) return;
      window.clearTimeout(this.closeTimer);
      this.classList.remove('is-closing');
      this.lastActive = document.activeElement;
      this.classList.add('is-open');
      window.MetryScrollLock?.lock();
      window.requestAnimationFrame(() => this.panel?.focus());
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      window.MetryScrollLock?.unlock();
      const finish = () => this.classList.remove('is-closing');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else this.closeTimer = window.setTimeout(finish, 320);
      this.lastActive?.focus?.();
    }
    onKeydown(event) {
      if (!this.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab' || !this.panel) return;
      const focusable = Array.from(this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => !element.hidden);
      if (!focusable.length) { event.preventDefault(); this.panel.focus(); return; }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    async change(id, quantity) {
      this.classList.add('is-loading');
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity }) });
        if (!response.ok) throw new Error(this.dataset.errorLabel);
        const cart = await response.json();
        const refreshed = await this.refresh();
        if (!refreshed) throw new Error(this.dataset.errorLabel);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer', cart } }));
      } catch (error) { this.announceError(error.message); } finally { this.classList.remove('is-loading'); }
    }
    async addRecommendation(event, form) {
      event.preventDefault();
      const button = form.querySelector('button');
      const status = form.querySelector('[data-cd-add-status]');
      if (!button || button.disabled) return;
      button.disabled = true;
      this.classList.add('is-loading');
      try {
        const response = await fetch(this.dataset.addUrl || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorLabel);
        const cartResponse = await fetch(this.dataset.cartUrl || '/cart.js', { headers: { Accept: 'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        const refreshed = await this.refresh();
        if (!refreshed) throw new Error(this.dataset.errorLabel);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer', cart } }));
      } catch (error) {
        if (status) status.textContent = error.message || this.dataset.errorLabel;
      } finally {
        this.classList.remove('is-loading');
        if (button.isConnected) button.disabled = false;
      }
    }
    applyNativeDiscount(event, form) {
      event.preventDefault();
      const input = form.querySelector('[data-cd-discount-input]');
      const code = input?.value.trim();
      if (!code) { input?.focus(); return; }
      this.updateNativeDiscount(code);
    }
    async updateNativeDiscount(code) {
      if (this.dataset.discountMode !== 'native_code') return;
      this.discountRequestController?.abort();
      this.discountRequestController = new AbortController();
      const requestController = this.discountRequestController;
      const requestId = (this.discountRequestId || 0) + 1;
      this.discountRequestId = requestId;
      this.classList.add('is-loading');
      try {
        const response = await fetch(this.dataset.updateUrl || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
          signal: requestController.signal
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || this.dataset.discountErrorLabel);
        if (requestId !== this.discountRequestId) return;
        const refreshed = await this.refresh();
        if (!refreshed) throw new Error(this.dataset.discountErrorLabel);
        if (requestId !== this.discountRequestId) return;
        const normalizedCode = code.trim().toLocaleLowerCase();
        const responseIncludesCodes = Array.isArray(cart.discount_codes);
        const confirmedByResponse = responseIncludesCodes && cart.discount_codes.some((discount) => String(discount.code || '').toLocaleLowerCase() === normalizedCode && discount.applicable !== false);
        const confirmedByMarkup = normalizedCode === '' || Array.from(this.querySelectorAll('[data-cd-discount-application]')).some((discount) => discount.dataset.discountType === 'discount_code' && discount.dataset.cdDiscountApplication === normalizedCode);
        const status = this.querySelector('[data-cd-discount-status]');
        if (status) status.textContent = code && responseIncludesCodes && !confirmedByResponse && !confirmedByMarkup ? this.dataset.discountInvalidLabel : this.dataset.discountSuccessLabel;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer', cart } }));
      } catch (error) {
        if (error.name !== 'AbortError') {
          const status = this.querySelector('[data-cd-discount-status]');
          if (status) status.textContent = error.message || this.dataset.discountErrorLabel;
          else this.announceError(error.message || this.dataset.discountErrorLabel);
        }
      } finally {
        if (requestId === this.discountRequestId) this.classList.remove('is-loading');
      }
    }
    announceError(message) {
      let status = this.querySelector('[data-cd-global-status]');
      if (!status) {
        status = document.createElement('p');
        status.className = 'cdrawer__sr-only';
        status.dataset.cdGlobalStatus = '';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        this.panel?.append(status);
      }
      status.textContent = message || this.dataset.errorLabel;
    }
    async refresh() {
      try {
        const response = await fetch(this.dataset.refreshUrl || '/?section_id=' + this.section);
        if (!response.ok) throw new Error(this.dataset.errorLabel);
        const html = await response.text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (!fresh) throw new Error(this.dataset.errorLabel);
        this.unmountDiscountProvider();
        this.innerHTML = fresh.innerHTML;
        this.syncNodes();
        this.initializeDiscountIntegration();
        return true;
      } catch (error) {
        this.announceError(this.dataset.errorLabel);
        return false;
      }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-countdown-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-countdown')) {
    class ClCountdown extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.mode = this.dataset.mode === 'fixed' ? 'fixed' : 'evergreen';
        this.periodMilliseconds = this.getPeriodMilliseconds();
        this.target = this.mode === 'evergreen'
          ? this.getNextEvergreenTarget()
          : this.parseFixedTarget(this.dataset.end);
        this.numbers = {
          days: this.querySelector('[data-cd="days"]'),
          hours: this.querySelector('[data-cd="hours"]'),
          minutes: this.querySelector('[data-cd="minutes"]'),
          seconds: this.querySelector('[data-cd="seconds"]')
        };
        this.handleVisibilityChange = () => {
          if (!document.hidden) this.update();
        };

        if (this.mode === 'fixed' && !this.target) {
          this.finish();
          return;
        }

        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.initialized = false;
      }

      getPeriodMilliseconds() {
        const hours = Number.parseInt(this.dataset.periodHours || '2', 10);
        const validHours = Number.isFinite(hours) && hours > 0 ? hours : 2;
        return validHours * 60 * 60 * 1000;
      }

      getNextEvergreenTarget() {
        const now = Date.now();
        return new Date((Math.floor(now / this.periodMilliseconds) + 1) * this.periodMilliseconds);
      }

      parseFixedTarget(value) {
        if (!value) return null;

        const normalizedValue = value.trim().replace(/-/g, '/');
        const target = new Date(normalizedValue);
        return Number.isNaN(target.getTime()) ? null : target;
      }

      update() {
        const now = Date.now();
        let difference = this.target.getTime() - now;

        if (difference <= 0) {
          if (this.mode === 'fixed') {
            this.finish();
            return;
          }

          this.target = this.getNextEvergreenTarget();
          difference = this.target.getTime() - now;
        }

        const days = Math.floor(difference / 86400000);
        const hours = Math.floor((difference % 86400000) / 3600000);
        const minutes = Math.floor((difference % 3600000) / 60000);
        const seconds = Math.floor((difference % 60000) / 1000);

        this.setNumber('days', days);
        this.setNumber('hours', hours);
        this.setNumber('minutes', minutes);
        this.setNumber('seconds', seconds);
      }

      setNumber(name, value) {
        const element = this.numbers[name];
        if (!element) return;

        const formattedValue = String(value).padStart(2, '0');
        element.textContent = formattedValue;
        element.setAttribute('aria-label', `${formattedValue} ${element.dataset.unit}`);
      }

      finish() {
        window.clearInterval(this.interval);
        this.classList.add('is-done');
        this.setAttribute('aria-hidden', 'true');
      }
    }

    customElements.define('cl-countdown', ClCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["environment-text-with-image"] && !Shopify.designMode) return;
  try {
    
  class EnvironmentCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.currentIndex = 0;
      this.position = this.slides.length > 1 ? 1 : 0;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.pauseReasons = new Set(['viewport']);
      this.timer = null;
      this.frame = null;
      this.startX = null;
      this.gap = 10;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || !this.track || this.slides.length === 0) return;

      this.handlePointerDown = this.onPointerDown.bind(this);
      this.handlePointerUp = this.onPointerUp.bind(this);
      this.handleTransitionEnd = this.onTransitionEnd.bind(this);
      this.handleResize = this.scheduleLayout.bind(this);
      this.handleVisibility = this.onVisibilityChange.bind(this);
      this.handleMotionChange = this.onMotionChange.bind(this);
      this.handleMouseEnter = () => this.pause('hover');
      this.handleMouseLeave = () => this.resume('hover');
      this.handleFocusIn = () => this.pause('focus');
      this.handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.resume('focus');
      };

      if (this.slides.length > 1) this.createLoopClones();

      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.addEventListener('pointercancel', this.handlePointerUp);
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      this.track.addEventListener('transitionend', this.handleTransitionEnd);
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.reduceMotion.addEventListener('change', this.handleMotionChange);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.handleResize);
      }

      this.observeViewport();
      this.onMotionChange();
      this.updateAccessibleState();
      this.scheduleLayout();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.observer) this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);

      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('pointercancel', this.handlePointerUp);
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      if (this.track) this.track.removeEventListener('transitionend', this.handleTransitionEnd);
      document.removeEventListener('visibilitychange', this.handleVisibility);
      window.removeEventListener('resize', this.handleResize);
      if (this.reduceMotion) this.reduceMotion.removeEventListener('change', this.handleMotionChange);
    }

    createLoopClones() {
      const firstClone = this.slides[0].cloneNode(true);
      const lastClone = this.slides[this.slides.length - 1].cloneNode(true);

      firstClone.setAttribute('data-carousel-clone', '');
      lastClone.setAttribute('data-carousel-clone', '');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.removeAttribute('data-carousel-slide');
      lastClone.removeAttribute('data-carousel-slide');
      [firstClone, lastClone].forEach((clone) => {
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('img').forEach((image) => {
          image.loading = 'lazy';
          image.setAttribute('fetchpriority', 'auto');
          image.classList.remove('lazy-fade');
          image.classList.add('is-loaded');
        });
      });

      this.track.append(firstClone);
      this.track.prepend(lastClone);
    }

    observeViewport() {
      if (!('IntersectionObserver' in window)) {
        this.resume('viewport');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.resume('viewport');
          } else {
            this.pause('viewport');
          }
        });
      }, { rootMargin: '150px 0px' });
      this.observer.observe(this);
    }

    onPointerDown(event) {
      if (!event.isPrimary) return;
      this.startX = event.clientX;
      if (this.setPointerCapture) this.setPointerCapture(event.pointerId);
      this.pause('pointer');
    }

    onPointerUp(event) {
      if (this.startX === null) return;
      if (event.type === 'pointercancel') {
        this.startX = null;
        this.resume('pointer');
        return;
      }
      const distance = event.clientX - this.startX;
      this.startX = null;

      if (Math.abs(distance) > 50) {
        if (distance < 0) {
          this.next(true);
        } else {
          this.previous(true);
        }
      }
      this.resume('pointer');
    }

    next(manual = false) {
      if (this.slides.length <= 1) return;

      if (this.currentIndex === this.slides.length - 1) {
        this.currentIndex = 0;
        this.position = this.slides.length + 1;
      } else {
        this.currentIndex += 1;
        this.position += 1;
      }
      this.applyPosition(true);
      this.updateAccessibleState();
      if (manual) this.restartAutoplay();
    }

    previous(manual = false) {
      if (this.slides.length <= 1) return;

      if (this.currentIndex === 0) {
        this.currentIndex = this.slides.length - 1;
        this.position = 0;
      } else {
        this.currentIndex -= 1;
        this.position -= 1;
      }
      this.applyPosition(true);
      this.updateAccessibleState();
      if (manual) this.restartAutoplay();
    }

    onTransitionEnd(event) {
      if (event.target !== this.track || this.slides.length <= 1) return;

      if (this.position === 0) {
        this.position = this.slides.length;
        this.applyPosition(false);
      } else if (this.position === this.slides.length + 1) {
        this.position = 1;
        this.applyPosition(false);
      }
    }

    scheduleLayout() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.applyPosition(false);
      });
    }

    applyPosition(animate) {
      if (!this.viewport || !this.track) return;
      const slideWidth = this.viewport.clientWidth;
      const offset = this.position * (slideWidth + this.gap);

      if (!animate || this.reduceMotion.matches) this.classList.add('is-jump');
      this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;

      if (!animate || this.reduceMotion.matches) {
        requestAnimationFrame(() => this.classList.remove('is-jump'));
      }
    }

    updateAccessibleState() {
      this.slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === this.currentIndex ? 'false' : 'true');
      });
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.pause('document');
      } else {
        this.resume('document');
      }
    }

    onMotionChange() {
      if (this.reduceMotion.matches) {
        this.pause('motion');
      } else {
        this.resume('motion');
      }
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.stopAutoplay();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.startAutoplay();
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.slides.length <= 1 || this.pauseReasons.size > 0 || this.timer) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('environment-carousel')) {
    customElements.define('environment-carousel', EnvironmentCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-pro"] && !Shopify.designMode) return;
  try {
    
  class FaqItem extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.faq__question');
      this.answer = this.querySelector('.faq__answer');
    }

    connectedCallback() {
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.classList.contains('is-open');
      
      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('faq-item')) {
    customElements.define('faq-item', FaqItem);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('country-select')) {
    customElements.define('country-select', class extends HTMLElement {
      connectedCallback() {
        const s = this.querySelector('select');
        if (s) s.addEventListener('change', () => s.form && s.form.submit());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc200-featured-collection"] && !Shopify.designMode) return;
  try {
    
  class Hc200FeaturedCollection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-hc200-collection-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-hc200-collection-panel]'));
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); this.initialized = false; }
    onClick(event) { const tab = event.target.closest('[data-hc200-collection-tab]'); if (tab && this.contains(tab)) this.show(Number(tab.dataset.hc200CollectionTab)); }
    show(index) {
      this.tabs.forEach((tab, tabIndex) => { tab.classList.toggle('is-active', tabIndex === index); tab.setAttribute('aria-current', String(tabIndex === index)); });
      this.panels.forEach((panel, panelIndex) => { const active = panelIndex === index; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    }
  }
  if (!customElements.get('hc200-featured-collection')) customElements.define('hc200-featured-collection', Hc200FeaturedCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc200-hero"] && !Shopify.designMode) return;
  try {
    
  class Hc200Hero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-hc200-slide]'));
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 6000;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      if (this.dataset.allowTransparentHeader === 'true') document.dispatchEvent(new CustomEvent('header:transparent-mode'));
      if (this.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }
      this.syncVideo();
    }
    disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); this.removeEventListener('click', this.onClick); this.initialized = false; }
    onClick(event) { if (event.target.closest('[data-hc200-previous]')) this.show(this.index - 1); else if (event.target.closest('[data-hc200-next]')) this.show(this.index + 1); }
    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { const active = index === this.index; slide.hidden = !active; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); });
      this.syncVideo();
    }
    syncVideo() {
      this.slides.forEach((slide, index) => {
        const video = slide.querySelector('video[data-hc200-autoplay]');
        if (!video) return;
        if (index === this.index) video.play().catch(() => {}); else video.pause();
      });
    }
  }
  if (!customElements.get('hc200-hero')) customElements.define('hc200-hero', Hc200Hero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc200-scene-carousel"] && !Shopify.designMode) return;
  try {
    
  class Hc200SceneCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.texts = Array.from(this.querySelectorAll('[data-hc200-scene-text]'));
      this.media = Array.from(this.querySelectorAll('[data-hc200-scene-media]'));
      this.selectors = Array.from(this.querySelectorAll('[data-hc200-scene-select]'));
      this.index = 0;
      this.isVisible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
      this.onMobileMediaChange = () => this.syncVideos();
      this.onClick = this.onClick.bind(this);
      this.mobileMedia.addEventListener?.('change', this.onMobileMediaChange);
      this.addEventListener('click', this.onClick);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.isVisible = entry.isIntersecting;
          if (this.isVisible) this.mountMedia(this.index);
          this.syncVideos();
        }, { rootMargin: '160px 0px' });
        this.observer.observe(this);
      } else {
        this.isVisible = true;
        this.mountMedia(0);
        this.syncVideos();
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.mobileMedia?.removeEventListener?.('change', this.onMobileMediaChange); this.removeEventListener('click', this.onClick); this.observer = undefined; this.initialized = false; }
    onClick(event) { if (event.target.closest('[data-hc200-scene-previous]')) this.show(this.index - 1); else if (event.target.closest('[data-hc200-scene-next]')) this.show(this.index + 1); else { const selector = event.target.closest('[data-hc200-scene-select]'); if (selector && this.contains(selector)) this.show(Number(selector.dataset.hc200SceneSelect)); } }
    mountMedia(index) {
      const media = this.media[index];
      const template = media?.querySelector('[data-hc200-scene-template]');
      if (template) media.replaceChildren(template.content.cloneNode(true));
    }
    show(next) {
      const count = Math.max(this.texts.length, this.media.length);
      if (!count) return;
      this.index = (next + count) % count;
      if (this.isVisible) this.mountMedia(this.index);
      this.texts.forEach((node, index) => { const active = index === this.index; node.hidden = !active; node.classList.toggle('is-active', active); });
      this.media.forEach((node, index) => {
        const active = index === this.index;
        node.hidden = !active;
        node.classList.toggle('is-active', active);
      });
      this.syncVideos();
      this.selectors.forEach((node, index) => { node.classList.toggle('is-active', index === this.index); node.setAttribute('aria-pressed', String(index === this.index)); });
    }
    syncVideos() {
      this.media.forEach((node, index) => {
        const video = node.querySelector('video[data-hc200-scene-autoplay]');
        if (!video) return;
        const canAutoplay = !this.mobileMedia.matches || !node.hasAttribute('data-hc200-scene-static-poster');
        if (this.isVisible && !this.reducedMotion && canAutoplay && index === this.index) video.play().catch(() => {}); else video.pause();
      });
    }
  }
  if (!customElements.get('hc200-scene-carousel')) customElements.define('hc200-scene-carousel', Hc200SceneCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc200-story-panels"] && !Shopify.designMode) return;
  try {
    
  class Hc200StoryPanel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-hc200-story-slide]'));
      this.controls = Array.from(this.querySelectorAll('[data-hc200-story-select]'));
      this.index = 0;
      this.isVisible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      if (!('IntersectionObserver' in window)) { this.isVisible = true; this.syncVideos(); return; }
      this.observer = new IntersectionObserver(([entry]) => {
        this.isVisible = entry.isIntersecting;
        this.syncVideos();
      }, { rootMargin: '160px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.removeEventListener('click', this.onClick); this.observer = undefined; this.initialized = false; }
    onClick(event) { const control = event.target.closest('[data-hc200-story-select]'); if (control && this.contains(control)) this.show(Number(control.dataset.hc200StorySelect)); }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      this.syncVideos();
      this.controls.forEach((control, controlIndex) => control.setAttribute('aria-current', String(controlIndex === index)));
    }
    syncVideos() {
      this.slides.forEach((slide, slideIndex) => {
        const video = slide.querySelector('[data-hc200-story-video]');
        if (!video) return;
        if (this.isVisible && !this.reducedMotion && slideIndex === this.index) video.play().catch(() => {}); else video.pause();
      });
    }
  }
  if (!customElements.get('hc200-story-panel')) customElements.define('hc200-story-panel', Hc200StoryPanel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class CartCount extends HTMLElement {
    connectedCallback() { this._on = () => this.refresh(); document.addEventListener('cart:updated', this._on); }
    disconnectedCallback() { document.removeEventListener('cart:updated', this._on); }
    async refresh() {
      try {
        const c = await (await fetch('/cart.js')).json();
        this.textContent = c.item_count;
        const cartLink = this.closest('[data-cart-label]');
        if (cartLink) cartLink.setAttribute('aria-label', `${cartLink.dataset.cartLabel} (${c.item_count})`);
      } catch (e) {}
    }
  }
  if (!customElements.get('cart-count')) customElements.define('cart-count', CartCount);

  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const burger = header.querySelector('[data-burger]');
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-overlay]');
    const closeBtn = drawer && drawer.querySelector('[data-drawer-close]');
    const toggle = (open) => {
      const willOpen = open ?? drawer.hasAttribute('hidden');
      [drawer, overlay].forEach(el => { if (!el) return; if (willOpen) { el.removeAttribute('hidden'); requestAnimationFrame(() => el.classList.add('is-open')); } else { el.classList.remove('is-open'); setTimeout(() => el.setAttribute('hidden', ''), 300); } });
      burger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) { window.MetryScrollLock.lock(); } else { window.MetryScrollLock.unlock(); }
    };
    if (burger && drawer) {
      burger.addEventListener('click', () => toggle());
      if (closeBtn) closeBtn.addEventListener('click', () => toggle(false));
      if (overlay) overlay.addEventListener('click', () => toggle(false));
      drawer.addEventListener('click', e => { if (e.target.tagName === 'A') toggle(false); });
      addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) toggle(false); });
    }
    // transparent-on-home → solid on scroll
    let transparentScrollBound = false;
    let headerScrolled = header.classList.contains('is-scrolled');
    let scrollFrame = 0;
    const syncTransparentHeader = () => {
      const shouldBeScrolled = window.scrollY > 40;
      if (shouldBeScrolled === headerScrolled) return;
      headerScrolled = shouldBeScrolled;
      header.classList.toggle('is-scrolled', shouldBeScrolled);
    };
    const enableTransparentHeader = () => {
      header.classList.remove('header--solid');
      header.classList.add('header--transparent');
      if (transparentScrollBound) return;
      transparentScrollBound = true;
      const onScroll = () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = 0;
          syncTransparentHeader();
        });
      };
      addEventListener('scroll', onScroll, { passive: true });
      syncTransparentHeader();
    };
    if (header.classList.contains('header--home')) enableTransparentHeader();
    const detectTransparentHero = () => {
      const hero = document.querySelector(
        "metry-slideshow[data-transparent-header='true'], hc200-hero[data-allow-transparent-header='true'], product-intro-hero[data-allow-transparent-header='true']"
      );
      if (hero) enableTransparentHeader();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', detectTransparentHero, { once: true });
    } else {
      detectTransparentHero();
    }
    document.addEventListener('header:transparent-mode', enableTransparentHeader, { once: true });
    // promo rotator; pause timers while the tab is hidden.
    const track = header.querySelector('[data-promo]');
    if (track) {
      const items = track.querySelectorAll('.header__promo-item');
      if (items.length > 1) {
        let i = 0, timer = null;
        const tick = () => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); };
        const startRot = () => { if (!timer) timer = setInterval(tick, 4000); };
        const stopRot = () => { if (timer) { clearInterval(timer); timer = null; } };
        document.addEventListener('visibilitychange', () => { if (document.hidden) { stopRot(); } else { startRot(); } });
        startRot();
      }
    }
    // locale select submit
    const sel = header.querySelector('[data-locale-select]');
    if (sel) sel.addEventListener('change', () => sel.form && sel.form.submit());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-special-img-swiper"] && !Shopify.designMode) return;
  try {
    
  class HomeSpecialImgSwiper extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.contentSlides = Array.from(this.querySelectorAll('[data-content-slide]'));
      this.mediaSlides = Array.from(this.querySelectorAll('[data-media-slide]'));
      this.selectors = Array.from(this.querySelectorAll('[data-selector]'));
      this.previousButton = this.querySelector('[data-previous]');
      this.nextButton = this.querySelector('[data-next]');
      this.mediaViewport = this.querySelector('[data-media-viewport]');
      this.deferInactiveMedia = this.dataset.deferInactiveMedia === 'true';
      this.index = 0;
      this.pointerStartX = null;
      this.isVisible = false;

      if (this.mediaSlides.length === 0) return;

      this.handleClick = this.onClick.bind(this);
      this.handlePointerDown = this.onPointerDown.bind(this);
      this.handlePointerUp = this.onPointerUp.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);
      this.handleVideoEnded = this.onVideoEnded.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('ended', this.handleVideoEnded, true);
      if (this.mediaViewport) {
        this.mediaViewport.addEventListener('pointerdown', this.handlePointerDown);
        this.mediaViewport.addEventListener('pointerup', this.handlePointerUp);
        this.mediaViewport.addEventListener('pointercancel', this.handlePointerUp);
      }
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      this.observeVisibility();
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('ended', this.handleVideoEnded, true);
      if (this.mediaViewport) {
        this.mediaViewport.removeEventListener('pointerdown', this.handlePointerDown);
        this.mediaViewport.removeEventListener('pointerup', this.handlePointerUp);
        this.mediaViewport.removeEventListener('pointercancel', this.handlePointerUp);
      }
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.mediaSlides?.forEach((slide) => this.pauseVideo(slide));
      this.initialized = false;
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this.isVisible = true;
        this.playActiveAutoplayVideo();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.isVisible = entry.isIntersecting;
          if (this.isVisible) {
            this.playActiveAutoplayVideo();
          } else {
            this.mediaSlides.forEach((slide) => this.pauseVideo(slide));
          }
        });
      }, { rootMargin: '150px 0px', threshold: 0.05 });
      this.observer.observe(this);
    }

    onClick(event) {
      const previous = event.target.closest('[data-previous]');
      const next = event.target.closest('[data-next]');
      const selector = event.target.closest('[data-selector]');
      const play = event.target.closest('[data-play-video]');

      if (previous) this.goTo(this.index - 1);
      if (next) this.goTo(this.index + 1);
      if (selector) this.goTo(Number.parseInt(selector.dataset.selector, 10));
      if (play) this.playVideo(Number.parseInt(play.dataset.playVideo, 10));
    }

    onPointerDown(event) {
      if (!event.isPrimary || event.pointerType !== 'touch') return;
      this.pointerStartX = event.clientX;
      this.mediaViewport.setPointerCapture?.(event.pointerId);
    }

    onPointerUp(event) {
      if (this.pointerStartX === null) return;
      if (event.type === 'pointercancel') {
        this.pointerStartX = null;
        return;
      }

      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;
      if (Math.abs(distance) === 0) return;
      this.goTo(distance < 0 ? this.index + 1 : this.index - 1);
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const block = event.target.closest('[data-block-index]');
      if (block) this.goTo(Number.parseInt(block.dataset.blockIndex, 10));
    }

    onVideoEnded(event) {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement) || video.loop) return;
      video.closest('[data-media-slide]')?.classList.remove('is-playing');
    }

    goTo(nextIndex) {
      const boundedIndex = Math.max(0, Math.min(nextIndex, this.mediaSlides.length - 1));
      if (!Number.isFinite(boundedIndex)) return;
      this.index = boundedIndex;
      this.update();
    }

    update() {
      this.style.setProperty('--hsis-shift', `${this.index * -100}%`);

      this.contentSlides.forEach((slide) => {
        const active = Number.parseInt(slide.dataset.blockIndex, 10) === this.index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.mediaSlides.forEach((slide, index) => {
        const active = index === this.index;
        if (active && this.deferInactiveMedia) this.hydrateInactiveSlideMedia(slide);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
        if (!active) this.pauseVideo(slide);
      });

      this.selectors.forEach((selector) => {
        const selected = Number.parseInt(selector.dataset.selector, 10) === this.index;
        selector.classList.toggle('selected', selected);
        selector.setAttribute('aria-current', selected ? 'true' : 'false');
      });

      if (this.previousButton) this.previousButton.disabled = this.index === 0;
      if (this.nextButton) this.nextButton.disabled = this.index === this.mediaSlides.length - 1;
      if (this.isVisible) this.playActiveAutoplayVideo();
    }

    hydrateInactiveSlideMedia(slide) {
      const template = slide.querySelector('template[data-deferred-image]');
      if (!template) return;
      template.replaceWith(template.content.cloneNode(true));
    }

    prepareVideo(video) {
      if (!video || video.dataset.prepared === 'true') return;
      video.dataset.prepared = 'true';
      video.load();
    }

    playActiveAutoplayVideo() {
      const slide = this.mediaSlides[this.index];
      const videoContainer = slide?.querySelector('.hsis__video--autoplay');
      const video = videoContainer?.querySelector('video');
      if (!video) return;

      this.prepareVideo(video);
      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => {});
    }

    playVideo(index) {
      const slide = this.mediaSlides[index];
      const video = slide?.querySelector('video');
      if (!video) return;

      this.prepareVideo(video);
      slide.classList.add('is-playing');
      const playPromise = video.play();
      if (playPromise) {
        playPromise.catch(() => {
          slide.classList.remove('is-playing');
        });
      }
    }

    pauseVideo(slide) {
      const video = slide?.querySelector('video');
      if (video && !video.paused) video.pause();
      if (slide && !slide.querySelector('.hsis__video--autoplay')) {
        slide.classList.remove('is-playing');
      }
    }
  }

  if (!customElements.get('home-special-img-swiper')) {
    customElements.define('home-special-img-swiper', HomeSpecialImgSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-max-pro"] && !Shopify.designMode) return;
  try {
    
  class IntroMaxCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.slides = Array.from(this.querySelectorAll('.intro-max__slide'));
      this.dots = Array.from(this.querySelectorAll('.intro-max__dot'));
      this.autoplay = this.dataset.autoplay === 'true'
        && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.dataset.interval) || 6000;
      this.autoplayTimer = null;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      if (this.slides.length <= 1) return;

      this.onClick = this.onClick.bind(this);
      this.onMouseEnter = () => this.stopAutoplay();
      this.onMouseLeave = () => this.startAutoplay();
      this.addEventListener('click', this.onClick);

      if (this.autoplay) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.initialized = false;
    }

    onClick(event) {
      const dot = event.target.closest('.intro-max__dot');
      if (dot && this.contains(dot)) this.goTo(Number(dot.dataset.index));
    }

    goTo(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex]?.classList.remove('is-active');

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex]?.classList.add('is-active');

      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goTo(nextIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('intro-max-carousel')) {
    customElements.define('intro-max-carousel', IntroMaxCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.pendingChanges = new Map();
      this.removeAfter = new Map();
      this.isProcessing = false;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onQuantityChange.bind(this));
    }

    onClick(event) {
      const control = event.target.closest('[data-cart-action]');
      if (!control || !this.contains(control)) return;
      const row = control.closest('[data-cart-row]');
      if (!row) return;

      event.preventDefault();
      if (row.dataset.removing === 'true') return;
      const key = row.dataset.key;
      const input = row.querySelector('[data-qty-input]');
      const queuedQuantity = this.pendingChanges.get(key);
      const currentQuantity = Number.isFinite(queuedQuantity)
        ? queuedQuantity
        : Math.max(0, Number.parseInt(input?.value, 10) || 0);
      const increment = this.quantityIncrement(input);
      const minimum = this.quantityMinimum(input);
      const maximum = this.quantityMaximum(input);
      const action = control.dataset.cartAction;
      const quantity = action === 'increase'
        ? this.normalizeQuantity(currentQuantity + increment, minimum, maximum, increment)
        : action === 'decrease'
          ? currentQuantity - increment < minimum ? 0 : currentQuantity - increment
          : 0;

      if (input) input.value = quantity;
      this.queueChange(key, quantity, input);
    }

    onQuantityChange(event) {
      const input = event.target.closest('[data-qty-input]');
      if (!input || !this.contains(input)) return;
      const row = input.closest('[data-cart-row]');
      if (!row) return;
      const minimum = this.quantityMinimum(input);
      const maximum = this.quantityMaximum(input);
      const increment = this.quantityIncrement(input);
      const requestedQuantity = Number.parseInt(input.value, 10) || 0;
      const quantity = requestedQuantity === 0
        ? 0
        : this.normalizeQuantity(requestedQuantity, minimum, maximum, increment);
      input.value = quantity;
      this.queueChange(row.dataset.key, quantity, input);
    }

    queueChange(key, quantity, focusTarget) {
      this.pendingChanges.set(key, quantity);
      if (quantity === 0) {
        this.removeAfter.set(key, Date.now() + 350);
      } else {
        this.removeAfter.delete(key);
      }
      this.focusAfterUpdate = focusTarget;
      this.processChanges();
    }

    async processChanges() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      this.setBusy(true);
      let cart;

      try {
        while (this.pendingChanges.size) {
          const [queuedKey, queuedQuantity] = this.pendingChanges.entries().next().value;
          const removeAt = this.removeAfter.get(queuedKey);
          if (queuedQuantity === 0 && removeAt && Date.now() < removeAt) {
            await new Promise((resolve) => window.setTimeout(resolve, removeAt - Date.now()));
            continue;
          }

          const [key, quantity] = this.pendingChanges.entries().next().value;
          this.pendingChanges.delete(key);
          this.removeAfter.delete(key);
          if (quantity === 0) this.lockRemovalRow(key);
          const response = await fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity })
          });
          if (!response.ok) {
            const failure = await response.json().catch(() => null);
            throw new Error(failure?.description || failure?.message || this.dataset.errorMessage);
          }
          cart = await response.json();
        }

        await this.renderLatestSection();
        this.announce(this.dataset.updatedMessage);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { source: 'cart-page', cart }
        }));
      } catch (error) {
        console.error('[cart-items] Unable to update cart', error);
        const message = error instanceof Error && error.message ? error.message : this.dataset.errorMessage;
        try {
          const serverCart = await this.fetchCart();
          await this.renderLatestSection();
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { source: 'cart-page', cart: serverCart }
          }));
        } catch (refreshError) {
          console.error('[cart-items] Unable to refresh cart after an error', refreshError);
        }
        this.announce(message, true);
      } finally {
        this.setBusy(false);
        this.isProcessing = false;
        if (this.pendingChanges.size) this.processChanges();
      }
    }

    async renderLatestSection() {
      const response = await fetch(this.dataset.sectionUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Cart section refresh failed: ${response.status}`);
      const html = await response.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
      if (!fresh) throw new Error('Cart section was not returned by Shopify');

      const noteInput = this.querySelector('[name="note"]');
      const note = noteInput ? noteInput.value : null;
      const focusKey = this.focusAfterUpdate?.closest?.('[data-cart-row]')?.dataset.key;
      const wasBusy = this.classList.contains('cart-items--loading');
      this.className = fresh.className;
      this.innerHTML = fresh.innerHTML;

      if (wasBusy) this.setBusy(true);

      const freshNote = this.querySelector('[name="note"]');
      if (freshNote && note !== null) freshNote.value = note;
      const freshInput = focusKey && [...this.querySelectorAll('[data-cart-row]')]
        .find((row) => row.dataset.key === focusKey)
        ?.querySelector('[data-qty-input]');
      freshInput?.focus({ preventScroll: true });
      this.focusAfterUpdate = null;
    }

    async fetchCart() {
      const cartUrl = this.dataset.cartChangeUrl.replace(/change\.js$/, 'js');
      const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
      return response.json();
    }

    quantityMinimum(input) {
      return Math.max(1, Number.parseInt(input?.dataset.quantityMin, 10) || 1);
    }

    quantityMaximum(input) {
      const maximum = Number.parseInt(input?.max, 10);
      return Number.isFinite(maximum) ? maximum : Infinity;
    }

    quantityIncrement(input) {
      return Math.max(1, Number.parseInt(input?.step, 10) || 1);
    }

    normalizeQuantity(quantity, minimum, maximum, increment) {
      const boundedQuantity = Math.min(maximum, Math.max(minimum, quantity));
      return minimum + Math.floor((boundedQuantity - minimum) / increment) * increment;
    }

    lockRemovalRow(key) {
      const row = [...this.querySelectorAll('[data-cart-row]')].find((candidate) => candidate.dataset.key === key);
      if (!row) return;
      row.dataset.removing = 'true';
      row.querySelectorAll('.qty__btn, .qty__input').forEach((control) => { control.disabled = true; });
      row.querySelector('[data-cart-action="remove"]')?.setAttribute('aria-disabled', 'true');
    }

    setBusy(isBusy) {
      this.classList.toggle('cart-items--loading', isBusy);
      this.toggleAttribute('aria-busy', isBusy);
      const checkout = this.querySelector('.cart__checkout');
      if (checkout) checkout.disabled = isBusy;
      this.querySelector('.cart__dynamic-checkout')?.toggleAttribute('inert', isBusy);
    }

    announce(message, isError = false) {
      const status = this.querySelector('[data-cart-status]');
      if (!status || !message) return;
      status.hidden = false;
      status.textContent = message;
      status.toggleAttribute('data-error', isError);
      status.classList.toggle('visually-hidden', !isError);
    }
  }

  class CartShippingEstimator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('[data-shipping-estimate]')?.addEventListener('click', () => this.estimate());
    }

    async estimate() {
      const button = this.querySelector('[data-shipping-estimate]');
      const status = this.querySelector('[data-shipping-status]');
      const rates = this.querySelector('[data-shipping-rates]');
      const country = this.querySelector('[name="country"]')?.value || '';
      const province = this.querySelector('[name="province"]')?.value || '';
      const zip = this.querySelector('[name="zip"]')?.value || '';
      const address = new URLSearchParams({
        'shipping_address[country]': country,
        'shipping_address[province]': province,
        'shipping_address[zip]': zip
      });

      button.disabled = true;
      status.hidden = false;
      status.textContent = '';
      rates.hidden = true;
      rates.replaceChildren();

      try {
        const prepared = await fetch(`${this.dataset.prepareUrl}?${address}`, { method: 'POST' });
        if (!prepared.ok) throw new Error(`Shipping rate preparation failed: ${prepared.status}`);

        for (let attempt = 0; attempt < 8; attempt += 1) {
          const response = await fetch(`${this.dataset.ratesUrl}?${address}`);
          if (response.ok) {
            const payload = await response.json();
            const shippingRates = payload.shipping_rates || [];
            if (shippingRates.length) {
              shippingRates.forEach((rate) => {
                const item = document.createElement('li');
                item.textContent = `${rate.name}: ${this.formatPrice(rate.price)}`;
                rates.append(item);
              });
              rates.hidden = false;
              status.hidden = true;
              return;
            }
            status.textContent = this.dataset.emptyMessage;
            return;
          }
          if (response.status !== 202) throw new Error(`Shipping rate fetch failed: ${response.status}`);
          await new Promise((resolve) => window.setTimeout(resolve, 650));
        }
        throw new Error('Shipping rate calculation timed out');
      } catch (error) {
        console.error('[cart-shipping-estimator] Unable to estimate shipping', error);
        status.textContent = this.dataset.errorMessage;
      } finally {
        button.disabled = false;
      }
    }

    formatPrice(price) {
      const amount = Number.parseFloat(price);
      if (!Number.isFinite(amount) || !this.dataset.currency) return price;
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.dataset.currency
      }).format(amount);
    }
  }

  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);
  if (!customElements.get('cart-shipping-estimator')) customElements.define('cart-shipping-estimator', CartShippingEstimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    class CollectionPromoVideo extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (!entries[0]?.isIntersecting) return;
            this.hydrate();
            this.observer.disconnect();
          }, { rootMargin: '240px 0px', threshold: 0.01 });
          this.observer.observe(this);
        } else {
          this.hydrate();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.querySelector('video')?.pause();
        this.initialized = false;
      }

      hydrate() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        const video = this.querySelector('[data-promo-video]');
        if (video) {
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.load();
          if (this.reduceMotion) {
            video.controls = true;
          } else {
            video.play().catch(() => {});
          }
          return;
        }
        const template = this.querySelector('template[data-external-video]');
        if (template) template.replaceWith(template.content.cloneNode(true));
      }
    }

    class MainCollection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.drawer = this.querySelector('[data-facets-drawer]');
        this.drawerPanel = this.querySelector('[data-facets-panel]');
        this.quickBuy = this.querySelector('[data-quick-buy]');
        this.quickBuyPanel = this.querySelector('[data-quick-buy-panel]');
        this.lastTrigger = null;
        this.activeCard = null;
        this.activeProduct = null;
        this.priceTimer = null;

        this.handleClick = (event) => this.onClick(event);
        this.handleChange = (event) => this.onChange(event);
        this.handleCardPreview = (event) => this.onCardPreview(event);
        this.handleCardPreviewEnd = (event) => this.onCardPreviewEnd(event);
        this.handleSubmit = (event) => this.onSubmit(event);
        this.handleKeydown = (event) => this.onKeydown(event);
        this.handlePopstate = () => this.updateFromUrl(window.location.href, false);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);
        this.addEventListener('pointerover', this.handleCardPreview);
        this.addEventListener('pointerout', this.handleCardPreviewEnd);
        this.addEventListener('focusin', this.handleCardPreview);
        this.addEventListener('focusout', this.handleCardPreviewEnd);
        this.addEventListener('submit', this.handleSubmit);
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('popstate', this.handlePopstate);
      }

      disconnectedCallback() {
        const hadOpenOverlay = Boolean((this.drawer && !this.drawer.hidden) || (this.quickBuy && !this.quickBuy.hidden));
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('pointerover', this.handleCardPreview);
        this.removeEventListener('pointerout', this.handleCardPreviewEnd);
        this.removeEventListener('focusin', this.handleCardPreview);
        this.removeEventListener('focusout', this.handleCardPreviewEnd);
        this.removeEventListener('submit', this.handleSubmit);
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('popstate', this.handlePopstate);
        window.clearTimeout(this.priceTimer);
        this.drawer?.classList.remove('is-open');
        this.quickBuy?.classList.remove('is-open');
        if (this.drawer) this.drawer.hidden = true;
        if (this.quickBuy) this.quickBuy.hidden = true;
        if (hadOpenOverlay) this.unlockScroll();
        this.initialized = false;
      }

      onClick(event) {
        const facetLink = event.target.closest('[data-facet-link]');
        if (facetLink) {
          event.preventDefault();
          this.updateFromUrl(facetLink.href, true);
          return;
        }

        if (event.target.closest('[data-open-facets]')) {
          this.openDrawer(event.target.closest('[data-open-facets]'));
          return;
        }

        if (event.target.closest('[data-close-facets]')) {
          this.closeDrawer();
          return;
        }

        const quickTrigger = event.target.closest('[data-open-quick-buy]');
        if (quickTrigger) {
          this.prepareQuickBuy(quickTrigger);
          return;
        }

        if (event.target.closest('[data-close-quick-buy]')) this.closeQuickBuy();
      }

      onChange(event) {
        if (event.target.matches('[data-main-card-swatch]')) {
          this.selectCardVariant(event.target);
          return;
        }
        if (event.target.matches('[data-sort-select]')) {
          this.submitForm(event.target.form);
          return;
        }

        if (event.target.closest('[data-quick-options]')) {
          this.updateQuickVariant();
          return;
        }

        const form = event.target.closest('[data-facet-form][data-auto-submit]');
        if (!form) return;
        if (event.target.type === 'number') {
          window.clearTimeout(this.priceTimer);
          this.priceTimer = window.setTimeout(() => this.submitForm(form), 500);
        } else {
          this.submitForm(form);
        }
      }

      selectCardVariant(input) {
        const card = input.closest('[data-product-card]');
        const data = card?.querySelector('[data-product-json]');
        if (!card || !data) return;

        const variantId = String(input.dataset.variantId || '');
        this.previewCardVariant(input);

        const target = new URL(card.dataset.productUrl, window.location.origin);
        if (variantId) target.searchParams.set('variant', variantId);
        const variantUrl = `${target.pathname}${target.search}${target.hash}`;
        card.querySelectorAll('[data-main-card-product-link]').forEach((link) => { link.href = variantUrl; });

        const price = card.querySelector('[data-main-card-price]');
        const compare = card.querySelector('[data-main-card-compare]');
        if (price) price.textContent = input.dataset.price || '';
        if (compare) {
          compare.textContent = input.dataset.compare || '';
          compare.hidden = !input.dataset.compare;
        }

        try {
          const product = JSON.parse(data.textContent);
          product.selectedVariantId = variantId;
          data.textContent = JSON.stringify(product);
        } catch (error) {
          // Keep links and product detail navigation usable if card JSON is invalid.
        }
      }

      onCardPreview(event) {
        const input = event.target.matches?.('[data-main-card-swatch]')
          ? event.target
          : event.target.closest?.('label')?.control;
        if (input?.matches?.('[data-main-card-swatch]')) this.previewCardVariant(input);
      }

      onCardPreviewEnd(event) {
        const card = event.target.closest?.('[data-product-card]');
        if (!card || card.contains(event.relatedTarget)) return;
        const selected = card.querySelector('[data-main-card-swatch]:checked');
        if (selected) this.previewCardVariant(selected);
      }

      previewCardVariant(input) {
        const card = input.closest('[data-product-card]');
        if (!card) return;
        const template = card.querySelector(`[data-main-card-media-template="${CSS.escape(input.dataset.variantId || '')}"]`);
        const media = card.querySelector('[data-main-card-media]');
        if (template && media) media.replaceChildren(template.content.cloneNode(true));
      }

      onSubmit(event) {
        const facetForm = event.target.closest('[data-facet-form], [data-sort-form]');
        if (facetForm) {
          event.preventDefault();
          this.submitForm(facetForm);
          return;
        }
        if (event.target.matches('[data-quick-form]')) this.addToCart(event);
      }

      onKeydown(event) {
        const activePanel = !this.quickBuy?.hidden ? this.quickBuyPanel : !this.drawer?.hidden ? this.drawerPanel : null;
        if (!activePanel) return;
        if (event.key === 'Escape') {
          if (!this.quickBuy?.hidden) this.closeQuickBuy();
          else this.closeDrawer();
        } else if (event.key === 'Tab') {
          this.trapFocus(event, activePanel);
        }
      }

      submitForm(form) {
        const data = new FormData(form);
        const params = new URLSearchParams();
        data.forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
        const url = `${form.action}?${params.toString()}`;
        this.updateFromUrl(url, true);
      }

      async updateFromUrl(url, pushState) {
        if (this.classList.contains('is-loading')) return;
        const requestedUrl = new URL(url, window.location.origin);
        const sectionUrl = new URL(requestedUrl);
        sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
        this.setLoading(true);

        try {
          const response = await fetch(sectionUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const replacement = documentFragment.querySelector('main-collection');
          if (!replacement) throw new Error('Collection section was not returned.');

          if (pushState) window.history.pushState({}, '', requestedUrl);
          this.replaceWith(replacement);
          window.scrollTo({
            top: replacement.getBoundingClientRect().top + window.scrollY - 100,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        } catch (error) {
          window.location.assign(requestedUrl);
        }
      }

      setLoading(loading) {
        this.classList.toggle('is-loading', loading);
        this.querySelector('[data-results-layout]')?.setAttribute('aria-busy', String(loading));
        const indicator = this.querySelector('[data-loading-indicator]');
        if (indicator) indicator.hidden = !loading;
      }

      openDrawer(trigger) {
        if (!this.drawer) return;
        this.lastTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        this.drawer.hidden = false;
        this.lockScroll();
        requestAnimationFrame(() => {
          this.drawer.classList.add('is-open');
          this.drawerPanel.focus();
        });
      }

      closeDrawer() {
        this.closeOverlay(this.drawer, () => {
          this.lastTrigger?.setAttribute('aria-expanded', 'false');
          this.lastTrigger?.focus();
        });
      }

      prepareQuickBuy(trigger) {
        const card = trigger.closest('[data-product-card]');
        const json = card?.querySelector('[data-product-json]');
        if (!card || !json || !this.quickBuy) return;

        try {
          this.activeProduct = JSON.parse(json.textContent);
        } catch (error) {
          window.location.assign(card.querySelector('a')?.href || '#');
          return;
        }

        const defaultVariant = this.activeProduct.variants.find((variant) => variant.id === this.activeProduct.selectedVariantId);
        if (this.activeProduct.hasOnlyDefaultVariant && defaultVariant?.available) {
          this.addVariant(defaultVariant.id, trigger);
          return;
        }

        this.activeCard = card;
        this.lastTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        const title = this.querySelector('[data-quick-title]');
        title.textContent = this.activeProduct.title;
        title.href = this.activeProduct.url;
        this.renderQuickMedia();
        this.renderQuickOptions();
        this.updateQuickVariant();
        this.quickBuy.hidden = false;
        this.lockScroll();
        requestAnimationFrame(() => {
          this.quickBuy.classList.add('is-open');
          this.quickBuyPanel.focus();
        });
      }

      renderQuickMedia() {
        const target = this.querySelector('[data-quick-media]');
        const source = this.activeCard?.querySelector('.main-collection-card__media');
        target.replaceChildren();
        if (source) target.append(source.cloneNode(true));
      }

      renderQuickOptions() {
        const target = this.querySelector('[data-quick-options]');
        const variants = this.activeProduct.variants || [];
        target.replaceChildren();
        if (this.activeProduct.hasOnlyDefaultVariant) return;
        const preferred = variants.find((variant) => variant.id === this.activeProduct.selectedVariantId) || variants[0];

        this.activeProduct.options.forEach((name, optionIndex) => {
          const values = [...new Set(variants.map((variant) => variant.options[optionIndex]))];
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'main-collection__quick-buy-option';
          const legend = document.createElement('legend');
          legend.textContent = name;
          const valueContainer = document.createElement('div');
          valueContainer.className = 'main-collection__quick-buy-values';
          const isColor = ['color', 'colour'].includes(name.toLowerCase());

          values.forEach((value, valueIndex) => {
            const id = `MainCollectionQuickOption-${this.dataset.sectionId}-${optionIndex}-${valueIndex}`;
            const input = document.createElement('input');
            input.type = 'radio';
            input.id = id;
            input.name = `main-collection-option-${this.dataset.sectionId}-${optionIndex}`;
            input.value = value;
            input.checked = value === preferred?.options[optionIndex];
            const label = document.createElement('label');
            label.htmlFor = id;
            label.textContent = value;
            if (isColor) {
              label.classList.add('is-color');
              label.setAttribute('aria-label', value);
              label.style.setProperty('--swatch-color', this.swatchColor(value));
            }
            valueContainer.append(input, label);
          });

          fieldset.append(legend, valueContainer);
          target.append(fieldset);
        });
      }

      updateQuickVariant() {
        if (!this.activeProduct) return;
        const selected = [...this.querySelectorAll('[data-quick-options] input:checked')].map((input) => input.value);
        const variant = this.activeProduct.variants.find((item) =>
          item.options.length === selected.length && item.options.every((value, index) => value === selected[index])
        );
        const idInput = this.querySelector('[data-quick-variant-id]');
        const submit = this.querySelector('[data-quick-submit]');
        const submitText = this.querySelector('[data-quick-submit-text]');
        const price = this.querySelector('[data-quick-price]');
        const status = this.querySelector('[data-quick-status]');
        status.hidden = true;
        price.replaceChildren();

        if (!variant) {
          idInput.value = '';
          submit.disabled = true;
          submitText.textContent = this.dataset.stringUnavailable;
          return;
        }

        idInput.value = variant.id;
        submit.disabled = !variant.available;
        submitText.textContent = variant.available ? this.dataset.stringAdd : this.dataset.stringSoldOut;
        const current = document.createElement('span');
        current.textContent = variant.price;
        price.append(current);
        if (variant.comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = variant.comparePrice;
          price.append(compare);
        }
      }

      async addToCart(event) {
        event.preventDefault();
        const id = this.querySelector('[data-quick-variant-id]')?.value;
        if (id) await this.addVariant(id, this.querySelector('[data-quick-submit]'), true);
      }

      async addVariant(id, trigger, closeAfter = false) {
        if (!id || trigger?.disabled) return;
        trigger.disabled = true;
        const status = this.querySelector('[data-quick-status]');
        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id, quantity: 1 })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.stringUnavailable);
          if (status) {
            status.textContent = this.dataset.stringAdded;
            status.classList.remove('is-error');
            status.hidden = false;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
          if (closeAfter) this.closeQuickBuy();
        } catch (error) {
          if (status && !this.quickBuy.hidden) {
            status.textContent = error.message;
            status.classList.add('is-error');
            status.hidden = false;
          }
        } finally {
          trigger.disabled = false;
        }
      }

      closeQuickBuy() {
        this.closeOverlay(this.quickBuy, () => {
          this.lastTrigger?.setAttribute('aria-expanded', 'false');
          this.lastTrigger?.focus();
        });
      }

      closeOverlay(element, callback) {
        if (!element || element.hidden) return;
        element.classList.remove('is-open');
        this.unlockScroll();
        const finish = () => {
          element.hidden = true;
          callback?.();
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else window.setTimeout(finish, 310);
      }

      lockScroll() {
        document.documentElement.style.overflow = 'hidden';
      }

      unlockScroll() {
        document.documentElement.style.removeProperty('overflow');
      }

      trapFocus(event, panel) {
        const focusable = [...panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter((element) => !element.hidden && element.offsetParent !== null);
        if (!focusable.length) {
          event.preventDefault();
          panel.focus();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      swatchColor(value) {
        const colors = {
          'almond cream': '#dcd0c3',
          'dark matter': '#42423f',
          'dark gray': '#42423f',
          'moonlit mist': '#9c9c9c',
          'navy blue': '#19304c',
          'light gray': '#bbbabC',
          'light green': '#3aefd0',
          'ivory white': '#fdf9de',
          'rust brown': '#b0561f',
          'moss green': '#42694c',
          'beige': '#dfd4cd',
          'cloud white': '#eae9e5',
          'walnut': '#775748'
        };
        return colors[value.toLowerCase()] || value.toLowerCase();
      }
    }

    if (!customElements.get('collection-promo-video')) customElements.define('collection-promo-video', CollectionPromoVideo);
    if (!customElements.get('main-collection')) customElements.define('main-collection', MainCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.thumbs = this.querySelector('.pgallery__thumbs');
      this.onThumbClick = (e) => {
        const t = e.target.closest('[data-target]'); if (!t) return;
        this.hydrateThumbnail(t);
        this.showMedia(t.getAttribute('data-target'));
      };
      this.onThumbFocus = (e) => this.hydrateThumbnail(e.target.closest('[data-target]'));
      this.addEventListener('click', this.onThumbClick);
      this.addEventListener('focusin', this.onThumbFocus);
      const deferredThumbs = Array.from(this.querySelectorAll('.pgallery__thumb [data-pgallery-thumb]')).map((placeholder) => placeholder.closest('.pgallery__thumb'));
      if (!deferredThumbs.length) return;
      if (!('IntersectionObserver' in window) || !this.thumbs) {
        deferredThumbs.forEach((thumb) => this.hydrateThumbnail(thumb));
        return;
      }
      this.thumbObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) this.hydrateThumbnail(entry.target); });
      }, { root: this.thumbs, rootMargin: '160px 0px' });
      deferredThumbs.forEach((thumb) => this.thumbObserver.observe(thumb));
    }
    disconnectedCallback() {
      this.thumbObserver?.disconnect();
      this.thumbObserver = null;
      this.removeEventListener('click', this.onThumbClick);
      this.removeEventListener('focusin', this.onThumbFocus);
      this.initialized = false;
    }
    hydrateThumbnail(thumb) {
      const placeholder = thumb?.querySelector('[data-pgallery-thumb]');
      const template = thumb?.querySelector('[data-pgallery-thumb-template]');
      if (!placeholder || !template) return;
      placeholder.replaceWith(template.content.cloneNode(true));
      template.remove();
      this.thumbObserver?.unobserve(thumb);
    }
    showMedia(id) {
      if (!id) return;
      this.querySelectorAll('.pgallery__slide').forEach(s => s.classList.toggle('is-active', s.dataset.mediaId == id));
      this.querySelectorAll('.pgallery__thumb').forEach(b => b.classList.toggle('is-active', b.dataset.target == id));
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form');
      this.addEventListener('change', () => this.form && this.form.onVariantChange());
    }
    get selectedValues() { return Array.from(this.querySelectorAll('input[type=radio]:checked')).map(i => i.value); }
  }
  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.selects = this.querySelector('variant-selects');
      this.form = this.closest('form');
      this.status = this.querySelector('[data-atc-status]');
      this.btn = this.querySelector('[data-atc]');
      this.section = this.dataset.section;
      this.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => this.stepQty(b.dataset.qty)));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', () => this.copyCode(b)));
    }
    copyCode(b) {
      const m = (b.dataset.copy.match(/([A-Z0-9]{4,})/) || [])[1] || b.dataset.copy;
      navigator.clipboard && navigator.clipboard.writeText(m);
      b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
    }
    stepQty(dir) { const q = this.querySelector('.qty__input'); let v = parseInt(q.value, 10) || 1; q.value = dir === 'plus' ? v + 1 : Math.max(1, v - 1); }
    onVariantChange() {
      if (!this.selects) return;
      const vals = this.selects.selectedValues;
      const match = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(vals));
      // update each option's shown value + close the accordion
      this.querySelectorAll('.voption').forEach((d, i) => {
        const val = d.querySelector('.voption__val'); if (val && vals[i]) val.textContent = vals[i];
        d.open = false;
      });
      const priceEl = document.getElementById('price-' + this.section);
      if (!match) { this.setUnavailable(); return; }
      this.idInput.value = match.id;
      if (match.featured_media_id) { const g = document.querySelector('product-gallery'); if (g) g.showMedia(match.featured_media_id); }
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      const text = this.querySelector('[data-atc-text]');
      if (match.available) { this.btn.disabled = false; text.textContent = this.strings.add; }
      else { this.btn.disabled = true; text.textContent = this.strings.soldout; }
    }
    setUnavailable() { this.btn.disabled = true; this.querySelector('[data-atc-text]').textContent = this.strings.unavailable; }
    async onSubmit(e) {
      e.preventDefault(); this.btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: this.idInput.value, quantity: parseInt(this.querySelector('.qty__input').value, 10) || 1 }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(this.strings.added, false);
      } catch (err) { this.showStatus(err.message, true); } finally { this.btn.disabled = false; }
    }
    showStatus(msg, isError) { if (!this.status) return; this.status.textContent = msg; this.status.hidden = false; this.status.classList.toggle('is-error', !!isError); }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-announcement-rotator')) {
    class MtAnnouncementRotator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.desktopItems = Array.from(this.querySelectorAll('[data-announcement-message]'));
        this.mobileItems = Array.from(this.querySelectorAll('[data-announcement-mobile-message]'));
        this.mobileSet = this.querySelector('[data-announcement-mobile-set]');
        this.mobileClone = this.querySelector('[data-announcement-mobile-clone]');
        this.activeIndex = Math.max(0, this.desktopItems.findIndex((item) => item.classList.contains('is-active')));
        this.intervalMilliseconds = this.clampNumber(this.dataset.desktopInterval, 2, 15, 5) * 1000;
        this.mobilePixelsPerSecond = this.clampNumber(this.dataset.mobileSpeed, 20, 120, 50);
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.editorPaused = false;
        this.handleEnvironmentChange = () => this.configureMode();
        this.handleVisibilityChange = () => document.hidden ? this.stopDesktopTimer() : this.startDesktopTimer();
        this.handlePointerEnter = () => this.stopDesktopTimer();
        this.handlePointerLeave = () => this.startDesktopTimer();
        this.handleFocusIn = () => this.stopDesktopTimer();
        this.handleFocusOut = (event) => { if (!this.contains(event.relatedTarget)) this.startDesktopTimer(); };
        this.handleBlockSelect = (event) => {
          const index = this.desktopItems.findIndex((item) => item.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editorPaused = true;
          this.stopDesktopTimer();
          this.activate(index);
        };
        this.handleBlockDeselect = () => { this.editorPaused = false; this.startDesktopTimer(); };
        this.mobileQuery.addEventListener('change', this.handleEnvironmentChange, { signal });
        this.motionQuery.addEventListener('change', this.handleEnvironmentChange, { signal });
        document.addEventListener('visibilitychange', this.handleVisibilityChange, { signal });
        this.addEventListener('pointerenter', this.handlePointerEnter, { signal });
        this.addEventListener('pointerleave', this.handlePointerLeave, { signal });
        this.addEventListener('focusin', this.handleFocusIn, { signal });
        this.addEventListener('focusout', this.handleFocusOut, { signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateMobileDuration());
          if (this.mobileSet) this.resizeObserver.observe(this.mobileSet);
        }
        this.configureMode();
      }

      disconnectedCallback() {
        this.stopDesktopTimer();
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.initialized = false;
      }

      clampNumber(value, minimum, maximum, fallback) {
        const number = Number.parseFloat(value);
        return Number.isFinite(number) ? Math.min(Math.max(number, minimum), maximum) : fallback;
      }

      configureMode() {
        this.stopDesktopTimer();
        if (this.mobileQuery.matches) { this.configureMobile(); return; }
        this.stopMobile();
        this.desktopItems.forEach((item) => item.removeAttribute('hidden'));
        this.activate(this.activeIndex);
        this.startDesktopTimer();
      }

      configureMobile() {
        const shouldRun = this.mobileItems.length > 1 && !this.motionQuery.matches;
        this.mobileItems.forEach((item, index) => { item.hidden = !shouldRun && index > 0; });
        if (this.mobileClone) this.mobileClone.hidden = !shouldRun;
        this.toggleAttribute('data-mobile-running', shouldRun);
        if (shouldRun) requestAnimationFrame(() => this.updateMobileDuration());
      }

      stopMobile() {
        this.removeAttribute('data-mobile-running');
        if (this.mobileClone) this.mobileClone.hidden = true;
      }

      updateMobileDuration() {
        if (!this.hasAttribute('data-mobile-running') || !this.mobileSet) return;
        const distance = this.mobileSet.scrollWidth;
        if (distance <= 0) return;
        const duration = Math.max(4, distance / this.mobilePixelsPerSecond);
        this.style.setProperty('--mt-announcement-mobile-duration', `${duration.toFixed(2)}s`);
      }

      activate(index) {
        if (!this.desktopItems.length) return;
        this.activeIndex = ((index % this.desktopItems.length) + this.desktopItems.length) % this.desktopItems.length;
        this.desktopItems.forEach((item, itemIndex) => {
          const active = itemIndex === this.activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
          if (item.matches('a')) item.tabIndex = active ? 0 : -1;
        });
      }

      advanceDesktop() {
        if (this.desktopItems.length < 2) return;
        this.activate((this.activeIndex + 1) % this.desktopItems.length);
      }

      startDesktopTimer() {
        this.stopDesktopTimer();
        if (this.mobileQuery.matches || this.motionQuery.matches || this.editorPaused || document.hidden || this.desktopItems.length < 2) return;
        this.desktopTimer = window.setInterval(() => this.advanceDesktop(), this.intervalMilliseconds);
      }

      stopDesktopTimer() {
        window.clearInterval(this.desktopTimer);
        this.desktopTimer = null;
      }
    }
    customElements.define('mt-announcement-rotator', MtAnnouncementRotator);
  }

  if (!customElements.get('mt-announcement-countdown')) {
    class MtAnnouncementCountdown extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.mode = this.dataset.mode === 'fixed' ? 'fixed' : 'evergreen';
        this.periodMilliseconds = this.getPeriodMilliseconds();
        this.target = this.mode === 'fixed' ? this.parseFixedTarget(this.dataset.end) : this.getNextEvergreenTarget();
        this.units = new Map(Array.from(this.querySelectorAll('[data-countdown-unit]')).map((element) => [element.dataset.countdownUnit, element]));
        this.handleVisibilityChange = () => { if (!document.hidden) this.update(); };
        if (!this.target) { this.finish(); return; }
        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
      }
      disconnectedCallback() { window.clearInterval(this.interval); document.removeEventListener('visibilitychange', this.handleVisibilityChange); this.initialized = false; }
      getPeriodMilliseconds() { const hours = Number.parseInt(this.dataset.periodHours || '192', 10); const validHours = Number.isFinite(hours) ? Math.min(Math.max(hours, 1), 720) : 192; return validHours * 60 * 60 * 1000; }
      getNextEvergreenTarget() { const now = Date.now(); return new Date((Math.floor(now / this.periodMilliseconds) + 1) * this.periodMilliseconds); }
      parseFixedTarget(value) { if (!value) return null; const timestamp = Date.parse(value.trim()); return Number.isNaN(timestamp) ? null : new Date(timestamp); }
      update() {
        const now = Date.now(); let difference = this.target.getTime() - now;
        if (difference <= 0) { if (this.mode === 'fixed') { this.finish(); return; } this.target = this.getNextEvergreenTarget(); difference = this.target.getTime() - now; }
        this.setNumber('days', Math.floor(difference / 86400000));
        this.setNumber('hours', Math.floor((difference % 86400000) / 3600000));
        this.setNumber('minutes', Math.floor((difference % 3600000) / 60000));
        this.setNumber('seconds', Math.floor((difference % 60000) / 1000));
      }
      setNumber(name, value) { const element = this.units.get(name); if (!element) return; const formattedValue = String(value).padStart(2, '0'); element.textContent = formattedValue; element.setAttribute('aria-label', `${formattedValue} ${element.dataset.unitLabel}`); }
      finish() { window.clearInterval(this.interval); this.hidden = true; this.closest('.mt-announcement-bar')?.classList.remove('mt-announcement-bar--mobile-countdown'); }
    }
    customElements.define('mt-announcement-countdown', MtAnnouncementCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-bestsellers-swiper"] && !Shopify.designMode) return;
  try {
    
  class MtBestsellersSwiper extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.viewport = this.querySelector('[data-mt-bs-viewport]');
      this.previous = this.querySelector('[data-mt-bs-previous]');
      this.next = this.querySelector('[data-mt-bs-next]');
      this.progress = this.querySelector('[data-mt-bs-progress]');
      const signal = this.abortController.signal;
      this.previous?.addEventListener('click', () => this.move(-1), { signal });
      this.next?.addEventListener('click', () => this.move(1), { signal });
      this.viewport?.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      if (this.viewport) this.resizeObserver.observe(this.viewport);
      this.update();
    }
    disconnectedCallback() { this.abortController?.abort(); this.abortController = null; this.resizeObserver?.disconnect(); this.resizeObserver = null; }
    move(direction) { const slide = this.querySelector('.mt-bestsellers-swiper__slide'); if (!slide || !this.viewport) return; const gap = Number.parseFloat(getComputedStyle(this.querySelector('.mt-bestsellers-swiper__track')).gap) || 0; this.viewport.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
    update() { if (!this.viewport) return; const max = this.viewport.scrollWidth - this.viewport.clientWidth; const ratio = max > 0 ? this.viewport.scrollLeft / max : 1; this.style.setProperty('--mt-bs-progress', `${Math.max(0, Math.min(100, ratio * 100))}%`); if (this.previous) this.previous.disabled = this.viewport.scrollLeft <= 1; if (this.next) this.next.disabled = this.viewport.scrollLeft >= max - 1; }
  }
  if (!customElements.get('mt-bestsellers-swiper')) customElements.define('mt-bestsellers-swiper', MtBestsellersSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-blog-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-blog-categories')) {
    class MtBlogCategories extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;
        this.isInitialized = true;
        this.scrollport = this.querySelector('[data-category-scrollport]');
        this.nextButton = this.querySelector('[data-category-next]');
        if (!this.scrollport || !this.nextButton) return;

        this.handleScroll = this.updateControl.bind(this);
        this.handleNext = this.scrollNext.bind(this);
        this.handleHubClick = this.onHubClick.bind(this);
        this.handlePaginationClick = this.onPaginationClick.bind(this);
        this.handleHistoryChange = this.onHistoryChange.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);
        this.motionFrame = null;
        this.scrollport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.nextButton.addEventListener('click', this.handleNext);
        this.scrollport.addEventListener('click', this.handleHubClick);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateControl());
          this.resizeObserver.observe(this.scrollport);
        }
        if (this.hasAttribute('data-blog-hub-navigation')) {
          this.sectionRoot = this.closest('[data-blog-hub]');
          this.hubLinks = Array.from(this.querySelectorAll('[data-blog-source-link]'));
          this.hubDiagnostics = Array.from(this.sectionRoot?.querySelectorAll('[data-blog-source-diagnostic]') || []);
          this.resultsInner = this.sectionRoot?.querySelector('.mt-blog-index__inner');
          this.cardSizes = this.sectionRoot?.dataset.blogCardSizes || '';
          this.sectionRoot?.addEventListener('click', this.handlePaginationClick);
          window.addEventListener('popstate', this.handleHistoryChange);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.restoreHubState(window.history.state);
        }
        this.updateControl();
      }

      disconnectedCallback() {
        this.scrollport?.removeEventListener('scroll', this.handleScroll);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.scrollport?.removeEventListener('click', this.handleHubClick);
        this.sectionRoot?.removeEventListener('click', this.handlePaginationClick);
        window.removeEventListener('popstate', this.handleHistoryChange);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.requestController?.abort();
        this.resizeObserver?.disconnect();
        if (this.motionFrame) window.cancelAnimationFrame(this.motionFrame);
        this.isInitialized = false;
      }

      updateControl() {
        const canScroll = this.scrollport.scrollWidth > this.scrollport.clientWidth + 2;
        const atEnd = this.scrollport.scrollLeft + this.scrollport.clientWidth >= this.scrollport.scrollWidth - 2;
        this.nextButton.disabled = !canScroll || atEnd;
      }

      scrollNext() {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.scrollport.scrollBy({ left: Math.max(this.scrollport.clientWidth * 0.75, 160), behavior });
      }

      onHubClick(event) {
        const link = event.target.closest('[data-blog-source-link]');
        if (!link || !this.contains(link)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.loadHubUrl(link.href, link, { pushState: true });
      }

      onPaginationClick(event) {
        const link = event.target.closest('[data-blog-pagination] a:not([data-load-more])');
        if (!link || !this.sectionRoot?.contains(link)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const activeLink = this.hubLinks?.find((item) => item.getAttribute('aria-current') === 'page') || this.hubLinks?.[0];
        if (!activeLink) return;
        event.preventDefault();
        this.loadHubUrl(link.href, activeLink, { pushState: true });
      }

      onHistoryChange(event) {
        this.restoreHubState(event.state);
      }

      restoreHubState(state) {
        if (!this.hubLinks?.length) return;
        const currentHash = window.location.hash.slice(1);
        const activeLink = this.hubLinks.find((link) => link.dataset.blogSourceHash === currentHash) || this.hubLinks[0];
        const storedHub = state?.mtBlogHub;
        const sourceUrl = storedHub?.sourceHash === activeLink.dataset.blogSourceHash && storedHub.url
          ? storedHub.url
          : activeLink.href;
        this.loadHubUrl(sourceUrl, activeLink, { pushState: false, animate: Boolean(currentHash || storedHub) });
      }

      setPendingLink(pendingLink) {
        this.hubLinks?.forEach((link) => {
          if (link === pendingLink) link.setAttribute('data-blog-pending', 'true');
          else link.removeAttribute('data-blog-pending');
        });
      }

      setActiveLink(activeLink) {
        this.hubLinks?.forEach((link) => {
          const isActive = link === activeLink;
          link.classList.toggle('mt-blog-index__category-link--active', isActive);
          link.removeAttribute('data-blog-pending');
          if (isActive) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        this.hubDiagnostics?.forEach((diagnostic) => {
          diagnostic.hidden = true;
        });
        if (this.resultsInner) this.resultsInner.hidden = false;
      }

      playResultsTransition(incomingInner, requestSequence, animate) {
        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        incomingInner.dataset.blogTransition = 'entering';
        this.motionFrame = window.requestAnimationFrame(() => {
          if (requestSequence !== this.requestSequence || this.resultsInner !== incomingInner || !incomingInner.isConnected) return;
          incomingInner.dataset.blogTransition = 'entered';
          this.motionFrame = null;
        });
      }

      applyCardSizes(resultsInner) {
        if (!this.cardSizes || !resultsInner) return;
        resultsInner.querySelectorAll('.mt-blog-card__image[sizes]').forEach((image) => {
          image.sizes = this.cardSizes;
        });
      }

      async loadHubUrl(sourceUrl, activeLink, options = {}) {
        if (!sourceUrl || !activeLink || !this.resultsInner) return;
        const requestUrl = new URL(sourceUrl, window.location.origin);
        if (requestUrl.origin !== window.location.origin) {
          window.location.assign(sourceUrl);
          return;
        }
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);

        this.requestController?.abort();
        this.requestController = new AbortController();
        const requestController = this.requestController;
        const requestSequence = (this.requestSequence || 0) + 1;
        this.requestSequence = requestSequence;
        if (this.motionFrame) window.cancelAnimationFrame(this.motionFrame);
        this.motionFrame = null;
        delete this.resultsInner.dataset.blogTransition;
        this.setPendingLink(activeLink);
        this.resultsInner.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(requestUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: requestController.signal,
          });
          if (!response.ok) throw new Error(`Blog source request failed: ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingInner = responseDocument.querySelector('.mt-blog-index__inner');
          if (!incomingInner) throw new Error('Blog source response did not contain the expected Section markup.');
          if (requestSequence !== this.requestSequence) return;

          this.applyCardSizes(incomingInner);
          this.resultsInner.replaceWith(incomingInner);
          this.resultsInner = incomingInner;
          this.setActiveLink(activeLink);
          this.playResultsTransition(incomingInner, requestSequence, options.animate === true);

          if (options.pushState) {
            const sourceHash = activeLink.dataset.blogSourceHash;
            const historyUrl = sourceHash ? `#${sourceHash}` : window.location.pathname;
            window.history.pushState(
              { mtBlogHub: { sourceHash, url: sourceUrl } },
              '',
              historyUrl
            );
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.assign(sourceUrl);
        } finally {
          if (requestSequence === this.requestSequence) {
            this.resultsInner?.removeAttribute('aria-busy');
          }
        }
      }

      onBlockSelect(event) {
        const blockId = event.detail?.blockId;
        if (!blockId) return;
        const link = this.hubLinks?.find((item) => item.dataset.blogSourceBlockId === blockId);
        if (link) {
          this.loadHubUrl(link.href, link, { pushState: false });
          return;
        }
        const diagnostic = this.hubDiagnostics?.find((item) => item.dataset.blogSourceDiagnostic === blockId);
        if (!diagnostic) return;
        if (this.resultsInner) this.resultsInner.hidden = true;
        this.hubDiagnostics.forEach((item) => {
          item.hidden = item !== diagnostic;
        });
      }
    }

    customElements.define('mt-blog-categories', MtBlogCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-collection-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mt-collection-catalog')) return;

    class MTCollectionCatalog extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.drawer = this.querySelector('[data-mt-filter-drawer]');
        this.panel = this.querySelector('[data-mt-filter-panel]');
        this.sortControl = this.querySelector('[data-mt-sort-control]');
        this.sortSelect = this.querySelector('[data-mt-sort-select]');
        this.sortToggle = this.querySelector('[data-mt-sort-toggle]');
        this.sortMenu = this.querySelector('[data-mt-sort-menu]');
        this.sortOptions = Array.from(this.querySelectorAll('[data-mt-sort-option]'));
        this.priceControls = Array.from(this.querySelectorAll('[data-mt-price-control]'));
        this.lastTrigger = null;
        this.priceTimer = null;
        this.sortCloseTimer = null;
        this.sortFrame = null;
        this.addResetTimers = new Map();
        this.mediaObserver = null;
        this.navigationController = null;
        this.loadMoreController = null;
        this.navigationRequestId = 0;
        this.colorPriority = this.reconcileColorPriority(
          this.pendingColorPriority ?? this.readColorPriorityFromState(),
          this
        );
        delete this.pendingColorPriority;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('input', (event) => this.onInput(event), { signal });
        this.addEventListener('change', (event) => this.onChange(event), { signal });
        this.addEventListener('pointerout', (event) => this.onPointerOut(event), { signal });
        this.addEventListener('submit', (event) => this.onSubmit(event), { signal });
        document.addEventListener('click', (event) => this.onDocumentClick(event), { signal });
        document.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        window.addEventListener('popstate', (event) => {
          this.load(window.location.href, false, false, this.readColorPriorityFromState(event.state));
        }, { signal });
        this.sortProductGrid(this, this.colorPriority);
        this.initializeSortControl();
        this.initializePriceControls();
        this.prepareSecondaryMedia(this);
      }

      disconnectedCallback() {
        const drawerWasOpen = Boolean(this.drawer && !this.drawer.hidden);
        this.abortController?.abort();
        this.navigationController?.abort();
        this.loadMoreController?.abort();
        window.clearTimeout(this.priceTimer);
        window.clearTimeout(this.sortCloseTimer);
        this.addResetTimers.forEach((timer) => window.clearTimeout(timer));
        this.addResetTimers.clear();
        this.mediaObserver?.disconnect();
        if (this.sortFrame) window.cancelAnimationFrame(this.sortFrame);
        if (this.drawer) this.drawer.hidden = true;
        if (drawerWasOpen) document.documentElement.style.removeProperty('overflow');
        this.lastTrigger?.setAttribute('aria-expanded', 'false');
        this.initialized = false;
      }

      normalizeColorText(value) {
        return String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
      }

      colorPriorityKey(item) {
        return `${this.normalizeColorText(item?.param)}\u001f${this.normalizeColorText(item?.value)}`;
      }

      normalizeColorPriority(priority) {
        if (!Array.isArray(priority)) return [];
        const seen = new Set();
        return priority.reduce((items, item) => {
          const normalized = {
            param: String(item?.param || ''),
            value: String(item?.value || '')
          };
          const key = this.colorPriorityKey(normalized);
          if (!normalized.param || !normalized.value || seen.has(key)) return items;
          seen.add(key);
          items.push(normalized);
          return items;
        }, []);
      }

      getActiveColorPriority(scope) {
        const seen = new Set();
        return Array.from(scope.querySelectorAll('[data-mt-color-filter]:checked')).reduce((items, input) => {
          const item = { param: input.name, value: input.dataset.mtColorValue || input.value };
          const key = this.colorPriorityKey(item);
          if (!item.param || !item.value || seen.has(key)) return items;
          seen.add(key);
          items.push(item);
          return items;
        }, []);
      }

      reconcileColorPriority(priority, scope) {
        const active = this.getActiveColorPriority(scope);
        const activeKeys = new Set(active.map((item) => this.colorPriorityKey(item)));
        const reconciled = this.normalizeColorPriority(priority).filter((item) => activeKeys.has(this.colorPriorityKey(item)));
        const knownKeys = new Set(reconciled.map((item) => this.colorPriorityKey(item)));
        active.forEach((item) => {
          const key = this.colorPriorityKey(item);
          if (knownKeys.has(key)) return;
          knownKeys.add(key);
          reconciled.push(item);
        });
        return reconciled;
      }

      updateColorPriority(input) {
        const item = { param: input.name, value: input.dataset.mtColorValue || input.value };
        const key = this.colorPriorityKey(item);
        this.colorPriority = this.normalizeColorPriority(this.colorPriority).filter((entry) => this.colorPriorityKey(entry) !== key);
        if (input.checked && item.param && item.value) this.colorPriority.unshift(item);
      }

      readColorPriorityFromState(state = window.history.state) {
        const priorities = state?.mtCollectionCatalogColorPriority;
        return this.normalizeColorPriority(priorities?.[this.dataset.sectionId]);
      }

      createHistoryState(priority) {
        const state = window.history.state && typeof window.history.state === 'object' ? { ...window.history.state } : {};
        const priorities = state.mtCollectionCatalogColorPriority && typeof state.mtCollectionCatalogColorPriority === 'object'
          ? { ...state.mtCollectionCatalogColorPriority }
          : {};
        priorities[this.dataset.sectionId] = this.normalizeColorPriority(priority);
        state.mtCollectionCatalogColorPriority = priorities;
        return state;
      }

      productColorRank(item, priority) {
        const card = item.querySelector('[data-mt-collection-card]');
        if (!card) return priority.length;
        let colors = [];
        try {
          colors = JSON.parse(card.dataset.mtProductColors || '[]');
        } catch (error) {
          colors = [];
        }
        const normalizedColors = new Set(colors.map((color) => this.normalizeColorText(color)).filter(Boolean));
        const rank = priority.findIndex((entry) => normalizedColors.has(this.normalizeColorText(entry.value)));
        return rank === -1 ? priority.length : rank;
      }

      sortProductGrid(scope, priority = this.colorPriority) {
        const grid = scope.matches?.('[data-mt-product-grid]') ? scope : scope.querySelector('[data-mt-product-grid]');
        const normalizedPriority = this.normalizeColorPriority(priority);
        if (!grid || normalizedPriority.length === 0) return;
        const items = Array.from(grid.children).map((item, index) => {
          const parsedOrder = Number.parseInt(item.dataset.mtCatalogOrder || '', 10);
          return {
            item,
            rank: this.productColorRank(item, normalizedPriority),
            order: Number.isFinite(parsedOrder) ? parsedOrder : index
          };
        });
        items.sort((left, right) => left.rank - right.rank || left.order - right.order);
        grid.append(...items.map(({ item }) => item));
      }

      facetValueKey(input) {
        return `${String(input?.name || '')}\u001f${String(input?.value || '')}`;
      }

      syncPreservedFacetValue(item, requestedUrl) {
        const input = item.querySelector('input[name][value]');
        if (!input) return;
        const selectedValues = requestedUrl.searchParams.getAll(input.name);
        input.checked = selectedValues.includes(input.value);
        input.removeAttribute('disabled');
        item.querySelectorAll('[data-mt-facet-count]').forEach((count) => {
          count.textContent = count.matches('small') ? '0' : '(0)';
        });
      }

      preserveFacetPresentation(sourceItem, targetItem) {
        const sourceSwatch = sourceItem.querySelector('.mt-collection-facets__swatch');
        const targetSwatch = targetItem.querySelector('.mt-collection-facets__swatch');
        if (!sourceSwatch || !targetSwatch) return;
        targetSwatch.setAttribute('style', sourceSwatch.getAttribute('style') || '');
        targetSwatch.title = sourceSwatch.title;
        const sourceInput = sourceItem.querySelector('[data-mt-color-filter]');
        const targetInput = targetItem.querySelector('[data-mt-color-filter]');
        if (sourceInput && targetInput) targetInput.dataset.mtColorValue = sourceInput.dataset.mtColorValue || '';
      }

      preserveFacetValues(sourceGroup, targetGroup, requestedUrl) {
        const sourceList = sourceGroup.querySelector('.mt-collection-facets__values');
        const targetList = targetGroup.querySelector('.mt-collection-facets__values');
        if (!sourceList || !targetList) return;
        const targetItems = new Map();
        Array.from(targetList.children).forEach((item) => {
          const input = item.querySelector('input[name][value]');
          if (input) targetItems.set(this.facetValueKey(input), item);
        });
        const orderedItems = [];
        Array.from(sourceList.children).forEach((sourceItem) => {
          const sourceInput = sourceItem.querySelector('input[name][value]');
          if (!sourceInput) return;
          const key = this.facetValueKey(sourceInput);
          const targetItem = targetItems.get(key);
          if (targetItem) {
            this.preserveFacetPresentation(sourceItem, targetItem);
            orderedItems.push(targetItem);
            targetItems.delete(key);
            return;
          }
          const preservedItem = sourceItem.cloneNode(true);
          this.syncPreservedFacetValue(preservedItem, requestedUrl);
          orderedItems.push(preservedItem);
        });
        orderedItems.push(...targetItems.values());
        targetList.replaceChildren(...orderedItems);
      }

      preserveFacetInventory(replacement, requestedUrl) {
        this.querySelectorAll('[data-mt-facet-form]').forEach((sourceForm) => {
          const mode = sourceForm.dataset.mtFacetMode;
          if (!mode) return;
          const targetForm = replacement.querySelector(`[data-mt-facet-form][data-mt-facet-mode="${CSS.escape(mode)}"]`);
          const sourceContainer = sourceForm.querySelector('.mt-collection-facets__groups');
          const targetContainer = targetForm?.querySelector('.mt-collection-facets__groups');
          if (!targetForm || !sourceContainer || !targetContainer) return;

          const targetGroups = new Map();
          targetContainer.querySelectorAll('[data-mt-list-filter][data-mt-filter-param]').forEach((group) => {
            targetGroups.set(this.normalizeColorText(group.dataset.mtFilterParam), group);
          });

          const sourceChildren = Array.from(sourceContainer.children);
          const sourceGroups = Array.from(sourceContainer.querySelectorAll('[data-mt-list-filter][data-mt-filter-param]'));
          sourceGroups.forEach((sourceGroup) => {
            const key = this.normalizeColorText(sourceGroup.dataset.mtFilterParam);
            let targetGroup = targetGroups.get(key);
            if (!targetGroup) {
              targetGroup = sourceGroup.cloneNode(true);
              targetGroup.querySelectorAll('li').forEach((item) => this.syncPreservedFacetValue(item, requestedUrl));
              const sourceIndex = sourceChildren.indexOf(sourceGroup);
              targetContainer.insertBefore(targetGroup, targetContainer.children[sourceIndex] || null);
              targetGroups.set(key, targetGroup);
            } else {
              targetGroup.open = sourceGroup.open;
              this.preserveFacetValues(sourceGroup, targetGroup, requestedUrl);
            }
          });
        });
      }

      onClick(event) {
        const expandSwatchesButton = event.target.closest('[data-mt-card-expand-swatches]');
        if (expandSwatchesButton) {
          this.expandCardSwatches(expandSwatchesButton);
          return;
        }
        const sortOption = event.target.closest('[data-mt-sort-option]');
        if (sortOption) {
          this.selectSortOption(sortOption);
          return;
        }
        if (event.target.closest('[data-mt-sort-toggle]')) {
          this.toggleSortMenu();
          return;
        }
        const loadMoreLink = event.target.closest('[data-mt-load-more]');
        if (loadMoreLink) {
          event.preventDefault();
          this.loadMore(loadMoreLink);
          return;
        }
        const link = event.target.closest('[data-mt-filter-link]');
        if (link) {
          event.preventDefault();
          this.load(link.href, true, true);
          return;
        }
        const openButton = event.target.closest('[data-mt-open-filters]');
        if (openButton) this.openDrawer(openButton);
        if (event.target.closest('[data-mt-close-filters]')) this.closeDrawer();
      }

      expandCardSwatches(button) {
        const swatches = button.closest('.mt-collection-card__swatches');
        if (!swatches) return;
        const extraSwatches = Array.from(swatches.querySelectorAll('[data-mt-card-swatch-extra]'));
        extraSwatches.forEach((element) => { element.hidden = false; });
        swatches.dataset.expanded = 'true';
        button.setAttribute('aria-expanded', 'true');
        extraSwatches.find((element) => element.matches('[data-mt-card-swatch]'))?.focus();
        button.remove();
      }

      initializeSortControl() {
        if (!this.sortControl || !this.sortSelect || !this.sortToggle || !this.sortMenu || !this.sortOptions.length) return;
        this.sortSelect.tabIndex = -1;
        this.sortSelect.setAttribute('aria-hidden', 'true');
        this.sortToggle.hidden = false;
        this.sortControl.classList.add('is-sort-ready');
      }

      onDocumentClick(event) {
        if (this.isSortMenuOpen() && !this.sortControl?.contains(event.target)) this.closeSortMenu();
      }

      onPointerOut(event) {
        const card = event.target.closest?.('[data-mt-collection-card]');
        if (!card || !card.hasAttribute('data-mt-card-swatch-committed')) return;
        if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) return;
        card.removeAttribute('data-mt-card-swatch-committed');
      }

      isSortMenuOpen() {
        return this.sortToggle?.getAttribute('aria-expanded') === 'true';
      }

      toggleSortMenu() {
        if (this.isSortMenuOpen()) this.closeSortMenu();
        else this.openSortMenu(false);
      }

      openSortMenu(focusOption = false, focusLast = false) {
        if (!this.sortMenu || !this.sortToggle) return;
        window.clearTimeout(this.sortCloseTimer);
        if (this.sortFrame) window.cancelAnimationFrame(this.sortFrame);
        this.sortMenu.hidden = false;
        this.sortToggle.setAttribute('aria-expanded', 'true');
        this.sortFrame = window.requestAnimationFrame(() => {
          this.sortMenu?.classList.add('is-open');
          if (focusOption) {
            const selected = this.sortOptions.find((option) => option.getAttribute('aria-selected') === 'true');
            const target = focusLast ? this.sortOptions[this.sortOptions.length - 1] : (selected || this.sortOptions[0]);
            target?.focus();
          }
          this.sortFrame = null;
        });
      }

      closeSortMenu(restoreFocus = false, immediate = false) {
        if (!this.sortMenu || !this.sortToggle) return;
        if (this.sortFrame) window.cancelAnimationFrame(this.sortFrame);
        this.sortFrame = null;
        this.sortMenu.classList.remove('is-open');
        this.sortToggle.setAttribute('aria-expanded', 'false');
        window.clearTimeout(this.sortCloseTimer);
        const finish = () => {
          if (!this.isSortMenuOpen() && this.sortMenu) this.sortMenu.hidden = true;
          this.sortCloseTimer = null;
        };
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else this.sortCloseTimer = window.setTimeout(finish, 170);
        if (restoreFocus) this.sortToggle.focus();
      }

      selectSortOption(option) {
        if (!this.sortSelect || !option.dataset.value) return;
        this.sortSelect.value = option.dataset.value;
        this.sortOptions.forEach((item) => {
          item.setAttribute('aria-selected', item === option ? 'true' : 'false');
        });
        this.closeSortMenu(true);
        this.sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      initializePriceControls() {
        this.priceControls.forEach((control) => {
          const slider = control.querySelector('[data-mt-price-slider]');
          if (!slider) return;
          this.syncPriceFromFields(control);
          slider.hidden = false;
        });
      }

      onInput(event) {
        const range = event.target.closest('[data-mt-price-range-min], [data-mt-price-range-max]');
        if (range) {
          const control = range.closest('[data-mt-price-control]');
          if (control) this.syncPriceFromRanges(control, range);
          return;
        }

        const field = event.target.closest('[data-mt-price-min], [data-mt-price-max]');
        if (!field) return;
        const control = field.closest('[data-mt-price-control]');
        if (control) this.syncPriceFromFields(control, field);
      }

      getPriceElements(control) {
        return {
          minField: control.querySelector('[data-mt-price-min]'),
          maxField: control.querySelector('[data-mt-price-max]'),
          minRange: control.querySelector('[data-mt-price-range-min]'),
          maxRange: control.querySelector('[data-mt-price-range-max]'),
          progress: control.querySelector('[data-mt-price-progress]')
        };
      }

      getPriceLimit(control) {
        const value = Number.parseFloat(control.dataset.rangeMax || '0');
        return Number.isFinite(value) && value > 0 ? value : 0;
      }

      clampPrice(value, minimum, maximum) {
        return Math.min(Math.max(value, minimum), maximum);
      }

      syncPriceFromFields(control, changedField = null, normalizeFields = false) {
        const { minField, maxField, minRange, maxRange, progress } = this.getPriceElements(control);
        const limit = this.getPriceLimit(control);
        if (!minField || !maxField || !minRange || !maxRange || !progress || limit <= 0) return;

        const parsedMinimum = Number.parseFloat(minField.value);
        const parsedMaximum = Number.parseFloat(maxField.value);
        let minimum = Number.isFinite(parsedMinimum) ? this.clampPrice(parsedMinimum, 0, limit) : 0;
        let maximum = Number.isFinite(parsedMaximum) ? this.clampPrice(parsedMaximum, 0, limit) : limit;

        if (minimum > maximum) {
          if (changedField === minField) maximum = minimum;
          else minimum = maximum;
        }

        minRange.value = String(minimum);
        maxRange.value = String(maximum);
        if (normalizeFields) {
          minField.value = minimum > 0 ? String(minimum) : '';
          maxField.value = maximum < limit ? String(maximum) : '';
        }
        this.updatePriceProgress(progress, minimum, maximum, limit);
      }

      syncPriceFromRanges(control, changedRange) {
        const { minField, maxField, minRange, maxRange, progress } = this.getPriceElements(control);
        const limit = this.getPriceLimit(control);
        if (!minField || !maxField || !minRange || !maxRange || !progress || limit <= 0) return;

        const parsedMinimum = Number.parseFloat(minRange.value);
        const parsedMaximum = Number.parseFloat(maxRange.value);
        let minimum = this.clampPrice(Number.isFinite(parsedMinimum) ? parsedMinimum : 0, 0, limit);
        let maximum = this.clampPrice(Number.isFinite(parsedMaximum) ? parsedMaximum : limit, 0, limit);
        if (minimum > maximum) {
          if (changedRange === minRange) minimum = maximum;
          else maximum = minimum;
        }

        minRange.value = String(minimum);
        maxRange.value = String(maximum);
        minField.value = minimum > 0 ? String(minimum) : '';
        maxField.value = maximum < limit ? String(maximum) : '';
        this.updatePriceProgress(progress, minimum, maximum, limit);
      }

      updatePriceProgress(progress, minimum, maximum, limit) {
        const start = (minimum / limit) * 100;
        const end = (maximum / limit) * 100;
        progress.style.left = `${start}%`;
        progress.style.width = `${Math.max(0, end - start)}%`;
      }

      onChange(event) {
        if (event.target.matches('[data-mt-card-swatch]')) {
          this.selectCardVariant(event.target);
          return;
        }
        if (event.target.matches('[data-mt-sort-select]')) {
          this.submitUrl(event.target.form);
          return;
        }
        if (event.target.matches('[data-mt-color-filter]')) this.updateColorPriority(event.target);
        const priceRange = event.target.closest('[data-mt-price-range-min], [data-mt-price-range-max]');
        if (priceRange) {
          const control = priceRange.closest('[data-mt-price-control]');
          if (control) this.syncPriceFromRanges(control, priceRange);
          const form = priceRange.closest('[data-mt-facet-form][data-auto-submit]');
          if (form) this.submitUrl(form);
          return;
        }
        const form = event.target.closest('[data-mt-facet-form][data-auto-submit]');
        if (!form) return;
        if (event.target.type === 'number') {
          const control = event.target.closest('[data-mt-price-control]');
          if (control) this.syncPriceFromFields(control, event.target, true);
          window.clearTimeout(this.priceTimer);
          this.priceTimer = window.setTimeout(() => this.submitUrl(form), 450);
        } else {
          this.submitUrl(form);
        }
      }

      selectCardVariant(input) {
        const card = input.closest('[data-mt-collection-card]');
        if (!card) return;
        if (card.matches(':hover')) card.setAttribute('data-mt-card-swatch-committed', '');
        this.updateCardMedia(input);
        const variantId = input.dataset.variantId;
        this.syncCardQuickAdd(card, input);
        const target = new URL(card.dataset.productUrl, window.location.origin);
        if (variantId) target.searchParams.set('variant', variantId);
        const variantUrl = `${target.pathname}${target.search}${target.hash}`;
        card.querySelectorAll('[data-mt-card-product-link]').forEach((link) => { link.href = variantUrl; });

        const price = card.querySelector('[data-mt-card-price]');
        const compare = card.querySelector('[data-mt-card-compare]');
        const saving = card.querySelector('[data-mt-card-saving]');
        const badge = card.querySelector('[data-mt-card-badge]');
        if (price) price.textContent = input.dataset.price || '';
        if (compare) {
          compare.textContent = input.dataset.compare || '';
          compare.hidden = !input.dataset.compare;
        }
        if (saving) {
          saving.textContent = input.dataset.saving ? this.dataset.saveLabel.replace('__AMOUNT__', input.dataset.saving) : '';
          saving.hidden = !input.dataset.saving;
        }
        if (badge) {
          const discountLabel = Number(input.dataset.discount) > 0 ? this.dataset.discountLabel.replace('__PERCENT__', input.dataset.discount) : '';
          badge.querySelector('[data-mt-card-badge-label]')?.replaceChildren(discountLabel);
          badge.querySelector('[data-mt-card-badge-sheen-label]')?.replaceChildren(discountLabel);
          badge.hidden = Number(input.dataset.discount) <= 0;
        }
      }

      syncCardQuickAdd(card, input) {
        const variantId = input.dataset.variantId || '';
        const available = input.dataset.available === 'true' && Boolean(variantId);
        const visibleLabel = available ? this.dataset.addToCartLabel : this.dataset.soldOutLabel;

        card.querySelectorAll('[data-mt-card-variant-input]').forEach((variantInput) => {
          variantInput.value = variantId;
        });
        card.querySelectorAll('[data-mt-card-add-button]').forEach((button) => {
          const resetTimer = this.addResetTimers.get(button);
          if (resetTimer) window.clearTimeout(resetTimer);
          this.addResetTimers.delete(button);
          button.classList.remove('is-added');
          button.dataset.variantId = variantId;
          button.disabled = !available;
          button.setAttribute('aria-label', available
            ? (button.dataset.addLabel || visibleLabel)
            : (button.dataset.soldOutLabel || visibleLabel));
        });
        card.querySelectorAll('[data-mt-add-label]').forEach((label) => {
          label.dataset.label = visibleLabel;
          label.querySelector('.mt-collection-card__quick-add-text-fill')?.replaceChildren(visibleLabel);
        });
        card.querySelectorAll('[data-mt-add-status]').forEach((status) => {
          status.textContent = '';
          status.hidden = true;
        });
      }

      updateCardMedia(input) {
        const card = input.closest('[data-mt-collection-card]');
        if (!card) return;
        const template = card.querySelector(`[data-mt-card-media-template="${CSS.escape(input.dataset.variantId || '')}"]`);
        const media = card.querySelector('[data-mt-card-media]');
        if (template && media) {
          media.querySelectorAll('.mt-collection-card__image--secondary').forEach((image) => this.mediaObserver?.unobserve(image));
          media.replaceChildren(template.content.cloneNode(true));
          this.prepareSecondaryMedia(media);
        }
      }

      prepareSecondaryMedia(scope) {
        const images = Array.from(scope.querySelectorAll('.mt-collection-card__image--secondary:not([data-mt-motion-prepared])'));
        if (!images.length) return;
        if (!('IntersectionObserver' in window)) {
          images.forEach((image) => image.decode?.().catch(() => {}));
          return;
        }
        if (!this.mediaObserver) {
          this.mediaObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.decode?.().catch(() => {});
              observer.unobserve(entry.target);
            });
          }, { rootMargin: '240px 0px' });
        }
        images.forEach((image) => {
          image.dataset.mtMotionPrepared = 'true';
          this.mediaObserver.observe(image);
        });
      }

      onSubmit(event) {
        const navigationForm = event.target.closest('[data-mt-facet-form], [data-mt-sort-form]');
        if (navigationForm) {
          event.preventDefault();
          this.submitUrl(navigationForm);
          return;
        }
        const quickAdd = event.target.closest('[data-mt-quick-add]');
        if (quickAdd) this.addToCart(event, quickAdd);
      }

      onKeydown(event) {
        if (this.handleSortKeydown(event)) return;
        if (!this.drawer || this.drawer.hidden) return;
        if (event.key === 'Escape') this.closeDrawer();
        if (event.key !== 'Tab') return;
        const focusable = [...this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleSortKeydown(event) {
        const isToggle = event.target.matches?.('[data-mt-sort-toggle]');
        const option = event.target.closest?.('[data-mt-sort-option]');
        if (!isToggle && !option && !this.isSortMenuOpen()) return false;

        if (event.key === 'Escape' && this.isSortMenuOpen()) {
          event.preventDefault();
          this.closeSortMenu(true);
          return true;
        }

        if (isToggle && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
          event.preventDefault();
          this.openSortMenu(true, event.key === 'ArrowUp');
          return true;
        }

        if (!option) return false;
        const currentIndex = this.sortOptions.indexOf(option);
        let nextIndex = null;
        if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.sortOptions.length;
        if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.sortOptions.length) % this.sortOptions.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.sortOptions.length - 1;
        if (nextIndex !== null) {
          event.preventDefault();
          this.sortOptions[nextIndex]?.focus();
          return true;
        }
        if (event.key === 'Tab') this.closeSortMenu(false, true);
        return false;
      }

      submitUrl(form) {
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (String(value).trim()) params.append(key, value);
        });
        this.load(`${form.action}?${params.toString()}`, true, true);
      }

      async load(url, updateHistory, scrollToSection, requestedPriority = this.colorPriority) {
        const requestedUrl = new URL(url, window.location.origin);
        const sectionUrl = new URL(requestedUrl);
        sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
        const prioritySnapshot = this.normalizeColorPriority(requestedPriority);
        this.navigationController?.abort();
        this.loadMoreController?.abort();
        const navigationController = new AbortController();
        const requestId = ++this.navigationRequestId;
        this.navigationController = navigationController;
        this.setLoading(true);

        try {
          const response = await fetch(sectionUrl, {
            headers: { Accept: 'text/html' },
            signal: navigationController.signal
          });
          if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
          const html = await response.text();
          if (requestId !== this.navigationRequestId) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const replacement = parsed.querySelector('mt-collection-catalog');
          if (!replacement) throw new Error('Collection catalog was not returned.');
          this.preserveFacetInventory(replacement, requestedUrl);
          const nextPriority = this.reconcileColorPriority(prioritySnapshot, replacement);
          this.sortProductGrid(replacement, nextPriority);
          replacement.pendingColorPriority = nextPriority;
          if (updateHistory) window.history.pushState(this.createHistoryState(nextPriority), '', requestedUrl);
          this.replaceWith(replacement);
          if (scrollToSection) {
            window.scrollTo({
              top: replacement.getBoundingClientRect().top + window.scrollY - 110,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        } catch (error) {
          if (error.name === 'AbortError' || requestId !== this.navigationRequestId) return;
          window.location.assign(requestedUrl);
        } finally {
          if (requestId === this.navigationRequestId) {
            this.navigationController = null;
            if (this.isConnected) this.setLoading(false);
          }
        }
      }

      async loadMore(link) {
        if (this.classList.contains('is-loading-more')) return;
        const grid = this.querySelector('[data-mt-product-grid]');
        const status = this.querySelector('[data-mt-load-more-status]');
        const label = link.querySelector('[data-mt-load-more-label]');
        if (!grid || !label) {
          window.location.assign(link.href);
          return;
        }

        const originalLabel = label.textContent;
        const loadMoreController = new AbortController();
        this.loadMoreController = loadMoreController;
        this.classList.add('is-loading-more');
        grid.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        label.textContent = this.dataset.loadingMoreLabel;

        try {
          const requestedUrl = new URL(link.href, window.location.origin);
          const sectionUrl = new URL(requestedUrl);
          sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(sectionUrl, {
            headers: { Accept: 'text/html' },
            signal: loadMoreController.signal
          });
          if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const replacement = parsed.querySelector('mt-collection-catalog');
          const nextGrid = replacement?.querySelector('[data-mt-product-grid]');
          if (!replacement || !nextGrid) throw new Error('Collection products were not returned.');

          const newItems = [...nextGrid.children].map((item) => document.importNode(item, true));
          grid.append(...newItems);
          this.sortProductGrid(grid, this.colorPriority);
          this.prepareSecondaryMedia(grid);
          const nextLink = replacement.querySelector('[data-mt-load-more]');
          if (nextLink) {
            link.href = nextLink.getAttribute('href');
            label.textContent = originalLabel;
            link.removeAttribute('aria-disabled');
          } else {
            link.remove();
          }
          if (status) status.textContent = this.dataset.loadedMoreLabel.replace('__COUNT__', String(newItems.length));
        } catch (error) {
          if (error.name === 'AbortError') return;
          label.textContent = originalLabel;
          link.removeAttribute('aria-disabled');
          if (status) status.textContent = this.dataset.loadMoreErrorLabel;
        } finally {
          if (this.loadMoreController === loadMoreController) this.loadMoreController = null;
          grid.setAttribute('aria-busy', 'false');
          this.classList.remove('is-loading-more');
        }
      }

      setLoading(loading) {
        this.classList.toggle('is-loading', loading);
        this.querySelector('[data-mt-results]')?.setAttribute('aria-busy', String(loading));
        const progress = this.querySelector('[data-mt-loading]');
        if (progress) progress.hidden = !loading;
      }

      openDrawer(trigger) {
        if (!this.drawer || !this.panel) return;
        this.lastTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        this.drawer.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        this.panel.focus();
      }

      closeDrawer() {
        if (!this.drawer) return;
        this.drawer.hidden = true;
        document.documentElement.style.removeProperty('overflow');
        this.lastTrigger?.setAttribute('aria-expanded', 'false');
        this.lastTrigger?.focus();
      }

      async addToCart(event, form) {
        event.preventDefault();
        const button = form.querySelector('[data-mt-card-add-button]');
        const status = form.querySelector('[data-mt-add-status]');
        if (!button || button.disabled) return;
        const card = form.closest('[data-mt-collection-card]');
        const cardButtons = card
          ? Array.from(card.querySelectorAll('[data-mt-card-add-button]'))
          : [button];
        const currentReset = this.addResetTimers.get(button);
        if (currentReset) window.clearTimeout(currentReset);
        this.addResetTimers.delete(button);
        button.classList.remove('is-added');
        cardButtons.forEach((cardButton) => { cardButton.disabled = true; });

        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorLabel);
          const cartResponse = await fetch(this.dataset.cartUrl || '/cart.js', { headers: { Accept: 'application/json' } });
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          status.textContent = this.dataset.addedLabel;
          status.hidden = false;
          if (button.querySelector('.mt-collection-card__quick-add-swap')) {
            button.classList.add('is-added');
            const resetTimer = window.setTimeout(() => {
              button.classList.remove('is-added');
              this.addResetTimers.delete(button);
            }, 1600);
            this.addResetTimers.set(button, resetTimer);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', cart } }));
        } catch (error) {
          status.textContent = error.message || this.dataset.errorLabel;
          status.hidden = false;
        } finally {
          const selectedSwatch = card?.querySelector('[data-mt-card-swatch]:checked');
          const canAdd = !selectedSwatch
            || (selectedSwatch.dataset.available === 'true' && Boolean(selectedSwatch.dataset.variantId));
          cardButtons.forEach((cardButton) => { cardButton.disabled = !canAdd; });
        }
      }
    }

    customElements.define('mt-collection-catalog', MTCollectionCatalog);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-collection-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mt-collection-faq')) return;

    class MTCollectionFaq extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.itemAnimations = new Map();
        this.abortController = new AbortController();
        this.addEventListener('click', (event) => this.onClick(event), {
          signal: this.abortController.signal
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.itemAnimations?.forEach((state, item) => {
          state.leader.onfinish = null;
          item.open = state.shouldOpen;
          item.removeAttribute('data-closing');
          state.animations.forEach((animation) => animation.cancel());
        });
        this.itemAnimations?.clear();
        this.initialized = false;
      }

      onClick(event) {
        const summary = event.target.closest?.('summary');
        const item = summary?.closest('.mt-collection-faq__item');
        if (!item || !this.contains(item)) return;
        event.preventDefault();

        const shouldOpen = !item.open || item.dataset.closing === 'true';
        this.setItemOpen(item, shouldOpen);
      }

      setItemOpen(item, shouldOpen) {
        const answer = item.querySelector('.mt-collection-faq__answer');
        const background = item.querySelector('.mt-collection-faq__active-background');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const activeState = this.itemAnimations.get(item);

        if (!answer || !background || reducedMotion || typeof answer.animate !== 'function') {
          if (activeState) {
            activeState.leader.onfinish = null;
            activeState.animations.forEach((animation) => animation.cancel());
          }
          this.itemAnimations.delete(item);
          item.removeAttribute('data-closing');
          item.open = shouldOpen;
          return;
        }

        if (activeState) {
          activeState.shouldOpen = shouldOpen;
          item.toggleAttribute('data-closing', !shouldOpen);
          activeState.animations.forEach((animation) => {
            animation.playbackRate = shouldOpen ? 1 : -1;
            animation.play();
          });
          return;
        }

        if (!shouldOpen && !item.open) return;

        const items = Array.from(this.querySelectorAll('.mt-collection-faq__item'));
        const itemIndex = items.indexOf(item);
        const affectedItems = items.slice(Math.max(0, itemIndex));
        const expandedRects = new Map();
        const collapsedRects = new Map();

        if (shouldOpen) {
          affectedItems.forEach((affectedItem) => collapsedRects.set(affectedItem, affectedItem.getBoundingClientRect()));
          item.open = true;
          affectedItems.forEach((affectedItem) => expandedRects.set(affectedItem, affectedItem.getBoundingClientRect()));
        } else {
          affectedItems.forEach((affectedItem) => expandedRects.set(affectedItem, affectedItem.getBoundingClientRect()));
          item.open = false;
          affectedItems.forEach((affectedItem) => collapsedRects.set(affectedItem, affectedItem.getBoundingClientRect()));
          item.open = true;
        }

        item.toggleAttribute('data-closing', !shouldOpen);

        const duration = 220;
        const easing = 'cubic-bezier(.22, 1, .36, 1)';
        const expandedHeight = expandedRects.get(item)?.height || item.getBoundingClientRect().height;
        const collapsedHeight = collapsedRects.get(item)?.height || expandedHeight;
        const collapsedScale = Math.max(.08, Math.min(1, collapsedHeight / expandedHeight));
        const animations = [];

        animations.push(background.animate(
          [
            { opacity: 0, transform: `scaleY(${collapsedScale})` },
            { opacity: 1, transform: 'scaleY(1)' }
          ],
          { duration, easing, fill: 'both' }
        ));
        animations.push(answer.animate(
          [
            { opacity: 0, transform: 'translateY(-10px) scaleY(.96)' },
            { opacity: 1, transform: 'translateY(0) scaleY(1)' }
          ],
          { duration, easing, fill: 'both' }
        ));

        affectedItems.slice(1).forEach((affectedItem) => {
          const expandedTop = expandedRects.get(affectedItem)?.top;
          const collapsedTop = collapsedRects.get(affectedItem)?.top;
          const offset = collapsedTop - expandedTop;
          if (!Number.isFinite(offset) || Math.abs(offset) < .5) return;
          animations.push(affectedItem.animate(
            [
              { transform: `translateY(${offset}px)`, composite: 'add' },
              { transform: 'translateY(0)', composite: 'add' }
            ],
            { duration, easing, fill: 'both' }
          ));
        });

        animations.forEach((animation) => {
          animation.pause();
          animation.currentTime = shouldOpen ? 0 : duration;
          animation.playbackRate = shouldOpen ? 1 : -1;
        });

        const state = { animations, leader: animations[0], shouldOpen };
        this.itemAnimations.set(item, state);
        state.leader.onfinish = () => {
          if (this.itemAnimations.get(item) !== state) return;
          if (!state.shouldOpen) item.open = false;
          item.removeAttribute('data-closing');
          state.animations.forEach((animation) => animation.cancel());
          this.itemAnimations.delete(item);
        };
        animations.forEach((animation) => animation.play());
      }
    }

    customElements.define('mt-collection-faq', MTCollectionFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-collection-story"] && !Shopify.designMode) return;
  try {
    
  class MtCollectionStoryGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-collection-story-slide]'));
      this.controls = Array.from(this.querySelectorAll('[data-collection-story-select]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
      this.onClick = this.onClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onPointerCancel = this.onPointerCancel.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerCancel);
      this.syncMedia();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerCancel);
      this.pointerStart = undefined;
      this.initialized = false;
    }

    onClick(event) {
      const control = event.target.closest('[data-collection-story-select]');
      if (!control || !this.contains(control)) return;
      this.show(Number(control.dataset.collectionStorySelect));
    }

    onKeyDown(event) {
      const control = event.target.closest('[data-collection-story-select]');
      if (!control || !this.contains(control)) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      this.controls[this.index]?.focus();
    }

    onPointerDown(event) {
      if (this.slides.length < 2 || event.pointerType !== 'touch' || !event.isPrimary) return;
      if (event.target.closest('[data-collection-story-select]')) return;
      this.pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }

    onPointerUp(event) {
      if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
      const deltaX = event.clientX - this.pointerStart.x;
      const deltaY = event.clientY - this.pointerStart.y;
      this.pointerStart = undefined;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      this.show(this.index + (deltaX < 0 ? 1 : -1));
    }

    onPointerCancel() {
      this.pointerStart = undefined;
    }

    show(index) {
      if (!this.slides.length || !Number.isFinite(index)) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== this.index;
      });
      this.controls.forEach((control, controlIndex) => {
        control.setAttribute('aria-current', String(controlIndex === this.index));
      });
      this.syncMedia();
    }

    syncMedia() {
      this.slides.forEach((slide, slideIndex) => {
        slide.querySelector('mt-collection-story-media')?.setSlideActive(slideIndex === this.index);
      });
    }
  }

  class MtCollectionStoryMedia extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.content = this.querySelector('[data-collection-story-media-content]');
      this.template = this.querySelector('[data-collection-story-video-template]');
      this.slideActive = !this.closest('[data-collection-story-slide]')?.hidden;
      this.motionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      this.handleMotionChange = this.handleMotionChange || (() => this.syncMotionPreference());
      this.motionQuery?.addEventListener('change', this.handleMotionChange);
      if (this.hydrated) {
        this.watchPlayback();
        return;
      }
      if (!this.content || !this.template) return;

      if (!('IntersectionObserver' in window)) {
        this.hydrate();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.hydrate();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.playbackObserver?.disconnect();
      this.motionQuery?.removeEventListener('change', this.handleMotionChange);
      const video = this.querySelector('video');
      if (video && !video.paused) {
        this.ignoreNextPause = true;
        video.pause();
      }
      this.isPlaybackVisible = false;
      this.initialized = false;
    }

    hydrate() {
      if (this.hydrated) return;

      this.hydrated = true;
      this.observer?.disconnect();
      const fragment = this.template.content.cloneNode(true);
      const video = fragment.querySelector('video');
      this.userPaused = false;
      this.isPlaybackVisible = false;

      if (video && this.motionQuery?.matches) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.controls = true;
      }

      this.content.replaceChildren(fragment);
      video?.addEventListener('pause', () => {
        if (this.ignoreNextPause) {
          this.ignoreNextPause = false;
          return;
        }
        if (!video.ended) this.userPaused = true;
      });
      video?.addEventListener('play', () => {
        this.userPaused = false;
      });

      this.watchPlayback();
    }

    watchPlayback() {
      this.playbackObserver?.disconnect();
      this.isPlaybackVisible = false;
      if ('IntersectionObserver' in window) {
        this.playbackObserver = new IntersectionObserver((entries) => {
          this.isPlaybackVisible = entries.some((entry) => entry.isIntersecting);
          this.syncMotionPreference();
        }, { threshold: 0.1 });
        this.playbackObserver.observe(this);
      } else {
        this.isPlaybackVisible = true;
      }

      this.syncMotionPreference();
    }

    setSlideActive(active) {
      this.slideActive = active;
      this.syncMotionPreference();
    }

    syncMotionPreference() {
      const video = this.querySelector('video');
      if (!video) return;

      if (this.motionQuery?.matches || !this.isPlaybackVisible || !this.slideActive || this.userPaused) {
        video.autoplay = false;
        if (!video.paused) {
          this.ignoreNextPause = true;
          video.pause();
        }
        return;
      }

      video.autoplay = true;
      video.play().catch(() => {});
    }
  }

  if (!customElements.get('mt-collection-story-media')) {
    customElements.define('mt-collection-story-media', MtCollectionStoryMedia);
  }
  if (!customElements.get('mt-collection-story-gallery')) {
    customElements.define('mt-collection-story-gallery', MtCollectionStoryGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-contact-benefits"] && !Shopify.designMode) return;
  try {
    
  class MtContactBenefits extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.list = this.querySelector('[data-contact-benefits-list]');
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.measure = this.measure.bind(this);
      this.addEventListener('click', this.onClick);
      this.list?.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.measure, { passive: true });
      this.measure();
      this.updateDots();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.list?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.measure);
      this.initialized = false;
    }
    measure() {
      const first = this.list?.children[0];
      const next = this.list?.children[1];
      this.step = first && next ? next.offsetLeft - first.offsetLeft : this.list?.clientWidth || 1;
      this.updateDots();
    }
    onClick(event) {
      const dot = event.target.closest('[data-contact-benefits-dot]');
      if (dot) this.list?.children[Number(dot.dataset.contactBenefitsDot)]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
    }
    onScroll() { requestAnimationFrame(() => this.updateDots()); }
    updateDots() {
      if (!this.list) return;
      const index = Math.round(this.list.scrollLeft / Math.max(1, this.step || this.list.clientWidth));
      this.querySelectorAll('[data-contact-benefits-dot]').forEach((dot) => { const active = Number(dot.dataset.contactBenefitsDot) === index; dot.classList.toggle('is-active', active); dot.setAttribute('aria-current', String(active)); });
    }
  }
  if (!customElements.get('mt-contact-benefits')) customElements.define('mt-contact-benefits', MtContactBenefits);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-contact-help"] && !Shopify.designMode) return;
  try {
    
  class MtContactHelp extends HTMLElement { connectedCallback() { if (this.initialized) return; this.initialized = true; this.list = this.querySelector('[data-contact-help-list]'); this.onClick = this.onClick.bind(this); this.onScroll = this.onScroll.bind(this); this.addEventListener('click', this.onClick); this.list?.addEventListener('scroll', this.onScroll, { passive: true }); this.updateDots(); } disconnectedCallback() { this.removeEventListener('click', this.onClick); this.list?.removeEventListener('scroll', this.onScroll); this.initialized = false; } onClick(event) { const dot = event.target.closest('[data-contact-help-dot]'); if (dot) { this.list?.children[Number(dot.dataset.contactHelpDot)]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline: 'start', block: 'nearest' }); return; } if (event.target.closest('[data-contact-live-chat]')) window.tidioChatApi?.open?.(); } onScroll() { requestAnimationFrame(() => this.updateDots()); } updateDots() { if (!this.list) return; const index = Math.round(this.list.scrollLeft / Math.max(1, this.list.clientWidth)); this.querySelectorAll('[data-contact-help-dot]').forEach((dot) => { const active = Number(dot.dataset.contactHelpDot) === index; dot.classList.toggle('is-active', active); dot.setAttribute('aria-current', String(active)); }); } } if (!customElements.get('mt-contact-help')) customElements.define('mt-contact-help', MtContactHelp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-feature-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MtFeaturedCollection extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.quickBuy=this.querySelector('[data-quick-buy]'); this.drawer=this.querySelector('[data-quick-buy-drawer]'); this.content=this.querySelector('[data-quick-content]'); this.request=null; this.trigger=null; this.product=null; this.closeTimer=null; this.collapsedOptions=new Set();
        this.click=(event)=>this.onClick(event); this.change=(event)=>this.onChange(event); this.submit=(event)=>this.onSubmit(event); this.scroll=(event)=>{if(event.target.matches?.('[data-product-viewport]'))this.updateControls(event.target);}; this.key=(event)=>{ if (!this.quickBuy || this.quickBuy.hidden) return; if (event.key === 'Escape') this.close(); else if (event.key === 'Tab') this.trapFocus(event); };
        this.addEventListener('click',this.click); this.addEventListener('change',this.change); this.addEventListener('submit',this.submit); this.addEventListener('scroll',this.scroll,true); document.addEventListener('keydown',this.key); this.querySelectorAll('[data-product-viewport]').forEach((viewport)=>this.updateControls(viewport)); this.ready=true;
      }
      disconnectedCallback(){ this.removeEventListener('click',this.click); this.removeEventListener('change',this.change); this.removeEventListener('submit',this.submit); this.removeEventListener('scroll',this.scroll,true); document.removeEventListener('keydown',this.key); this.abort();clearTimeout(this.closeTimer);this.closeTimer=null; this.ready=false; }
      onClick(event){ const tab=event.target.closest('[data-tab-target]'); if(tab){this.tabs(tab);return;} const optionToggle=event.target.closest('[data-mt-quick-option-toggle]');if(optionToggle){this.toggleQuickOption(optionToggle);return;} const trigger=event.target.closest('[data-open-quick-buy]'); if(trigger){if(!trigger.disabled)this.open(trigger);return;} if(event.target.closest('[data-close-quick-buy]'))this.close(); }
      onChange(event){ if(event.target.matches('[data-card-swatch]'))this.cardVariant(event.target); else if(event.target.matches('[data-mt-quick-option]')){const current=event.target.closest('[data-mt-quick-option-group]')?.querySelector('[data-mt-quick-option-current]');if(current)current.textContent=event.target.value;this.quickVariant(event.target);} }
      onSubmit(event){ const form=event.target.closest('.mt-fc-quick-buy__form'); if(form&&event.submitter?.matches('[data-mt-quick-buy-add]'))this.add(event,form); }
      tabs(tab){ this.querySelectorAll('[role="tab"]').forEach((item)=>{const active=item===tab;item.classList.toggle('is-selected',active);item.setAttribute('aria-selected',active);}); this.querySelectorAll('[data-product-panel]').forEach((panel)=>{const active=panel.id===tab.dataset.tabTarget;panel.hidden=!active;panel.classList.toggle('is-active',active);if(active)this.updateControls(panel.querySelector('[data-product-viewport]'));}); }
      data(card){ try{return JSON.parse(card.querySelector('[data-product-json]')?.textContent||'');}catch{return null;} }
      cardVariant(input){ const card=input.closest('[data-product-card]'),product=card&&this.data(card),variant=product?.variants.find((item)=>String(item.id)===String(input.dataset.cardVariantId)); if(!variant)return; product.selectedVariantId=String(variant.id);card.dataset.selectedVariantId=variant.id;card.querySelector('[data-product-json]').textContent=JSON.stringify(product);const tpl=card.querySelector(`[data-card-variant-media-template="${CSS.escape(String(variant.id))}"]`);if(tpl)card.querySelector('[data-card-media]').replaceChildren(tpl.content.cloneNode(true));const url=this.url(product.url,variant.id);card.querySelectorAll('[data-card-product-link]').forEach((link)=>link.href=url);const price=card.querySelector('[data-card-price-current]'),compare=card.querySelector('[data-card-compare-price]'),saving=card.querySelector('[data-card-saving-badge]');if(price)price.textContent=variant.price;if(compare){compare.hidden=!variant.comparePrice;compare.textContent=variant.comparePrice||'';}if(saving){saving.hidden=!variant.savingLabel;saving.textContent=variant.savingLabel||'';}card.querySelectorAll('[data-open-quick-buy]').forEach((button)=>{button.disabled=!variant.available;button.setAttribute('aria-disabled',!variant.available);const label=button.querySelector('[data-card-quick-buy-label]');if(label)label.textContent=variant.available?this.dataset.stringAdd:this.dataset.stringSoldOut;}); }
      open(trigger){ const card=trigger.closest('[data-product-card]'),product=card&&this.data(card);if(!product){const link=card?.querySelector('[data-card-product-link]')?.href;if(link)location.assign(link);return;}clearTimeout(this.closeTimer);this.closeTimer=null;this.product=product;this.trigger=trigger;this.collapsedOptions.clear();trigger.setAttribute('aria-expanded','true');this.quickBuy.hidden=false;document.documentElement.style.overflow='hidden';requestAnimationFrame(()=>{this.quickBuy.classList.add('is-open');this.drawer.focus();});this.load(product,product.selectedVariantId,false).catch((error)=>{if(error.name!=='AbortError')location.assign(this.url(product.url,product.selectedVariantId));}); }
      async load(product,id,preserve=false,focusOptionIndex=null){ this.abort();const controller=new AbortController();this.request=controller;this.loading(preserve);const url=new URL(product.url,location.origin);url.searchParams.set('view','quick-buy');url.searchParams.set('variant',id);const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});if(!response.ok)throw Error('quick-buy');const documentNode=new DOMParser().parseFromString(await response.text(),'text/html'),fragment=documentNode.querySelector('[data-mt-quick-buy-content]');if(!fragment)throw Error('quick-buy');if(controller.signal.aborted)return;this.content.replaceChildren(...[...fragment.childNodes].map((node)=>document.importNode(node,true)));this.restoreQuickOptions();this.updateQuickAvailability();window.Shopify?.PaymentButton?.init?.();this.content.classList.remove('is-loading');this.content.setAttribute('aria-busy','false');product.selectedVariantId=String(id);if(focusOptionIndex!==null)this.content.querySelector(`[data-mt-quick-option][data-option-index="${CSS.escape(String(focusOptionIndex))}"]:checked`)?.focus({preventScroll:true});if(this.request===controller)this.request=null; }
      loading(preserve){ if(!preserve||!this.content.querySelector('[data-mt-quick-buy-content]')){const message=document.createElement('p');message.className='mt-fc-quick-buy__loading';message.textContent=this.dataset.stringLoading;this.content.replaceChildren(message);}this.content.classList.add('is-loading');this.content.setAttribute('aria-busy','true'); }
      toggleQuickOption(button){const group=button.closest('[data-mt-quick-option-group]'),values=group?.querySelector('[data-mt-quick-option-values]'),key=group?.dataset.optionIndex;if(!group||!values||key===undefined)return;const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));values.hidden=expanded;if(expanded)this.collapsedOptions.add(key);else this.collapsedOptions.delete(key);}
      restoreQuickOptions(){this.content.querySelectorAll('[data-mt-quick-option-group]').forEach((group)=>{const collapsed=this.collapsedOptions.has(group.dataset.optionIndex),button=group.querySelector('[data-mt-quick-option-toggle]'),values=group.querySelector('[data-mt-quick-option-values]');if(button)button.setAttribute('aria-expanded',String(!collapsed));if(values)values.hidden=collapsed;});}
      quickVariants(){try{return JSON.parse(this.content.querySelector('[data-mt-quick-variants]')?.textContent||'[]');}catch{return [];} }
      updateQuickAvailability(variants=this.quickVariants()){
        const selected=[...this.content.querySelectorAll('[data-mt-quick-option]:checked')].reduce((values,item)=>{values[Number(item.dataset.optionIndex)]=item.value;return values;},[]);
        this.content.querySelectorAll('[data-mt-quick-option]').forEach((input)=>{
          const index=Number(input.dataset.optionIndex);
          // A real sold-out variant remains selectable so its product state can be shown; only impossible combinations are disabled.
          const exists=variants.some((variant)=>variant.options[index]===input.value&&variant.options.every((value,optionIndex)=>optionIndex===index||selected[optionIndex]===undefined||value===selected[optionIndex]));
          input.disabled=!exists;
          input.toggleAttribute('aria-disabled',!exists);
        });
      }
      quickVariant(input){ const variants=this.quickVariants(),values=[...this.content.querySelectorAll('[data-mt-quick-option]:checked')].sort((a,b)=>a.dataset.optionIndex-b.dataset.optionIndex).map((item)=>item.value),variant=variants.find((item)=>item.options.length===values.length&&item.options.every((value,index)=>value===values[index]));this.updateQuickAvailability(variants);if(!variant){const button=this.content.querySelector('[data-mt-quick-buy-add]'),label=this.content.querySelector('[data-mt-quick-buy-label]');if(button)button.disabled=true;if(label)label.textContent=this.dataset.stringUnavailable;return;}this.load(this.product,variant.id,true,input?.dataset.optionIndex??null).catch((error)=>{if(error.name!=='AbortError')location.assign(this.url(this.product.url,variant.id));}); }
      async add(event,form){ event.preventDefault();const button=event.submitter,id=form.querySelector('[data-mt-quick-variant-id]')?.value,status=form.querySelector('[data-mt-quick-status]');if(!id||button.disabled)return;button.disabled=true;try{const response=await fetch(this.dataset.cartAddUrl||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity:1})}),payload=await response.json();if(!response.ok)throw Error(payload.description||payload.message||this.dataset.stringUnavailable);document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'mt-featured-collection'}}));this.close();}catch(error){if(status){status.textContent=error.message;status.classList.add('is-error');status.hidden=false;}button.disabled=false;} }
      close(){ if(this.quickBuy.hidden)return;this.abort();clearTimeout(this.closeTimer);const trigger=this.trigger;this.quickBuy.classList.remove('is-open');trigger?.setAttribute('aria-expanded','false');document.documentElement.style.removeProperty('overflow');const finish=()=>{this.quickBuy.hidden=true;requestAnimationFrame(()=>{if(!this.quickBuy.hidden)return;trigger?.focus({preventScroll:true});if(this.trigger===trigger)this.trigger=null;});this.closeTimer=null;};if(matchMedia('(prefers-reduced-motion: reduce)').matches)finish();else this.closeTimer=setTimeout(finish,260); }
      updateControls(viewport){if(!viewport)return;const panel=viewport.closest('[data-product-panel]'),progress=viewport.scrollWidth===0?1:Math.min(1,(viewport.scrollLeft+viewport.clientWidth)/viewport.scrollWidth),progressBar=panel?.querySelector('[data-scroll-progress]');if(progressBar)progressBar.style.setProperty('--mt-fc-progress',Math.max(.08,progress));}
      trapFocus(event){ const items=[...this.drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((item)=>item.offsetParent!==null);if(!items.length){event.preventDefault();this.drawer.focus();return;}const first=items[0],last=items.at(-1);if(!this.drawer.contains(document.activeElement)||document.activeElement===this.drawer){event.preventDefault();(event.shiftKey?last:first).focus();}else if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();} }
      abort(){this.request?.abort();this.request=null;}
      url(url,id){const target=new URL(url,location.origin);target.searchParams.set('variant',id);return target.pathname+target.search+target.hash;}
    }
    if(!customElements.get('mt-featured-collection'))customElements.define('mt-featured-collection',MtFeaturedCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mt-footer-reveal')) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    class MtFooterReveal extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.footer = this.querySelector('[data-mt-footer-surface]');
        this.content = this.querySelector('[data-mt-footer-content]');
        this.section = this.closest('.mt-footer-section') || this.closest('.shopify-section');
        if (!this.footer || !this.content) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.scrollResponseRate = -Math.log(1 - 0.115) * 60;
        this.scrollMinimumDuration = 0.5;
        this.scrollPositionEpsilon = 0.4;
        this.scrollCollapseReleaseProgress = 0.8;
        this.scrollCurrent = window.scrollY;
        this.scrollTarget = this.scrollCurrent;
        this.scrollFrameTime = 0;
        this.scrollBounds = null;
        this.revealBounds = null;
        this.scrollMinimum = this.scrollCurrent;
        this.scrollFrame = 0;
        this.scrollDirection = 0;
        this.onScroll = this.requestUpdate.bind(this);
        this.onWheel = this.handleWheel.bind(this);
        this.onResize = this.requestResize.bind(this);
        this.onMotionChange = this.configureMotion.bind(this);
        this.motionQuery.addEventListener?.('change', this.onMotionChange);
        window.addEventListener('resize', this.onResize, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.footer);
        }
        this.setupMicroInteractions();
        this.configureMotion();
      }

      disconnectedCallback() {
        this.stopTracking();
        window.removeEventListener('resize', this.onResize);
        this.motionQuery?.removeEventListener?.('change', this.onMotionChange);
        this.resizeObserver?.disconnect();
        this.microInteractionController?.abort();
        window.cancelAnimationFrame(this.updateFrame || 0);
        this.updateFrame = 0;
        this.stopRevealScroll();
        window.clearTimeout(this.motionRestTimer || 0);
        this.section?.removeAttribute('data-mt-footer-fixed');
        this.section?.style.removeProperty('--mt-footer-stage-height');
        this.removeAttribute('data-mt-footer-enhanced');
        this.removeAttribute('data-mt-footer-active');
        this.initialized = false;
      }

      setupMicroInteractions() {
        this.microInteractionController = new AbortController();
        const { signal } = this.microInteractionController;
        this.querySelectorAll('.mt-footer__form').forEach((form) => {
          form.addEventListener('submit', () => {
            const button = form.querySelector('.mt-footer__submit');
            if (button && form.checkValidity()) button.classList.add('is-submitting');
          }, { signal });
        });
      }

      configureMotion() {
        if (this.motionQuery.matches) {
          this.stopTracking();
          window.cancelAnimationFrame(this.updateFrame || 0);
          this.updateFrame = 0;
          window.clearTimeout(this.motionRestTimer || 0);
          this.motionRestTimer = 0;
          this.section?.removeAttribute('data-mt-footer-fixed');
          this.section?.style.removeProperty('--mt-footer-stage-height');
          this.fixed = false;
          this.removeAttribute('data-mt-footer-enhanced');
          this.removeAttribute('data-mt-footer-active');
          this.style.removeProperty('--mt-footer-reveal-y');
          this.style.removeProperty('--mt-footer-reveal-opacity');
          this.style.removeProperty('--mt-footer-logo-scale');
          this.style.removeProperty('--mt-footer-content-lag-y');
          this.style.removeProperty('--mt-footer-bottom-lag-y');
          return;
        }
        this.setAttribute('data-mt-footer-enhanced', '');
        this.updateMode();
        this.startTracking();
        this.updateProgress();
      }

      startTracking() {
        if (this.tracking) return;
        this.tracking = true;
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.syncWheelTracking();
      }

      stopTracking() {
        if (!this.tracking) return;
        this.tracking = false;
        window.removeEventListener('scroll', this.onScroll);
        if (this.wheelTracking) {
          window.removeEventListener('wheel', this.onWheel);
          this.wheelTracking = false;
        }
        this.stopRevealScroll();
      }

      requestUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = window.requestAnimationFrame(() => {
          this.updateFrame = 0;
          this.updateProgress();
        });
      }

      requestResize() {
        this.updateMode();
        this.syncWheelTracking();
        this.refreshRevealScrollBounds();
        if (!this.fixed) this.stopRevealScroll();
        if (!this.motionQuery.matches) this.updateProgress();
      }

      updateMode() {
        const footerHeight = this.footer.getBoundingClientRect().height;
        const viewportHeight = window.innerHeight;
        const followingVisibleSection = this.section?.nextElementSibling?.getBoundingClientRect().height > 0;
        this.footerHeight = Math.max(1, footerHeight);
        this.fixed = Boolean(
          this.section &&
          !this.motionQuery.matches &&
          !followingVisibleSection &&
          footerHeight <= viewportHeight
        );
        if (this.fixed) {
          this.section.style.setProperty('--mt-footer-stage-height', `${this.footerHeight.toFixed(2)}px`);
          this.section.setAttribute('data-mt-footer-fixed', '');
        } else {
          this.section?.removeAttribute('data-mt-footer-fixed');
          this.section?.style.removeProperty('--mt-footer-stage-height');
          this.revealBounds = null;
        }
      }

      updateProgress() {
        if (!this.footer || this.motionQuery.matches) return;
        const viewportHeight = window.innerHeight;
        let progress;
        if (this.fixed) {
          const stageTop = this.section.getBoundingClientRect().top;
          this.cacheRevealScrollBounds(window.scrollY + stageTop);
          progress = clamp((viewportHeight - stageTop) / this.footerHeight, 0, 1);
        } else {
          const footerTop = this.footer.getBoundingClientRect().top;
          progress = clamp((viewportHeight - footerTop) / this.footerHeight, 0, 1);
        }
        const remainingProgress = 1 - progress;
        this.style.setProperty('--mt-footer-reveal-y', `${(remainingProgress * 170).toFixed(2)}px`);
        this.style.setProperty('--mt-footer-reveal-opacity', Math.min(1, 0.4 + progress * 1.2).toFixed(3));
        const logoScale = 0.9 + progress * 0.1;
        this.style.setProperty('--mt-footer-logo-scale', logoScale.toFixed(4));
        this.style.setProperty('--mt-footer-content-lag-y', `${(remainingProgress * 14).toFixed(2)}px`);
        this.style.setProperty('--mt-footer-bottom-lag-y', `${(remainingProgress * 20).toFixed(2)}px`);
        this.setAttribute('data-mt-footer-active', '');
        window.clearTimeout(this.motionRestTimer || 0);
        this.motionRestTimer = window.setTimeout(() => {
          this.motionRestTimer = 0;
          this.removeAttribute('data-mt-footer-active');
        }, 450);
      }

      handleWheel(event) {
        if (
          !this.fixed ||
          this.motionQuery.matches ||
          event.defaultPrevented ||
          event.ctrlKey
        ) return;

        const delta = this.normalizeWheelDelta(event);
        if (!delta) return;

        const bounds = this.refreshRevealScrollBounds();
        const currentScroll = window.scrollY;
        const projectedScroll = currentScroll + delta;
        const direction = delta > 0 ? 1 : -1;
        const boundaryEpsilon = Math.max(1, this.scrollPositionEpsilon);
        if (bounds.start === bounds.end) {
          this.stopRevealScroll();
          return;
        }
        if (
          (direction < 0 && currentScroll <= bounds.start + boundaryEpsilon) ||
          (direction > 0 && currentScroll >= bounds.end - boundaryEpsilon)
        ) {
          this.stopRevealScroll();
          return;
        }
        if (this.isWheelExcluded(event.target, delta)) return;
        const directionChanged = this.scrollDirection !== 0 && this.scrollDirection !== direction;
        const projectedTarget = !this.scrollFrame || directionChanged
          ? projectedScroll
          : this.scrollTarget + delta;
        const upwardReleaseScroll = this.getUpwardReleaseScroll(bounds);
        if (
          direction < 0 &&
          (
            currentScroll <= upwardReleaseScroll + boundaryEpsilon ||
            projectedTarget <= upwardReleaseScroll + boundaryEpsilon
          )
        ) {
          this.stopRevealScroll();
          return;
        }

        if (delta > 0 && currentScroll < bounds.start) {
          if (projectedScroll <= bounds.start) {
            this.stopRevealScroll();
            return;
          }
          event.preventDefault();
          this.prepareRevealScroll(bounds.start, bounds);
          this.scrollDirection = direction;
          this.scrollTarget = clamp(projectedScroll, bounds.start, bounds.end);
          window.scrollTo(0, bounds.start);
          this.startRevealScroll();
          return;
        }

        if (delta < 0 && currentScroll > bounds.end) {
          if (projectedScroll >= bounds.end) {
            this.stopRevealScroll();
            return;
          }
          event.preventDefault();
          this.prepareRevealScroll(bounds.end, bounds);
          this.scrollDirection = direction;
          this.scrollTarget = clamp(projectedScroll, bounds.start, bounds.end);
          window.scrollTo(0, bounds.end);
          this.startRevealScroll();
          return;
        }

        if (currentScroll < bounds.start || currentScroll > bounds.end) {
          this.stopRevealScroll();
          return;
        }
        event.preventDefault();
        if (!this.scrollFrame || directionChanged) {
          this.prepareRevealScroll(currentScroll, bounds);
        } else {
          this.scrollBounds = bounds;
        }
        this.scrollDirection = direction;
        this.scrollTarget = clamp(this.scrollTarget + delta, bounds.start, bounds.end);
        this.startRevealScroll();
      }

      syncWheelTracking() {
        const shouldTrack = Boolean(this.tracking && this.fixed && !this.motionQuery.matches);
        if (shouldTrack === Boolean(this.wheelTracking)) return;
        this.wheelTracking = shouldTrack;
        if (shouldTrack) {
          window.addEventListener('wheel', this.onWheel, { passive: false });
        } else {
          window.removeEventListener('wheel', this.onWheel);
          this.stopRevealScroll();
        }
      }

      normalizeWheelDelta(event) {
        if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * 16;
        if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * window.innerHeight;
        return event.deltaY;
      }

      isWheelExcluded(target, delta) {
        if (!(target instanceof Element)) return false;
        if (target.closest('input, textarea, select, [contenteditable="true"]')) return true;
        let node = target;
        while (node && node !== document.body) {
          const style = window.getComputedStyle(node);
          const canScroll = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1;
          const hasRoom = delta > 0
            ? node.scrollTop + node.clientHeight < node.scrollHeight - 1
            : node.scrollTop > 1;
          if (canScroll && hasRoom) return true;
          node = node.parentElement;
        }
        return false;
      }

      getRevealScrollBounds() {
        return this.revealBounds || this.refreshRevealScrollBounds();
      }

      getUpwardReleaseScroll(bounds) {
        const revealProgressAtRelease = 1 - this.scrollCollapseReleaseProgress;
        return bounds.start + (bounds.end - bounds.start) * revealProgressAtRelease;
      }

      refreshRevealScrollBounds() {
        if (!this.section || !this.fixed) {
          this.revealBounds = { start: 0, end: 0 };
          return this.revealBounds;
        }
        const sectionTop = window.scrollY + this.section.getBoundingClientRect().top;
        return this.cacheRevealScrollBounds(sectionTop);
      }

      cacheRevealScrollBounds(sectionTop) {
        const maximumScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const start = clamp(sectionTop - window.innerHeight, 0, maximumScroll);
        this.revealBounds = { start, end: clamp(start + this.footerHeight, start, maximumScroll) };
        return this.revealBounds;
      }

      startRevealScroll() {
        if (!this.scrollFrame) {
          this.scrollFrame = window.requestAnimationFrame((time) => this.animateRevealScroll(time));
        }
      }

      prepareRevealScroll(currentScroll, bounds) {
        this.scrollCurrent = currentScroll;
        this.scrollTarget = currentScroll;
        this.scrollFrameTime = 0;
        this.scrollBounds = bounds;
        this.scrollMinimum = Math.min(currentScroll, bounds.start);
      }

      animateRevealScroll(time) {
        this.scrollFrame = 0;
        if (!this.fixed || this.motionQuery.matches) return;
        if (Math.abs(window.scrollY - this.scrollCurrent) > 2) {
          this.stopRevealScroll();
          this.requestUpdate();
          return;
        }

        const elapsed = this.scrollFrameTime
          ? clamp((time - this.scrollFrameTime) / 1000, 1 / 240, 0.05)
          : 1 / 60;
        this.scrollFrameTime = time;
        const bounds = this.scrollBounds || this.getRevealScrollBounds();
        const error = this.scrollTarget - this.scrollCurrent;
        const maximumSpeed = this.footerHeight / this.scrollMinimumDuration;
        const response = 1 - Math.exp(-this.scrollResponseRate * elapsed);
        const maximumStep = maximumSpeed * elapsed;
        const desiredStep = error * response;
        const step = maximumStep * Math.tanh(desiredStep / maximumStep);
        let nextScroll = this.scrollCurrent + step;

        if (this.scrollCurrent >= bounds.start) this.scrollMinimum = bounds.start;
        nextScroll = clamp(nextScroll, this.scrollMinimum, bounds.end);
        const upwardReleaseScroll = this.getUpwardReleaseScroll(bounds);
        if (
          this.scrollDirection < 0 &&
          nextScroll <= upwardReleaseScroll + this.scrollPositionEpsilon
        ) {
          this.scrollCurrent = upwardReleaseScroll;
          window.scrollTo(0, this.scrollCurrent);
          this.stopRevealScroll();
          this.requestUpdate();
          return;
        }
        this.scrollCurrent = nextScroll;

        if (Math.abs(this.scrollTarget - this.scrollCurrent) <= this.scrollPositionEpsilon) {
          this.scrollCurrent = this.scrollTarget;
        }
        window.scrollTo(0, this.scrollCurrent);
        if (this.scrollCurrent !== this.scrollTarget) {
          this.startRevealScroll();
        } else {
          this.stopRevealScroll();
        }
      }

      stopRevealScroll() {
        window.cancelAnimationFrame(this.scrollFrame || 0);
        this.scrollFrame = 0;
        this.scrollCurrent = window.scrollY;
        this.scrollTarget = this.scrollCurrent;
        this.scrollFrameTime = 0;
        this.scrollBounds = null;
        this.scrollMinimum = this.scrollCurrent;
        this.scrollDirection = 0;
      }
    }

    customElements.define('mt-footer-reveal', MtFooterReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-go-to-top"]) return;
  try {
    
  class MtGoToTop extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.initialized = false;
    }

    onClick(event) {
      const trigger = event.target.closest('[data-mt-go-to-top]');
      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top: 0, behavior });
    }
  }

  if (!customElements.get('mt-go-to-top')) customElements.define('mt-go-to-top', MtGoToTop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-home-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-home-hero-slideshow')) {
    class MtHomeHeroSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
        this.progressTracks = Array.from(this.querySelectorAll('[data-progress-track]'));
        this.progressFills = Array.from(this.querySelectorAll('[data-progress-fill]'));
        this.status = this.querySelector('[data-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Math.max(1000, Number.parseInt(this.dataset.interval || '6000', 10));
        this.remaining = this.interval;
        this.deadline = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileMedia = window.matchMedia('(max-width: 1023px)');
        this.mobileSwipeMedia = window.matchMedia('(max-width: 767px)');
        this.pauseReasons = new Set(['viewport']);
        if (document.hidden || !document.hasFocus()) this.pauseReasons.add('document');
        this.pointerStart = null;
        this.suppressSlideLinkUntil = 0;
        this.timer = null;
        this.progressAnimation = null;
        this.idleHandle = null;
        this.idleTimeout = null;
        this.transitionTimer = null;
        this.transitionToken = 0;
        this.abortController = new AbortController();
        this.bindEvents();
        this.observeViewport();
        this.onMotionChange();
        this.updateSlides(false);
        this.updateMedia();
        this.startAutoplay();
        this.scheduleNextImage();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.progressAnimation?.cancel();
        this.pauseAllMedia();
        this.observer?.disconnect();
        this.abortController?.abort();
        if ('cancelIdleCallback' in window && this.idleHandle) window.cancelIdleCallback(this.idleHandle);
        window.clearTimeout(this.idleTimeout);
        window.clearTimeout(this.transitionTimer);
        this.transitionToken += 1;
        this.clearTransitionClasses();
        this.initialized = false;
      }

      bindEvents() {
        const signal = this.abortController.signal;
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        this.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (!slide) return;
          this.pause('editor');
          this.goTo(Number.parseInt(slide.dataset.index, 10), true);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => this.resume('editor'), { signal });
        document.addEventListener('visibilitychange', () => this.onVisibilityChange(), { signal });
        window.addEventListener('blur', () => this.pause('document'), { signal });
        window.addEventListener('focus', () => this.onDocumentFocus(), { signal });
        this.reduceMotion.addEventListener('change', () => this.onMotionChange(), { signal });
        this.mobileMedia.addEventListener('change', () => this.onViewportModeChange(), { signal });
      }

      observeViewport() {
        if (!('IntersectionObserver' in window)) {
          this.resume('viewport');
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry && entry.intersectionRatio >= 0.15) this.resume('viewport');
          else this.pause('viewport');
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
      }

      onClick(event) {
        const slideLink = event.target.closest('[data-slide-link]');
        if (slideLink && performance.now() < this.suppressSlideLinkUntil) {
          event.preventDefault();
          return;
        }
        if (event.target.closest('[data-previous]')) {
          this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
          return;
        }
        if (event.target.closest('[data-next]')) {
          this.goTo((this.currentIndex + 1) % this.slides.length, true);
          return;
        }
        const dot = event.target.closest('[data-go-to]');
        if (dot) {
          this.goTo(Number.parseInt(dot.dataset.goTo, 10), true);
          return;
        }
      }

      onKeydown(event) {
        if (this.slides.length < 2) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo((this.currentIndex + 1) % this.slides.length, true);
        }
      }

      onPointerDown(event) {
        const interactiveControl = event.target.closest('a, button');
        if (
          !this.mobileSwipeMedia.matches ||
          !event.isPrimary ||
          (interactiveControl && !interactiveControl.matches('[data-slide-link]'))
        ) return;
        this.pointerStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          slideLink: event.target.closest('[data-slide-link]')
        };
        this.setPointerCapture?.(event.pointerId);
        this.pause('pointer');
      }

      onPointerUp(event) {
        if (this.pointerStart === null || event.pointerId !== this.pointerStart.id) return;
        const distanceX = event.clientX - this.pointerStart.x;
        const distanceY = event.clientY - this.pointerStart.y;
        const startedOnSlideLink = Boolean(this.pointerStart.slideLink);
        const isHorizontalSwipe = event.type !== 'pointercancel' && Math.abs(distanceX) > 50 && Math.abs(distanceX) > Math.abs(distanceY);
        if (this.hasPointerCapture?.(event.pointerId)) this.releasePointerCapture(event.pointerId);
        this.pointerStart = null;
        if (isHorizontalSwipe && startedOnSlideLink) {
          event.preventDefault();
          this.suppressSlideLinkUntil = performance.now() + 500;
        }
        if (isHorizontalSwipe && this.slides.length > 1) {
          const nextIndex = distanceX < 0
            ? (this.currentIndex + 1) % this.slides.length
            : (this.currentIndex - 1 + this.slides.length) % this.slides.length;
          this.goTo(nextIndex, true);
        }
        this.resume('pointer');
      }

      goTo(index, userInitiated = false) {
        if (!Number.isInteger(index) || index < 0 || index >= this.slides.length) return;
        if (index === this.currentIndex) {
          if (userInitiated) this.restartAutoplay();
          return;
        }
        this.finishTransition();
        const previousIndex = this.currentIndex;
        const direction = this.getDirection(previousIndex, index);
        this.hydrateSlide(index);
        this.currentIndex = index;
        this.remaining = this.interval;
        if (this.reduceMotion.matches) this.updateSlides(userInitiated);
        else this.animateSlides(previousIndex, index, direction, userInitiated);
        this.updateMedia();
        this.resetProgress();
        this.scheduleNextImage();
        this.restartAutoplay();
      }

      getDirection(fromIndex, toIndex) {
        const forwardDistance = (toIndex - fromIndex + this.slides.length) % this.slides.length;
        const backwardDistance = (fromIndex - toIndex + this.slides.length) % this.slides.length;
        return forwardDistance <= backwardDistance ? 'forward' : 'backward';
      }

      animateSlides(previousIndex, nextIndex, direction, announce) {
        const previousSlide = this.slides[previousIndex];
        const nextSlide = this.slides[nextIndex];
        if (!previousSlide || !nextSlide) {
          this.updateSlides(announce);
          return;
        }

        const transitionToken = ++this.transitionToken;
        const enteringClass = `is-entering-${direction}`;
        const leavingClass = `is-leaving-${direction}`;
        nextSlide.classList.add('is-entering', enteringClass);
        nextSlide.hidden = false;
        previousSlide.classList.add('is-leaving', leavingClass);

        requestAnimationFrame(() => {
          if (!this.initialized || transitionToken !== this.transitionToken) return;
          previousSlide.classList.remove('is-active');
          nextSlide.classList.add('is-active');
          nextSlide.classList.remove('is-entering', enteringClass);
          this.updateSlideSemantics(announce);
        });

        this.transitionTimer = window.setTimeout(() => {
          if (transitionToken !== this.transitionToken) return;
          previousSlide.classList.remove('is-leaving', leavingClass);
          previousSlide.hidden = true;
          this.unmountGif(previousSlide);
          previousSlide.removeAttribute('data-active-media');
          this.transitionTimer = null;
        }, 650);
      }

      finishTransition() {
        window.clearTimeout(this.transitionTimer);
        this.transitionTimer = null;
        this.transitionToken += 1;
        this.clearTransitionClasses();
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
          if (!active) {
            this.pauseSlideVideo(slide);
            this.unmountGif(slide);
            slide.removeAttribute('data-active-media');
          }
        });
      }

      clearTransitionClasses() {
        this.slides?.forEach((slide) => {
          slide.classList.remove(
            'is-entering',
            'is-leaving',
            'is-entering-forward',
            'is-entering-backward',
            'is-leaving-forward',
            'is-leaving-backward'
          );
        });
      }

      updateSlides(announce = true) {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.classList.toggle('is-active', active);
        });
        this.updateSlideSemantics(announce);
      }

      updateSlideSemantics(announce = true) {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
          if (active || slide.classList.contains('is-leaving')) slide.hidden = false;
          else slide.hidden = true;
        });
        this.dots.forEach((dot) => {
          dot.setAttribute('aria-current', Number.parseInt(dot.dataset.goTo, 10) === this.currentIndex ? 'true' : 'false');
        });
        if (announce && this.status) {
          this.status.textContent = this.slides[this.currentIndex]?.getAttribute('aria-label') || '';
        }
      }

      hydrateSlide(index) {
        const slide = this.slides[index];
        const template = slide?.querySelector('template[data-media-template]');
        const slot = slide?.querySelector('[data-media-slot]');
        if (!template || !slot) return;
        slot.append(template.content.cloneNode(true));
        template.remove();
      }

      getMediaChoice(slide) {
        const mode = this.mobileMedia.matches ? 'mobile' : 'desktop';
        const alternate = mode === 'mobile' ? 'desktop' : 'mobile';
        const has = (candidateMode, type) => slide.dataset[`${candidateMode}${type}`] === 'true';
        if (has(mode, 'Video')) return { type: 'video', mode };
        if (has(mode, 'Gif')) return { type: 'gif', mode };
        if (has(mode, 'Image')) return { type: 'image', mode };
        if (has(alternate, 'Video')) return { type: 'video', mode: alternate };
        if (has(alternate, 'Gif')) return { type: 'gif', mode: alternate };
        if (has(alternate, 'Image')) return { type: 'image', mode: alternate };
        return { type: 'fixed', mode };
      }

      updateMediaLayout(slide, choice) {
        const viewportMode = this.mobileMedia.matches ? 'mobile' : 'desktop';
        const adaptive = choice.type === 'image' || choice.type === 'gif';
        this.dataset[`${viewportMode}LayoutMedia`] = adaptive ? 'adaptive' : 'fixed';
        if (!adaptive) return;

        const mediaType = choice.type === 'gif' ? 'Gif' : 'Image';
        const width = Number.parseFloat(slide.dataset[`${choice.mode}${mediaType}Width`]);
        const height = Number.parseFloat(slide.dataset[`${choice.mode}${mediaType}Height`]);
        if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return;
        this.style.setProperty(`--mt-hero-${viewportMode}-ratio`, `${width} / ${height}`);
      }

      updateMedia() {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          if (!active) {
            this.pauseSlideVideo(slide);
            if (!slide.classList.contains('is-leaving')) {
              this.unmountGif(slide);
              slide.removeAttribute('data-active-media');
            }
            return;
          }

          this.hydrateSlide(index);
          const choice = this.getMediaChoice(slide);
          this.updateMediaLayout(slide, choice);
          slide.dataset.activeMedia = choice.type;
          if (choice.type === 'video') {
            this.unmountGif(slide);
            this.mountVideo(slide, choice.mode);
            if (this.canPlayMedia()) this.playSlideVideo(slide);
            else this.pauseSlideVideo(slide);
          } else if (choice.type === 'gif') {
            this.pauseSlideVideo(slide);
            if (this.canPlayMedia()) this.mountGif(slide);
            else this.unmountGif(slide);
          } else {
            this.pauseSlideVideo(slide);
            this.unmountGif(slide);
          }
        });
      }

      canPlayMedia() {
        return !this.pauseReasons.has('viewport') && !this.pauseReasons.has('document') && !this.pauseReasons.has('motion');
      }

      mountVideo(slide, mode) {
        const slot = slide.querySelector('[data-video-slot]');
        if (!slot) return;
        if (slot.dataset.mode === mode && slot.querySelector('video')) return;
        const template = slide.querySelector(`template[data-video-template="${mode}"]`);
        if (!template) return;
        slot.replaceChildren(template.content.cloneNode(true));
        slot.dataset.mode = mode;
        const video = slot.querySelector('video');
        if (!video) return;
        video.preload = 'none';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.addEventListener('playing', () => {
          if (this.slides[this.currentIndex] === slide && !video.paused) slide.classList.add('has-playing-video');
        }, { signal: this.abortController.signal });
      }

      playSlideVideo(slide) {
        const video = slide.querySelector('[data-video-slot] video');
        if (!video) return;
        video.play().catch(() => slide.classList.remove('has-playing-video'));
      }

      pauseSlideVideo(slide) {
        const video = slide.querySelector('[data-video-slot] video');
        if (video) video.pause();
        slide.classList.remove('has-playing-video');
      }

      mountGif(slide) {
        const slot = slide.querySelector('[data-gif-slot]');
        const template = slide.querySelector('template[data-gif-template]');
        if (!slot || !template || slot.childElementCount > 0) return;
        slot.append(template.content.cloneNode(true));
      }

      unmountGif(slide) {
        slide.querySelector('[data-gif-slot]')?.replaceChildren();
      }

      pauseAllMedia() {
        this.slides?.forEach((slide) => {
          this.pauseSlideVideo(slide);
          this.unmountGif(slide);
        });
      }

      onViewportModeChange() {
        this.slides.forEach((slide) => {
          this.pauseSlideVideo(slide);
          const slot = slide.querySelector('[data-video-slot]');
          if (slot) {
            slot.replaceChildren();
            delete slot.dataset.mode;
          }
          this.unmountGif(slide);
        });
        this.updateMedia();
      }

      scheduleNextImage() {
        if (this.slides.length < 2) return;
        if ('cancelIdleCallback' in window && this.idleHandle) window.cancelIdleCallback(this.idleHandle);
        window.clearTimeout(this.idleTimeout);

        const hydrateNext = () => {
          this.idleHandle = null;
          this.idleTimeout = null;
          this.hydrateSlide((this.currentIndex + 1) % this.slides.length);
        };
        if ('requestIdleCallback' in window) {
          this.idleHandle = window.requestIdleCallback(hydrateNext, { timeout: 2500 });
        } else {
          this.idleTimeout = window.setTimeout(hydrateNext, 1200);
        }
      }

      onVisibilityChange() {
        if (document.hidden) this.pause('document');
        else this.onDocumentFocus();
      }

      onDocumentFocus() {
        if (!document.hidden && document.hasFocus()) this.resume('document');
      }

      onMotionChange() {
        if (this.reduceMotion.matches) {
          this.finishTransition();
          this.updateSlides(false);
          this.pause('motion');
        } else {
          this.resume('motion');
        }
      }

      pause(reason) {
        if (this.pauseReasons.has(reason)) return;
        this.captureRemaining();
        this.pauseReasons.add(reason);
        this.stopAutoplay();
        this.updateProgress(false);
        this.updateMedia();
      }

      resume(reason) {
        this.pauseReasons.delete(reason);
        this.updateMedia();
        this.startAutoplay();
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.slides.length < 2 || this.pauseReasons.size > 0 || this.timer) return;
        this.deadline = performance.now() + this.remaining;
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.deadline = 0;
          this.remaining = this.interval;
          this.goTo((this.currentIndex + 1) % this.slides.length, false);
        }, this.remaining);
        this.updateProgress(false);
      }

      stopAutoplay() {
        if (!this.timer) {
          this.deadline = 0;
          return;
        }
        window.clearTimeout(this.timer);
        this.timer = null;
        this.deadline = 0;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.remaining = this.interval;
        this.startAutoplay();
      }

      captureRemaining() {
        if (!this.timer || !this.deadline) return;
        this.remaining = Math.max(0, this.deadline - performance.now());
      }

      resetProgress() {
        this.progressAnimation?.cancel();
        this.progressAnimation = null;
        this.progressTracks.forEach((track, index) => {
          track.classList.toggle('is-active', index === this.currentIndex);
        });
        this.progressFills.forEach((fill) => {
          fill.style.transform = 'scaleX(0)';
        });
      }

      updateProgress(reset = false) {
        if (reset) this.resetProgress();
        const fill = this.progressFills[this.currentIndex];
        if (!fill) return;
        this.progressAnimation?.cancel();
        this.progressAnimation = null;
        if (!this.autoplayEnabled || this.reduceMotion.matches || this.slides.length < 2) {
          fill.style.transform = 'scaleX(1)';
          return;
        }
        const progress = Math.min(1, Math.max(0, 1 - (this.remaining / this.interval)));
        fill.style.transform = `scaleX(${progress})`;
        if (this.pauseReasons.size > 0 || this.remaining <= 0) return;
        if (typeof fill.animate !== 'function') {
          fill.style.transform = 'scaleX(1)';
          return;
        }
        this.progressAnimation = fill.animate(
          [{ transform: `scaleX(${progress})` }, { transform: 'scaleX(1)' }],
          { duration: this.remaining, easing: 'linear', fill: 'forwards' }
        );
      }
    }

    customElements.define('mt-home-hero-slideshow', MtHomeHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-linsy-navigation"] && !Shopify.designMode) return;
  try {
    
  class MtLinsyNavigation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.nav = this.querySelector('.mt-linsy-nav');
      this.inner = this.querySelector('[data-navigation-items]');
      this.items = Array.from(this.querySelectorAll('[data-navigation-item]'));
      this.previousButton = this.querySelector('[data-scroll-previous]');
      this.nextButton = this.querySelector('[data-scroll-next]');
      this.navSection = this.closest('.shopify-section') || this.parentElement;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileBreakpoint = window.matchMedia('(max-width: 767px)');
      this.frame = null;
      this.activeIndex = -1;
      this.stickyHeight = null;
      this.stickyPosition = null;
      this.stickyTop = null;
      this.placeholderHeight = null;
      this.collapseTimer = null;
      this.scrollAlignmentTimer = null;
      this.headerMutationObserver = null;
      this.headerStateSignature = null;

      this.handleClick = this.onClick.bind(this);
      this.handlePageScroll = this.schedulePageUpdate.bind(this);
      this.handleInnerScroll = this.scheduleArrowUpdate.bind(this);
      this.handleBreakpoint = this.onBreakpointChange.bind(this);
      this.handleStructureChange = this.onStructureChange.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      window.addEventListener('scroll', this.handlePageScroll, { passive: true });
      this.inner?.addEventListener('scroll', this.handleInnerScroll, { passive: true });
      this.mobileBreakpoint.addEventListener('change', this.handleBreakpoint);
      document.addEventListener('shopify:section:load', this.handleStructureChange);
      document.addEventListener('shopify:section:unload', this.handleStructureChange);
      document.addEventListener('shopify:section:reorder', this.handleStructureChange);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateArrows();
          this.schedulePageUpdate();
        });
        if (this.inner) this.resizeObserver.observe(this.inner);
        if (this.nav) this.resizeObserver.observe(this.nav);
        this.getHeaderCandidates().forEach((header) => this.resizeObserver.observe(header));
      }

      this.refreshTargets();
      this.createStickySentinel();
      this.observeHeaderState();
      this.syncStickyPosition({ recalculatePlaceholder: true });
      this.buildStickyObserver();
      this.updateArrows();
      this.updateActiveItem();
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('scroll', this.handlePageScroll);
      this.inner?.removeEventListener('scroll', this.handleInnerScroll);
      this.mobileBreakpoint?.removeEventListener('change', this.handleBreakpoint);
      document.removeEventListener('shopify:section:load', this.handleStructureChange);
      document.removeEventListener('shopify:section:unload', this.handleStructureChange);
      document.removeEventListener('shopify:section:reorder', this.handleStructureChange);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.resizeObserver?.disconnect();
      this.headerMutationObserver?.disconnect();
      this.stickyObserver?.disconnect();
      this.sentinel?.remove();
      this.navSection?.removeAttribute('data-mt-linsy-nav-sticky-position');
      this.navSection?.style.removeProperty('--mt-linsy-nav-sticky-height');
      this.navSection?.style.removeProperty('--mt-linsy-nav-sticky-top');
      this.navSection?.style.removeProperty('--mt-linsy-nav-placeholder-height');
      if (this.collapseTimer) window.clearTimeout(this.collapseTimer);
      if (this.scrollAlignmentTimer) window.clearTimeout(this.scrollAlignmentTimer);
      if (this.frame) window.cancelAnimationFrame(this.frame);
      if (this.arrowFrame) window.cancelAnimationFrame(this.arrowFrame);
      this.sentinel = null;
      this.collapseTimer = null;
      this.scrollAlignmentTimer = null;
      this.headerMutationObserver = null;
      this.headerStateSignature = null;
      this.frame = null;
      this.arrowFrame = null;
      this.initialized = false;
    }

    refreshTargets() {
      const sections = Array.from(document.querySelectorAll('.shopify-section'));
      this.targets = this.items.map((item) => {
        const index = Number.parseInt(item.dataset.sectionIndex, 10);
        const anchor = item.dataset.targetAnchor;
        const anchoredTarget = anchor
          ? Array.from(
              document.querySelectorAll(
                '[data-linsy-nav-anchor], [data-why-modular-directional-nav-anchor]'
              )
            ).find(
              (node) =>
                (node.dataset.linsyNavAnchor || node.dataset.whyModularDirectionalNavAnchor) === anchor
            )
          : null;
        const target = anchoredTarget || (Number.isInteger(index) && index >= 1 ? sections[index - 1] || null : null);
        if (target?.id) {
          item.href = `#${target.id}`;
          item.setAttribute('aria-controls', target.id);
        } else {
          item.href = '#MainContent';
          item.removeAttribute('aria-controls');
        }
        return target;
      });
    }

    createStickySentinel() {
      if (!this.navSection || this.sentinel) return;
      this.sentinel = document.createElement('div');
      this.sentinel.className = 'mt-linsy-nav__sentinel';
      this.sentinel.setAttribute('aria-hidden', 'true');
      this.navSection.insertAdjacentElement('beforebegin', this.sentinel);
    }

    buildStickyObserver() {
      this.stickyObserver?.disconnect();
      if (!this.sentinel || !('IntersectionObserver' in window)) return;
      const stickyTriggerTop = this.getStickyTriggerTop();
      this.stickyObserver = new IntersectionObserver(([entry]) => {
        const shouldStick = !entry.isIntersecting && entry.boundingClientRect.top <= stickyTriggerTop;
        this.sentinel?.classList.toggle('is-placeholder-active', shouldStick);
        if (this.nav?.classList.contains('is-stuck') === shouldStick) return;
        this.setStickyState(shouldStick);
        this.schedulePageUpdate();
      }, {
        rootMargin: `-${stickyTriggerTop}px 0px 0px 0px`,
        threshold: 0
      });
      this.stickyObserver.observe(this.sentinel);
    }

    onBreakpointChange() {
      this.syncStickyPosition({ recalculatePlaceholder: true });
      this.buildStickyObserver();
      this.updateArrows();
      this.schedulePageUpdate();
    }

    onStructureChange() {
      window.requestAnimationFrame(() => {
        this.items = Array.from(this.querySelectorAll('[data-navigation-item]'));
        this.refreshTargets();
        this.observeHeaderState();
        this.syncStickyPosition({ recalculatePlaceholder: true });
        this.updateArrows();
        this.updateActiveItem();
      });
    }

    onBlockSelect(event) {
      const item = event.target.closest('[data-navigation-item]');
      if (!item || !this.contains(item)) return;
      const index = this.items.indexOf(item);
      if (index >= 0) this.centerItem(item);
    }

    onClick(event) {
      const previous = event.target.closest('[data-scroll-previous]');
      if (previous) {
        this.scrollNavigationBy(-200);
        return;
      }

      const next = event.target.closest('[data-scroll-next]');
      if (next) {
        this.scrollNavigationBy(200);
        return;
      }

      const item = event.target.closest('[data-navigation-item]');
      if (!item || !this.contains(item)) return;
      const index = this.items.indexOf(item);
      const target = this.targets[index];
      if (!target) return;
      event.preventDefault();
      this.scrollToTarget(target);
    }

    getStickyTriggerTop() {
      if (!this.navSection) return 0;
      if (this.getStickyPosition() === 'top' && Number.isFinite(this.stickyTop)) return this.stickyTop;
      return Number.parseFloat(window.getComputedStyle(this.navSection).top) || 0;
    }

    getStickyPosition() {
      const configuredPosition = this.mobileBreakpoint.matches
        ? this.dataset.mobileStickyPosition
        : this.dataset.desktopStickyPosition;
      if (configuredPosition === 'top' || configuredPosition === 'bottom') return configuredPosition;
      return this.mobileBreakpoint.matches ? 'top' : 'bottom';
    }

    getHeaderCandidates() {
      return Array.from(document.querySelectorAll('[data-header], mt-transparent-navbar'))
        .filter((header) => !this.contains(header) && !this.navSection?.contains(header));
    }

    observeHeaderState() {
      this.headerMutationObserver?.disconnect();
      if (!('MutationObserver' in window)) return;
      const headerCandidates = this.getHeaderCandidates();
      this.headerStateSignature = this.getHeaderStateSignature(headerCandidates);
      this.headerMutationObserver = new MutationObserver(() => {
        const nextSignature = this.getHeaderStateSignature(headerCandidates);
        if (nextSignature === this.headerStateSignature) return;
        this.headerStateSignature = nextSignature;
        this.schedulePageUpdate();
      });
      headerCandidates.forEach((header) => {
        this.resizeObserver?.observe(header);
        this.headerMutationObserver.observe(header, {
          attributes: true,
          attributeFilter: ['class', 'inert']
        });
      });
    }

    getHeaderStateSignature(headerCandidates = this.getHeaderCandidates()) {
      return headerCandidates.map((header) => [
        header.classList.contains('is-sticky'),
        header.classList.contains('is-scroll-visible'),
        header.classList.contains('is-scroll-hidden'),
        header.hasAttribute('inert')
      ].join(':')).join('|');
    }

    getHeaderOffset() {
      let offset = 0;

      this.getHeaderCandidates().forEach((header) => {
        if (header.classList.contains('is-scroll-hidden') || header.hasAttribute('inert')) return;
        const styles = window.getComputedStyle(header);
        if (styles.position !== 'fixed' && styles.position !== 'sticky') return;
        const rect = header.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0 || rect.top > 4) return;
        offset = Math.max(offset, rect.bottom);
      });

      return Math.max(0, Math.round(offset));
    }

    measureExpandedNavigationHeight() {
      if (!this.nav) return 0;
      const wasStuck = this.nav.classList.contains('is-stuck');
      const wasCollapsed = this.nav.classList.contains('is-collapsed');
      this.nav.classList.remove('is-stuck', 'is-collapsed');
      const expandedHeight = Math.ceil(this.getNavigationHeight());
      this.nav.classList.toggle('is-stuck', wasStuck);
      this.nav.classList.toggle('is-collapsed', wasCollapsed);
      return expandedHeight;
    }

    getCollapsedNavigationHeight() {
      if (!this.nav || this.nav.classList.contains('is-collapsed')) return this.getNavigationHeight();
      const wasStuck = this.nav.classList.contains('is-stuck');
      this.nav.classList.add('is-measuring-collapsed', 'is-stuck', 'is-collapsed');
      const collapsedHeight = this.getNavigationHeight();
      this.nav.classList.remove('is-measuring-collapsed', 'is-collapsed');
      if (!wasStuck) this.nav.classList.remove('is-stuck');
      return collapsedHeight;
    }

    getTopContentOffset() {
      if (this.getStickyPosition() !== 'top') return this.getHeaderOffset();
      return this.getHeaderOffset() + this.getCollapsedNavigationHeight();
    }

    syncStickyPosition({ recalculatePlaceholder = false } = {}) {
      if (!this.navSection) return false;
      const nextStickyPosition = this.getStickyPosition();
      const nextStickyHeight = Math.ceil(this.getNavigationHeight());
      const nextStickyTop = nextStickyPosition === 'top' ? this.getHeaderOffset() : 0;
      const expandedHeight = recalculatePlaceholder || !this.placeholderHeight
        ? this.measureExpandedNavigationHeight()
        : 0;
      const retainedPlaceholderHeight = recalculatePlaceholder ? 0 : (this.placeholderHeight || 0);
      const nextPlaceholderHeight = Math.max(expandedHeight, nextStickyHeight, retainedPlaceholderHeight);
      let didChange = false;

      if (nextStickyPosition !== this.stickyPosition) {
        this.stickyPosition = nextStickyPosition;
        this.navSection.dataset.mtLinsyNavStickyPosition = nextStickyPosition;
        didChange = true;
      }
      if (nextStickyHeight > 0 && nextStickyHeight !== this.stickyHeight) {
        this.stickyHeight = nextStickyHeight;
        this.navSection.style.setProperty('--mt-linsy-nav-sticky-height', `${nextStickyHeight}px`);
        didChange = true;
      }
      if (nextStickyTop !== this.stickyTop) {
        this.stickyTop = nextStickyTop;
        this.navSection.style.setProperty('--mt-linsy-nav-sticky-top', `${nextStickyTop}px`);
        didChange = true;
      }
      if (nextPlaceholderHeight > 0 && nextPlaceholderHeight !== this.placeholderHeight) {
        this.placeholderHeight = nextPlaceholderHeight;
        this.navSection.style.setProperty('--mt-linsy-nav-placeholder-height', `${nextPlaceholderHeight}px`);
        this.sentinel?.style.setProperty('--mt-linsy-nav-placeholder-height', `${nextPlaceholderHeight}px`);
        didChange = true;
      }

      if (this.sentinel && this.nav) {
        this.sentinel.style.setProperty('--mt-linsy-nav-placeholder-bg', window.getComputedStyle(this.nav).backgroundColor);
      }

      return didChange;
    }

    setStickyState(shouldStick) {
      if (!this.nav) return;
      if (this.collapseTimer) window.clearTimeout(this.collapseTimer);
      this.collapseTimer = null;

      if (shouldStick) {
        this.nav.classList.add('is-stuck');
        this.syncStickyPosition();
        if (this.reducedMotion.matches) {
          this.nav.classList.add('is-collapsed');
          this.syncStickyPosition();
          return;
        }
        this.collapseTimer = window.setTimeout(() => {
          this.nav?.classList.add('is-collapsed');
          this.collapseTimer = null;
          if (this.syncStickyPosition()) this.buildStickyObserver();
          this.schedulePageUpdate();
        }, 350);
        return;
      }

      this.nav.classList.remove('is-collapsed');
      if (this.reducedMotion.matches) {
        this.nav.classList.remove('is-stuck');
        if (this.syncStickyPosition()) this.buildStickyObserver();
        return;
      }
      window.requestAnimationFrame(() => {
        this.nav?.classList.remove('is-stuck');
        if (this.syncStickyPosition()) this.buildStickyObserver();
      });
    }

    getNavigationHeight() {
      return this.nav?.getBoundingClientRect().height || 0;
    }

    getScrollBehavior() {
      return this.reducedMotion.matches ? 'auto' : 'smooth';
    }

    scrollToTarget(target) {
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const destination = targetTop - this.getTopContentOffset();
      const behavior = this.getScrollBehavior();
      window.scrollTo({ top: destination, behavior });

      if (this.scrollAlignmentTimer) window.clearTimeout(this.scrollAlignmentTimer);

      const alignAfterStickyChange = () => {
        this.scrollAlignmentTimer = null;
        const adjustment = target.getBoundingClientRect().top - this.getTopContentOffset();
        if (Math.abs(adjustment) > 1) window.scrollBy({ top: adjustment, behavior: 'auto' });
      };

      if (behavior === 'smooth') {
        this.scrollAlignmentTimer = window.setTimeout(() => {
          alignAfterStickyChange();
          this.scrollAlignmentTimer = window.setTimeout(alignAfterStickyChange, 450);
        }, 1600);
      } else {
        window.requestAnimationFrame(alignAfterStickyChange);
      }
    }

    scrollNavigationBy(left) {
      this.inner?.scrollBy({ left, behavior: this.getScrollBehavior() });
    }

    scheduleArrowUpdate() {
      if (this.arrowFrame) return;
      this.arrowFrame = window.requestAnimationFrame(() => {
        this.arrowFrame = null;
        this.updateArrows();
      });
    }

    updateArrows() {
      if (!this.inner || !this.previousButton || !this.nextButton) return;
      const scrollLeft = this.inner.scrollLeft;
      const scrollWidth = this.inner.scrollWidth;
      const clientWidth = this.inner.clientWidth;
      const canScroll = scrollWidth > clientWidth + 2;
      this.previousButton.hidden = !canScroll || scrollLeft <= 2;
      this.nextButton.hidden = !canScroll || scrollLeft + clientWidth >= scrollWidth - 2;
    }

    schedulePageUpdate() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        if (this.syncStickyPosition()) this.buildStickyObserver();
        this.updateActiveItem();
      });
    }

    updateActiveItem() {
      if (!this.targets?.length) return;
      const threshold = this.getTopContentOffset() + 10;
      let nextActiveIndex = -1;

      for (let index = this.targets.length - 1; index >= 0; index -= 1) {
        const target = this.targets[index];
        if (target && target.getBoundingClientRect().top <= threshold) {
          nextActiveIndex = index;
          break;
        }
      }

      if (nextActiveIndex === this.activeIndex) return;
      this.activeIndex = nextActiveIndex;
      this.items.forEach((item, index) => {
        const active = index === nextActiveIndex;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });

      if (nextActiveIndex >= 0) this.centerItem(this.items[nextActiveIndex]);
    }

    centerItem(item) {
      if (!this.inner || !item) return;
      const innerRect = this.inner.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const left = this.inner.scrollLeft
        + itemRect.left
        - innerRect.left
        - (innerRect.width / 2 - itemRect.width / 2);
      this.inner.scrollTo({ left, behavior: this.getScrollBehavior() });
    }
  }

  if (!customElements.get('mt-linsy-navigation')) {
    customElements.define('mt-linsy-navigation', MtLinsyNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-linsy-product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MtLinsyProductList extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.feature = this.querySelector('[data-feature]');
        this.activeSlide = 0;
        this.featureInView = false;
        this.quickBuy = this.querySelector('[data-quick-buy]');
        this.quickBuyDrawer = this.querySelector('[data-quick-buy-drawer]');
        this.activeCard = null;
        this.activeProduct = null;
        this.lastTrigger = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.handleClick = (event) => this.onClick(event);
        this.handleChange = (event) => {
          if (event.target.closest('[data-quick-options]')) this.updateQuickVariant();
        };
        this.handleSubmit = (event) => this.addToCart(event);
        this.handleKeydown = (event) => this.onKeydown(event);
        this.handleBlockSelect = (event) => this.onBlockSelect(event);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);
        this.querySelector('[data-quick-form]')?.addEventListener('submit', this.handleSubmit);
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.feature && 'IntersectionObserver' in window) {
          this.featureObserver = new IntersectionObserver((entries) => {
            this.featureInView = entries[0]?.isIntersecting || false;
            this.syncVideos();
          }, { rootMargin: '160px 0px', threshold: .05 });
          this.featureObserver.observe(this.feature);
        } else if (this.feature) {
          this.featureInView = true;
          this.syncVideos();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleChange);
        this.querySelector('[data-quick-form]')?.removeEventListener('submit', this.handleSubmit);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.featureObserver?.disconnect();
        this.querySelectorAll('[data-feature-video]').forEach((video) => video.pause());
        window.clearTimeout(this.closeTimer);
        this.closeTimer = null;
        if (this.scrollLocked) {
          if (window.MetryScrollLock) window.MetryScrollLock.unlock();
          else document.documentElement.style.removeProperty('overflow');
          this.scrollLocked = false;
        }
        this.initialized = false;
      }

      onClick(event) {
        if (event.target.closest('[data-feature-previous]')) {
          this.goToSlide(this.activeSlide - 1);
          return;
        }

        if (event.target.closest('[data-feature-next]')) {
          this.goToSlide(this.activeSlide + 1);
          return;
        }

        const trigger = event.target.closest('[data-open-quick-buy]');
        if (trigger) {
          this.openQuickBuy(trigger);
          return;
        }

        if (event.target.closest('[data-close-quick-buy]')) this.closeQuickBuy();
      }

      onKeydown(event) {
        if (!this.quickBuy || this.quickBuy.hidden) return;
        if (event.key === 'Escape') {
          this.closeQuickBuy();
          return;
        }
        if (event.key === 'Tab') this.trapFocus(event);
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const blockId = event.target.dataset.blockId || event.detail?.blockId;
        const slide = this.querySelector(`[data-feature-slide][data-block-id="${blockId}"]`);
        if (slide) this.goToSlide(Number(slide.dataset.featureSlide));
      }

      goToSlide(index) {
        if (!this.feature) return;
        const total = Number(this.feature.dataset.total) || 1;
        this.activeSlide = (index + total) % total;

        this.querySelectorAll('[data-feature-slide]').forEach((slide) => {
          const active = Number(slide.dataset.featureSlide) === this.activeSlide;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.querySelectorAll('[data-feature-content]').forEach((content) => {
          const active = Number(content.dataset.featureContent) === this.activeSlide;
          content.hidden = !active;
          content.classList.toggle('is-active', active);
          content.setAttribute('aria-hidden', String(!active));
        });
        this.syncVideos();
      }

      hydrateVideo(video) {
        if (video.dataset.loaded === 'true') return;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
        video.dataset.loaded = 'true';
      }

      syncVideos() {
        this.querySelectorAll('[data-feature-video]').forEach((video) => {
          const slide = video.closest('[data-feature-slide]');
          const shouldPlay = this.featureInView && !slide.hidden;
          if (shouldPlay) {
            this.hydrateVideo(video);
            if (this.reduceMotion) {
              video.controls = true;
              video.pause();
              return;
            }
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      openQuickBuy(trigger) {
        const card = trigger.closest('[data-product-card]');
        const json = card?.querySelector('[data-product-json]');
        if (!card || !json || !this.quickBuy) return;

        try {
          this.activeProduct = JSON.parse(json.textContent);
        } catch (error) {
          window.location.href = card.querySelector('.mt-linsy-product-card__link')?.href || '#';
          return;
        }

        window.clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.activeCard = card;
        this.lastTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        const titleLink = this.querySelector('[data-quick-title]');
        titleLink.textContent = this.activeProduct.title;
        const detailLink = new URL(this.activeProduct.url, window.location.origin);
        detailLink.searchParams.set('variant', this.activeProduct.selectedVariantId);
        titleLink.href = `${detailLink.pathname}${detailLink.search}${detailLink.hash}`;
        this.renderQuickMedia();
        this.renderQuickOptions();
        this.updateQuickVariant();

        this.quickBuy.hidden = false;
        if (window.MetryScrollLock) window.MetryScrollLock.lock();
        else document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        requestAnimationFrame(() => {
          this.quickBuy.classList.add('is-open');
          this.quickBuyDrawer.focus();
        });
      }

      closeQuickBuy() {
        if (!this.quickBuy || this.quickBuy.hidden) return;
        this.quickBuy.classList.remove('is-open');
        this.lastTrigger?.setAttribute('aria-expanded', 'false');
        if (this.scrollLocked) {
          if (window.MetryScrollLock) window.MetryScrollLock.unlock();
          else document.documentElement.style.removeProperty('overflow');
          this.scrollLocked = false;
        }

        const finish = () => {
          this.closeTimer = null;
          this.quickBuy.hidden = true;
          this.lastTrigger?.focus();
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = window.setTimeout(finish, 310);
        }
      }

      renderQuickMedia() {
        const target = this.querySelector('[data-quick-media]');
        const source = this.activeCard?.querySelector('.mt-linsy-product-card__image-wrap');
        target.replaceChildren();
        if (source) target.append(source.cloneNode(true));
      }

      renderQuickOptions() {
        const target = this.querySelector('[data-quick-options]');
        const variants = this.activeProduct.variants || [];
        target.replaceChildren();
        if (this.activeProduct.hasOnlyDefaultVariant) return;
        const preferredVariant = variants.find((variant) => variant.id === this.activeProduct.selectedVariantId) || variants[0];

        this.activeProduct.options.forEach((name, optionIndex) => {
          const values = [...new Set(variants.map((variant) => variant.options[optionIndex]))];
          const isColor = ['color', 'colour'].includes(name.toLowerCase());
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'mt-linsy-product-list__quick-buy-option';
          const legend = document.createElement('legend');
          legend.textContent = name;
          const valueContainer = document.createElement('div');
          valueContainer.className = 'mt-linsy-product-list__quick-buy-values';

          values.forEach((value, valueIndex) => {
            const id = `mt-lpl-quick-${this.dataset.sectionId}-${optionIndex}-${valueIndex}`;
            const input = document.createElement('input');
            input.type = 'radio';
            input.id = id;
            input.name = `mt-lpl-option-${this.dataset.sectionId}-${optionIndex}`;
            input.value = value;
            input.checked = value === preferredVariant?.options[optionIndex];
            const label = document.createElement('label');
            label.htmlFor = id;
            label.textContent = value;

            if (isColor) {
              label.classList.add('is-color');
              label.setAttribute('aria-label', value);
              label.style.setProperty('--swatch-color', this.swatchColor(value));
            }
            valueContainer.append(input, label);
          });

          fieldset.append(legend, valueContainer);
          target.append(fieldset);
        });
      }

      updateQuickVariant() {
        if (!this.activeProduct) return;
        const selected = [...this.querySelectorAll('[data-quick-options] input:checked')].map((input) => input.value);
        const variant = this.activeProduct.variants.find((item) =>
          item.options.length === selected.length && item.options.every((value, index) => value === selected[index])
        );
        const idInput = this.querySelector('[data-quick-variant-id]');
        const submit = this.querySelector('[data-quick-submit]');
        const submitText = this.querySelector('[data-quick-submit-text]');
        const price = this.querySelector('[data-quick-price]');
        const status = this.querySelector('[data-quick-status]');
        status.hidden = true;

        if (!variant) {
          idInput.value = '';
          submit.disabled = true;
          submitText.textContent = this.dataset.stringUnavailable;
          price.replaceChildren();
          return;
        }

        idInput.value = variant.id;
        this.activeProduct.selectedVariantId = String(variant.id);
        const detailLink = this.querySelector('[data-quick-product-link]');
        if (detailLink) {
          const target = new URL(this.activeProduct.url, window.location.origin);
          target.searchParams.set('variant', variant.id);
          detailLink.href = `${target.pathname}${target.search}${target.hash}`;
        }
        submit.disabled = !variant.available;
        submitText.textContent = variant.available ? this.dataset.stringAdd : this.dataset.stringSoldOut;
        price.replaceChildren();
        const current = document.createElement('span');
        current.textContent = variant.price;
        price.append(current);
        if (variant.comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = variant.comparePrice;
          price.append(compare);
        }
        this.syncQuickMedia(variant);
      }

      syncQuickMedia(variant) {
        if (!this.activeCard || !variant) return;
        const variantTemplate = this.activeCard.querySelector(`[data-linsy-card-variant-media-template="${CSS.escape(String(variant.id))}"]`);
        const target = this.querySelector('[data-quick-media] [data-linsy-card-media-images]');
        if (variantTemplate && target) {
          target.replaceChildren(variantTemplate.content.cloneNode(true));
          return;
        }
        const colorIndex = this.activeProduct.options.findIndex((name) => ['color', 'colour'].includes(name.toLowerCase()));
        if (colorIndex < 0) return;
        const color = variant.options[colorIndex];
        const template = this.activeCard.querySelector(`[data-linsy-card-color-template="${CSS.escape(color || '')}"]`);
        if (template && target) target.replaceChildren(template.content.cloneNode(true));
      }

      async addToCart(event) {
        event.preventDefault();
        const id = this.querySelector('[data-quick-variant-id]').value;
        const submit = this.querySelector('[data-quick-submit]');
        const status = this.querySelector('[data-quick-status]');
        if (!id || submit.disabled) return;

        submit.disabled = true;
        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id, quantity: 1 })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.stringUnavailable);
          status.textContent = this.dataset.stringAdded;
          status.classList.remove('is-error');
          status.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
          this.closeQuickBuy();
        } catch (error) {
          status.textContent = error.message;
          status.classList.add('is-error');
          status.hidden = false;
          submit.disabled = false;
        }
      }

      trapFocus(event) {
        const focusable = [...this.quickBuyDrawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter((element) => !element.hidden && element.offsetParent !== null);
        if (focusable.length === 0) {
          event.preventDefault();
          this.quickBuyDrawer.focus();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!this.quickBuyDrawer.contains(document.activeElement) || document.activeElement === this.quickBuyDrawer) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      swatchColor(value) {
        const colors = {
          'almond cream': '#dcd0c3',
          'dark matter': '#42423f',
          'moonlit mist': '#9c9c9c',
          'navy blue': '#19304c',
          'light gray': '#bbbabC',
          'light green': '#3aefd0',
          'dark gray': '#42423f',
          'ivory white': '#fdf9de',
          'rust brown': '#b0561f',
          'moss green': '#42694c',
          'moon gray': '#3d3c3a',
          'black grey': '#514f54',
          beige: '#dfd4cd',
          'slate grey': '#3a3b43',
          'cloud white': '#eae9e5',
          'charcoal grey': '#484848',
          shadow: '#16130e',
          walnut: '#775748',
          'bottle green': '#4a5f48',
          'soft gray': '#8b8a84',
          'moonstone grey': '#363634',
          'cloud ivory': '#dbdad5',
          'silver mist': '#8b8a84',
          'olive green': '#4a5f48',
          green: '#49573b'
        };
        return colors[String(value).toLowerCase()] || String(value).toLowerCase();
      }
    }

    if (!customElements.get('mt-linsy-product-list')) {
      customElements.define('mt-linsy-product-list', MtLinsyProductList);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-modular-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-modular-collections')) {
    class MtModularCollections extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.track = this.querySelector('[data-collections-track]');
        this.previousButton = this.querySelector('[data-collections-previous]');
        this.nextButton = this.querySelector('[data-collections-next]');
        this.scrollbar = this.querySelector('[data-collections-scrollbar]');
        this.scrollbarThumb = this.querySelector('[data-collections-scrollbar-thumb]');
        this.hoverMediaQuery = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
        const signal = this.abortController.signal;

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('pointerover', (event) => this.onHoverIntent(event), { passive: true, signal });
        this.addEventListener('focusin', (event) => this.onHoverIntent(event), { signal });
        this.hoverMediaQuery.addEventListener('change', () => this.prepareHoverImages(), { signal });

        if (this.track) {
          this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
          this.addEventListener('pointerdown', (event) => this.onSurfacePointerDown(event), { signal });
          this.addEventListener('pointermove', (event) => this.onSurfacePointerMove(event), { signal });
          this.addEventListener('pointerup', (event) => this.onSurfacePointerUp(event), { signal });
          this.addEventListener('pointercancel', (event) => this.onSurfacePointerUp(event), { signal });
          this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
          this.resizeObserver.observe(this.track);
          this.setAttribute('data-carousel-ready', '');
        }

        if (this.scrollbar) {
          this.scrollbar.addEventListener('keydown', (event) => this.onScrollbarKeydown(event), { signal });
          this.scrollbar.addEventListener('pointerdown', (event) => this.onScrollbarPointerDown(event), { signal });
          this.scrollbar.addEventListener('pointermove', (event) => this.onScrollbarPointerMove(event), { signal });
          this.scrollbar.addEventListener('pointerup', (event) => this.onScrollbarPointerUp(event), { signal });
          this.scrollbar.addEventListener('pointercancel', (event) => this.onScrollbarPointerUp(event), { signal });
        }

        this.prepareHoverImages();
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        if (this.intentTimer) clearTimeout(this.intentTimer);
        this.hoverObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.abortController?.abort();
        this.removeAttribute('data-carousel-ready');
        this.initialized = false;
      }

      prepareHoverImages() {
        this.hoverObserver?.disconnect();
        this.hoverObserver = null;
        if (!this.hoverMediaQuery.matches || !('IntersectionObserver' in window)) return;

        this.hoverObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.hydrateHoverImage(entry.target);
            this.hoverObserver?.unobserve(entry.target);
          });
        }, { rootMargin: '240px 0px' });

        this.querySelectorAll('[data-collections-hover-template]').forEach((template) => {
          const card = template.closest('[data-collections-card]');
          if (card) this.hoverObserver.observe(card);
        });
      }

      onHoverIntent(event) {
        if (!this.hoverMediaQuery.matches) return;
        const card = event.target.closest('[data-collections-card]');
        if (card && this.contains(card)) this.hydrateHoverImage(card);
      }

      hydrateHoverImage(card) {
        if (!card || card.dataset.hoverHydrated === 'true') return;
        const template = card.querySelector('[data-collections-hover-template]');
        const target = card.querySelector('[data-collections-hover-media]');
        if (!template || !target) return;

        card.dataset.hoverHydrated = 'true';
        target.appendChild(template.content.cloneNode(true));
        template.remove();
        this.hoverObserver?.unobserve(card);
        const image = target.querySelector('img');
        if (!image) return;
        const markReady = () => card.setAttribute('data-hover-ready', '');
        if (image.complete && image.naturalWidth > 0) markReady();
        else image.addEventListener('load', markReady, { once: true, signal: this.abortController.signal });
      }

      onClick(event) {
        const previous = event.target.closest('[data-collections-previous]');
        if (previous) {
          this.move(-1);
          return;
        }
        const next = event.target.closest('[data-collections-next]');
        if (next) this.move(1);
      }

      move(direction) {
        if (!this.track) return;
        const metrics = this.getCarouselMetrics();
        if (!metrics) return;
        const actualIndex = Math.round(metrics.current / metrics.step);
        const baseIndex = Number.isInteger(this.intentIndex) ? this.intentIndex : actualIndex;
        this.scrollToIndex(baseIndex + direction, metrics);
      }

      scrollToIndex(index, metrics = this.getCarouselMetrics()) {
        if (!this.track || !metrics) return;
        const targetIndex = Math.max(0, Math.min(metrics.maximumIndex, index));
        this.intentIndex = targetIndex;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: Math.min(metrics.maximum, targetIndex * metrics.step), behavior });
      }

      getCarouselMetrics() {
        if (!this.track) return null;
        const card = this.track.querySelector('[data-collections-item]');
        if (!card) return null;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        return {
          current: Math.max(0, this.track.scrollLeft),
          maximum,
          maximumIndex: Math.max(0, Math.ceil(maximum / Math.max(1, step))),
          step: Math.max(1, step)
        };
      }

      onScroll() {
        this.scheduleUpdate();
        if (this.intentTimer) clearTimeout(this.intentTimer);
        this.intentTimer = setTimeout(() => {
          const metrics = this.getCarouselMetrics();
          this.intentIndex = metrics ? Math.round(metrics.current / metrics.step) : null;
        }, 180);
      }

      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = 0;
          this.updateCarousel();
        });
      }

      updateCarousel() {
        const metrics = this.getCarouselMetrics();
        if (!metrics) return;
        const ratio = metrics.maximum > 0 ? metrics.current / metrics.maximum : 0;
        if (this.previousButton) this.previousButton.disabled = metrics.current <= 1;
        if (this.nextButton) this.nextButton.disabled = metrics.maximum <= 1 || metrics.current >= metrics.maximum - 1;
        if (this.scrollbar) this.scrollbar.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));

        if (this.scrollbar && this.scrollbarThumb) {
          const trackWidth = this.scrollbar.clientWidth;
          const visibleRatio = this.track.clientWidth / Math.max(this.track.clientWidth, this.track.scrollWidth);
          const thumbWidth = Math.max(28, trackWidth * visibleRatio);
          const travel = Math.max(0, trackWidth - thumbWidth);
          this.scrollbarThumb.style.width = `${thumbWidth}px`;
          this.scrollbarThumb.style.transform = `translate(${travel * ratio}px, -50%)`;
        }
      }

      onScrollbarKeydown(event) {
        const keyDirections = { ArrowLeft: -1, ArrowRight: 1, PageUp: -1, PageDown: 1 };
        if (Object.prototype.hasOwnProperty.call(keyDirections, event.key)) {
          event.preventDefault();
          this.move(keyDirections[event.key]);
          return;
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const metrics = this.getCarouselMetrics();
          this.scrollToIndex(event.key === 'Home' ? 0 : metrics?.maximumIndex || 0, metrics);
        }
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar || !this.track) return;
        event.preventDefault();
        this.draggingPointerId = event.pointerId;
        this.scrollbar.setPointerCapture(event.pointerId);
        this.scrollbar.setAttribute('data-dragging', '');
        this.dragScrollbarTo(event.clientX);
      }

      onScrollbarPointerMove(event) {
        if (event.pointerId !== this.draggingPointerId) return;
        this.dragScrollbarTo(event.clientX);
      }

      onScrollbarPointerUp(event) {
        if (event.pointerId !== this.draggingPointerId || !this.scrollbar) return;
        if (this.scrollbar.hasPointerCapture(event.pointerId)) this.scrollbar.releasePointerCapture(event.pointerId);
        this.draggingPointerId = null;
        this.scrollbar.removeAttribute('data-dragging');
      }

      onSurfacePointerDown(event) {
        if (event.button !== 0 || event.pointerType !== 'mouse' || !this.track) return;
        if (event.target.closest('[data-collections-card], [data-collections-scrollbar], button, input, select, textarea')) return;
        event.preventDefault();
        this.surfacePointerId = event.pointerId;
        this.surfaceStartX = event.clientX;
        this.surfaceStartScroll = this.track.scrollLeft;
        this.surfaceMoved = false;
        this.intentIndex = null;
        this.setPointerCapture(event.pointerId);
      }

      onSurfacePointerMove(event) {
        if (event.pointerId !== this.surfacePointerId || !this.track) return;
        const distance = event.clientX - this.surfaceStartX;
        if (!this.surfaceMoved && Math.abs(distance) < 4) return;
        event.preventDefault();
        this.surfaceMoved = true;
        this.setAttribute('data-surface-dragging', '');
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.track.scrollLeft = Math.max(0, Math.min(maximum, this.surfaceStartScroll - distance));
      }

      onSurfacePointerUp(event) {
        if (event.pointerId !== this.surfacePointerId) return;
        if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        const shouldSnap = this.surfaceMoved;
        this.surfacePointerId = null;
        this.surfaceMoved = false;
        this.removeAttribute('data-surface-dragging');
        if (!shouldSnap) return;
        const metrics = this.getCarouselMetrics();
        if (metrics) this.scrollToIndex(Math.round(metrics.current / metrics.step), metrics);
      }

      dragScrollbarTo(clientX) {
        if (!this.scrollbar || !this.scrollbarThumb || !this.track) return;
        const bounds = this.scrollbar.getBoundingClientRect();
        const thumbWidth = this.scrollbarThumb.getBoundingClientRect().width;
        const travel = Math.max(1, bounds.width - thumbWidth);
        const thumbPosition = Math.max(0, Math.min(travel, clientX - bounds.left - (thumbWidth / 2)));
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.intentIndex = null;
        this.track.scrollLeft = maximum * (thumbPosition / travel);
      }
    }

    customElements.define('mt-modular-collections', MtModularCollections);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-pdp-bundle"] && !Shopify.designMode) return;
  try {
    
  class MtPdpBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = this.querySelector('[data-bundle-items]');
      this.total = this.querySelector('[data-bundle-total]');
      this.currentPrice = this.querySelector('[data-bundle-current-price]');
      this.currentCompareAt = this.querySelector('[data-bundle-current-compare-at]');
      this.status = this.querySelector('[data-bundle-status]');
      this.button = this.querySelector('[data-bundle-add]');
      this.sectionRoot = this.closest('[data-bundle-section]');
      this.productRoot = document.querySelector('mt-fast-product, product-form');
      this.onSelectionChange = this.onSelectionChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.addEventListener('change', this.onSelectionChange);
      this.addEventListener('click', this.onClick);
      this.productRoot?.addEventListener('change', this.onSelectionChange);
      this.scheduleUpdate(true);
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('change', this.onSelectionChange);
      this.removeEventListener('click', this.onClick);
      this.productRoot?.removeEventListener('change', this.onSelectionChange);
      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.initialized = false;
    }
    syncAddonImageToggle(card) {
      const checkbox = card?.querySelector('[data-bundle-addon]');
      const imageToggle = card?.querySelector('[data-bundle-addon-image-toggle]');
      if (!checkbox || !imageToggle) return;
      imageToggle.disabled = checkbox.disabled;
      imageToggle.setAttribute('aria-pressed', String(Boolean(checkbox.checked)));
    }
    onSelectionChange(event) {
      if (event.target.matches('[data-bundle-addon]')) {
        event.target.dataset.bundleTouched = 'true';
        this.syncAddonImageToggle(event.target.closest('[data-bundle-addon-card]'));
        this.scheduleUpdate(false);
        return;
      }
      if (event.currentTarget === this.productRoot) this.scheduleUpdate(true);
    }
    onClick(event) {
      if (event.target.closest('[data-bundle-add]')) {
        this.addSelected();
        return;
      }
      const imageToggle = event.target.closest('[data-bundle-addon-image-toggle]');
      if (!imageToggle || !this.contains(imageToggle)) return;
      const checkbox = imageToggle.closest('[data-bundle-addon-card]')?.querySelector('[data-bundle-addon]');
      if (!checkbox || checkbox.disabled) return;
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
    scheduleUpdate(syncAddons = false) {
      this.pendingAddonSync = this.pendingAddonSync || syncAddons;
      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.updateTimer = setTimeout(() => {
        this.updateTimer = null;
        if (this.pendingAddonSync) this.syncAddons();
        this.pendingAddonSync = false;
        this.updateTotal();
      }, 0);
    }
    normalizeOption(value) {
      return String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    }
    getCurrentVariant() {
      const variants = this.productRoot?.querySelector('[data-mt-fp-variants], [data-variants]');
      if (!variants) return null;
      try {
        const parsedVariants = JSON.parse(variants.textContent);
        const activeVariant = this.productRoot?.currentVariant;
        if (activeVariant?.id) {
          return parsedVariants.find((variant) => String(variant.id) === String(activeVariant.id)) || activeVariant;
        }

        const id = this.productRoot?.querySelector('[data-mt-fp-variant-id], [data-variant-id]')?.value;
        if (id) {
          const variantById = parsedVariants.find((variant) => String(variant.id) === String(id));
          if (variantById) return variantById;
        }

        const selectedOptions = Array.from(
          this.productRoot?.querySelectorAll('[data-mt-fp-option-fieldset]') || []
        ).map((field) => field.querySelector('[data-mt-fp-option]:checked')?.value || '');
        if (!selectedOptions.length || selectedOptions.some((value) => !value)) return null;
        return parsedVariants.find(
          (variant) => JSON.stringify(variant.options || []) === JSON.stringify(selectedOptions)
        ) || null;
      } catch {
        return null;
      }
    }
    primaryVariantData() {
      if (this.bundleVariantData) return this.bundleVariantData;
      try { this.bundleVariantData = JSON.parse(this.querySelector('[data-bundle-variant-prices]')?.textContent || '{}'); } catch { this.bundleVariantData = {}; }
      return this.bundleVariantData;
    }
    getCurrentPrice() {
      const variant = this.getCurrentVariant();
      return variant ? this.primaryVariantData()[String(variant.id)]?.price || 0 : 0;
    }
    getCurrentCompareAtPrice() {
      const variant = this.getCurrentVariant();
      return variant ? this.primaryVariantData()[String(variant.id)]?.compare_at_price || 0 : 0;
    }
    currentSelectionIsAvailable() {
      const current = this.getCurrentVariant();
      const primaryAddButton = this.productRoot?.querySelector('[data-mt-fp-add], [data-atc]');
      return Boolean(current?.available && !primaryAddButton?.disabled);
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
    }
    currentMatch() {
      const variant = this.getCurrentVariant();
      const fields = Array.from(this.productRoot?.querySelectorAll('[data-mt-fp-option-fieldset]') || []);
      const fabricIndex = fields.findIndex((field) => field.dataset.mtFpOptionRole === 'fabric');
      const colorIndex = fields.findIndex((field) => field.dataset.mtFpOptionRole === 'color');
      if (!variant || fabricIndex < 0 || colorIndex < 0) return null;
      return {
        fabric: variant.options?.[fabricIndex] || '',
        color: variant.options?.[colorIndex] || '',
        match_key: variant.accessory_match_key || ''
      };
    }
    updateCurrentSummary(match) {
      const summary = this.querySelector('[data-bundle-current-summary]');
      if (!summary) return;
      const hasMatch = Boolean(match?.fabric && match?.color);
      summary.hidden = !hasMatch;
      summary.textContent = hasMatch
        ? (this.dataset.currentSelectionTemplate || '')
          .replace('__fabric__', match.fabric)
          .replace('__color__', match.color)
        : '';
    }
    addonVariants(card) {
      if (card.bundleVariants) return card.bundleVariants;
      try { card.bundleVariants = JSON.parse(card.querySelector('[data-bundle-addon-variants]')?.textContent || '[]'); } catch { card.bundleVariants = []; }
      return card.bundleVariants;
    }
    updateImage(container, imageData) {
      if (!container || !imageData?.image_src) return;
      let image = container.querySelector('.mt-pdp-bundle__image');
      if (!image) {
        const template = container.querySelector('[data-bundle-addon-image-template]');
        if (template instanceof HTMLTemplateElement) {
          container.insertBefore(template.content.cloneNode(true), template);
          image = container.querySelector('.mt-pdp-bundle__image');
        }
      }
      if (!image) return;
      image.src = imageData.image_src;
      if (imageData.image_srcset) image.srcset = imageData.image_srcset; else image.removeAttribute('srcset');
      image.closest('picture')?.querySelectorAll('source').forEach((source) => {
        if (imageData.image_srcset) source.srcset = imageData.image_srcset; else source.removeAttribute('srcset');
      });
    }
    moveFocusFromHiddenCard(card) {
      const active = document.activeElement;
      if (!(active instanceof HTMLElement) || !card.contains(active)) return;
      const fallback = this.productRoot?.querySelector('[data-mt-fp-option-fieldset] input:checked, [data-mt-fp-option-fieldset] select, [data-mt-fp-option-fieldset] button[aria-pressed="true"]')
        || this.button;
      fallback?.focus();
    }
    applyAddonVariant(card, variant, variants, match) {
      const checkbox = card.querySelector('[data-bundle-addon]');
      const wasChecked = Boolean(checkbox?.checked);
      const wasTouched = checkbox?.dataset.bundleTouched === 'true';
      if (!variant) {
        this.moveFocusFromHiddenCard(card);
        card.hidden = true;
        card.removeAttribute('data-bundle-position');
        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = true;
          checkbox.dataset.variantId = '';
          checkbox.dataset.price = '0';
        }
        return;
      }

      card.hidden = false;
      if (checkbox) {
        checkbox.dataset.variantId = String(variant.id);
        checkbox.dataset.price = String(variant.price || 0);
        checkbox.disabled = !variant.available;
        checkbox.checked = Boolean(variant.available && wasTouched && wasChecked);
      }
      this.syncAddonImageToggle(card);
      card.querySelectorAll('[data-bundle-addon-link]').forEach((link) => { if (variant.url) link.href = variant.url; });
      const price = card.querySelector('[data-bundle-addon-price]');
      if (price) price.textContent = this.money(variant.price || 0);
      const compareAt = card.querySelector('[data-bundle-addon-compare-at]');
      if (compareAt) {
        compareAt.hidden = !(variant.compare_at_price > variant.price);
        compareAt.textContent = variant.compare_at_price > variant.price ? this.money(variant.compare_at_price) : '';
      }
      const matchSummary = card.querySelector('[data-bundle-addon-match]');
      if (matchSummary) {
        matchSummary.hidden = false;
        matchSummary.textContent = `${this.dataset.matchLabel}: ${match.fabric} · ${match.color}`;
      }
      const soldOut = card.querySelector('[data-bundle-addon-soldout]');
      if (soldOut) soldOut.hidden = variant.available;
      this.updateImage(card.querySelector('.mt-pdp-bundle__image-wrap'), variant);
    }
    syncAddons() {
      const match = this.currentMatch();
      this.updateCurrentSummary(match);
      const visibleCards = [];
      this.querySelectorAll('[data-bundle-addon-card]').forEach((card) => {
        const variants = this.addonVariants(card);
        const fabricIndexValue = card.dataset.bundleAddonFabricIndex || '';
        const colorIndexValue = card.dataset.bundleAddonColorIndex || '';
        const fabricIndex = Number(fabricIndexValue);
        const colorIndex = Number(colorIndexValue);
        const hasRoles = fabricIndexValue !== '' && colorIndexValue !== ''
          && Number.isInteger(fabricIndex) && fabricIndex >= 0
          && Number.isInteger(colorIndex) && colorIndex >= 0;
        const exactMatches = match && hasRoles ? variants.filter((variant) => (
          this.normalizeOption(variant.options?.[fabricIndex]) === this.normalizeOption(match.fabric)
          && this.normalizeOption(variant.options?.[colorIndex]) === this.normalizeOption(match.color)
        )) : [];
        const aliasCandidates = exactMatches.length === 0 && match?.match_key
          ? variants.filter((variant) => variant.match_key === match.match_key)
          : [];
        const aliasColors = new Set(aliasCandidates.map((variant) => this.normalizeOption(variant.options?.[colorIndex])));
        const aliasMatches = aliasColors.size <= 1 ? aliasCandidates : [];
        const rawMatches = exactMatches.length > 0 ? exactMatches : aliasMatches;
        card.dataset.bundleAddonMatchMode = exactMatches.length > 0
          ? 'exact'
          : aliasMatches.length > 0
            ? 'alias'
            : '';
        const eligible = this.dataset.hideSoldOut === 'true' ? rawMatches.filter((variant) => variant.available) : rawMatches;
        const currentId = card.querySelector('[data-bundle-addon]')?.dataset.variantId || '';
        const selected = eligible.find((variant) => String(variant.id) === String(currentId))
          || eligible.find((variant) => variant.available)
          || eligible[0]
          || null;
        const visibleVariant = selected && visibleCards.length < 3 ? selected : null;
        this.applyAddonVariant(card, visibleVariant, eligible, match || { fabric: '', color: '' });
        if (visibleVariant) visibleCards.push(card);
      });

      this.querySelectorAll('[data-bundle-plus]').forEach((plus) => {
        plus.hidden = true;
        plus.removeAttribute('data-bundle-position');
      });
      visibleCards.forEach((card, index) => {
        const position = String(index + 1);
        card.dataset.bundlePosition = position;
        const key = card.dataset.bundleAddonKey;
        const plus = Array.from(this.querySelectorAll('[data-bundle-plus]')).find((item) => item.dataset.bundleAddonKey === key);
        if (plus) {
          plus.hidden = false;
          plus.dataset.bundlePosition = position;
        }
      });
      if (this.items) this.items.dataset.addonCount = String(visibleCards.length);
      if (this.sectionRoot) this.sectionRoot.hidden = visibleCards.length === 0 && this.dataset.designMode !== 'true';
      const current = this.getCurrentVariant();
      const currentData = current ? this.primaryVariantData()[String(current.id)] : null;
      this.updateImage(this.querySelector('.mt-pdp-bundle__card--current .mt-pdp-bundle__image-wrap'), currentData);
    }
    updateTotal() {
      const price = this.getCurrentPrice();
      const addons = Array.from(this.querySelectorAll('[data-bundle-addon]:checked'));
      const addonTotal = addons.reduce((sum, addon) => sum + Number(addon.dataset.price || 0), 0);
      const total = price + addonTotal;
      const basePrice = this.querySelector('[data-bundle-base-price]');
      const addonSummary = this.querySelector('[data-bundle-addon-summary]');
      const totalEquals = this.querySelector('[data-bundle-total-equals]');
      if (basePrice) basePrice.textContent = this.money(price);
      if (addonSummary) {
        addonSummary.textContent = addonTotal > 0
          ? (this.dataset.addonsSelectedTemplate || '').replace('__amount__', this.money(addonTotal))
          : (this.dataset.addonsPending || '');
      }
      if (totalEquals) totalEquals.hidden = addonTotal === 0;
      if (this.total) {
        this.total.hidden = addonTotal === 0;
        this.total.textContent = this.money(total);
      }
      if (this.currentPrice && price) this.currentPrice.textContent = this.money(price);
      const compareAtPrice = this.getCurrentCompareAtPrice();
      if (this.currentCompareAt) {
        this.currentCompareAt.hidden = !(compareAtPrice > price);
        this.currentCompareAt.textContent = compareAtPrice > price ? this.money(compareAtPrice) : '';
      }
      this.button && (this.button.disabled = !this.currentSelectionIsAvailable());
    }
    async addSelected() {
      const current = this.getCurrentVariant();
      if (!current?.id || !this.currentSelectionIsAvailable() || !this.button) return;
      const items = [{ id: current.id, quantity: 1 }];
      this.querySelectorAll('[data-bundle-addon]:checked').forEach((addon) => items.push({ id: addon.dataset.variantId, quantity: 1 }));
      if (this.status) {
        this.status.hidden = true;
        this.status.textContent = '';
      }
      this.button.disabled = true;
      try {
        const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorMessage);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', origin: 'product-bundle' } }));
      } catch (error) {
        if (this.status) {
          this.status.hidden = false;
          this.status.textContent = error.message || this.dataset.errorMessage;
        }
      } finally { this.scheduleUpdate(false); }
    }
  }
  if (!customElements.get('mt-pdp-bundle')) customElements.define('mt-pdp-bundle', MtPdpBundle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-pdp-dimensions"] && !Shopify.designMode) return;
  try {
    
  class MtPdpDimensions extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-dimension-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-dimension-panel]'));
      this.isTransitioning = false;
      this.mediaTransitionFrame = null;
      this.mediaTransitionTimer = null;
      this.mediaTransitionId = 0;
      this.normalizeMediaPanels();
      this.removeEventListener('click', this.onClick);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.cancelMediaTransition();
    }

    onClick = (event) => {
      const trigger = event.target.closest('[data-dimension-trigger]');
      if (!trigger || trigger.disabled || this.isTransitioning) return;
      this.show(trigger.dataset.dimensionIndex);
    };

    show(index) {
      const activeTrigger = this.triggers.find((trigger) => trigger.getAttribute('aria-pressed') === 'true');
      if (activeTrigger?.dataset.dimensionIndex === index) return;
      const targetPanel = this.panels.find((panel) => panel.dataset.dimensionPanel === index);
      const targetImage = targetPanel?.querySelector('img');

      if (!targetPanel || !targetImage || targetImage.complete) {
        this.activate(index);
        return;
      }

      this.isTransitioning = true;
      this.setBusy(true);

      const finish = (ready) => {
        this.isTransitioning = false;
        this.setBusy(false);
        if (ready && this.isConnected) this.activate(index);
      };

      targetImage.addEventListener('load', () => finish(true), { once: true });
      targetImage.addEventListener('error', () => finish(false), { once: true });
      targetImage.loading = 'eager';
    }

    activate(index) {
      const targetPanel = this.panels.find((panel) => panel.dataset.dimensionPanel === index);
      const activePanel = this.panels.find((panel) => panel.classList.contains('is-active'));
      const motionAllowed = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

      this.triggers.forEach((trigger) => {
        const active = trigger.dataset.dimensionIndex === index;
        trigger.classList.toggle('is-highlighted', active);
        trigger.setAttribute('aria-pressed', String(active));
      });

      if (!targetPanel || !motionAllowed || !activePanel || activePanel === targetPanel) {
        this.cancelMediaTransition();
        this.panels.forEach((panel) => {
          const active = panel === targetPanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.classList.remove('is-entering', 'is-leaving');
        });
        return;
      }

      this.cancelMediaTransition();
      const transitionId = ++this.mediaTransitionId;

      this.panels.forEach((panel) => {
        if (panel !== activePanel && panel !== targetPanel) {
          panel.hidden = true;
          panel.classList.remove('is-active', 'is-leaving');
        }
      });

      activePanel.hidden = false;
      activePanel.classList.remove('is-active');
      activePanel.classList.add('is-leaving');
      targetPanel.hidden = false;
      targetPanel.classList.remove('is-leaving');
      targetPanel.classList.add('is-active', 'is-entering');

      // Keep the entering state through a complete render cycle. Removing it in the
      // first frame can be coalesced with `hidden = false`, which skips the transition.
      this.mediaTransitionFrame = requestAnimationFrame(() => {
        if (transitionId !== this.mediaTransitionId || !this.isConnected) return;
        this.mediaTransitionFrame = requestAnimationFrame(() => {
          if (transitionId !== this.mediaTransitionId || !this.isConnected) return;
          targetPanel.classList.remove('is-entering');
          this.mediaTransitionFrame = null;
          this.mediaTransitionTimer = window.setTimeout(() => {
            if (transitionId !== this.mediaTransitionId || !this.isConnected) return;
            this.panels.forEach((panel) => {
              const active = panel === targetPanel;
              panel.hidden = !active;
              panel.classList.toggle('is-active', active);
              panel.classList.remove('is-entering', 'is-leaving');
            });
            this.mediaTransitionTimer = null;
          }, 320);
        });
      });
    }

    normalizeMediaPanels() {
      const activePanel = this.panels.find((panel) => panel.classList.contains('is-active')) || this.panels[0];
      this.panels.forEach((panel) => {
        const active = panel === activePanel;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        panel.classList.remove('is-entering', 'is-leaving');
      });
    }

    cancelMediaTransition() {
      this.mediaTransitionId += 1;
      if (this.mediaTransitionFrame) {
        cancelAnimationFrame(this.mediaTransitionFrame);
        this.mediaTransitionFrame = null;
      }
      if (this.mediaTransitionTimer) {
        window.clearTimeout(this.mediaTransitionTimer);
        this.mediaTransitionTimer = null;
      }
    }

    setBusy(isBusy) {
      this.toggleAttribute('aria-busy', isBusy);
      this.triggers.forEach((trigger) => {
        trigger.disabled = isBusy;
      });
    }
  }

  if (!customElements.get('mt-pdp-dimensions')) customElements.define('mt-pdp-dimensions', MtPdpDimensions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-pdp-fabric"] && !Shopify.designMode) return;
  try {
    
  class MtPdpFabric extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-fabric-slide]'));
      this.featurePanels = Array.from(this.querySelectorAll('[data-fabric-feature-panel]'));
      this.dots = Array.from(this.querySelectorAll('[data-fabric-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active') && !slide.hidden));
      this.intentIndex = this.index;
      this.isTransitioning = false;
      this.requestId = (this.requestId || 0) + 1;
      this.previousButton = this.querySelector('[data-fabric-previous]');
      this.nextButton = this.querySelector('[data-fabric-next]');
      this.heading = this.querySelector('[data-fabric-header-heading]');
      this.text = this.querySelector('[data-fabric-header-text]');
      this.header = this.querySelector('.mt-pdp-fabric__header');
      this.carousel = this.querySelector('.mt-pdp-fabric__carousel');
      this.cancelTransition();
      if (window.Shopify?.designMode) {
        this.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('reveal-in'));
      }
      this.removeEventListener('click', this.onClick);
      this.addEventListener('click', this.onClick);
      this.syncHeader();
      this.updateControls();
      this.setupMediaWarmup();
    }

    disconnectedCallback() {
      this.cancelTransition();
      this.mediaWarmupObserver?.disconnect();
      this.mediaWarmupObserver = null;
      this.removeEventListener('click', this.onClick);
    }

    setupMediaWarmup() {
      this.mediaWarmupObserver?.disconnect();
      const warmAdjacentSlides = () => this.warmAdjacentSlides();
      if (!('IntersectionObserver' in window)) {
        warmAdjacentSlides();
        return;
      }
      this.mediaWarmupObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        warmAdjacentSlides();
        this.mediaWarmupObserver?.disconnect();
        this.mediaWarmupObserver = null;
      }, { rootMargin: '600px 0px' });
      this.mediaWarmupObserver.observe(this.carousel || this);
    }

    warmSlide(index) {
      const image = this.slides[index]?.querySelector('img');
      if (!image || image.complete) return;
      image.loading = 'eager';
    }

    warmAdjacentSlides() {
      this.warmSlide(this.index);
      this.warmSlide(this.index - 1);
      this.warmSlide(this.index + 1);
    }

    onClick = (event) => {
      const controlIndex = this.intentIndex ?? this.index;
      if (event.target.closest('[data-fabric-next]')) this.show(controlIndex + 1);
      if (event.target.closest('[data-fabric-previous]')) this.show(controlIndex - 1);
      const dot = event.target.closest('[data-fabric-dot]');
      if (dot) this.show(Number(dot.dataset.index));
    };

    show(nextIndex) {
      if (!this.slides.length) return;
      const targetIndex = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
      if (targetIndex === this.intentIndex && (this.isTransitioning || targetIndex === this.index)) return;
      this.cancelTransition();
      const requestId = this.requestId;
      this.intentIndex = targetIndex;
      if (targetIndex === this.index) {
        this.updateControls();
        return;
      }
      this.warmSlide(targetIndex);
      const targetImage = this.slides[targetIndex].querySelector('img');

      if (!targetImage || targetImage.complete) {
        this.startTransition(targetIndex, requestId);
        return;
      }

      this.setBusy(true);

      const finish = (ready) => {
        if (requestId !== this.requestId || !this.isConnected) return;
        this.setBusy(false);
        if (ready) this.startTransition(targetIndex, requestId);
        else {
          this.intentIndex = this.index;
          this.updateControls();
        }
      };

      targetImage.addEventListener('load', () => finish(true), { once: true });
      targetImage.addEventListener('error', () => finish(false), { once: true });
      targetImage.loading = 'eager';
    }

    startTransition(nextIndex, requestId) {
      if (requestId !== this.requestId || nextIndex === this.index || !this.isConnected) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.activate(nextIndex);
        this.intentIndex = this.index;
        this.setBusy(false);
        return;
      }

      const previousSlide = this.slides[this.index];
      const nextSlide = this.slides[nextIndex];
      if (!previousSlide || !nextSlide) {
        this.activate(nextIndex);
        this.intentIndex = this.index;
        this.setBusy(false);
        return;
      }

      this.isTransitioning = true;
      this.intentIndex = nextIndex;
      this.dataset.fabricTransition = nextIndex > this.index ? 'next' : 'previous';
      this.classList.add('is-switching');
      nextSlide.hidden = false;
      nextSlide.setAttribute('aria-hidden', 'true');
      nextSlide.classList.add('is-entering');
      previousSlide.classList.add('is-leaving');
      this.setBusy(true);

      const complete = () => {
        if (requestId !== this.requestId || !this.isConnected) return;
        this.clearTransitionListeners();
        this.clearTransitionClasses();
        this.isTransitioning = false;
        this.activate(nextIndex, { animateContent: true });
        this.intentIndex = this.index;
        this.setBusy(false);
      };
      const onAnimationEnd = (event) => {
        if (event.target === nextSlide) complete();
      };
      nextSlide.addEventListener('animationend', onAnimationEnd, { once: true });
      this.transitionCleanup = () => nextSlide.removeEventListener('animationend', onAnimationEnd);
      this.transitionTimer = window.setTimeout(complete, 290);
    }

    activate(nextIndex, { animateContent = false } = {}) {
      this.index = nextIndex;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
      });
      this.featurePanels.forEach((panel, index) => {
        panel.hidden = index !== this.index;
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
      });
      this.syncHeader();
      this.updateControls();
      this.warmAdjacentSlides();
      if (animateContent) this.playContentMotion();
    }

    playContentMotion() {
      this.clearContentMotion();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const elements = [this.header, this.featurePanels[this.index]].filter(Boolean);
      const cleanup = () => {
        elements.forEach((element) => {
          element.removeEventListener('animationend', onAnimationEnd);
          element.classList.remove('is-content-entering');
        });
        if (this.contentMotionCleanup === cleanup) this.contentMotionCleanup = null;
      };
      const onAnimationEnd = (event) => {
        if (event.target === elements[0]) cleanup();
      };
      elements.forEach((element) => {
        element.addEventListener('animationend', onAnimationEnd);
        element.classList.add('is-content-entering');
      });
      this.contentMotionCleanup = cleanup;
    }

    clearContentMotion() {
      this.contentMotionCleanup?.();
      this.contentMotionCleanup = null;
    }

    clearTransitionListeners() {
      this.transitionCleanup?.();
      this.transitionCleanup = null;
      if (this.transitionTimer) window.clearTimeout(this.transitionTimer);
      this.transitionTimer = null;
    }

    clearTransitionClasses() {
      this.classList.remove('is-switching');
      delete this.dataset.fabricTransition;
      this.slides.forEach((slide) => slide.classList.remove('is-entering', 'is-leaving'));
    }

    cancelTransition() {
      this.requestId = (this.requestId || 0) + 1;
      this.clearTransitionListeners();
      this.clearContentMotion();
      this.clearTransitionClasses();
      this.isTransitioning = false;
      if (this.slides?.length) {
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
        });
      }
      this.intentIndex = this.index;
      this.setBusy(false);
    }

    syncHeader() {
      const slide = this.slides[this.index];
      if (!slide) return;
      const heading = slide.dataset.fabricSlideHeading || '';
      const text = slide.dataset.fabricSlideText || '';
      if (this.heading) this.heading.textContent = heading;
      if (this.text) {
        this.text.textContent = text;
        this.text.hidden = !text;
      }
      if (this.carousel && heading) this.carousel.setAttribute('aria-label', heading);
      const activePanel = this.featurePanels[this.index];
      if (activePanel && heading) activePanel.setAttribute('aria-label', `${heading} ${this.index + 1}`);
    }

    setBusy(isBusy) {
      this.toggleAttribute('aria-busy', isBusy);
      this.updateControls();
    }

    updateControls() {
      const controlIndex = this.intentIndex ?? this.index;
      if (this.previousButton) this.previousButton.disabled = controlIndex === 0;
      if (this.nextButton) this.nextButton.disabled = controlIndex === this.slides.length - 1;
    }
  }

  if (!customElements.get('mt-pdp-fabric')) customElements.define('mt-pdp-fabric', MtPdpFabric);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  class MtPdpFaq extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.transitionTimers = new Map();
      this.layoutAnimations = new Map();
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.onClick);
      this.resetTransitions();
      this.cancelLayoutAnimations();
      this.initialized = false;
    }
    motionAllowed() {
      return !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    }
    clearTransitionTimers() {
      this.transitionTimers?.forEach((timer) => window.clearTimeout(timer));
      this.transitionTimers?.clear();
    }
    cancelLayoutAnimations() {
      this.layoutAnimations?.forEach((animation) => animation.cancel());
      this.layoutAnimations?.clear();
    }
    finishLayoutAnimations() {
      this.layoutAnimations?.forEach((animation) => {
        try {
          animation.finish();
        } catch (_error) {
          animation.cancel();
        }
      });
      this.layoutAnimations?.clear();
    }
    captureItemRects() {
      return new Map(
        Array.from(this.querySelectorAll('.mt-pdp-faq__item')).map((item) => [item, item.getBoundingClientRect()])
      );
    }
    animateLayoutFrom(beforeRects) {
      if (!this.motionAllowed() || typeof Element.prototype.animate !== 'function') return;

      const movedItems = Array.from(this.querySelectorAll('.mt-pdp-faq__item')).map((item) => {
        const before = beforeRects.get(item);
        const after = item.getBoundingClientRect();
        return { item, deltaY: before ? before.top - after.top : 0 };
      }).filter(({ deltaY }) => Math.abs(deltaY) >= 0.5);

      movedItems.forEach(({ item, deltaY }) => {
        const animation = item.animate(
          [
            { transform: `translateY(${deltaY}px)` },
            { transform: 'translateY(0)' }
          ],
          { duration: 280, easing: 'cubic-bezier(.16, 1, .3, 1)' }
        );
        this.layoutAnimations.set(item, animation);
        animation.finished.then(() => {
          if (this.layoutAnimations.get(item) === animation) this.layoutAnimations.delete(item);
        }).catch(() => {});
      });
    }
    animateItemHeight(item, fromHeight, toHeight) {
      if (!this.motionAllowed() || typeof item.animate !== 'function' || Math.abs(fromHeight - toHeight) < 0.5) return;

      const animation = item.animate(
        [
          { height: `${fromHeight}px`, overflow: 'clip' },
          { height: `${toHeight}px`, overflow: 'clip' }
        ],
        { duration: 280, easing: 'cubic-bezier(.16, 1, .3, 1)' }
      );
      this.layoutAnimations.set(item, animation);
      animation.finished.then(() => {
        if (this.layoutAnimations.get(item) === animation) this.layoutAnimations.delete(item);
      }).catch(() => {});
    }
    resetTransitions() {
      this.clearTransitionTimers();
      this.querySelectorAll('[data-faq-intent]').forEach((item) => {
        item.open = item.dataset.faqIntent === 'open';
        delete item.dataset.faqIntent;
        delete item.dataset.faqTransition;
      });
    }
    schedule(item, intent, callback, delay) {
      const existingTimer = this.transitionTimers.get(item);
      if (existingTimer) window.clearTimeout(existingTimer);
      const timer = window.setTimeout(() => {
        this.transitionTimers.delete(item);
        if (item.dataset.faqIntent !== intent) return;
        callback();
      }, delay);
      this.transitionTimers.set(item, timer);
    }
    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const summary = event.target.closest('.mt-pdp-faq__item > summary');
      const item = summary?.parentElement;
      if (!(item instanceof HTMLDetailsElement) || !this.contains(item)) return;
      event.preventDefault();
      this.finishLayoutAnimations();
      const pendingIntent = item.dataset.faqIntent;
      const shouldOpen = pendingIntent ? pendingIntent === 'closed' : !item.open;
      this.resetTransitions();
      if (shouldOpen) {
        this.openItem(item);
      } else {
        this.closeItem(item);
      }
    }
    openItem(item) {
      if (!this.motionAllowed()) {
        item.open = true;
        return;
      }
      const beforeRects = this.captureItemRects();
      const collapsedHeight = item.getBoundingClientRect().height;
      item.dataset.faqIntent = 'open';
      item.dataset.faqTransition = 'opening';
      item.open = true;
      const expandedHeight = item.getBoundingClientRect().height;
      this.animateItemHeight(item, collapsedHeight, expandedHeight);
      this.animateLayoutFrom(beforeRects);
      this.schedule(item, 'open', () => {
        delete item.dataset.faqIntent;
        delete item.dataset.faqTransition;
      }, 260);
    }
    closeItem(item) {
      if (!item.open) {
        delete item.dataset.faqIntent;
        delete item.dataset.faqTransition;
        return;
      }
      if (!this.motionAllowed()) {
        item.open = false;
        return;
      }
      item.dataset.faqIntent = 'closed';
      item.dataset.faqTransition = 'closing';
      this.schedule(item, 'closed', () => {
        const beforeRects = this.captureItemRects();
        const expandedHeight = item.getBoundingClientRect().height;
        item.open = false;
        const collapsedHeight = item.getBoundingClientRect().height;
        this.animateItemHeight(item, expandedHeight, collapsedHeight);
        delete item.dataset.faqIntent;
        delete item.dataset.faqTransition;
        this.animateLayoutFrom(beforeRects);
      }, 160);
    }
  }
  if (!customElements.get('mt-pdp-faq')) customElements.define('mt-pdp-faq', MtPdpFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-pdp-story"] && !Shopify.designMode) return;
  try {
    
  class MtPdpStoryMedia extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.content = this.querySelector('[data-story-media-content]');
      this.template = this.querySelector('[data-story-video-template]');
      if (!this.content || !this.template) return;

      this.hydrate = this.hydrate.bind(this);
      if (!('IntersectionObserver' in window)) {
        this.hydrate();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.hydrate();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.playbackObserver?.disconnect();
      this.motionQuery?.removeEventListener('change', this.handleMotionChange);
      this.querySelector('video')?.pause();
      if (!this.hydrated) this.initialized = false;
    }

    hydrate() {
      if (this.hydrated) return;

      this.hydrated = true;
      this.observer?.disconnect();
      const fragment = this.template.content.cloneNode(true);
      const video = fragment.querySelector('video');
      this.motionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      this.handleMotionChange = () => this.syncMotionPreference();
      this.userPaused = false;
      this.isPlaybackVisible = false;

      if (video && this.motionQuery?.matches) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
      }

      this.content.replaceChildren(fragment);
      this.motionQuery?.addEventListener('change', this.handleMotionChange);
      video?.addEventListener('pause', () => {
        if (this.ignoreNextPause) {
          this.ignoreNextPause = false;
          return;
        }
        if (!video.ended) this.userPaused = true;
      });
      video?.addEventListener('play', () => {
        this.userPaused = false;
      });

      if ('IntersectionObserver' in window) {
        this.playbackObserver = new IntersectionObserver((entries) => {
          this.isPlaybackVisible = entries.some((entry) => entry.isIntersecting);
          this.syncMotionPreference();
        }, { threshold: 0.1 });
        this.playbackObserver.observe(this);
      } else {
        this.isPlaybackVisible = true;
      }

      this.syncMotionPreference();
    }

    syncMotionPreference() {
      const video = this.querySelector('video');
      if (!video) return;

      if (this.motionQuery?.matches || !this.isPlaybackVisible || this.userPaused) {
        video.autoplay = false;
        if (!video.paused) {
          this.ignoreNextPause = true;
          video.pause();
        }
        return;
      }

      video.autoplay = true;
      video.play().catch(() => {});
    }
  }

  if (!customElements.get('mt-pdp-story-media')) {
    customElements.define('mt-pdp-story-media', MtPdpStoryMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  class MtPdpUgc extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.status = this.querySelector('[data-ugc-status]');
      this.dialog = this.querySelector('[data-ugc-dialog]');
      this.defaultDialogLabel = this.dialog?.getAttribute('aria-label') || '';
      this.dialogMedia = this.querySelector('[data-ugc-dialog-media]');
      this.lastTrigger = null;
      this.onClick = this.onClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onDialogCancel = this.onDialogCancel.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('submit', this.onSubmit);
      this.dialog?.addEventListener('close', this.onDialogClose);
      this.dialog?.addEventListener('cancel', this.onDialogCancel);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('submit', this.onSubmit);
      this.dialog?.removeEventListener('close', this.onDialogClose);
      this.dialog?.removeEventListener('cancel', this.onDialogCancel);
      this.clearDialogMedia();
      this.initialized = false;
    }
    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const close = event.target.closest('[data-ugc-close]');
      if (close) { this.closeDialog(); return; }
      const open = event.target.closest('[data-ugc-open]');
      if (open instanceof HTMLElement) this.openDialog(open);
    }
    async onSubmit(event) {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches('[data-ugc-add-form]')) return;
      event.preventDefault();
      const submit = event.target.querySelector('[data-ugc-add]');
      const id = event.target.querySelector('[name="id"]')?.value;
      if (!(submit instanceof HTMLButtonElement) || !id) return;
      if (this.status) this.status.textContent = '';
      submit.disabled = true;
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', origin: 'product-ugc' } }));
      } catch (error) {
        if (this.status) this.status.textContent = error.message || this.dataset.errorMessage;
      } finally { submit.disabled = false; }
    }
    openDialog(trigger) {
      const source = trigger.dataset.videoSrc || trigger.dataset.imageSrc;
      if (!source || !this.dialog || !this.dialogMedia) return;
      this.lastTrigger = trigger;
      this.clearDialogMedia();
      if (trigger.dataset.imageSrc) {
        const image = document.createElement('img');
        image.src = source;
        image.alt = trigger.dataset.imageAlt || '';
        this.dialogMedia.append(image);
        this.dialog.setAttribute('aria-label', image.alt || this.dialog.getAttribute('aria-label') || '');
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
        return;
      }
      this.dialog.setAttribute('aria-label', this.defaultDialogLabel);
      const video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.preload = 'none';
      if (trigger.dataset.videoPoster) video.poster = trigger.dataset.videoPoster;
      const mediaSource = document.createElement('source');
      mediaSource.src = source;
      if (trigger.dataset.videoType) mediaSource.type = trigger.dataset.videoType;
      video.append(mediaSource);
      video.addEventListener('error', () => {
        if (this.status) this.status.textContent = this.dataset.videoErrorMessage;
      }, { once: true });
      this.dialogMedia.append(video);
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      video.play().catch(() => {});
    }
    closeDialog() {
      if (typeof this.dialog?.close === 'function' && this.dialog.open) this.dialog.close();
      else if (this.dialog) { this.dialog.removeAttribute('open'); this.onDialogClose(); }
    }
    onDialogCancel(event) { event.preventDefault(); this.closeDialog(); }
    onDialogClose() { this.clearDialogMedia(); this.lastTrigger?.focus(); this.lastTrigger = null; }
    clearDialogMedia() {
      const video = this.dialogMedia?.querySelector('video');
      if (video) { video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach((source) => source.remove()); video.load(); }
      this.dialogMedia?.replaceChildren();
    }
  }
  if (!customElements.get('mt-pdp-ugc')) customElements.define('mt-pdp-ugc', MtPdpUgc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-press-logo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-press-logo-bar')) {
    class MtPressLogoBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-press-logo-viewport]');
        this.track = this.querySelector('[data-press-logo-track]');
        if (!this.viewport || !this.track) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.speedLevel = Math.min(10, Math.max(1, Number.parseInt(this.dataset.scrollSpeed, 10) || 4));
        this.pixelsPerSecond = 24 + (this.speedLevel * 9);
        this.hasVisualFocus = false;
        this.dragging = false;
        this.suppressClick = false;
        this.pointerPaused = false;
        this.focusPaused = false;
        this.editorPaused = false;

        this.onMediaChange = () => this.syncMode();
        this.onVisibilityChange = () => this.syncAnimation();
        this.onPointerDown = (event) => this.handlePointerDown(event);
        this.onPointerMove = (event) => this.handlePointerMove(event);
        this.onPointerUp = (event) => this.handlePointerUp(event);
        this.onClickCapture = (event) => this.handleClickCapture(event);
        this.onFocusIn = (event) => this.handleFocusIn(event);
        this.onFocusOut = (event) => this.handleFocusOut(event);
        this.onBlockSelect = (event) => this.handleBlockSelect(event);
        this.onBlockDeselect = () => {
          this.editorPaused = false;
          this.syncAnimation();
        };

        this.motionQuery.addEventListener('change', this.onMediaChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointermove', this.onPointerMove);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerUp);
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.hasVisualFocus = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          this.syncAnimation();
        }, { threshold: [0, 0.5] });
        this.intersectionObserver.observe(this);

        this.resizeObserver = new ResizeObserver(() => {
          if (!this.motionQuery.matches) this.scheduleBuild();
        });
        this.resizeObserver.observe(this.viewport);
        this.syncMode();
      }

      disconnectedCallback() {
        this.initialized = false;
        this.buildRevision = (this.buildRevision || 0) + 1;
        this.animation?.cancel();
        window.cancelAnimationFrame(this.buildFrame);
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.motionQuery?.removeEventListener('change', this.onMediaChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport?.removeEventListener('pointermove', this.onPointerMove);
        this.viewport?.removeEventListener('pointerup', this.onPointerUp);
        this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
        this.viewport?.removeEventListener('click', this.onClickCapture, true);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      syncMode() {
        const shouldEnable = !this.motionQuery.matches;
        if (shouldEnable) {
          this.scheduleBuild();
        } else {
          this.disableCarousel();
        }
      }

      scheduleBuild() {
        const previousProgress = this.animation && this.duration
          ? ((Number(this.animation.currentTime) || 0) % this.duration) / this.duration
          : (this.pendingBuildProgress || 0);
        this.pendingBuildProgress = previousProgress;
        this.animation?.cancel();
        this.animation = null;
        window.cancelAnimationFrame(this.buildFrame);
        const revision = (this.buildRevision || 0) + 1;
        this.buildRevision = revision;
        this.buildFrame = window.requestAnimationFrame(() => {
          if (!this.initialized || revision !== this.buildRevision) return;
          const progress = this.pendingBuildProgress || 0;
          this.pendingBuildProgress = 0;
          this.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());
          this.setAttribute('data-carousel-ready', '');
          this.track.style.transform = '';
          this.buildCarousel(progress);
        });
      }

      buildCarousel(previousProgress = 0) {
        this.originalItems = Array.from(this.track.children).filter((item) => !item.hasAttribute('data-carousel-clone'));
        if (this.originalItems.length < 2) {
          this.disableCarousel();
          return;
        }

        const firstItem = this.originalItems[0];
        const lastItem = this.originalItems[this.originalItems.length - 1];
        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        this.cycleDistance = (lastItem.offsetLeft + lastItem.offsetWidth - firstItem.offsetLeft) + gap;
        if (this.cycleDistance <= 0) {
          this.disableCarousel();
          return;
        }

        const requiredCloneCoverage = this.viewport.clientWidth + gap + 1;
        const totalSets = Math.max(2, 1 + Math.ceil(requiredCloneCoverage / this.cycleDistance));
        const fragment = document.createDocumentFragment();
        for (let setIndex = 1; setIndex < totalSets; setIndex += 1) {
          this.originalItems.forEach((item) => fragment.append(this.createClone(item)));
        }
        this.track.append(fragment);

        this.duration = (this.cycleDistance / this.pixelsPerSecond) * 1000;
        this.animation = this.track.animate(
          [
            { transform: 'translate3d(0, 0, 0)' },
            { transform: `translate3d(${-this.cycleDistance}px, 0, 0)` }
          ],
          { duration: this.duration, iterations: Infinity, easing: 'linear' }
        );
        this.animation.pause();
        this.animation.currentTime = previousProgress * this.duration;
        this.syncAnimation();
      }

      createClone(item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('data-carousel-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-reveal');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('img.lazy-fade').forEach((image) => image.classList.add('is-loaded'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
        return clone;
      }

      disableCarousel() {
        this.buildRevision = (this.buildRevision || 0) + 1;
        this.pendingBuildProgress = 0;
        this.animation?.cancel();
        this.animation = null;
        window.cancelAnimationFrame(this.buildFrame);
        this.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());
        this.removeAttribute('data-carousel-ready');
        this.track.style.transform = '';
        this.duration = 0;
        this.cycleDistance = 0;
      }

      syncAnimation() {
        if (!this.animation) return;
        const canPlay = !this.motionQuery.matches
          && this.hasVisualFocus
          && !document.hidden
          && !this.pointerPaused
          && !this.focusPaused
          && !this.editorPaused;
        if (canPlay) {
          this.animation.play();
        } else {
          this.animation.pause();
        }
      }

      handlePointerDown(event) {
        if (!this.hasAttribute('data-carousel-ready') || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.pointerPaused = true;
        this.dragging = true;
        this.dragStartX = event.clientX;
        this.dragDelta = 0;
        this.dragStartTime = Number(this.animation?.currentTime) || 0;
        this.syncAnimation();
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      handlePointerMove(event) {
        if (!this.dragging || !this.animation || !this.duration) return;
        this.dragDelta = event.clientX - this.dragStartX;
        if (Math.abs(this.dragDelta) > 6) this.suppressClick = true;
        const requestedTime = this.dragStartTime - ((this.dragDelta / this.pixelsPerSecond) * 1000);
        this.animation.currentTime = ((requestedTime % this.duration) + this.duration) % this.duration;
      }

      handlePointerUp(event) {
        if (!this.dragging) return;
        this.dragging = false;
        this.pointerPaused = false;
        if (this.viewport.hasPointerCapture?.(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
        this.syncAnimation();
        window.setTimeout(() => { this.suppressClick = false; }, 0);
      }

      handleClickCapture(event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }

      handleFocusIn(event) {
        if (!this.hasAttribute('data-carousel-ready')) return;
        this.focusPaused = true;
        this.syncAnimation();
      }

      handleFocusOut(event) {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.syncAnimation();
      }

      handleBlockSelect(event) {
        if (!this.hasAttribute('data-carousel-ready')) return;
        this.editorPaused = true;
        const item = event.target.closest('.mt-press-logo-bar__item');
        const itemIndex = this.originalItems.indexOf(item);
        if (itemIndex >= 0 && this.animation && this.cycleDistance) {
          const itemOffset = item.offsetLeft - this.originalItems[0].offsetLeft;
          this.animation.currentTime = (itemOffset / this.cycleDistance) * this.duration;
        }
        this.syncAnimation();
      }
    }

    customElements.define('mt-press-logo-bar', MtPressLogoBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product-comparison"] && !Shopify.designMode) return;
  try {
    
  class MtProductComparison extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.scrollElement = this.querySelector('[data-mt-pc-scroll]');
      this.scrollElement?.addEventListener('scroll', () => this.updateProgress(), { passive: true, signal: this.abortController.signal });
      this.resizeObserver = new ResizeObserver(() => this.updateProgress());
      if (this.scrollElement) this.resizeObserver.observe(this.scrollElement);
      this.updateProgress();
    }
    disconnectedCallback() { this.abortController?.abort(); this.abortController = null; this.resizeObserver?.disconnect(); this.resizeObserver = null; }
    updateProgress() { if (!this.scrollElement) return; const width = this.scrollElement.clientWidth; const scrollWidth = this.scrollElement.scrollWidth; const max = scrollWidth - width; const thumb = scrollWidth > 0 ? Math.max(10, width / scrollWidth * 100) : 100; const left = max > 0 ? this.scrollElement.scrollLeft / max * (100 - thumb) : 0; this.style.setProperty('--mt-pc-progress-width', `${thumb}%`); this.style.setProperty('--mt-pc-progress-left', `${left}%`); }
  }
  if (!customElements.get('mt-product-comparison')) customElements.define('mt-product-comparison', MtProductComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product-details"] && !Shopify.designMode) return;
  try {
    
  class MtProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('.mt-product-details__form');
      this.variantInput = this.querySelector('[data-mt-pd-variant-id]');
      if (this.variantInput) this.variantInput.name = 'id';
      this.variants = JSON.parse(this.querySelector('[data-mt-pd-variants]')?.textContent || '[]');
      this.addButton = this.querySelector('[data-mt-pd-add]');
      this.status = this.querySelector('[data-mt-pd-status]');
      this.lastFocusedElement = null;
      this.activeMediaId = String(this.querySelector('[data-mt-pd-media-id].is-active')?.dataset.mtPdMediaId || '');
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-mt-pd-option]')) this.syncVariant();
      });
      this.addEventListener('click', (event) => this.onClick(event));
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.querySelectorAll('[data-mt-pd-dialog]').forEach((dialog) => {
        dialog.addEventListener('close', () => this.onDialogClose(dialog));
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      });
      this.setupStickyBar();
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-mt-pd-option-fieldset]')).map((field) => field.querySelector('[data-mt-pd-option]:checked')?.value || '');
    }

    syncVariant() {
      const selected = this.selectedOptions();
      this.querySelectorAll('[data-mt-pd-selected-option]').forEach((node, index) => { node.textContent = selected[index] || ''; });
      const variant = this.variants.find((candidate) => JSON.stringify(candidate.options) === JSON.stringify(selected));
      if (!variant) { this.setUnavailable(); return; }
      if (this.variantInput) this.variantInput.value = variant.id;
      this.setAvailability(variant.available);
      this.querySelectorAll('[data-mt-pd-price], [data-mt-pd-sticky-price]').forEach((node) => { if (variant.price_html) node.innerHTML = variant.price_html; });
      if (variant.featured_media_id) this.showMedia(String(variant.featured_media_id));
      if (variant.url) window.history.replaceState({}, '', variant.url);
    }

    setAvailability(available) {
      const label = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      if (this.addButton) this.addButton.disabled = !available;
      this.querySelectorAll('[data-mt-pd-add-label], [data-mt-pd-sticky-label]').forEach((node) => { node.textContent = label; });
      this.querySelectorAll('[data-mt-pd-sticky-add]').forEach((button) => { button.disabled = !available; });
    }

    setUnavailable() {
      if (this.addButton) this.addButton.disabled = true;
      this.querySelectorAll('[data-mt-pd-add-label], [data-mt-pd-sticky-label]').forEach((node) => { node.textContent = this.dataset.unavailableLabel; });
      this.querySelectorAll('[data-mt-pd-sticky-add]').forEach((button) => { button.disabled = true; });
    }

    onClick(event) {
      const mediaTarget = event.target.closest('[data-mt-pd-media-target]');
      if (mediaTarget) { this.showMedia(mediaTarget.dataset.mtPdMediaTarget); return; }
      const thumbnailScroll = event.target.closest('[data-mt-pd-thumbnail-scroll]');
      if (thumbnailScroll) { this.scrollThumbnails(thumbnailScroll.dataset.mtPdThumbnailScroll); return; }
      const quantity = event.target.closest('[data-mt-pd-quantity]');
      if (quantity) { this.changeQuantity(quantity.dataset.mtPdQuantity); return; }
      const dialogTrigger = event.target.closest('[data-mt-pd-open-dialog]');
      if (dialogTrigger) { this.openDialog(dialogTrigger.dataset.mtPdOpenDialog); return; }
      if (event.target.closest('[data-mt-pd-open-material]')) { this.openMaterialDialog(); return; }
      if (event.target.closest('[data-mt-pd-close-dialog]')) { event.target.closest('dialog')?.close(); return; }
      const copy = event.target.closest('[data-mt-pd-copy]');
      if (copy) { this.copyText(copy.dataset.mtPdCopy, copy); return; }
      if (event.target.closest('[data-mt-pd-sticky-add]')) { this.form?.requestSubmit(this.addButton); }
    }

    changeQuantity(direction) {
      const input = this.querySelector('[data-mt-pd-quantity-input]');
      if (!input) return;
      const current = Number.parseInt(input.value, 10) || 1;
      input.value = direction === 'increase' ? current + 1 : Math.max(1, current - 1);
    }

    scrollThumbnails(direction) {
      const scroller = this.querySelector('[data-mt-pd-thumbnail-scroller]');
      if (!scroller) return;
      const offset = Math.max(104, Math.round(scroller.clientWidth * .8));
      scroller.scrollBy({ left: direction === 'next' ? offset : -offset, behavior: 'smooth' });
    }

    showMedia(id) {
      if (!id) return;
      this.activeMediaId = String(id);
      this.querySelectorAll('[data-mt-pd-media-id]').forEach((slide) => {
        const active = String(slide.dataset.mtPdMediaId) === this.activeMediaId;
        slide.classList.toggle('is-active', active);
        if (active && window.matchMedia('(max-width: 899px)').matches) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      this.querySelectorAll('[data-mt-pd-media-target]').forEach((button) => {
        const active = String(button.dataset.mtPdMediaTarget) === this.activeMediaId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    openMaterialDialog() {
      const activeValue = this.querySelector('[data-mt-pd-option]:checked')?.value;
      this.querySelectorAll('[data-mt-pd-material-panel]').forEach((panel) => { panel.hidden = panel.dataset.mtPdMaterialPanel !== activeValue; });
      this.openDialog('material');
    }

    openDialog(name) {
      const dialog = this.querySelector(`[data-mt-pd-dialog="${name}"]`);
      if (!dialog) return;
      this.lastFocusedElement = document.activeElement;
      if (name === 'zoom') this.populateZoom(dialog);
      document.body.classList.add('mt-product-details--dialog-open');
      dialog.showModal();
    }

    populateZoom(dialog) {
      const source = this.querySelector(`[data-mt-pd-media-id="${this.activeMediaId}"] img`);
      const content = dialog.querySelector('[data-mt-pd-zoom-content]');
      if (!source || !content) return;
      const image = document.createElement('img');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      content.replaceChildren(image);
    }

    onDialogClose() {
      if (!this.querySelector('[data-mt-pd-dialog][open]')) document.body.classList.remove('mt-product-details--dialog-open');
      this.lastFocusedElement?.focus?.();
      this.lastFocusedElement = null;
    }

    async copyText(text, button) {
      const originalText = button.textContent;
      try { await navigator.clipboard?.writeText(text); button.textContent = this.dataset.addedLabel; } catch (_) { return; }
      window.setTimeout(() => { button.textContent = originalText; }, 1400);
    }

    async onSubmit(event) {
      if (!event.submitter?.matches('[data-mt-pd-add]')) return;
      event.preventDefault();
      if (!this.form || !this.variantInput || !this.addButton) return;
      this.addButton.disabled = true;
      try {
        const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorLabel);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'mt-product-details' } }));
        this.setStatus(this.dataset.addedLabel, false);
      } catch (error) {
        this.setStatus(error.message || this.dataset.errorLabel, true);
      } finally {
        const current = this.variants.find((variant) => String(variant.id) === String(this.variantInput.value));
        if (current) this.setAvailability(current.available);
      }
    }

    setStatus(message, isError) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.hidden = false;
      this.status.classList.toggle('is-error', Boolean(isError));
    }

    setupStickyBar() {
      const sticky = this.querySelector('[data-mt-pd-sticky-bar]');
      if (!sticky || !('IntersectionObserver' in window)) return;
      const addButton = this.querySelector('[data-mt-pd-add]');
      if (!addButton) return;
      this.stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
      this.stickyObserver.observe(addButton);
    }

    disconnectedCallback() { this.stickyObserver?.disconnect(); }
  }

  if (!customElements.get('mt-product-details')) customElements.define('mt-product-details', MtProductDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-sale-floating-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-sale-floating-video')) {
    class MtSaleFloatingVideo extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-floating-video-item]'));
        this.dialog = this.querySelector('[data-floating-video-dialog]');
        this.media = this.querySelector('[data-floating-video-media]');
        this.title = this.querySelector('[data-floating-video-title]');
        this.index = 0;
        this.querySelector('[data-floating-video-open]')?.addEventListener('click', () => this.open());
        this.querySelector('[data-floating-video-close]')?.addEventListener('click', () => this.dialog?.close());
        this.querySelector('[data-floating-video-previous]')?.addEventListener('click', () => this.render(this.index - 1));
        this.querySelector('[data-floating-video-next]')?.addEventListener('click', () => this.render(this.index + 1));
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      }

      open() {
        if (!this.dialog || !this.items.length) return;
        this.render(this.index);
        this.dialog.showModal();
      }

      render(nextIndex) {
        if (!this.items.length || !this.media) return;
        this.index = (nextIndex + this.items.length) % this.items.length;
        this.media.replaceChildren(this.items[this.index].content.cloneNode(true));
        if (this.title) this.title.textContent = this.items[this.index].dataset.title || '';
      }
    }
    customElements.define('mt-sale-floating-video', MtSaleFloatingVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-sale-legacy-press"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-sale-legacy-press')) {
    class MtSaleLegacyPress extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-press-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-press-go-to]'));
        this.index = 0;
        this.querySelector('[data-press-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-press-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.pressGoTo))));
      }

      show(nextIndex) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      }
    }
    customElements.define('mt-sale-legacy-press', MtSaleLegacyPress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-seasonal-promo-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-seasonal-promo-slideshow')) {
    class MtSeasonalPromoSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
        this.progressFills = Array.from(this.querySelectorAll('[data-progress-fill]'));
        this.status = this.querySelector('[data-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Math.max(1000, Number.parseInt(this.dataset.interval || '6000', 10));
        this.remaining = this.interval;
        this.deadline = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileMedia = window.matchMedia('(max-width: 1023px)');
        this.finePointerMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.pauseReasons = new Set(['viewport']);
        if (document.hidden) this.pauseReasons.add('document');
        this.pointerStart = null;
        this.timer = null;
        this.progressAnimation = null;
        this.idleHandle = null;
        this.idleTimeout = null;
        this.transitionTimer = null;
        this.transitionToken = 0;
        this.abortController = new AbortController();
        this.bindEvents();
        this.observeViewport();
        this.onMotionChange();
        this.updateSlides(false);
        this.updateMedia();
        this.startAutoplay();
        this.scheduleNextImage();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.progressAnimation?.cancel();
        this.pauseAllMedia();
        this.observer?.disconnect();
        this.abortController?.abort();
        if ('cancelIdleCallback' in window && this.idleHandle) window.cancelIdleCallback(this.idleHandle);
        window.clearTimeout(this.idleTimeout);
        window.clearTimeout(this.transitionTimer);
        this.transitionToken += 1;
        this.clearTransitionClasses();
        this.initialized = false;
      }

      bindEvents() {
        const signal = this.abortController.signal;
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        this.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && this.finePointerMedia.matches) this.pause('hover');
        }, { signal });
        this.addEventListener('pointerleave', () => this.resume('hover'), { signal });
        this.addEventListener('focusin', (event) => {
          if (this.finePointerMedia.matches && event.target.matches(':focus-visible')) this.pause('focus');
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resume('focus');
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (!slide) return;
          this.pause('editor');
          this.goTo(Number.parseInt(slide.dataset.index, 10), true);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => this.resume('editor'), { signal });
        document.addEventListener('visibilitychange', () => this.onVisibilityChange(), { signal });
        window.addEventListener('blur', () => {
          if (this.finePointerMedia.matches) this.pause('document');
        }, { signal });
        window.addEventListener('focus', () => this.onDocumentFocus(), { signal });
        window.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        window.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
        this.reduceMotion.addEventListener('change', () => this.onMotionChange(), { signal });
        this.mobileMedia.addEventListener('change', () => this.onViewportModeChange(), { signal });
        this.finePointerMedia.addEventListener('change', () => this.onPointerCapabilityChange(), { signal });
      }

      observeViewport() {
        if (!('IntersectionObserver' in window)) {
          this.resume('viewport');
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry && entry.intersectionRatio >= 0.15) {
            this.clearUnsupportedInteractionPauses();
            this.resume('viewport');
          }
          else this.pause('viewport');
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
      }

      onClick(event) {
        if (event.target.closest('[data-previous]')) {
          this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
          return;
        }
        if (event.target.closest('[data-next]')) {
          this.goTo((this.currentIndex + 1) % this.slides.length, true);
          return;
        }
        const dot = event.target.closest('[data-go-to]');
        if (dot) {
          this.goTo(Number.parseInt(dot.dataset.goTo, 10), true);
          return;
        }
      }

      onKeydown(event) {
        if (this.slides.length < 2) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo((this.currentIndex + 1) % this.slides.length, true);
        }
      }

      onPointerDown(event) {
        if (!event.isPrimary || event.target.closest('a, button')) return;
        this.pointerStart = event.clientX;
        this.pause('pointer');
      }

      onPointerUp(event) {
        if (this.pointerStart === null) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (event.type !== 'pointercancel' && Math.abs(distance) > 50 && this.slides.length > 1) {
          const nextIndex = distance < 0
            ? (this.currentIndex + 1) % this.slides.length
            : (this.currentIndex - 1 + this.slides.length) % this.slides.length;
          this.goTo(nextIndex, true);
        }
        this.resume('pointer');
      }

      goTo(index, userInitiated = false) {
        if (!Number.isInteger(index) || index < 0 || index >= this.slides.length) return;
        if (index === this.currentIndex) {
          if (userInitiated) this.restartAutoplay();
          return;
        }
        this.finishTransition();
        const previousIndex = this.currentIndex;
        const direction = this.getDirection(previousIndex, index);
        this.hydrateSlide(index);
        this.currentIndex = index;
        this.remaining = this.interval;
        if (this.reduceMotion.matches) this.updateSlides(userInitiated);
        else this.animateSlides(previousIndex, index, direction, userInitiated);
        this.updateMedia();
        this.resetProgress();
        this.scheduleNextImage();
        this.restartAutoplay();
      }

      getDirection(fromIndex, toIndex) {
        const forwardDistance = (toIndex - fromIndex + this.slides.length) % this.slides.length;
        const backwardDistance = (fromIndex - toIndex + this.slides.length) % this.slides.length;
        return forwardDistance <= backwardDistance ? 'forward' : 'backward';
      }

      animateSlides(previousIndex, nextIndex, direction, announce) {
        const previousSlide = this.slides[previousIndex];
        const nextSlide = this.slides[nextIndex];
        if (!previousSlide || !nextSlide) {
          this.updateSlides(announce);
          return;
        }
        const transitionToken = ++this.transitionToken;
        const enteringClass = `is-entering-${direction}`;
        const leavingClass = `is-leaving-${direction}`;
        nextSlide.classList.add('is-entering', enteringClass);
        nextSlide.hidden = false;
        previousSlide.classList.add('is-leaving', leavingClass);
        requestAnimationFrame(() => {
          if (!this.initialized || transitionToken !== this.transitionToken) return;
          previousSlide.classList.remove('is-active');
          nextSlide.classList.add('is-active');
          nextSlide.classList.remove('is-entering', enteringClass);
          this.updateSlideSemantics(announce);
        });
        this.transitionTimer = window.setTimeout(() => {
          if (transitionToken !== this.transitionToken) return;
          previousSlide.classList.remove('is-leaving', leavingClass);
          previousSlide.hidden = true;
          this.unmountGif(previousSlide);
          previousSlide.removeAttribute('data-active-media');
          this.transitionTimer = null;
        }, 560);
      }

      finishTransition() {
        window.clearTimeout(this.transitionTimer);
        this.transitionTimer = null;
        this.transitionToken += 1;
        this.clearTransitionClasses();
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
          if (!active) {
            this.pauseSlideVideo(slide);
            this.unmountGif(slide);
            slide.removeAttribute('data-active-media');
          }
        });
      }

      clearTransitionClasses() {
        this.slides?.forEach((slide) => {
          slide.classList.remove('is-entering', 'is-leaving', 'is-entering-forward', 'is-entering-backward', 'is-leaving-forward', 'is-leaving-backward');
        });
      }

      updateSlides(announce = true) {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.classList.toggle('is-active', active);
        });
        this.updateSlideSemantics(announce);
      }

      updateSlideSemantics(announce = true) {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
          slide.hidden = !(active || slide.classList.contains('is-leaving'));
        });
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
        });
        if (announce && this.status) {
          this.status.textContent = this.slides[this.currentIndex]?.getAttribute('aria-label') || '';
        }
      }

      hydrateSlide(index) {
        const slide = this.slides[index];
        const template = slide?.querySelector('template[data-media-template]');
        const slot = slide?.querySelector('[data-media-slot]');
        if (!template || !slot) return;
        slot.append(template.content.cloneNode(true));
        template.remove();
        this.initializeLazyImages(slot);
      }

      initializeLazyImages(container) {
        container.querySelectorAll('img.lazy-fade').forEach((image) => {
          if (image.complete && image.naturalWidth > 0) {
            image.classList.add('is-loaded');
            return;
          }
          const revealImage = () => image.classList.add('is-loaded');
          image.addEventListener('load', revealImage, { once: true, signal: this.abortController.signal });
          image.addEventListener('error', revealImage, { once: true, signal: this.abortController.signal });
        });
      }

      getMediaChoice(slide) {
        const mode = this.mobileMedia.matches ? 'mobile' : 'desktop';
        const alternate = mode === 'mobile' ? 'desktop' : 'mobile';
        const has = (candidateMode, type) => slide.dataset[`${candidateMode}${type}`] === 'true';
        if (has(mode, 'Video')) return { type: 'video', mode };
        if (has(mode, 'Gif')) return { type: 'gif', mode };
        if (has(mode, 'Image')) return { type: 'image', mode };
        if (has(alternate, 'Video')) return { type: 'video', mode: alternate };
        if (has(alternate, 'Gif')) return { type: 'gif', mode: alternate };
        if (has(alternate, 'Image')) return { type: 'image', mode: alternate };
        return { type: 'fixed', mode };
      }

      updateMediaLayout(slide, choice) {
        const viewportMode = this.mobileMedia.matches ? 'mobile' : 'desktop';
        const adaptive = choice.type === 'image' || choice.type === 'gif';
        this.dataset[`${viewportMode}LayoutMedia`] = adaptive ? 'adaptive' : 'fixed';
        if (!adaptive) return;
        const mediaType = choice.type === 'gif' ? 'Gif' : 'Image';
        const width = Number.parseFloat(slide.dataset[`${choice.mode}${mediaType}Width`]);
        const height = Number.parseFloat(slide.dataset[`${choice.mode}${mediaType}Height`]);
        if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return;
        this.style.setProperty(`--mt-promo-${viewportMode}-ratio`, `${width} / ${height}`);
      }

      updateMedia() {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          if (!active) {
            this.pauseSlideVideo(slide);
            if (!slide.classList.contains('is-leaving')) {
              this.unmountGif(slide);
              slide.removeAttribute('data-active-media');
            }
            return;
          }
          this.hydrateSlide(index);
          const choice = this.getMediaChoice(slide);
          this.updateMediaLayout(slide, choice);
          slide.dataset.activeMedia = choice.type;
          if (choice.type === 'video') {
            this.unmountGif(slide);
            this.mountVideo(slide, choice.mode);
            if (this.canPlayMedia()) this.playSlideVideo(slide);
            else this.pauseSlideVideo(slide);
          } else if (choice.type === 'gif') {
            this.pauseSlideVideo(slide);
            if (this.canPlayMedia()) this.mountGif(slide);
            else this.unmountGif(slide);
          } else {
            this.pauseSlideVideo(slide);
            this.unmountGif(slide);
          }
        });
      }

      canPlayMedia() {
        return !this.pauseReasons.has('viewport') && !this.pauseReasons.has('document') && !this.pauseReasons.has('motion');
      }

      mountVideo(slide, mode) {
        const slot = slide.querySelector('[data-video-slot]');
        if (!slot || (slot.dataset.mode === mode && slot.querySelector('video'))) return;
        const template = slide.querySelector(`template[data-video-template="${mode}"]`);
        if (!template) return;
        slot.replaceChildren(template.content.cloneNode(true));
        slot.dataset.mode = mode;
        const video = slot.querySelector('video');
        if (!video) return;
        video.preload = 'none';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.addEventListener('playing', () => {
          if (this.slides[this.currentIndex] === slide && !video.paused) slide.classList.add('has-playing-video');
        }, { signal: this.abortController.signal });
      }

      playSlideVideo(slide) {
        const video = slide.querySelector('[data-video-slot] video');
        if (video) video.play().catch(() => slide.classList.remove('has-playing-video'));
      }

      pauseSlideVideo(slide) {
        const video = slide.querySelector('[data-video-slot] video');
        if (video) video.pause();
        slide.classList.remove('has-playing-video');
      }

      mountGif(slide) {
        const slot = slide.querySelector('[data-gif-slot]');
        const template = slide.querySelector('template[data-gif-template]');
        if (!slot || !template || slot.childElementCount > 0) return;
        slot.append(template.content.cloneNode(true));
        slide.classList.add('has-playing-gif');
      }

      unmountGif(slide) {
        slide.querySelector('[data-gif-slot]')?.replaceChildren();
        slide.classList.remove('has-playing-gif');
      }

      pauseAllMedia() {
        this.slides?.forEach((slide) => {
          this.pauseSlideVideo(slide);
          this.unmountGif(slide);
        });
      }

      onViewportModeChange() {
        this.slides.forEach((slide) => {
          this.pauseSlideVideo(slide);
          const slot = slide.querySelector('[data-video-slot]');
          if (slot) {
            slot.replaceChildren();
            delete slot.dataset.mode;
          }
          this.unmountGif(slide);
        });
        this.updateMedia();
      }

      onPointerCapabilityChange() {
        this.clearUnsupportedInteractionPauses();
        this.startAutoplay();
      }

      clearUnsupportedInteractionPauses() {
        if (this.finePointerMedia.matches) return;
        this.pauseReasons.delete('hover');
        this.pauseReasons.delete('focus');
        if (!document.hidden) this.pauseReasons.delete('document');
      }

      scheduleNextImage() {
        if (this.slides.length < 2) return;
        if ('cancelIdleCallback' in window && this.idleHandle) window.cancelIdleCallback(this.idleHandle);
        window.clearTimeout(this.idleTimeout);
        const hydrateNext = () => {
          this.idleHandle = null;
          this.idleTimeout = null;
          this.hydrateSlide((this.currentIndex + 1) % this.slides.length);
        };
        if ('requestIdleCallback' in window) {
          this.idleHandle = window.requestIdleCallback(hydrateNext, { timeout: 2500 });
        } else {
          this.idleTimeout = window.setTimeout(hydrateNext, 1200);
        }
      }

      onVisibilityChange() {
        if (document.hidden) this.pause('document');
        else this.onDocumentFocus();
      }

      onDocumentFocus() {
        if (!document.hidden) {
          this.clearUnsupportedInteractionPauses();
          this.resume('document');
        }
      }

      onMotionChange() {
        if (this.reduceMotion.matches) {
          this.finishTransition();
          this.updateSlides(false);
          this.pause('motion');
        } else {
          this.resume('motion');
        }
      }

      pause(reason) {
        if (this.pauseReasons.has(reason)) return;
        this.captureRemaining();
        this.pauseReasons.add(reason);
        this.stopAutoplay();
        this.updateProgress(false);
        this.updateMedia();
      }

      resume(reason) {
        this.pauseReasons.delete(reason);
        this.updateMedia();
        this.startAutoplay();
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.slides.length < 2 || this.pauseReasons.size > 0 || this.timer) return;
        this.deadline = performance.now() + this.remaining;
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.deadline = 0;
          this.remaining = this.interval;
          this.goTo((this.currentIndex + 1) % this.slides.length, false);
        }, this.remaining);
        this.updateProgress(false);
      }

      stopAutoplay() {
        if (!this.timer) {
          this.deadline = 0;
          return;
        }
        window.clearTimeout(this.timer);
        this.timer = null;
        this.deadline = 0;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.remaining = this.interval;
        this.startAutoplay();
      }

      captureRemaining() {
        if (!this.timer || !this.deadline) return;
        this.remaining = Math.max(0, this.deadline - performance.now());
      }

      resetProgress() {
        this.progressAnimation?.cancel();
        this.progressAnimation = null;
        this.progressFills.forEach((fill) => {
          fill.style.transform = 'scaleX(0)';
        });
      }

      updateProgress(reset = false) {
        if (reset) this.resetProgress();
        const fill = this.progressFills[this.currentIndex];
        if (!fill) return;
        this.progressAnimation?.cancel();
        this.progressAnimation = null;
        if (!this.autoplayEnabled || this.reduceMotion.matches || this.slides.length < 2) {
          fill.style.transform = 'scaleX(1)';
          return;
        }
        const progress = Math.min(1, Math.max(0, 1 - (this.remaining / this.interval)));
        fill.style.transform = `scaleX(${progress})`;
        if (this.pauseReasons.size > 0 || this.remaining <= 0 || typeof fill.animate !== 'function') return;
        this.progressAnimation = fill.animate(
          [{ transform: `scaleX(${progress})` }, { transform: 'scaleX(1)' }],
          { duration: this.remaining, easing: 'linear', fill: 'forwards' }
        );
      }
    }

    customElements.define('mt-seasonal-promo-slideshow', MtSeasonalPromoSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-social-swiper"] && !Shopify.designMode) return;
  try {
    
  class MtSocialSwiper extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.viewport = this.querySelector('[data-social-viewport]');
      this.track = this.querySelector('.mt-social-swiper__track');
      this.realSlides = [...this.querySelectorAll('[data-social-slide]')];
      this.activeIndex = 0;
      this.loopMedia = window.matchMedia('(min-width: 621px)');
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onLoopChange = this.onLoopChange.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.loopMedia.addEventListener('change', this.onLoopChange);
      this.rebuildLoop();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.loopMedia?.removeEventListener('change', this.onLoopChange);
      window.clearTimeout(this.scrollTimer);
      this.initialized = false;
    }
    createClone(slide) {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-social-slide');
      clone.setAttribute('data-social-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.tabIndex = -1;
      clone.querySelectorAll('a, button, [tabindex]').forEach((element) => { element.tabIndex = -1; });
      clone.querySelectorAll('img').forEach((image) => { image.loading = 'lazy'; image.removeAttribute('fetchpriority'); });
      return clone;
    }
    rebuildLoop() {
      this.track?.querySelectorAll('[data-social-clone]').forEach((clone) => clone.remove());
      if (!this.track || !this.realSlides.length) return;
      if (this.loopMedia.matches && this.realSlides.length > 3) {
        const cloneCount = Math.min(3, this.realSlides.length);
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        this.realSlides.slice(-cloneCount).forEach((slide) => before.append(this.createClone(slide)));
        this.realSlides.slice(0, cloneCount).forEach((slide) => after.append(this.createClone(slide)));
        this.track.prepend(before);
        this.track.append(after);
      }
      this.slides = [...this.track.querySelectorAll('[data-social-slide], [data-social-clone]')];
      window.requestAnimationFrame(() => this.activate(this.activeIndex, 'auto'));
    }
    onLoopChange() { this.rebuildLoop(); }
    setActive(index) {
      this.activeIndex = index;
      this.slides.forEach((item) => item.classList.toggle('is-active', Number(item.dataset.socialIndex) === index));
    }
    scrollTo(slide, behavior) {
      if (!slide || !this.viewport) return;
      const left = slide.offsetLeft - Math.max((this.viewport.clientWidth - slide.offsetWidth) / 2, 0);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({ left, behavior: reduceMotion ? 'auto' : behavior });
    }
    activate(index, behavior = 'smooth') {
      if (!this.realSlides.length) return;
      const normalizedIndex = (index + this.realSlides.length) % this.realSlides.length;
      this.setActive(normalizedIndex);
      this.scrollTo(this.realSlides[normalizedIndex], behavior);
    }
    onScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => {
        const viewportCenter = this.viewport.scrollLeft + (this.viewport.clientWidth / 2);
        const closest = this.slides.reduce((candidate, slide) => {
          const candidateDistance = Math.abs((candidate.offsetLeft + (candidate.offsetWidth / 2)) - viewportCenter);
          const slideDistance = Math.abs((slide.offsetLeft + (slide.offsetWidth / 2)) - viewportCenter);
          return slideDistance < candidateDistance ? slide : candidate;
        }, this.slides[0]);
        if (!closest) return;
        const index = Number(closest.dataset.socialIndex);
        this.setActive(index);
        if (closest.hasAttribute('data-social-clone')) this.scrollTo(this.realSlides[index], 'auto');
      }, 120);
    }
    onClick(event) {
      const link = event.target.closest('[data-social-link]');
      if (link && this.contains(link)) {
        event.preventDefault();
        window.open(link.href, '_blank', 'noopener,width=800,height=600');
        return;
      }
      const slide = event.target.closest('[data-social-slide], [data-social-clone]');
      if (!slide || !this.contains(slide)) return;
      this.activate(Number(slide.dataset.socialIndex));
    }
    onKeydown(event) {
      if (!['Enter', ' '].includes(event.key)) return;
      const slide = event.target.closest('[data-social-slide]');
      if (!slide || !this.contains(slide)) return;
      event.preventDefault();
      this.activate(Number(slide.dataset.socialIndex));
    }
  }
  if (!customElements.get('mt-social-swiper')) customElements.define('mt-social-swiper', MtSocialSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-social-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-social-ugc-wall')) {
    class MtSocialUgcWall extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.addEventListener('click', (event) => this.onClick(event), { signal: this.abortController.signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.abortController?.abort();
        this.initialized = false;
      }

      onClick(event) {
        const button = event.target.closest('[data-social-play]');
        if (!button) return;
        const card = button.closest('[data-social-card]');
        if (card) this.playCard(card, button);
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        const card = event.target.closest('[data-social-card]');
        if (!card || !card.querySelector('video')) return;
        event.preventDefault();
        this.resetCard(card, true);
      }

      playCard(card, button) {
        this.querySelectorAll('[data-social-card]').forEach((otherCard) => {
          if (otherCard !== card && otherCard.querySelector('video')) this.resetCard(otherCard, false);
        });
        const template = card.querySelector('template[data-social-video-template]');
        if (!template || card.querySelector('video')) return;
        card.append(template.content.cloneNode(true));
        const video = card.querySelector('video');
        const poster = card.querySelector(':scope > picture, :scope > .mt-social-ugc-wall__image');
        if (!video) return;
        poster?.setAttribute('aria-hidden', 'true');
        button.hidden = true;
        card.classList.add('is-playing');
        video.addEventListener('ended', () => this.resetCard(card, true), { once: true });
        video.focus({ preventScroll: true });
        video.play().catch(() => {
          video.controls = true;
        });
      }

      resetCard(card, restoreFocus) {
        const video = card.querySelector('video');
        const button = card.querySelector('[data-social-play]');
        const poster = card.querySelector(':scope > picture, :scope > .mt-social-ugc-wall__image');
        if (video) {
          video.pause();
          video.remove();
        }
        poster?.removeAttribute('aria-hidden');
        card.classList.remove('is-playing');
        if (button) button.hidden = false;
        if (restoreFocus && button) button.focus({ preventScroll: true });
      }
    }

    customElements.define('mt-social-ugc-wall', MtSocialUgcWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-top-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-top-sellers')) {
    class MtTopSellers extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.track = this.querySelector('.mt-top-sellers__track');
        this.previousControl = this.querySelector('[data-seller-scroll="previous"]');
        this.nextControl = this.querySelector('[data-seller-scroll="next"]');
        this.addEventListener('change', (event) => this.onChange(event), { signal: this.abortController.signal });
        this.addEventListener('click', (event) => this.onClick(event), { signal: this.abortController.signal });
        this.track?.addEventListener('scroll', () => this.scheduleControlUpdate(), { passive: true, signal: this.abortController.signal });
        if ('ResizeObserver' in window && this.track) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleControlUpdate());
          this.resizeObserver.observe(this.track);
        }
        this.scheduleControlUpdate();
      }

      disconnectedCallback() {
        if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
        this.resizeObserver?.disconnect();
        this.abortController?.abort();
        this.initialized = false;
      }

      scheduleControlUpdate() {
        if (this.controlFrame) return;
        this.controlFrame = requestAnimationFrame(() => {
          this.controlFrame = 0;
          this.updateControls();
        });
      }

      updateControls() {
        if (!this.track) return;
        const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const currentScroll = Math.abs(this.track.scrollLeft);
        if (this.previousControl) this.previousControl.disabled = currentScroll <= 1;
        if (this.nextControl) this.nextControl.disabled = maximumScroll <= 1 || currentScroll >= maximumScroll - 1;
      }

      onChange(event) {
        const input = event.target.closest('[data-seller-swatch]');
        if (!input) return;
        const card = input.closest('[data-seller-card]');
        if (!card) return;
        card.querySelectorAll('[data-seller-media]').forEach((media) => {
          const active = media.dataset.sellerMedia === input.dataset.variantId;
          media.hidden = !active;
        });
        card.querySelectorAll('[data-seller-price]').forEach((price) => {
          const active = price.dataset.sellerPrice === input.dataset.variantId;
          price.hidden = !active;
        });
        card.querySelectorAll('[data-seller-link]').forEach((link) => {
          link.href = input.dataset.variantUrl;
        });
        const variantInput = card.querySelector('[data-seller-variant]');
        if (variantInput) variantInput.value = input.dataset.variantId || '';
        const addButton = card.querySelector('[data-seller-add]');
        if (addButton) {
          const available = !input.disabled && Boolean(input.dataset.variantId);
          addButton.dataset.variantId = input.dataset.variantId || '';
          addButton.closest('.mt-top-sellers__form')?.classList.toggle('mt-top-sellers__form--unavailable', !available);
          addButton.disabled = !available;
        }
      }

      onClick(event) {
        const button = event.target.closest('[data-seller-scroll]');
        if (!button || !this.track) return;
        const card = this.track.querySelector('[data-seller-card]');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        const direction = button.dataset.sellerScroll === 'previous' ? -1 : 1;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * step * visibleCards, behavior });
      }
    }

    customElements.define('mt-top-sellers', MtTopSellers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-transparent-navbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-transparent-navbar')) {
    class MtTransparentNavbar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.desktopMedia = window.matchMedia('(min-width: 1024px)');
        this.motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        this.closeTimer = null;
        this.openTimer = null;
        this.drawerCloseTimer = null;
        this.drawerTransitionCleanup = null;
        this.drawerTransitionToken = 0;
        this.itemCloseTimers = new Map();
        this.submenuTransitionTimers = new Map();
        this.submenuTransitionToken = (this.submenuTransitionToken || 0) + 1;
        this.tertiaryPreviewStates = new Map();
        this.panelTransitionToken = (this.panelTransitionToken || 0) + 1;
        this.activeDesktopItem = null;
        this.activeDesktopOpenSource = null;
        this.panelSurface = null;
        this.panelSurfaceAnimation = null;
        this.panelSurfaceGeometry = null;
        this.panelSurfaceResizeObserver = null;
        this.panelSurfaceRefreshFrame = null;
        this.panelSurfaceRefreshPanel = null;
        this.panelSurfaceRefreshMorph = false;
        this.panelContentAnimations = new Map();
        this.navItems = Array.from(this.querySelectorAll('[data-nav-item]'));
        this.drawer = this.querySelector('[data-drawer]');
        this.backdrop = this.querySelector('[data-drawer-backdrop]');
        this.drawerOpenButton = this.querySelector('[data-drawer-open]');
        this.drawerCloseButton = this.querySelector('[data-drawer-close]');
        this.mobilePanels = Array.from(this.querySelectorAll('[data-mobile-panel]'));
        this.mobileRootPanel = this.querySelector('[data-mobile-root]');
        this.activeMobilePanel = this.mobileRootPanel;
        this.mobilePanelHistory = [];
        this.mobilePanelTransitionCleanup = null;
        this.searchModal = this.querySelector('[data-search-modal]');
        this.searchPanel = this.querySelector('[data-search-panel]');
        this.searchForm = this.querySelector('[data-search-form]');
        this.searchInput = this.querySelector('[data-search-input]');
        this.searchResults = this.querySelector('[data-search-results]');
        this.searchPopular = this.querySelector('[data-search-popular]');
        this.searchStatus = this.querySelector('[data-search-status]');
        this.searchCloseButton = this.querySelector('[data-search-close]');
        this.searchTriggers = Array.from(this.querySelectorAll('[data-search-open]'));
        this.searchCloseTimer = null;
        this.searchTransitionCleanup = null;
        this.searchTransitionToken = 0;
        this.searchDebounceTimer = null;
        this.searchFetchController = null;
        this.searchRequestToken = 0;
        this.searchResultCache = new Map();
        this.currentSearchCategory = '';
        this.categoryDragState = null;
        this.suppressCategoryClick = false;
        this.activeSearchTrigger = null;
        this.navSliderStates = new Map();
        this.navSliderResizeObserver = null;
        this.navSliderRefreshFrame = null;
        this.navSliderRefreshRequests = new Map();
        this.topNavPointerCandidate = null;
        this.topNavPointerOwner = null;
        this.topNavPointerIntentTimer = null;
        this.topNavPointerLeaveTimer = null;
        this.topNavPointerRestoreTimer = null;
        this.topNavPointerIntentToken = 0;
        this.classList.add('is-motion-ready');
        this.setupPanelSurface();
        this.bindPanelSurfaceGeometry();
        this.bindDesktopMenus();
        this.bindNavSliders();
        this.bindDrawer();
        this.bindSearch();
        this.bindCartCount();
        this.bindStickyState();
      }

      disconnectedCallback() {
        if (this.stickyFrame) window.cancelAnimationFrame(this.stickyFrame);
        window.clearTimeout(this.closeTimer);
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.drawerCloseTimer);
        window.clearTimeout(this.searchCloseTimer);
        window.clearTimeout(this.searchDebounceTimer);
        window.clearTimeout(this.topNavPointerIntentTimer);
        window.clearTimeout(this.topNavPointerLeaveTimer);
        window.clearTimeout(this.topNavPointerRestoreTimer);
        this.searchFetchController?.abort();
        this.panelSurfaceAnimation?.cancel();
        if (this.panelSurfaceRefreshFrame) window.cancelAnimationFrame(this.panelSurfaceRefreshFrame);
        this.panelSurfaceRefreshFrame = null;
        this.panelSurfaceRefreshPanel = null;
        this.panelSurfaceRefreshMorph = false;
        this.panelSurfaceResizeObserver?.disconnect();
        this.panelSurfaceResizeObserver = null;
        this.panelContentAnimations?.forEach((animation) => animation.cancel());
        this.panelContentAnimations?.clear();
        this.panelSurface?.remove();
        this.panelSurface = null;
        this.panelSurfaceGeometry = null;
        this.destroyNavSliders();
        this.drawerTransitionCleanup?.();
        this.mobilePanelTransitionCleanup?.();
        this.searchTransitionCleanup?.();
        this.itemCloseTimers?.forEach((timer) => window.clearTimeout(timer));
        this.submenuTransitionTimers?.forEach((timer) => window.clearTimeout(timer));
        this.submenuTransitionTimers?.clear();
        this.tertiaryPreviewStates?.forEach((state) => {
          window.clearTimeout(state.restoreTimer);
          state.transitionToken += 1;
          state.transitionAnimation?.cancel();
          state.outgoingAnimation?.cancel();
          state.outgoingLayer?.remove();
        });
        this.tertiaryPreviewStates?.clear();
        this.submenuTransitionToken += 1;
        this.panelTransitionToken += 1;
        this.abortController?.abort();
        document.documentElement.classList.remove('mt-navbar-scroll-locked');
        this.navItems?.forEach((item) => {
          item.open = false;
          item.classList.remove('is-expanded');
          item.querySelector(':scope > .mt-transparent-navbar__trigger')?.setAttribute('aria-expanded', 'false');
        });
        this.activeDesktopItem = null;
        this.activeDesktopOpenSource = null;
        this.drawer?.classList.remove('is-open');
        this.backdrop?.classList.remove('is-open');
        if (this.drawer) this.drawer.hidden = true;
        if (this.backdrop) this.backdrop.hidden = true;
        this.drawerOpenButton?.setAttribute('aria-expanded', 'false');
        this.resetMobilePanels();
        this.searchTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.searchModal?.classList.remove('is-open');
        if (this.searchModal) this.searchModal.hidden = true;
        this.classList.remove('is-search-open');
        this.classList.remove('is-sticky', 'is-scroll-visible', 'is-scroll-hidden');
        this.removeAttribute('inert');
        this.classList.remove('is-motion-ready');
        this.classList.remove('has-panel-surface');
        this.initialized = false;
      }

      setupPanelSurface() {
        const surface = document.createElement('span');
        surface.className = 'mt-transparent-navbar__panel-surface';
        surface.setAttribute('aria-hidden', 'true');
        this.append(surface);
        this.panelSurface = surface;
        this.classList.add('has-panel-surface');
      }

      bindPanelSurfaceGeometry() {
        const signal = this.abortController.signal;
        const refreshActivePanel = () => {
          if (this.activeDesktopItem?.dataset.layout === 'simple') this.positionSimplePanel(this.activeDesktopItem);
          const panel = this.activeDesktopItem?.querySelector('[data-nav-panel]');
          if (panel) this.schedulePanelSurfaceRefresh(panel, false);
        };
        if ('ResizeObserver' in window) {
          this.panelSurfaceResizeObserver = new ResizeObserver((entries) => {
            const panel = this.activeDesktopItem?.querySelector('[data-nav-panel]');
            if (panel && entries.some(({ target }) => target === panel)) this.schedulePanelSurfaceRefresh(panel, true);
          });
          this.querySelectorAll('[data-nav-panel]').forEach((panel) => this.panelSurfaceResizeObserver.observe(panel));
        }
        window.addEventListener('resize', refreshActivePanel, { signal });
        window.visualViewport?.addEventListener('resize', refreshActivePanel, { signal });
      }

      bindNavSliders() {
        const signal = this.abortController.signal;
        const lists = Array.from(this.querySelectorAll(
          '.mt-transparent-navbar__primary-list, .mt-transparent-navbar__secondary-list, .mt-transparent-navbar__tertiary-list, .mt-transparent-navbar__simple-list, .mt-transparent-navbar__icons'
        ));
        if (!lists.length) return;

        lists.forEach((list) => {
          const isIconGroup = list.classList.contains('mt-transparent-navbar__icons');
          const indicator = document.createElement(isIconGroup ? 'span' : 'li');
          const isPrimary = list.classList.contains('mt-transparent-navbar__primary-list');
          indicator.className = `mt-transparent-navbar__slider${isPrimary || isIconGroup ? ' mt-transparent-navbar__slider--primary' : ''}`;
          indicator.setAttribute('aria-hidden', 'true');
          indicator.setAttribute('role', 'presentation');
          list.append(indicator);
          list.classList.add('is-slider-ready');

          let inverse = null;
          let inverseItems = [];
          if (isPrimary || isIconGroup) {
            inverse = document.createElement('span');
            inverse.className = 'mt-transparent-navbar__slider-inverse';
            indicator.append(inverse);
            list.classList.add('has-slider-inverse');
            inverseItems = this.getNavSliderItems(list).map((source) => {
              const clone = document.createElement('span');
              clone.className = 'mt-transparent-navbar__slider-inverse-item';
              clone.innerHTML = source.innerHTML;
              clone.querySelectorAll('[id], [name], [aria-controls], [aria-expanded], [aria-current]').forEach((element) => {
                element.removeAttribute('id');
                element.removeAttribute('name');
                element.removeAttribute('aria-controls');
                element.removeAttribute('aria-expanded');
                element.removeAttribute('aria-current');
              });
              inverse.append(clone);
              return { source, clone };
            });
          }

          const state = {
            list,
            indicator,
            inverse,
            inverseItems,
            inverseAnimation: null,
            animation: null,
            currentTarget: null,
            hoverTarget: null,
            focusTarget: null,
            visible: false,
            geometry: null,
            needsAlignment: false,
            isTopLevel: isPrimary || isIconGroup,
            suppressPersistent: false,
            pointerExitFrame: null
          };
          this.navSliderStates.set(list, state);

          if (!state.isTopLevel) {
            list.addEventListener('pointerover', (event) => {
              if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
              const target = this.getNavSliderTarget(list, event.target);
              if (!target || target.contains(event.relatedTarget)) return;
              if (state.pointerExitFrame) cancelAnimationFrame(state.pointerExitFrame);
              state.pointerExitFrame = null;
              state.hoverTarget = target;
              this.syncNavSlider(state, true);
            }, { signal });

            list.addEventListener('pointerout', (event) => {
              if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
              const target = this.getNavSliderTarget(list, event.target);
              if (!target || target.contains(event.relatedTarget)) return;
              state.hoverTarget = this.getNavSliderTarget(list, event.relatedTarget);
              if (state.hoverTarget) {
                this.syncNavSlider(state, true);
                return;
              }
              if (state.pointerExitFrame) cancelAnimationFrame(state.pointerExitFrame);
              state.pointerExitFrame = requestAnimationFrame(() => {
                state.pointerExitFrame = null;
                if (!state.list.matches(':hover')) this.syncNavSlider(state, true);
              });
            }, { signal });

            list.addEventListener('pointerleave', (event) => {
              if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
              state.hoverTarget = null;
              if (state.pointerExitFrame) cancelAnimationFrame(state.pointerExitFrame);
              state.pointerExitFrame = requestAnimationFrame(() => {
                state.pointerExitFrame = null;
                if (!state.list.matches(':hover')) this.syncNavSlider(state, true);
              });
            }, { signal });
          }

          list.addEventListener('focusin', (event) => {
            if (!this.desktopMedia.matches) return;
            const target = this.getNavSliderTarget(list, event.target);
            if (!target) return;
            state.focusTarget = target;
            this.syncNavSlider(state, true);
          }, { signal });

          list.addEventListener('focusout', (event) => {
            if (!this.desktopMedia.matches) return;
            state.focusTarget = this.getNavSliderTarget(list, event.relatedTarget);
            this.syncNavSlider(state, true);
          }, { signal });
        });

        this.bindTopNavPointerIntent(signal);
        this.navSliderStates.forEach((state) => this.syncNavSlider(state, false));

        if ('ResizeObserver' in window) {
          this.navSliderResizeObserver = new ResizeObserver((entries) => {
            if (!this.desktopMedia.matches) return;
            const affectedLists = new Set();
            entries.forEach(({ target }) => {
              const list = target.matches?.('.is-slider-ready') ? target : target.closest?.('.is-slider-ready');
              if (list && this.navSliderStates.has(list)) affectedLists.add(list);
            });
            affectedLists.forEach((list) => this.scheduleNavSliderRefresh(list, false));
          });
          this.navSliderStates.forEach((state) => {
            this.navSliderResizeObserver.observe(state.list);
            this.getNavSliderItems(state.list).forEach((item) => this.navSliderResizeObserver.observe(item));
          });
        }

        this.desktopMedia.addEventListener('change', (event) => {
          if (event.matches) this.scheduleNavSliderRefresh(this, false);
          else this.resetNavSliders();
        }, { signal });
        document.fonts?.ready.then(() => {
          if (this.initialized && this.desktopMedia.matches) this.scheduleNavSliderRefresh(this, false);
        });
        this.scheduleNavSliderRefresh(this, false);
      }

      bindTopNavPointerIntent(signal) {
        const desktop = this.querySelector('.mt-transparent-navbar__desktop');
        if (!desktop) return;
        desktop.addEventListener('pointerover', (event) => {
          if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
          this.queueTopNavPointerIntent(this.resolveTopNavSliderTarget(event.target), event.target);
        }, { signal });
        desktop.addEventListener('pointerleave', (event) => {
          if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
          this.queueTopNavPointerIntent(null, null);
        }, { signal });
      }

      getTopNavSliderStates() {
        return Array.from(this.navSliderStates?.values() || []).filter((state) => state.isTopLevel);
      }

      resolveTopNavSliderTarget(node) {
        if (!(node instanceof Element)) return null;
        const states = this.getTopNavSliderStates();
        for (const state of states) {
          const target = this.getNavSliderTarget(state.list, node);
          if (target) return { state, target };
        }
        const openItem = node.closest('[data-nav-item]');
        if (!openItem?.open) return null;
        const trigger = openItem.querySelector(':scope > .mt-transparent-navbar__trigger');
        const primaryState = states.find((state) => state.list.classList.contains('mt-transparent-navbar__primary-list'));
        return trigger && primaryState ? { state: primaryState, target: trigger } : null;
      }

      queueTopNavPointerIntent(match, pointerNode) {
        window.clearTimeout(this.topNavPointerLeaveTimer);
        this.topNavPointerLeaveTimer = null;
        this.topNavPointerNode = pointerNode;

        if (!match) {
          this.topNavPointerCandidate = null;
          window.clearTimeout(this.topNavPointerIntentTimer);
          this.topNavPointerIntentTimer = null;
          this.topNavPointerIntentToken += 1;
          if (!this.topNavPointerOwner) return;
          const token = this.topNavPointerIntentToken;
          this.topNavPointerLeaveTimer = window.setTimeout(() => {
            this.topNavPointerLeaveTimer = null;
            if (token !== this.topNavPointerIntentToken || this.resolveTopNavSliderTarget(this.topNavPointerNode)) return;
            this.releaseTopNavPointerIntent();
          }, 120);
          return;
        }

        window.clearTimeout(this.topNavPointerRestoreTimer);
        this.topNavPointerRestoreTimer = null;
        if (this.topNavPointerOwner?.state === match.state && this.topNavPointerOwner.target === match.target) {
          this.topNavPointerCandidate = null;
          window.clearTimeout(this.topNavPointerIntentTimer);
          this.topNavPointerIntentTimer = null;
          return;
        }
        if (this.topNavPointerCandidate?.state === match.state && this.topNavPointerCandidate.target === match.target) return;

        this.topNavPointerCandidate = match;
        window.clearTimeout(this.topNavPointerIntentTimer);
        const token = ++this.topNavPointerIntentToken;
        const delay = this.topNavPointerOwner ? 80 : 110;
        this.topNavPointerIntentTimer = window.setTimeout(() => {
          this.topNavPointerIntentTimer = null;
          if (token !== this.topNavPointerIntentToken || this.topNavPointerCandidate !== match) return;
          const current = this.resolveTopNavSliderTarget(this.topNavPointerNode);
          if (!current || current.state !== match.state || current.target !== match.target) return;
          this.commitTopNavPointerIntent(match);
        }, delay);
      }

      commitTopNavPointerIntent(match) {
        window.clearTimeout(this.topNavPointerRestoreTimer);
        this.topNavPointerRestoreTimer = null;
        this.topNavPointerCandidate = null;
        this.topNavPointerOwner = match;
        if (match.state.list.classList.contains('mt-transparent-navbar__icons')) {
          this.closePointerOpenedDesktopMenu();
        }
        this.getTopNavSliderStates().forEach((state) => {
          const isOwner = state === match.state;
          state.hoverTarget = isOwner ? match.target : null;
          state.suppressPersistent = !isOwner;
          this.syncNavSlider(state, true);
        });
      }

      closePointerOpenedDesktopMenu() {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.closeTimer);
        this.openTimer = null;
        this.closeTimer = null;
        const item = this.activeDesktopItem;
        if (!item?.open || this.activeDesktopOpenSource !== 'pointer' || item.contains(document.activeElement)) return;
        this.closeItem(item);
      }

      releaseTopNavPointerIntent() {
        this.topNavPointerCandidate = null;
        this.topNavPointerOwner = null;
        this.topNavPointerIntentToken += 1;
        const delayedRestore = [];
        this.getTopNavSliderStates().forEach((state) => {
          state.hoverTarget = null;
          const persistentTarget = this.getPersistentNavSliderTarget(state.list);
          const focusTarget = state.focusTarget
            && (state.focusTarget === document.activeElement || state.focusTarget.contains(document.activeElement))
            ? state.focusTarget
            : null;
          const needsHiddenReset = Boolean(
            state.currentTarget
            && state.currentTarget !== persistentTarget
            && state.currentTarget !== focusTarget
          );
          state.suppressPersistent = needsHiddenReset;
          this.syncNavSlider(state, true);
          if (needsHiddenReset) delayedRestore.push(state);
        });
        if (!delayedRestore.length) return;
        this.topNavPointerRestoreTimer = window.setTimeout(() => {
          this.topNavPointerRestoreTimer = null;
          if (this.topNavPointerOwner || this.topNavPointerCandidate) return;
          delayedRestore.forEach((state) => {
            state.suppressPersistent = false;
            this.syncNavSlider(state, true);
          });
        }, 140);
      }

      clearTopNavPointerIntent() {
        window.clearTimeout(this.topNavPointerIntentTimer);
        window.clearTimeout(this.topNavPointerLeaveTimer);
        window.clearTimeout(this.topNavPointerRestoreTimer);
        this.topNavPointerIntentTimer = null;
        this.topNavPointerLeaveTimer = null;
        this.topNavPointerRestoreTimer = null;
        this.topNavPointerCandidate = null;
        this.topNavPointerOwner = null;
        this.topNavPointerNode = null;
        this.topNavPointerIntentToken += 1;
      }

      destroyNavSliders() {
        this.clearTopNavPointerIntent();
        if (this.navSliderRefreshFrame) cancelAnimationFrame(this.navSliderRefreshFrame);
        this.navSliderRefreshFrame = null;
        this.navSliderRefreshRequests?.clear();
        this.navSliderResizeObserver?.disconnect();
        this.navSliderResizeObserver = null;
        this.navSliderStates?.forEach((state) => {
          if (state.pointerExitFrame) cancelAnimationFrame(state.pointerExitFrame);
          state.animation?.cancel();
          state.inverseAnimation?.cancel();
          state.currentTarget?.classList.remove('is-slider-current');
          state.list.classList.remove('is-slider-ready');
          state.list.classList.remove('has-slider-inverse');
          state.indicator.remove();
        });
        this.navSliderStates?.clear();
      }

      resetNavSliders() {
        this.clearTopNavPointerIntent();
        if (this.navSliderRefreshFrame) cancelAnimationFrame(this.navSliderRefreshFrame);
        this.navSliderRefreshFrame = null;
        this.navSliderRefreshRequests?.clear();
        this.navSliderStates?.forEach((state) => {
          if (state.pointerExitFrame) cancelAnimationFrame(state.pointerExitFrame);
          state.pointerExitFrame = null;
          state.animation?.cancel();
          state.inverseAnimation?.cancel();
          state.animation = null;
          state.inverseAnimation = null;
          state.currentTarget?.classList.remove('is-slider-current');
          state.currentTarget = null;
          state.hoverTarget = null;
          state.focusTarget = null;
          state.suppressPersistent = false;
          state.visible = false;
          state.geometry = null;
          state.needsAlignment = false;
          state.indicator.style.opacity = '0';
        });
      }

      getNavSliderItems(list) {
        if (list.classList.contains('mt-transparent-navbar__icons')) {
          return Array.from(list.children).filter((child) => child.matches('.mt-transparent-navbar__icon-link'));
        }
        return Array.from(list.children).flatMap((child) => {
          if (child.classList.contains('mt-transparent-navbar__slider')) return [];
          if (list.classList.contains('mt-transparent-navbar__primary-list')) {
            return [child.querySelector(':scope > .mt-transparent-navbar__primary-link, :scope > .mt-transparent-navbar__details > .mt-transparent-navbar__trigger')].filter(Boolean);
          }
          return [child.querySelector(':scope > a, :scope > button')].filter(Boolean);
        });
      }

      getNavSliderTarget(list, node) {
        if (!(node instanceof Element)) return null;
        return this.getNavSliderItems(list).find((item) => item === node || item.contains(node)) || null;
      }

      getPersistentNavSliderTarget(list) {
        const items = this.getNavSliderItems(list);
        if (list.classList.contains('mt-transparent-navbar__primary-list')) {
          const openTrigger = items.find((item) => {
            const details = item.matches('.mt-transparent-navbar__trigger') ? item.closest('[data-nav-item]') : null;
            return details?.open && details.classList.contains('is-expanded');
          });
          if (openTrigger) return openTrigger;
        }
        return items.find((item) => item.getAttribute('aria-expanded') === 'true')
          || items.find((item) => item.matches('.is-active, [aria-current="page"]'))
          || null;
      }

      syncNavSlider(state, animate = true) {
        if (!state || !this.desktopMedia.matches || !state.list.isConnected || state.list.getClientRects().length === 0) return;
        if (state.hoverTarget && !state.hoverTarget.matches(':hover')) {
          const isCommittedPointerOwner = state.isTopLevel
            && this.topNavPointerOwner?.state === state
            && this.topNavPointerOwner.target === state.hoverTarget;
          if (!isCommittedPointerOwner) {
            const resolved = state.isTopLevel ? this.resolveTopNavSliderTarget(this.topNavPointerNode) : null;
            if (!resolved || resolved.state !== state || resolved.target !== state.hoverTarget) state.hoverTarget = null;
          }
        }
        if (state.focusTarget && state.focusTarget !== document.activeElement && !state.focusTarget.contains(document.activeElement)) state.focusTarget = null;
        const persistentTarget = state.suppressPersistent ? null : this.getPersistentNavSliderTarget(state.list);
        const target = state.hoverTarget || state.focusTarget || persistentTarget;
        if (target) this.moveNavSlider(state, target, animate);
        else this.hideNavSlider(state, animate);
      }

      refreshSliderInverse(state, coordinateContainer, listBox) {
        if (!state.inverse) return;
        state.inverse.style.width = `${Math.max(coordinateContainer.scrollWidth, listBox.width)}px`;
        state.inverse.style.height = `${Math.max(coordinateContainer.scrollHeight, listBox.height)}px`;
        state.inverseItems.forEach(({ source, clone }) => {
          clone.innerHTML = source.innerHTML;
          clone.querySelectorAll('[id], [name], [aria-controls], [aria-expanded], [aria-current]').forEach((element) => {
            element.removeAttribute('id');
            element.removeAttribute('name');
            element.removeAttribute('aria-controls');
            element.removeAttribute('aria-expanded');
            element.removeAttribute('aria-current');
          });
          const sourceBox = source.getBoundingClientRect();
          const sourceStyle = getComputedStyle(source);
          const x = sourceBox.left - listBox.left + coordinateContainer.scrollLeft;
          const y = sourceBox.top - listBox.top + coordinateContainer.scrollTop;
          clone.style.width = `${sourceBox.width}px`;
          clone.style.height = `${sourceBox.height}px`;
          clone.style.fontFamily = sourceStyle.fontFamily;
          clone.style.fontSize = sourceStyle.fontSize;
          clone.style.fontWeight = sourceStyle.fontWeight;
          clone.style.lineHeight = sourceStyle.lineHeight;
          clone.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        });
      }

      moveNavSlider(state, target, animate = true) {
        const coordinateContainer = state.list.classList.contains('mt-transparent-navbar__primary-list') ? this : state.list;
        const listBox = coordinateContainer.getBoundingClientRect();
        const targetBox = target.getBoundingClientRect();
        if (targetBox.width <= 0 || targetBox.height <= 0) return;
        this.refreshSliderInverse(state, coordinateContainer, listBox);

        const indicatorBox = state.visible || state.animation ? state.indicator.getBoundingClientRect() : null;
        const startOpacity = indicatorBox ? Number.parseFloat(getComputedStyle(state.indicator).opacity) || 0 : 0;
        const start = indicatorBox ? {
          x: indicatorBox.left - listBox.left + coordinateContainer.scrollLeft,
          y: indicatorBox.top - listBox.top + coordinateContainer.scrollTop,
          width: indicatorBox.width,
          height: indicatorBox.height
        } : null;
        const end = {
          x: targetBox.left - listBox.left + coordinateContainer.scrollLeft,
          y: targetBox.top - listBox.top + coordinateContainer.scrollTop,
          width: targetBox.width,
          height: targetBox.height
        };
        const finalTransform = `translate3d(${end.x}px, ${end.y}px, 0)`;
        const sameTarget = state.currentTarget === target;
        const sameGeometry = state.geometry
          && Math.abs(state.geometry.x - end.x) < .5
          && Math.abs(state.geometry.y - end.y) < .5
          && Math.abs(state.geometry.width - end.width) < .5
          && Math.abs(state.geometry.height - end.height) < .5;

        if (sameTarget && sameGeometry) return;
        if (sameTarget && state.animation) {
          state.needsAlignment = true;
          return;
        }

        state.animation?.cancel();
        state.inverseAnimation?.cancel();
        state.needsAlignment = false;
        state.currentTarget?.classList.remove('is-slider-current');
        state.currentTarget = target;
        state.geometry = end;
        target.classList.add('is-slider-current');
        state.indicator.style.width = `${end.width}px`;
        state.indicator.style.height = `${end.height}px`;
        state.indicator.style.transform = finalTransform;
        state.indicator.style.opacity = '1';
        const inverseTransform = `translate3d(${-end.x}px, ${-end.y}px, 0)`;
        if (state.inverse) state.inverse.style.transform = inverseTransform;

        if (!animate || this.motionMedia.matches || typeof state.indicator.animate !== 'function') {
          state.animation = null;
          state.inverseAnimation = null;
          state.visible = true;
          return;
        }

        const startScaleX = start ? start.width / end.width : 1;
        const startScaleY = start ? start.height / end.height : 1;
        const startTransform = start
          ? `translate3d(${start.x}px, ${start.y}px, 0) scale(${startScaleX}, ${startScaleY})`
          : finalTransform;
        const animation = state.indicator.animate(
          [
            { transform: startTransform, opacity: start ? startOpacity : 0 },
            { transform: `${finalTransform} scale(1, 1)`, opacity: 1 }
          ],
          { duration: start ? 280 : 150, easing: 'cubic-bezier(.22, 1, .36, 1)' }
        );
        if (state.inverse && start) {
          const inverseStartTransform = `scale(${1 / startScaleX}, ${1 / startScaleY}) translate3d(${-start.x}px, ${-start.y}px, 0)`;
          state.inverseAnimation = state.inverse.animate(
            [
              { transform: inverseStartTransform },
              { transform: inverseTransform }
            ],
            { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
          state.inverseAnimation.finished.then(() => {
            state.inverseAnimation = null;
          }).catch(() => {});
        }
        state.animation = animation;
        state.visible = true;
        animation.finished.then(() => {
          if (state.animation !== animation) return;
          state.animation = null;
          if (state.needsAlignment) {
            state.needsAlignment = false;
            this.scheduleNavSliderRefresh(state.list, false);
          }
        }).catch(() => {});
      }

      hideNavSlider(state, animate = true) {
        if (!state.visible && !state.currentTarget) return;
        state.currentTarget?.classList.remove('is-slider-current');
        state.currentTarget = null;
        state.geometry = null;
        state.needsAlignment = false;
        const startOpacity = Number.parseFloat(getComputedStyle(state.indicator).opacity) || 0;
        state.animation?.cancel();
        state.inverseAnimation?.cancel();
        state.inverseAnimation = null;
        if (!state.visible) {
          state.indicator.style.opacity = '0';
          state.animation = null;
          return;
        }
        state.indicator.style.opacity = '0';
        if (!animate || this.motionMedia.matches || typeof state.indicator.animate !== 'function') {
          state.visible = false;
          state.animation = null;
          return;
        }
        const animation = state.indicator.animate(
          [
            { opacity: startOpacity },
            { opacity: 0 }
          ],
          { duration: 120, easing: 'ease-out' }
        );
        state.animation = animation;
        state.visible = false;
        animation.finished.then(() => {
          if (state.animation === animation) state.animation = null;
        }).catch(() => {});
      }

      scheduleNavSliderRefresh(scope = this, animate = false) {
        this.navSliderStates?.forEach((state) => {
          if (scope !== this && !scope.contains(state.list)) return;
          const pending = this.navSliderRefreshRequests.get(state);
          this.navSliderRefreshRequests.set(state, Boolean(pending || animate));
        });
        if (this.navSliderRefreshFrame) return;
        this.navSliderRefreshFrame = requestAnimationFrame(() => {
          this.navSliderRefreshFrame = null;
          const requests = Array.from(this.navSliderRefreshRequests.entries());
          this.navSliderRefreshRequests.clear();
          if (!this.initialized || !this.desktopMedia.matches) return;
          requests.forEach(([state, shouldAnimate]) => {
            if (this.navSliderStates.has(state.list)) this.syncNavSlider(state, shouldAnimate);
          });
        });
      }

      bindDesktopMenus() {
        const signal = this.abortController.signal;
        this.navItems.forEach((item) => {
          const trigger = item.querySelector(':scope > .mt-transparent-navbar__trigger');
          if (!trigger) return;

          item.addEventListener('pointerenter', () => {
            if (this.desktopMedia.matches) this.scheduleOpen(item);
          }, { signal });
          item.addEventListener('pointerleave', () => {
            if (this.desktopMedia.matches) this.scheduleClose(item);
          }, { signal });
          item.addEventListener('focusout', (event) => {
            if (this.desktopMedia.matches && !item.contains(event.relatedTarget)) this.scheduleClose(item);
          }, { signal });
          item.addEventListener('focusin', () => {
            if (this.desktopMedia.matches) this.scheduleOpen(item, 'keyboard');
          }, { signal });

          item.querySelectorAll('[data-submenu-target]').forEach((button) => {
            const activate = () => this.activateSubmenu(item, button);
            button.addEventListener('pointerenter', activate, { signal });
            button.addEventListener('focus', activate, { signal });
            button.addEventListener('click', activate, { signal });
          });

          item.querySelectorAll('[data-tertiary-link]').forEach((link) => {
            const activate = (event) => {
              if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
              if (link.hasAttribute('data-tertiary-preview')) this.activateTertiaryPreview(item, link);
              else this.restoreTertiaryPreview(link.closest('[data-submenu-panel]'));
            };
            link.addEventListener('pointerenter', activate, { signal });
            link.addEventListener('focus', () => {
              if (!this.desktopMedia.matches) return;
              if (link.hasAttribute('data-tertiary-preview')) this.activateTertiaryPreview(item, link);
              else this.restoreTertiaryPreview(link.closest('[data-submenu-panel]'));
            }, { signal });
            link.addEventListener('pointerleave', (event) => {
              if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
              this.scheduleTertiaryPreviewRestore(link.closest('[data-submenu-panel]'), event.relatedTarget);
            }, { signal });
            link.addEventListener('focusout', (event) => {
              if (this.desktopMedia.matches) this.scheduleTertiaryPreviewRestore(link.closest('[data-submenu-panel]'), event.relatedTarget);
            }, { signal });
          });

          item.querySelectorAll('[data-submenu-panel] [data-preview-region]').forEach((region) => {
            const panel = region.closest('[data-submenu-panel]');
            region.addEventListener('pointerenter', (event) => {
              if (this.desktopMedia.matches && event.pointerType !== 'touch') this.cancelTertiaryPreviewRestore(panel);
            }, { signal });
            region.addEventListener('pointerleave', (event) => {
              if (!this.desktopMedia.matches || event.pointerType === 'touch') return;
              this.scheduleTertiaryPreviewRestore(panel, event.relatedTarget);
            }, { signal });
            region.addEventListener('focusin', () => {
              if (this.desktopMedia.matches) this.cancelTertiaryPreviewRestore(panel);
            }, { signal });
            region.addEventListener('focusout', (event) => {
              if (this.desktopMedia.matches) this.scheduleTertiaryPreviewRestore(panel, event.relatedTarget);
            }, { signal });
          });
        });

        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.closeOtherItems();
        }, { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.desktopMedia.matches) return;
          const openItem = this.navItems.find((item) => item.open);
          if (!openItem) return;
          this.closeItem(openItem);
          openItem.querySelector(':scope > .mt-transparent-navbar__trigger')?.focus();
        }, { signal });
      }

      scheduleOpen(item, source = 'pointer') {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.closeTimer);
        if (this.activeDesktopItem === item && item.open) return;
        const delay = this.activeDesktopItem?.open ? 60 : 120;
        this.openTimer = window.setTimeout(() => {
          this.openTimer = null;
          if (item.matches(':hover') || item.contains(document.activeElement)) this.openItem(item, source);
        }, delay);
      }

      openItem(item, source = 'programmatic') {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.closeTimer);
        this.clearItemClose(item);
        const previous = this.activeDesktopItem?.open && this.activeDesktopItem !== item ? this.activeDesktopItem : null;
        const previousIndex = previous ? this.navItems.indexOf(previous) : -1;
        const nextIndex = this.navItems.indexOf(item);
        const direction = previous && nextIndex < previousIndex ? 'previous' : 'next';
        const panel = item.querySelector('[data-nav-panel]');
        const enteringClass = previous ? `is-entering-${direction}` : null;

        this.activeDesktopItem = item;
        this.activeDesktopOpenSource = source;
        this.closeOtherItems(item, direction, true);
        if (!item.open) item.open = true;
        panel?.classList.remove('is-entering-next', 'is-entering-previous', 'is-leaving-next', 'is-leaving-previous');
        if (enteringClass && panel) panel.classList.add(enteringClass);
        this.prepareItem(item);
        this.expandItem(item, enteringClass);
        const transitionToken = ++this.panelTransitionToken;
        requestAnimationFrame(() => {
          if (!this.initialized || transitionToken !== this.panelTransitionToken || this.activeDesktopItem !== item || !item.open) return;
          this.updatePanelHeightConstraint(panel);
          this.showPanelSurface(panel, Boolean(previous));
        });
      }

      expandItem(item, enteringClass = null) {
        const trigger = item.querySelector(':scope > .mt-transparent-navbar__trigger');
        const panel = item.querySelector('[data-nav-panel]');
        trigger?.setAttribute('aria-expanded', 'true');
        if (this.motionMedia.matches) {
          item.classList.add('is-expanded');
          if (enteringClass) panel?.classList.remove(enteringClass);
          return;
        }
        requestAnimationFrame(() => {
          if (!this.initialized || !item.open) return;
          item.classList.add('is-expanded');
          if (enteringClass) requestAnimationFrame(() => {
            if (!this.initialized || !item.open || this.activeDesktopItem !== item || !panel) return;
            panel.classList.remove(enteringClass);
            this.panelContentAnimations.get(panel)?.cancel();
            const startX = enteringClass.endsWith('previous') ? -16 : 16;
            const animation = panel.animate(
              [
                { opacity: 0, transform: `translate3d(${startX}px, 0, 0)` },
                { opacity: 1, transform: 'translate3d(0, 0, 0)' }
              ],
              { duration: 250, delay: 90, easing: 'cubic-bezier(0, 0, .2, 1)', fill: 'both' }
            );
            this.panelContentAnimations.set(panel, animation);
            animation.finished.then(() => {
              if (this.panelContentAnimations.get(panel) !== animation) return;
              this.panelContentAnimations.delete(panel);
              animation.cancel();
            }).catch(() => {});
          });
        });
      }

      scheduleClose(item) {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => {
          if (!item.matches(':hover') && !item.contains(document.activeElement)) this.closeItem(item);
        }, 180);
      }

      closeOtherItems(exception = null, direction = null, keepSurface = false) {
        this.navItems.forEach((item) => {
          if (item !== exception) this.closeItem(item, false, direction, keepSurface);
        });
      }

      clearItemClose(item) {
        const timer = this.itemCloseTimers.get(item);
        if (timer) window.clearTimeout(timer);
        this.itemCloseTimers.delete(item);
      }

      closeItem(item, immediate = false, direction = null, keepSurface = false) {
        if (!item?.open) return;
        this.clearItemClose(item);
        const panel = item.querySelector('[data-nav-panel]');
        this.panelContentAnimations.get(panel)?.cancel();
        this.panelContentAnimations.delete(panel);
        panel?.classList.remove('is-entering-next', 'is-entering-previous', 'is-leaving-next', 'is-leaving-previous');
        if (direction && !immediate && !this.motionMedia.matches) panel?.classList.add(`is-leaving-${direction}`);
        item.classList.remove('is-expanded');
        item.querySelector(':scope > .mt-transparent-navbar__trigger')?.setAttribute('aria-expanded', 'false');
        item.querySelectorAll('.mt-transparent-navbar__product-card').forEach((card) => card.classList.remove('is-revealed'));
        if (!keepSurface && this.activeDesktopItem === item) {
          this.activeDesktopItem = null;
          this.activeDesktopOpenSource = null;
          this.panelTransitionToken += 1;
          this.hidePanelSurface();
        }
        if (immediate || this.motionMedia.matches) {
          item.open = false;
          panel?.classList.remove('is-leaving-next', 'is-leaving-previous');
          this.scheduleNavSliderRefresh(this, false);
          return;
        }
        const timer = window.setTimeout(() => {
          item.open = false;
          panel?.classList.remove('is-leaving-next', 'is-leaving-previous');
          this.itemCloseTimers.delete(item);
          this.scheduleNavSliderRefresh(this, true);
        }, direction ? 140 : 150);
        this.itemCloseTimers.set(item, timer);
      }

      getPanelGeometry(panel) {
        if (!panel) return null;
        const rootBox = this.getBoundingClientRect();
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        if (width <= 0 || height <= 0) return null;
        const offsetParentBox = panel.offsetParent?.getBoundingClientRect();
        const parentX = offsetParentBox ? offsetParentBox.left - rootBox.left : 0;
        const parentY = offsetParentBox ? offsetParentBox.top - rootBox.top : 0;
        return {
          x: parentX + panel.offsetLeft,
          y: parentY + panel.offsetTop,
          width,
          height
        };
      }

      updatePanelHeightConstraint(panel) {
        const supportsHeightConstraint = panel?.classList.contains('mt-transparent-navbar__panel--cascade')
          || panel?.classList.contains('mt-transparent-navbar__panel--products');
        if (!supportsHeightConstraint) return;
        panel.classList.remove('is-height-constrained');
        panel.style.removeProperty('--mt-navbar-panel-available-height');
        const panelBox = panel.getBoundingClientRect();
        const viewport = window.visualViewport;
        const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const availableHeight = Math.max(160, Math.floor(viewportBottom - panelBox.top - 16));
        if (panel.offsetHeight <= availableHeight) return;
        panel.style.setProperty('--mt-navbar-panel-available-height', `${availableHeight}px`);
        panel.classList.add('is-height-constrained');
      }

      schedulePanelSurfaceRefresh(panel, morph = true) {
        if (!panel) return;
        this.panelSurfaceRefreshPanel = panel;
        this.panelSurfaceRefreshMorph = this.panelSurfaceRefreshMorph || morph;
        if (this.panelSurfaceRefreshFrame) return;
        this.panelSurfaceRefreshFrame = requestAnimationFrame(() => {
          this.panelSurfaceRefreshFrame = null;
          const refreshPanel = this.panelSurfaceRefreshPanel;
          const shouldMorph = this.panelSurfaceRefreshMorph;
          this.panelSurfaceRefreshPanel = null;
          this.panelSurfaceRefreshMorph = false;
          const item = refreshPanel?.closest('[data-nav-item]');
          if (!this.initialized || !refreshPanel || this.activeDesktopItem !== item || !item.open || !item.classList.contains('is-expanded')) return;
          this.updatePanelHeightConstraint(refreshPanel);
          this.showPanelSurface(refreshPanel, shouldMorph);
        });
      }

      showPanelSurface(panel, morph = false) {
        if (!this.panelSurface) return;
        const end = this.getPanelGeometry(panel);
        if (!end) return;
        const rootBox = this.getBoundingClientRect();
        const surfaceBox = this.panelSurface.getBoundingClientRect();
        const surfaceOpacity = Number.parseFloat(getComputedStyle(this.panelSurface).opacity) || 0;
        const start = morph && surfaceBox.width > 0 && surfaceBox.height > 0 && surfaceOpacity > 0
          ? {
              x: surfaceBox.left - rootBox.left,
              y: surfaceBox.top - rootBox.top,
              width: surfaceBox.width,
              height: surfaceBox.height
            }
          : null;
        const finalTransform = `translate3d(${end.x}px, ${end.y}px, 0) scale(1, 1)`;
        this.panelSurfaceAnimation?.cancel();
        this.panelSurface.style.width = `${end.width}px`;
        this.panelSurface.style.height = `${end.height}px`;
        this.panelSurface.style.transform = finalTransform;
        this.panelSurface.style.opacity = '1';
        this.panelSurfaceGeometry = end;

        if (this.motionMedia.matches || typeof this.panelSurface.animate !== 'function') return;
        const startTransform = start
          ? `translate3d(${start.x}px, ${start.y}px, 0) scale(${start.width / end.width}, ${start.height / end.height})`
          : `translate3d(${end.x}px, ${end.y + 4}px, 0) scale(1, 1)`;
        const animation = this.panelSurface.animate(
          [
            { transform: startTransform, opacity: start ? 1 : 0 },
            { transform: finalTransform, opacity: 1 }
          ],
          { duration: start ? 250 : 200, easing: 'cubic-bezier(0, 0, .2, 1)' }
        );
        this.panelSurfaceAnimation = animation;
        animation.finished.then(() => {
          if (this.panelSurfaceAnimation === animation) this.panelSurfaceAnimation = null;
        }).catch(() => {});
      }

      hidePanelSurface() {
        if (!this.panelSurface || !this.panelSurfaceGeometry) return;
        const geometry = this.panelSurfaceGeometry;
        const startOpacity = Number.parseFloat(getComputedStyle(this.panelSurface).opacity) || 0;
        this.panelSurfaceAnimation?.cancel();
        this.panelSurface.style.opacity = '0';
        this.panelSurfaceGeometry = null;
        if (this.motionMedia.matches || typeof this.panelSurface.animate !== 'function') return;
        const animation = this.panelSurface.animate(
          [
            { transform: `translate3d(${geometry.x}px, ${geometry.y}px, 0)`, opacity: startOpacity },
            { transform: `translate3d(${geometry.x}px, ${geometry.y + 4}px, 0)`, opacity: 0 }
          ],
          { duration: 150, easing: 'cubic-bezier(.4, 0, 1, 1)' }
        );
        this.panelSurfaceAnimation = animation;
        animation.finished.then(() => {
          if (this.panelSurfaceAnimation === animation) this.panelSurfaceAnimation = null;
        }).catch(() => {});
      }

      prepareItem(item) {
        const firstSubmenu = item.querySelector('[data-submenu-target]');
        if (firstSubmenu) this.activateSubmenu(item, firstSubmenu);
        this.hydrateProducts(item.querySelector('[data-nav-panel]'));
        if (item.dataset.layout === 'simple') this.positionSimplePanel(item);
        this.scheduleNavSliderRefresh(item, false);
      }

      activateSubmenu(item, button) {
        const targetId = button.dataset.submenuTarget;
        const target = item.querySelector(`#${CSS.escape(targetId)}`);
        if (!target) return;
        this.restoreTertiaryPreview(target, true);
        if (button.getAttribute('aria-expanded') === 'true' && !target.hidden && target.classList.contains('is-active')) {
          this.hydrateProducts(target);
          this.schedulePanelSurfaceRefresh(item.querySelector('[data-nav-panel]'), true);
          return;
        }
        const transitionToken = ++this.submenuTransitionToken;
        const buttons = Array.from(item.querySelectorAll('[data-submenu-target]'));
        const panels = Array.from(item.querySelectorAll('[data-submenu-panel]'));
        const currentButton = buttons.find((candidate) => candidate.getAttribute('aria-expanded') === 'true');
        const currentPanel = panels.find((panel) => !panel.hidden && panel.classList.contains('is-active'));
        const currentIndex = currentButton ? buttons.indexOf(currentButton) : -1;
        const nextIndex = buttons.indexOf(button);
        const direction = currentIndex >= 0 && nextIndex < currentIndex ? 'previous' : 'next';

        buttons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-expanded', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const timer = this.submenuTransitionTimers.get(panel);
          if (timer) window.clearTimeout(timer);
          this.submenuTransitionTimers.delete(panel);
          panel.classList.remove('is-entering-next', 'is-entering-previous', 'is-leaving-next', 'is-leaving-previous');
          if (panel !== target && panel !== currentPanel) {
            panel.classList.remove('is-active');
            panel.hidden = true;
          }
        });

        target.hidden = false;
        target.classList.add('is-active');
        if (!currentPanel || currentPanel === target || this.motionMedia.matches) {
          if (currentPanel && currentPanel !== target) {
            currentPanel.classList.remove('is-active');
            currentPanel.hidden = true;
          }
        } else {
          currentPanel.classList.remove('is-active');
          currentPanel.classList.add(`is-leaving-${direction}`);
          const leavingTimer = window.setTimeout(() => {
            this.submenuTransitionTimers.delete(currentPanel);
            currentPanel.classList.remove('is-leaving-next', 'is-leaving-previous');
            if (!currentPanel.classList.contains('is-active')) currentPanel.hidden = true;
          }, 140);
          this.submenuTransitionTimers.set(currentPanel, leavingTimer);

          target.classList.add(`is-entering-${direction}`);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (!this.initialized || transitionToken !== this.submenuTransitionToken || target.hidden) return;
              target.classList.remove('is-entering-next', 'is-entering-previous');
            });
          });
        }
        this.hydrateProducts(target);
        this.scheduleNavSliderRefresh(item, true);
        this.schedulePanelSurfaceRefresh(item.querySelector('[data-nav-panel]'), true);
      }

      getTertiaryPreviewState(panel) {
        if (!panel) return null;
        const existingState = this.tertiaryPreviewStates.get(panel);
        if (existingState) return existingState;
        const region = panel.querySelector('[data-preview-region]');
        const slot = region?.querySelector('[data-product-slot]');
        if (!region || !slot) return null;
        const state = {
          panel,
          region,
          slot,
          defaultNodes: Array.from(slot.childNodes),
          previewNodes: new Map(),
          activeTrigger: null,
          restoreTimer: null,
          transitionToken: 0,
          transitionAnimation: null,
          outgoingAnimation: null,
          outgoingLayer: null
        };
        this.tertiaryPreviewStates.set(panel, state);
        return state;
      }

      cancelTertiaryPreviewRestore(panel) {
        const state = this.tertiaryPreviewStates.get(panel);
        if (!state?.restoreTimer) return;
        window.clearTimeout(state.restoreTimer);
        state.restoreTimer = null;
      }

      activateTertiaryPreview(item, trigger) {
        const panel = trigger.closest('[data-submenu-panel]');
        const template = trigger.parentElement?.querySelector('template[data-tertiary-product-template]');
        if (!panel || !template) return;
        this.hydrateProducts(panel);
        const state = this.getTertiaryPreviewState(panel);
        if (!state) return;
        this.cancelTertiaryPreviewRestore(panel);
        if (state.activeTrigger === trigger) return;
        let previewNodes = state.previewNodes.get(template);
        if (!previewNodes) {
          previewNodes = Array.from(template.content.cloneNode(true).childNodes);
          state.previewNodes.set(template, previewNodes);
        }
        const previewTriggers = Array.from(panel.querySelectorAll('[data-tertiary-link][data-tertiary-preview]'));
        const currentIndex = state.activeTrigger ? previewTriggers.indexOf(state.activeTrigger) : -1;
        const nextIndex = previewTriggers.indexOf(trigger);
        const direction = currentIndex >= 0 && nextIndex < currentIndex ? 'previous' : 'next';
        state.activeTrigger = trigger;
        this.transitionTertiaryPreview(item, state, previewNodes, direction);
      }

      transitionTertiaryPreview(item, state, nodes, direction = 'next', immediate = false) {
        const transitionToken = ++state.transitionToken;
        state.transitionAnimation?.cancel();
        state.outgoingAnimation?.cancel();
        state.outgoingLayer?.remove();
        state.transitionAnimation = null;
        state.outgoingAnimation = null;
        state.outgoingLayer = null;

        const replacePreview = () => {
          if (!this.initialized || transitionToken !== state.transitionToken) return;
          state.slot.replaceChildren(...nodes);
          state.slot.querySelectorAll('.mt-transparent-navbar__product-card').forEach((card) => {
            card.classList.remove('is-revealed');
          });
          this.revealProductCards(state.slot);
          this.schedulePanelSurfaceRefresh(item?.querySelector('[data-nav-panel]'), true);
        };

        if (immediate || this.motionMedia.matches || typeof state.slot.animate !== 'function' || !state.slot.childNodes.length) {
          replacePreview();
          return;
        }

        const leavingOffset = direction === 'previous' ? '8px' : '-8px';
        const enteringOffset = direction === 'previous' ? '-16px' : '16px';
        const outgoingLayer = state.slot.cloneNode(true);
        outgoingLayer.setAttribute('aria-hidden', 'true');
        outgoingLayer.inert = true;
        Object.assign(outgoingLayer.style, {
          position: 'absolute',
          top: `${state.slot.offsetTop}px`,
          left: `${state.slot.offsetLeft}px`,
          width: `${state.slot.offsetWidth}px`,
          height: `${state.slot.offsetHeight}px`,
          pointerEvents: 'none',
          zIndex: '1'
        });
        state.region.append(outgoingLayer);
        state.outgoingLayer = outgoingLayer;
        replacePreview();

        const leavingAnimation = outgoingLayer.animate(
          [
            { opacity: 1, transform: 'translateX(0)' },
            { opacity: 0, transform: `translateX(${leavingOffset})` }
          ],
          { duration: 140, easing: 'cubic-bezier(0, 0, .2, 1)', fill: 'forwards' }
        );
        state.outgoingAnimation = leavingAnimation;
        leavingAnimation.finished.then(() => {
          if (state.outgoingAnimation !== leavingAnimation) return;
          outgoingLayer.remove();
          state.outgoingLayer = null;
          state.outgoingAnimation = null;
        }).catch(() => {});

        const enteringAnimation = state.slot.animate(
          [
            { opacity: 0, transform: `translateX(${enteringOffset})` },
            { opacity: 1, transform: 'translateX(0)' }
          ],
          { duration: 250, delay: 90, easing: 'cubic-bezier(0, 0, .2, 1)', fill: 'both' }
        );
        state.transitionAnimation = enteringAnimation;
        enteringAnimation.finished.then(() => {
          if (state.transitionAnimation !== enteringAnimation) return;
          enteringAnimation.cancel();
          state.transitionAnimation = null;
        }).catch(() => {});
      }

      scheduleTertiaryPreviewRestore(panel, relatedTarget = null) {
        const state = this.tertiaryPreviewStates.get(panel);
        if (!state?.activeTrigger) return;
        if (relatedTarget && (state.activeTrigger.contains(relatedTarget) || state.region.contains(relatedTarget))) return;
        this.cancelTertiaryPreviewRestore(panel);
        state.restoreTimer = window.setTimeout(() => {
          state.restoreTimer = null;
          if (state.activeTrigger?.matches(':hover') || state.region.matches(':hover')) return;
          const activeElement = document.activeElement;
          if (activeElement && (state.activeTrigger?.contains(activeElement) || state.region.contains(activeElement))) return;
          this.restoreTertiaryPreview(panel);
        }, 80);
      }

      restoreTertiaryPreview(panel, immediate = false) {
        const state = this.tertiaryPreviewStates.get(panel);
        if (!state) return;
        this.cancelTertiaryPreviewRestore(panel);
        if (!state.activeTrigger) return;
        state.activeTrigger = null;
        const item = panel.closest('[data-nav-item]');
        this.transitionTertiaryPreview(item, state, state.defaultNodes, 'previous', immediate);
      }

      hydrateProducts(scope) {
        if (!scope) return;
        scope.querySelectorAll('template[data-product-template]').forEach((template) => {
          const slot = template.parentElement.querySelector('[data-product-slot]');
          if (slot) slot.append(template.content.cloneNode(true));
          template.remove();
        });
        this.revealProductCards(scope);
      }

      revealProductCards(scope) {
        scope.querySelectorAll('.mt-transparent-navbar__product-card').forEach((card, index) => {
          card.style.setProperty('--mt-navbar-card-index', index);
          if (card.classList.contains('is-revealed')) return;
          if (this.motionMedia.matches) card.classList.add('is-revealed');
          else requestAnimationFrame(() => {
            if (this.initialized && card.isConnected) card.classList.add('is-revealed');
          });
        });
      }

      positionSimplePanel(item) {
        const panel = item.querySelector('[data-simple-panel]');
        const trigger = item.querySelector(':scope > .mt-transparent-navbar__trigger');
        if (!panel || !trigger) return;
        const rootBox = this.getBoundingClientRect();
        const triggerBox = trigger.getBoundingClientRect();
        const panelWidth = panel.offsetWidth;
        const preferredLeft = triggerBox.left - rootBox.left;
        const desktopBox = panel.classList.contains('mt-transparent-navbar__panel--sale')
          ? this.querySelector('.mt-transparent-navbar__desktop')?.getBoundingClientRect()
          : null;
        const maximumLeft = desktopBox
          ? desktopBox.right - rootBox.left - panelWidth
          : rootBox.width - panelWidth - 16;
        const left = Math.min(Math.max(preferredLeft, 16), maximumLeft);
        panel.style.left = `${left}px`;
      }

      bindDrawer() {
        if (!this.drawer || !this.drawerOpenButton || !this.backdrop) return;
        const signal = this.abortController.signal;
        this.drawerOpenButton.addEventListener('click', () => this.openDrawer(), { signal });
        this.drawer.querySelectorAll('[data-drawer-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeDrawer(), { signal });
        });
        this.drawer.querySelectorAll('[data-mobile-panel-open]').forEach((button) => {
          button.addEventListener('click', () => this.openMobilePanel(button), { signal });
        });
        this.drawer.querySelectorAll('[data-mobile-panel-back]').forEach((button) => {
          button.addEventListener('click', () => this.backMobilePanel(), { signal });
        });
        this.backdrop.addEventListener('click', () => this.closeDrawer(), { signal });
        this.drawer.addEventListener('click', (event) => {
          if (event.target.closest('a')) this.closeDrawer();
        }, { signal });
        this.drawer.addEventListener('keydown', (event) => this.handleDrawerKeydown(event), { signal });
        this.desktopMedia.addEventListener('change', (event) => {
          if (event.matches) this.closeDrawer(false);
        }, { signal });
      }

      openDrawer() {
        window.clearTimeout(this.drawerCloseTimer);
        this.drawerTransitionToken += 1;
        this.drawerTransitionCleanup?.();
        this.drawerTransitionCleanup = null;
        this.resetMobilePanels();
        const drawerTop = this.classList.contains('is-sticky') ? 0 : Math.max(0, this.getBoundingClientRect().top);
        this.drawer.style.setProperty('--mt-navbar-drawer-top', `${drawerTop}px`);
        this.drawer.hidden = false;
        this.backdrop.hidden = false;
        this.drawerOpenButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mt-navbar-scroll-locked');
        requestAnimationFrame(() => {
          this.drawer.classList.add('is-open');
          this.backdrop.classList.add('is-open');
          this.mobileRootPanel?.querySelector('[data-drawer-close]')?.focus({ preventScroll: true });
        });
      }

      closeDrawer(restoreFocus = true) {
        if (!this.drawer || this.drawer.hidden) return;
        const transitionToken = ++this.drawerTransitionToken;
        this.drawer.classList.remove('is-open');
        this.backdrop.classList.remove('is-open');
        this.drawerOpenButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mt-navbar-scroll-locked');
        window.clearTimeout(this.drawerCloseTimer);
        this.drawerTransitionCleanup?.();

        const finishClose = () => {
          if (transitionToken !== this.drawerTransitionToken) return;
          this.drawer.hidden = true;
          this.backdrop.hidden = true;
          this.drawer.style.removeProperty('--mt-navbar-drawer-top');
          this.resetMobilePanels();
          if (restoreFocus) this.drawerOpenButton.focus();
          this.drawerTransitionCleanup?.();
          this.drawerTransitionCleanup = null;
        };

        if (this.motionMedia.matches) {
          finishClose();
        } else {
          const onTransitionEnd = (event) => {
            if (event.target === this.drawer && event.propertyName === 'transform') finishClose();
          };
          this.drawer.addEventListener('transitionend', onTransitionEnd);
          this.drawerCloseTimer = window.setTimeout(finishClose, 320);
          this.drawerTransitionCleanup = () => {
            window.clearTimeout(this.drawerCloseTimer);
            this.drawer.removeEventListener('transitionend', onTransitionEnd);
          };
        }
      }

      handleDrawerKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          if (this.mobilePanelHistory.length > 0) this.backMobilePanel();
          else this.closeDrawer();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusScope = this.activeMobilePanel || this.drawer;
        const focusable = Array.from(focusScope.querySelectorAll('a[href], button:not([disabled])'))
          .filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      openMobilePanel(trigger) {
        const targetId = trigger.dataset.mobilePanelOpen;
        const target = targetId ? this.querySelector(`#${CSS.escape(targetId)}`) : null;
        if (!target || target === this.activeMobilePanel) return;
        trigger.setAttribute('aria-expanded', 'true');
        this.mobilePanelHistory.push({ panel: this.activeMobilePanel, trigger });
        this.switchMobilePanel(target, 'forward');
      }

      backMobilePanel() {
        const previous = this.mobilePanelHistory.pop();
        if (!previous?.panel) return;
        previous.trigger?.setAttribute('aria-expanded', 'false');
        this.switchMobilePanel(previous.panel, 'back', previous.trigger);
      }

      switchMobilePanel(nextPanel, direction, restoreTarget = null) {
        const currentPanel = this.activeMobilePanel;
        if (!currentPanel || currentPanel === nextPanel) return;
        this.mobilePanelTransitionCleanup?.();
        const enteringClass = direction === 'back' ? 'is-entering-back' : 'is-entering-forward';
        const leavingClass = direction === 'back' ? 'is-leaving-back' : 'is-leaving-forward';

        nextPanel.hidden = false;
        nextPanel.scrollTop = 0;
        nextPanel.classList.add('is-active', enteringClass);
        currentPanel.classList.add(leavingClass);
        this.activeMobilePanel = nextPanel;

        const finish = () => {
          currentPanel.hidden = true;
          currentPanel.classList.remove('is-active', leavingClass);
          nextPanel.classList.remove(enteringClass);
          this.mobilePanelTransitionCleanup?.();
          this.mobilePanelTransitionCleanup = null;
          const focusTarget = restoreTarget || nextPanel.querySelector('[data-mobile-panel-back], [data-drawer-close], a[href], button:not([disabled])');
          focusTarget?.focus({ preventScroll: true });
        };

        if (this.motionMedia.matches) {
          finish();
          return;
        }

        requestAnimationFrame(() => nextPanel.classList.remove(enteringClass));
        const transitionTimer = window.setTimeout(finish, 240);
        this.mobilePanelTransitionCleanup = () => {
          window.clearTimeout(transitionTimer);
          currentPanel.classList.remove(leavingClass);
          nextPanel.classList.remove(enteringClass);
        };
      }

      resetMobilePanels() {
        if (!this.mobilePanels?.length || !this.mobileRootPanel) return;
        this.mobilePanelTransitionCleanup?.();
        this.mobilePanelTransitionCleanup = null;
        this.mobilePanelHistory = [];
        this.querySelectorAll('[data-mobile-panel-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.mobilePanels.forEach((panel) => {
          const isRoot = panel === this.mobileRootPanel;
          panel.hidden = !isRoot;
          panel.scrollTop = 0;
          panel.classList.toggle('is-active', isRoot);
          panel.classList.remove('is-entering-forward', 'is-entering-back', 'is-leaving-forward', 'is-leaving-back');
        });
        this.activeMobilePanel = this.mobileRootPanel;
      }

      bindSearch() {
        if (!this.searchModal || !this.searchPanel || !this.searchForm || !this.searchInput || !this.searchResults || !this.searchTriggers.length) return;
        const signal = this.abortController.signal;
        this.searchTriggers.forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.openSearch(trigger);
          }, { signal });
        });
        this.searchCloseButton?.addEventListener('click', () => this.closeSearch(), { signal });
        this.querySelector('[data-search-overlay]')?.addEventListener('click', () => this.closeSearch(), { signal });
        this.searchModal.addEventListener('keydown', (event) => this.handleSearchKeydown(event), { signal });
        this.searchForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const query = this.searchInput.value.trim();
          if (!query) {
            this.resetSearchResults();
            return;
          }
          window.clearTimeout(this.searchDebounceTimer);
          this.searchProducts({ query, category: '', page: 1 });
        }, { signal });
        this.searchInput.addEventListener('input', () => {
          const query = this.searchInput.value.trim();
          window.clearTimeout(this.searchDebounceTimer);
          this.searchFetchController?.abort();
          this.searchFetchController = null;
          this.searchRequestToken += 1;
          this.currentSearchCategory = '';
          if (!query) {
            this.resetSearchResults();
            return;
          }
          if (this.searchPopular) this.searchPopular.hidden = true;
          this.searchResults.setAttribute('aria-busy', 'true');
          this.showSearchMessage(this.dataset.searchLoading || 'Searching products…');
          this.searchDebounceTimer = window.setTimeout(() => {
            this.searchProducts({ query, category: '', page: 1 });
          }, 300);
        }, { signal });
        this.searchResults.addEventListener('click', (event) => this.handleSearchResultsClick(event), { signal });
        this.searchResults.addEventListener('pointerdown', (event) => this.startCategoryDrag(event), { signal });
        this.searchResults.addEventListener('pointermove', (event) => this.moveCategoryDrag(event), { signal });
        this.searchResults.addEventListener('pointerup', (event) => this.endCategoryDrag(event), { signal });
        this.searchResults.addEventListener('pointercancel', (event) => this.endCategoryDrag(event), { signal });
        this.querySelectorAll('[data-search-popular-term]').forEach((link) => {
          link.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            const query = link.dataset.searchPopularTerm?.trim();
            if (!query) return;
            this.searchInput.value = query;
            this.currentSearchCategory = '';
            this.searchProducts({ query, category: '', page: 1 });
          }, { signal });
        });
      }

      resetSearchResults() {
        window.clearTimeout(this.searchDebounceTimer);
        this.searchFetchController?.abort();
        this.searchFetchController = null;
        this.searchRequestToken += 1;
        this.currentSearchCategory = '';
        this.searchResults?.replaceChildren();
        if (this.searchResults) {
          this.searchResults.hidden = true;
          this.searchResults.setAttribute('aria-busy', 'false');
        }
        if (this.searchPopular) this.searchPopular.hidden = false;
        if (this.searchStatus) this.searchStatus.textContent = '';
      }

      buildSearchUrl(query, category = '', page = 1, drawerResponse = true) {
        const url = new URL(this.searchForm.action, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('options[unavailable_products]', 'hide');
        if (category) url.searchParams.set('filter.p.product_type', category);
        if (page > 1) url.searchParams.set('page', String(page));
        if (drawerResponse) {
          url.searchParams.set('section_id', this.dataset.searchSectionId || 'mt-navbar-search-results');
        }
        return url;
      }

      handleSearchResultsClick(event) {
        const categoryButton = event.target.closest('[data-search-category]');
        if (categoryButton && this.searchResults.contains(categoryButton)) {
          event.preventDefault();
          if (this.suppressCategoryClick) return;
          this.searchProducts({
            query: this.searchInput.value.trim(),
            category: categoryButton.dataset.searchCategory || '',
            page: 1,
            focusResults: true
          });
          return;
        }

        const pageButton = event.target.closest('[data-search-page]');
        if (!pageButton || pageButton.disabled || !this.searchResults.contains(pageButton)) return;
        event.preventDefault();
        const page = Number.parseInt(pageButton.dataset.searchPage, 10);
        if (!Number.isInteger(page) || page < 1) return;
        this.searchProducts({
          query: this.searchInput.value.trim(),
          category: this.currentSearchCategory,
          page,
          focusResults: true
        });
      }

      startCategoryDrag(event) {
        const categories = event.target.closest('[data-search-categories]');
        if (!categories || !this.searchResults.contains(categories) || event.button !== 0 || event.pointerType === 'touch') return;
        this.categoryDragState = {
          categories,
          pointerId: event.pointerId,
          startX: event.clientX,
          startScrollLeft: categories.scrollLeft,
          moved: false
        };
      }

      moveCategoryDrag(event) {
        const state = this.categoryDragState;
        if (!state || state.pointerId !== event.pointerId) return;
        const distance = event.clientX - state.startX;
        if (!state.moved && Math.abs(distance) < 5) return;
        if (!state.moved) {
          state.moved = true;
          state.categories.classList.add('is-dragging');
          state.categories.setPointerCapture?.(event.pointerId);
        }
        event.preventDefault();
        state.categories.scrollLeft = state.startScrollLeft - distance;
      }

      endCategoryDrag(event) {
        const state = this.categoryDragState;
        if (!state || state.pointerId !== event.pointerId) return;
        if (state.categories.hasPointerCapture?.(event.pointerId)) state.categories.releasePointerCapture(event.pointerId);
        state.categories.classList.remove('is-dragging');
        this.categoryDragState = null;
        if (!state.moved) return;
        this.suppressCategoryClick = true;
        window.setTimeout(() => { this.suppressCategoryClick = false; }, 0);
      }

      showSearchMessage(message) {
        const paragraph = document.createElement('p');
        paragraph.className = 'mt-transparent-navbar__search-message';
        paragraph.textContent = message;
        this.searchResults.replaceChildren(paragraph);
        this.searchResults.hidden = false;
      }

      showSearchError(query) {
        this.showSearchMessage(this.dataset.searchError || 'Search results could not be loaded.');
        const fallback = document.createElement('a');
        fallback.className = 'mt-transparent-navbar__search-fallback';
        fallback.href = this.buildSearchUrl(query, '', 1, false).toString();
        fallback.textContent = this.dataset.searchViewAll || 'View all search results';
        this.searchResults.append(fallback);
        if (this.searchStatus) this.searchStatus.textContent = this.dataset.searchError || '';
      }

      applySearchResponse(markup, focusResults = false) {
        const template = document.createElement('template');
        template.innerHTML = markup.trim();
        this.searchResults.replaceChildren(template.content.cloneNode(true));
        this.searchResults.hidden = false;
        const response = this.searchResults.querySelector('[data-navbar-search-response]');
        this.currentSearchCategory = response?.dataset.activeCategory || '';
        if (this.searchStatus) this.searchStatus.textContent = response?.dataset.announcement || '';
        if (focusResults && response) {
          response.focus({ preventScroll: true });
          this.searchResults.scrollIntoView({ block: 'start' });
        }
      }

      async searchProducts({ query, category = '', page = 1, focusResults = false }) {
        const normalizedQuery = query.trim();
        if (!normalizedQuery) {
          this.resetSearchResults();
          return;
        }

        window.clearTimeout(this.searchDebounceTimer);
        this.currentSearchCategory = category;
        if (this.searchPopular) this.searchPopular.hidden = true;
        const cacheKey = JSON.stringify([normalizedQuery.toLocaleLowerCase(), category, page]);
        const cachedMarkup = this.searchResultCache.get(cacheKey);
        if (cachedMarkup) {
          this.searchFetchController?.abort();
          this.searchFetchController = null;
          this.searchRequestToken += 1;
          this.searchResults.setAttribute('aria-busy', 'false');
          this.applySearchResponse(cachedMarkup, focusResults);
          return;
        }

        this.searchFetchController?.abort();
        this.searchFetchController = new AbortController();
        const requestController = this.searchFetchController;
        const requestToken = ++this.searchRequestToken;
        this.searchResults.setAttribute('aria-busy', 'true');
        this.showSearchMessage(this.dataset.searchLoading || 'Searching products…');
        if (this.searchStatus) this.searchStatus.textContent = this.dataset.searchLoading || '';

        try {
          const response = await fetch(this.buildSearchUrl(normalizedQuery, category, page), {
            headers: { Accept: 'text/html' },
            signal: requestController.signal
          });
          const text = await response.text();
          if (!response.ok) throw new Error(`${response.status}: ${text}`);
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const result = documentFragment.querySelector('[data-navbar-search-response]');
          if (!result) throw new Error('Navigation search response was empty.');
          if (requestToken !== this.searchRequestToken) return;
          const markup = result.outerHTML;
          if (this.searchResultCache.size >= 24) this.searchResultCache.delete(this.searchResultCache.keys().next().value);
          this.searchResultCache.set(cacheKey, markup);
          this.applySearchResponse(markup, focusResults);
        } catch (error) {
          if (error.name === 'AbortError' || requestToken !== this.searchRequestToken) return;
          this.showSearchError(normalizedQuery);
        } finally {
          if (requestToken === this.searchRequestToken) {
            this.searchResults.setAttribute('aria-busy', 'false');
            if (this.searchFetchController === requestController) this.searchFetchController = null;
          }
        }
      }

      openSearch(trigger) {
        window.clearTimeout(this.searchCloseTimer);
        this.searchTransitionToken += 1;
        this.searchTransitionCleanup?.();
        this.searchTransitionCleanup = null;
        this.closeOtherItems(null);
        if (this.drawer && !this.drawer.hidden) this.closeDrawer(false);
        this.activeSearchTrigger = trigger;
        this.searchModal.hidden = false;
        this.searchTriggers.forEach((candidate) => candidate.setAttribute('aria-expanded', 'true'));
        this.classList.add('is-search-open');
        document.documentElement.classList.add('mt-navbar-scroll-locked');
        requestAnimationFrame(() => {
          if (!this.initialized || this.searchModal.hidden) return;
          this.searchModal.classList.add('is-open');
          this.searchInput?.focus({ preventScroll: true });
          const query = this.searchInput?.value.trim();
          if (query && this.searchResults?.hidden) this.searchProducts({ query, category: '', page: 1 });
        });
      }

      closeSearch(restoreFocus = true) {
        if (!this.searchModal || this.searchModal.hidden) return;
        const searchWasLoading = this.searchResults?.getAttribute('aria-busy') === 'true';
        window.clearTimeout(this.searchDebounceTimer);
        this.searchFetchController?.abort();
        this.searchFetchController = null;
        this.searchRequestToken += 1;
        if (searchWasLoading && this.searchResults) {
          this.searchResults.replaceChildren();
          this.searchResults.hidden = true;
          this.searchResults.setAttribute('aria-busy', 'false');
          if (this.searchStatus) this.searchStatus.textContent = '';
        }
        const transitionToken = ++this.searchTransitionToken;
        this.searchModal.classList.remove('is-open');
        this.searchTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.classList.remove('is-search-open');
        document.documentElement.classList.remove('mt-navbar-scroll-locked');
        window.clearTimeout(this.searchCloseTimer);
        this.searchTransitionCleanup?.();

        const finishClose = () => {
          if (transitionToken !== this.searchTransitionToken) return;
          this.searchModal.hidden = true;
          this.searchTransitionCleanup?.();
          this.searchTransitionCleanup = null;
          if (restoreFocus && this.activeSearchTrigger?.isConnected) this.activeSearchTrigger.focus({ preventScroll: true });
          this.activeSearchTrigger = null;
        };

        if (this.motionMedia.matches) {
          finishClose();
          return;
        }
        const onTransitionEnd = (event) => {
          if (event.target === this.searchPanel && event.propertyName === 'transform') finishClose();
        };
        this.searchPanel.addEventListener('transitionend', onTransitionEnd);
        this.searchCloseTimer = window.setTimeout(finishClose, 320);
        this.searchTransitionCleanup = () => {
          window.clearTimeout(this.searchCloseTimer);
          this.searchPanel.removeEventListener('transitionend', onTransitionEnd);
        };
      }

      handleSearchKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeSearch();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.searchPanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'))
          .filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      bindStickyState() {
        if (this.dataset.sticky !== 'true' || this.dataset.overlayMode !== 'true') return;
        const signal = this.abortController.signal;
        const directionThreshold = 8;
        this.stickyFrame = null;
        this.lastStickyScrollY = Math.max(0, window.scrollY);

        const update = (forceVisible = false) => {
          const currentScrollY = Math.max(0, window.scrollY);
          const top = this.desktopMedia.matches
            ? Number.parseInt(this.dataset.topDesktop || '53', 10)
            : Number.parseInt(this.dataset.topMobile || '72', 10);
          if (currentScrollY <= top) {
            this.resetStickyVisibility();
            this.lastStickyScrollY = currentScrollY;
            return;
          }

          this.classList.add('is-sticky');
          if (forceVisible || this.hasOpenNavigationLayer()) {
            this.setStickyVisibility(true);
            this.lastStickyScrollY = currentScrollY;
            return;
          }

          const delta = currentScrollY - this.lastStickyScrollY;
          if (Math.abs(delta) < directionThreshold) return;
          this.setStickyVisibility(delta < 0);
          this.lastStickyScrollY = currentScrollY;
        };

        const scheduleUpdate = () => {
          if (this.stickyFrame) return;
          this.stickyFrame = window.requestAnimationFrame(() => {
            this.stickyFrame = null;
            update(false);
          });
        };

        window.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
        this.desktopMedia.addEventListener('change', () => update(true), { signal });
        update(true);
      }

      hasOpenNavigationLayer() {
        const activeElement = document.activeElement;
        const hasKeyboardFocus = activeElement instanceof Element
          && this.contains(activeElement)
          && activeElement.matches(':focus-visible');
        return this.classList.contains('is-search-open')
          || this.drawer?.classList.contains('is-open')
          || this.navItems.some((item) => item.open)
          || hasKeyboardFocus;
      }

      setStickyVisibility(visible) {
        this.classList.toggle('is-scroll-visible', visible);
        this.classList.toggle('is-scroll-hidden', !visible);
        this.toggleAttribute('inert', !visible);
      }

      resetStickyVisibility() {
        this.classList.remove('is-sticky', 'is-scroll-visible', 'is-scroll-hidden');
        this.removeAttribute('inert');
      }

      bindCartCount() {
        document.addEventListener('cart:updated', (event) => {
          const count = event.detail?.cart?.item_count ?? event.detail?.item_count;
          if (!Number.isFinite(count)) return;
          this.querySelectorAll('[data-navbar-cart-count]').forEach((element) => {
            element.textContent = count;
            element.hidden = count === 0;
          });
        }, { signal: this.abortController.signal });
      }
    }

    customElements.define('mt-transparent-navbar', MtTransparentNavbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-user-support-faq"] && !Shopify.designMode) return;
  try {
    
  class MtUserSupportFaq extends HTMLElement {
    connectedCallback() { if (this.initialized) return; this.initialized = true; this.onClick = this.onClick.bind(this); this.onFilter = this.onFilter.bind(this); this.addEventListener('click', this.onClick); document.addEventListener('mt-support-filter', this.onFilter); }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); document.removeEventListener('mt-support-filter', this.onFilter); this.initialized = false; }
    onClick(event) { const button = event.target.closest('button[aria-controls]'); if (!button || !this.contains(button)) return; const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`); const open = button.getAttribute('aria-expanded') === 'true'; button.setAttribute('aria-expanded', String(!open)); if (panel) panel.hidden = open; }
    onFilter(event) { const query = event.detail?.query || ''; this.querySelectorAll('[data-support-search-item]').forEach((item) => { item.hidden = Boolean(query) && !item.dataset.supportSearchText.includes(query); }); }
  }
  if (!customElements.get('mt-user-support-faq')) customElements.define('mt-user-support-faq', MtUserSupportFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-user-support-hero"] && !Shopify.designMode) return;
  try {
    
  class MtUserSupportHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-support-search-form]');
      this.input = this.querySelector('[data-support-search-input]');
      this.placeholderPrefix = this.dataset.supportPlaceholderPrefix || '';
      this.defaultPlaceholder = this.dataset.supportDefaultPlaceholder || '';
      this.onSubmit = this.onSubmit.bind(this);
      this.onCategoryClick = this.onCategoryClick.bind(this);
      this.form?.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onCategoryClick);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onCategoryClick);
      this.initialized = false;
    }

    onSubmit(event) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('mt-support-filter', { detail: { query: this.input?.value.trim().toLowerCase() || '' } }));
    }

    onCategoryClick(event) {
      const button = event.target.closest('[data-support-category]');
      if (!button || !this.contains(button)) return;
      const category = button.dataset.supportCategory || '';
      const categoryPlaceholder = button.dataset.supportCategoryPlaceholder || '';
      if (this.input) this.input.placeholder = categoryPlaceholder ? `${this.placeholderPrefix}${categoryPlaceholder}` : this.defaultPlaceholder;
      this.querySelectorAll('[data-support-category]').forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      document.querySelectorAll('[data-support-category-section]').forEach((section) => {
        section.hidden = section.dataset.supportCategorySection !== category;
      });
      document.dispatchEvent(new CustomEvent('mt-support-filter', { detail: { query: this.input?.value.trim().toLowerCase() || '', category } }));
    }
  }
  if (!customElements.get('mt-user-support-hero')) customElements.define('mt-user-support-hero', MtUserSupportHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-user-support-installations"] && !Shopify.designMode) return;
  try {
    
  class MtUserSupportInstallations extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.pickerButton = this.querySelector('[data-installation-picker-button]');
      this.options = this.querySelector('[data-installation-options]');
      this.label = this.querySelector('[data-installation-picker-label]');
      this.onClick = this.onClick.bind(this);
      this.onFilter = this.onFilter.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onVideoIntersection = this.onVideoIntersection.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('mt-support-filter', this.onFilter);
      document.addEventListener('click', this.onDocumentClick);
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(this.onVideoIntersection, { rootMargin: '300px 0px' });
        this.videoObserver.observe(this);
      } else {
        this.activateVisibleVideos();
      }
      this.updateAllPagination();
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); document.removeEventListener('mt-support-filter', this.onFilter); document.removeEventListener('click', this.onDocumentClick); this.videoObserver?.disconnect(); this.videoObserver = undefined; this.initialized = false; }
    onVideoIntersection(entries) { if (!entries.some((entry) => entry.isIntersecting)) return; this.videoObserver?.disconnect(); this.activateVisibleVideos(); }
    activateVisibleVideos() { this.mediaActivated = true; this.querySelectorAll('[data-installation-panel]:not([hidden])').forEach((panel) => this.loadVisibleVideo(panel)); }
    onDocumentClick(event) { if (!this.contains(event.target)) this.closePicker(); }
    closePicker() { if (!this.options) return; this.options.hidden = true; this.pickerButton?.setAttribute('aria-expanded', 'false'); }
    onClick(event) {
      const picker = event.target.closest('[data-installation-picker-button]');
      if (picker) { const open = picker.getAttribute('aria-expanded') === 'true'; this.options.hidden = open; picker.setAttribute('aria-expanded', String(!open)); return; }
      const select = event.target.closest('[data-installation-select]');
      if (select) { this.selectInstallation(select.dataset.installationSelect); return; }
      const next = event.target.closest('[data-video-next]'); const previous = event.target.closest('[data-video-previous]');
      if (next || previous) { const carousel = event.target.closest('[data-video-carousel]'); this.changeVideo(carousel, next ? 1 : -1); }
    }
    selectInstallation(id) {
      const panel = this.querySelector(`[data-installation-panel="${CSS.escape(id)}"]`);
      if (!panel) return;
      this.querySelectorAll('[data-installation-panel]').forEach((item) => { item.hidden = item !== panel; });
      this.querySelectorAll('[data-installation-select]').forEach((item) => item.setAttribute('aria-selected', String(item.dataset.installationSelect === id)));
      this.label.textContent = this.querySelector(`[data-installation-select="${CSS.escape(id)}"]`)?.textContent.trim() || '';
      this.closePicker(); this.mediaActivated = true; this.loadVisibleVideo(panel); this.updateAllPagination();
    }
    changeVideo(carousel, amount) {
      if (!carousel) return;
      this.mediaActivated = true; this.videoObserver?.disconnect();
      const slides = [...carousel.querySelectorAll('[data-video-slide]')]; const current = slides.findIndex((slide) => !slide.hidden);
      const next = (current + amount + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== next; });
      this.loadVisibleVideo(carousel); this.updatePagination(carousel);
    }
    loadVisibleVideo(scope) { if (!this.mediaActivated) return; const iframe = scope.querySelector('[data-video-slide]:not([hidden]) iframe[data-src]'); if (!iframe || iframe.src) return; iframe.src = iframe.dataset.src; }
    updateAllPagination() { this.querySelectorAll('[data-video-carousel]').forEach((carousel) => this.updatePagination(carousel)); }
    updatePagination(carousel) { const pagination = carousel.querySelector('[data-video-pagination]'); if (!pagination) return; const slides = [...carousel.querySelectorAll('[data-video-slide]')]; const current = Math.max(0, slides.findIndex((slide) => !slide.hidden)) + 1; pagination.textContent = `${current} / ${slides.length}`; }
    onFilter(event) {
      const query = event.detail?.query || '';
      this.querySelectorAll('[data-installation-panel]').forEach((panel) => { panel.dataset.matchesSearch = String(!query || panel.dataset.supportSearchText.includes(query)); });
      const active = [...this.querySelectorAll('[data-installation-panel]')].find((panel) => !panel.hidden && panel.dataset.matchesSearch !== 'false') || [...this.querySelectorAll('[data-installation-panel]')].find((panel) => panel.dataset.matchesSearch !== 'false');
      if (active) this.selectInstallation(active.dataset.installationPanel);
    }
  }
  if (!customElements.get('mt-user-support-installations')) customElements.define('mt-user-support-installations', MtUserSupportInstallations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-accordion-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('mt-why-modular-accordion-gallery')) {
    class MtAccordionGallery extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
          this.indicators = Array.from(this.querySelectorAll('[data-accordion-indicator]'));
          this.track = this.querySelector('.mt-why-modular-accordion-gallery__items');
          this.activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
          this.activeIndex = this.activeIndex < 0 ? 0 : this.activeIndex;
          this.abortController = new AbortController();
          this.scrollFrame = null;

          this.items.forEach((item, index) => {
            item.addEventListener('pointerenter', () => this.setActive(index), { signal: this.abortController.signal });
            item.addEventListener('focus', () => this.setActive(index), { signal: this.abortController.signal });
            item.addEventListener('click', () => this.setActive(index, { scroll: true }), { signal: this.abortController.signal });
            item.addEventListener('keydown', (event) => this.onItemKeydown(event, index), { signal: this.abortController.signal });
          });

          this.indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => this.setActive(index, { scroll: true }), { signal: this.abortController.signal });
          });

          if (this.track) {
            this.track.addEventListener('scroll', () => this.onTrackScroll(), { passive: true, signal: this.abortController.signal });
          }

          this.setActive(this.activeIndex);
        }

        disconnectedCallback() {
          this.abortController?.abort();
          if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
        }

        onItemKeydown(event, index) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          let nextIndex = index;

          if (event.key === 'ArrowLeft') nextIndex = Math.max(index - 1, 0);
          if (event.key === 'ArrowRight') nextIndex = Math.min(index + 1, this.items.length - 1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.items.length - 1;

          this.setActive(nextIndex, { scroll: true });
          this.items[nextIndex]?.focus();
        }

        onTrackScroll() {
          if (this.scrollFrame || !this.track || this.items.length < 2) return;

          this.scrollFrame = window.requestAnimationFrame(() => {
            const currentIndex = this.items.reduce((closestIndex, item, index) => {
              const currentDistance = Math.abs(item.offsetLeft - this.track.scrollLeft);
              const closestDistance = Math.abs(this.items[closestIndex].offsetLeft - this.track.scrollLeft);
              return currentDistance < closestDistance ? index : closestIndex;
            }, 0);

            this.setActive(currentIndex);
            this.scrollFrame = null;
          });
        }

        setActive(index, options = {}) {
          if (!this.items[index]) return;

          this.activeIndex = index;
          this.items.forEach((item, itemIndex) => {
            const isActive = itemIndex === index;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', String(isActive));
          });
          this.indicators.forEach((indicator, indicatorIndex) => {
            const isActive = indicatorIndex === index;
            indicator.classList.toggle('is-active', isActive);
            indicator.setAttribute('aria-current', String(isActive));
          });

          if (options.scroll && this.track) {
            this.track.scrollTo({
              left: this.items[index].offsetLeft,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
      }

    window.customElements.define('mt-why-modular-accordion-gallery', MtAccordionGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-closing-slideshow"]) return;
  try {
    
    (() => {
      if (customElements.get('mt-why-modular-closing-slideshow')) return;
      class MtWhyModularClosingSlideshow extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.slides = Array.from(this.querySelectorAll('[data-why-modular-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-why-modular-slide-to]'));
          this.current = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
          this.querySelector('[data-why-modular-prev]')?.addEventListener('click', () => this.show(this.current - 1), { signal: this.abortController.signal });
          this.querySelector('[data-why-modular-next]')?.addEventListener('click', () => this.show(this.current + 1), { signal: this.abortController.signal });
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal: this.abortController.signal }));
          this.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') this.show(this.current - 1); if (event.key === 'ArrowRight') this.show(this.current + 1); }, { signal: this.abortController.signal });
          if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.startAutoplay();
        }
        disconnectedCallback() { this.abortController?.abort(); clearInterval(this.autoplayTimer); }
        show(index) {
          if (!this.slides.length) return;
          this.current = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => { const active = slideIndex === this.current; slide.hidden = !active; slide.classList.toggle('is-active', active); });
          this.dots.forEach((dot, dotIndex) => { const active = dotIndex === this.current; dot.classList.toggle('is-active', active); if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        }
        startAutoplay() { const delay = Number(this.dataset.cycleSpeed) || 6000; this.autoplayTimer = setInterval(() => this.show(this.current + 1), delay); }
      }
      customElements.define('mt-why-modular-closing-slideshow', MtWhyModularClosingSlideshow);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-directional-navigation"] && !Shopify.designMode) return;
  try {
    
  class MtWhyModularDirectionalNavigation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.nav = this.querySelector('.mt-why-modular-directional-nav');
      this.inner = this.querySelector('[data-navigation-items]');
      this.items = Array.from(this.querySelectorAll('[data-navigation-item]'));
      this.previousButton = this.querySelector('[data-scroll-previous]');
      this.nextButton = this.querySelector('[data-scroll-next]');
      this.navSection = this.closest('.shopify-section') || this.parentElement;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileBreakpoint = window.matchMedia('(max-width: 767px)');
      this.frame = null;
      this.activeIndex = -1;
      this.stickyHeight = null;
      this.collapseTimer = null;

      this.handleClick = this.onClick.bind(this);
      this.handlePageScroll = this.schedulePageUpdate.bind(this);
      this.handleInnerScroll = this.scheduleArrowUpdate.bind(this);
      this.handleBreakpoint = this.onBreakpointChange.bind(this);
      this.handleStructureChange = this.onStructureChange.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      window.addEventListener('scroll', this.handlePageScroll, { passive: true });
      this.inner?.addEventListener('scroll', this.handleInnerScroll, { passive: true });
      this.mobileBreakpoint.addEventListener('change', this.handleBreakpoint);
      document.addEventListener('shopify:section:load', this.handleStructureChange);
      document.addEventListener('shopify:section:unload', this.handleStructureChange);
      document.addEventListener('shopify:section:reorder', this.handleStructureChange);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateArrows();
          this.schedulePageUpdate();
        });
        if (this.inner) this.resizeObserver.observe(this.inner);
        if (this.nav) this.resizeObserver.observe(this.nav);
      }

      this.refreshTargets();
      this.syncStickyPosition();
      this.createStickySentinel();
      this.buildStickyObserver();
      this.updateArrows();
      this.updateActiveItem();
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('scroll', this.handlePageScroll);
      this.inner?.removeEventListener('scroll', this.handleInnerScroll);
      this.mobileBreakpoint?.removeEventListener('change', this.handleBreakpoint);
      document.removeEventListener('shopify:section:load', this.handleStructureChange);
      document.removeEventListener('shopify:section:unload', this.handleStructureChange);
      document.removeEventListener('shopify:section:reorder', this.handleStructureChange);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.resizeObserver?.disconnect();
      this.stickyObserver?.disconnect();
      this.sentinel?.remove();
      if (this.collapseTimer) window.clearTimeout(this.collapseTimer);
      if (this.frame) window.cancelAnimationFrame(this.frame);
      if (this.arrowFrame) window.cancelAnimationFrame(this.arrowFrame);
      this.sentinel = null;
      this.collapseTimer = null;
      this.frame = null;
      this.arrowFrame = null;
      this.initialized = false;
    }

    refreshTargets() {
      const sections = Array.from(document.querySelectorAll('.shopify-section'));
      this.targets = this.items.map((item) => {
        const index = Number.parseInt(item.dataset.sectionIndex, 10);
        const anchor = item.dataset.targetAnchor;
        const anchoredTarget = anchor ? Array.from(document.querySelectorAll('[data-why-modular-directional-nav-anchor]')).find((node) => node.dataset.whyModularDirectionalNavAnchor === anchor) : null;
        const target = anchoredTarget || (Number.isInteger(index) && index >= 1 ? sections[index - 1] || null : null);
        if (target?.id) {
          item.href = `#${target.id}`;
          item.setAttribute('aria-controls', target.id);
        } else {
          item.href = '#MainContent';
          item.removeAttribute('aria-controls');
        }
        return target;
      });
    }

    createStickySentinel() {
      if (!this.navSection || this.sentinel) return;
      this.sentinel = document.createElement('div');
      this.sentinel.className = 'mt-why-modular-directional-nav__sentinel';
      this.sentinel.setAttribute('aria-hidden', 'true');
      this.navSection.insertAdjacentElement('beforebegin', this.sentinel);
    }

    buildStickyObserver() {
      this.stickyObserver?.disconnect();
      if (!this.sentinel || !('IntersectionObserver' in window)) return;
      const stickyTriggerTop = this.getStickyTriggerTop();
      this.stickyObserver = new IntersectionObserver(([entry]) => {
        const shouldStick = !entry.isIntersecting && entry.boundingClientRect.top <= stickyTriggerTop;
        if (this.nav?.classList.contains('is-stuck') === shouldStick) return;
        this.setStickyState(shouldStick);
        this.schedulePageUpdate();
      }, {
        rootMargin: `-${stickyTriggerTop}px 0px 0px 0px`,
        threshold: 0
      });
      this.stickyObserver.observe(this.sentinel);
    }

    onBreakpointChange() {
      this.syncStickyPosition();
      this.buildStickyObserver();
      this.updateArrows();
      this.schedulePageUpdate();
    }

    onStructureChange() {
      window.requestAnimationFrame(() => {
        this.items = Array.from(this.querySelectorAll('[data-navigation-item]'));
        this.refreshTargets();
        this.updateArrows();
        this.updateActiveItem();
      });
    }

    onBlockSelect(event) {
      const item = event.target.closest('[data-navigation-item]');
      if (!item || !this.contains(item)) return;
      const index = this.items.indexOf(item);
      if (index >= 0) this.centerItem(item);
    }

    onClick(event) {
      const previous = event.target.closest('[data-scroll-previous]');
      if (previous) {
        this.scrollNavigationBy(-200);
        return;
      }

      const next = event.target.closest('[data-scroll-next]');
      if (next) {
        this.scrollNavigationBy(200);
        return;
      }

      const item = event.target.closest('[data-navigation-item]');
      if (!item || !this.contains(item)) return;
      const index = this.items.indexOf(item);
      const target = this.targets[index];
      if (!target) return;
      event.preventDefault();
      this.scrollToTarget(target);
    }

    getStickyTriggerTop() {
      if (!this.navSection) return 0;
      return Number.parseFloat(window.getComputedStyle(this.navSection).top) || 0;
    }

    getHeaderOffset() {
      const headerCandidates = Array.from(document.querySelectorAll('[data-header], mt-transparent-navbar'));
      let offset = 0;

      headerCandidates.forEach((header) => {
        if (this.contains(header) || this.navSection?.contains(header)) return;
        const styles = window.getComputedStyle(header);
        if (styles.position !== 'fixed' && styles.position !== 'sticky') return;
        const rect = header.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0 || rect.top > 4) return;
        offset = Math.max(offset, rect.bottom);
      });

      return Math.max(0, Math.round(offset));
    }

    syncStickyPosition() {
      if (!this.navSection) return false;
      const nextStickyHeight = Math.ceil(this.getNavigationHeight());
      if (nextStickyHeight <= 0 || nextStickyHeight === this.stickyHeight) return false;
      this.stickyHeight = nextStickyHeight;
      this.navSection.style.setProperty('--mt-why-modular-directional-nav-sticky-height', `${nextStickyHeight}px`);
      return true;
    }

    setStickyState(shouldStick) {
      if (!this.nav) return;
      if (this.collapseTimer) window.clearTimeout(this.collapseTimer);
      this.collapseTimer = null;

      if (shouldStick) {
        this.nav.classList.add('is-stuck');
        this.syncStickyPosition();
        if (this.reducedMotion.matches) {
          this.nav.classList.add('is-collapsed');
          this.syncStickyPosition();
          return;
        }
        this.collapseTimer = window.setTimeout(() => {
          this.nav?.classList.add('is-collapsed');
          this.collapseTimer = null;
          if (this.syncStickyPosition()) this.buildStickyObserver();
          this.schedulePageUpdate();
        }, 350);
        return;
      }

      this.nav.classList.remove('is-collapsed');
      if (this.reducedMotion.matches) {
        this.nav.classList.remove('is-stuck');
        if (this.syncStickyPosition()) this.buildStickyObserver();
        return;
      }
      window.requestAnimationFrame(() => {
        this.nav?.classList.remove('is-stuck');
        if (this.syncStickyPosition()) this.buildStickyObserver();
      });
    }

    getNavigationHeight() {
      return this.nav?.getBoundingClientRect().height || 0;
    }

    getScrollBehavior() {
      return this.reducedMotion.matches ? 'auto' : 'smooth';
    }

    scrollToTarget(target) {
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const destination = targetTop - this.getHeaderOffset();
      window.scrollTo({ top: destination, behavior: this.getScrollBehavior() });
    }

    scrollNavigationBy(left) {
      this.inner?.scrollBy({ left, behavior: this.getScrollBehavior() });
    }

    scheduleArrowUpdate() {
      if (this.arrowFrame) return;
      this.arrowFrame = window.requestAnimationFrame(() => {
        this.arrowFrame = null;
        this.updateArrows();
      });
    }

    updateArrows() {
      if (!this.inner || !this.previousButton || !this.nextButton) return;
      const scrollLeft = this.inner.scrollLeft;
      const scrollWidth = this.inner.scrollWidth;
      const clientWidth = this.inner.clientWidth;
      const canScroll = scrollWidth > clientWidth + 2;
      this.previousButton.hidden = !canScroll || scrollLeft <= 2;
      this.nextButton.hidden = !canScroll || scrollLeft + clientWidth >= scrollWidth - 2;
    }

    schedulePageUpdate() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        if (this.syncStickyPosition()) this.buildStickyObserver();
        this.updateActiveItem();
      });
    }

    updateActiveItem() {
      if (!this.targets?.length) return;
      const threshold = this.getHeaderOffset() + 10;
      let nextActiveIndex = -1;

      for (let index = this.targets.length - 1; index >= 0; index -= 1) {
        const target = this.targets[index];
        if (target && target.getBoundingClientRect().top <= threshold) {
          nextActiveIndex = index;
          break;
        }
      }

      if (nextActiveIndex === this.activeIndex) return;
      this.activeIndex = nextActiveIndex;
      this.items.forEach((item, index) => {
        const active = index === nextActiveIndex;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });

      if (nextActiveIndex >= 0) this.centerItem(this.items[nextActiveIndex]);
    }

    centerItem(item) {
      if (!this.inner || !item) return;
      const innerRect = this.inner.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const left = this.inner.scrollLeft
        + itemRect.left
        - innerRect.left
        - (innerRect.width / 2 - itemRect.width / 2);
      this.inner.scrollTo({ left, behavior: this.getScrollBehavior() });
    }
  }

  if (!customElements.get('mt-why-modular-directional-navigation')) {
    customElements.define('mt-why-modular-directional-navigation', MtWhyModularDirectionalNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-hero"] && !Shopify.designMode) return;
  try {
    
class MtWhyModularHeroVideo extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      if (this.isConnected) this._connect();
    });
  }

  _connect() {
    this._observer?.disconnect();
    this._mediaQuery?.removeEventListener('change', this._onMediaChange);
    this._slideshow?.removeEventListener('mt-why-modular-hero:change', this._onSlideChange);
    this._mountedFor = null;
    this._isIntersecting = false;
    this._mount = this.querySelector('[data-video-mount]');
    this._desktopTemplate = this.querySelector('[data-video-template="desktop"]');
    this._mobileTemplate = this.querySelector('[data-video-template="mobile"]');
    this._slideshow = this.closest('mt-why-modular-hero');
    this._mediaQuery = window.matchMedia('(min-width: 700px)');
    this._onMediaChange = () => this._sync();
    this._onSlideChange = () => this._sync();
    this._mediaQuery.addEventListener('change', this._onMediaChange);
    this._slideshow?.addEventListener('mt-why-modular-hero:change', this._onSlideChange);
    this._observer = new IntersectionObserver((entries) => {
      this._isIntersecting = entries.some((entry) => entry.isIntersecting);
      this._sync();
    }, { rootMargin: '150px 0px' });
    this._observer.observe(this);
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    this._mediaQuery?.removeEventListener('change', this._onMediaChange);
    this._slideshow?.removeEventListener('mt-why-modular-hero:change', this._onSlideChange);
  }

  _sync() {
    const slide = this.closest('[data-slide]');
    if (!this._isIntersecting || !slide?.classList.contains('is-active')) {
      this.querySelector('video')?.pause();
      return;
    }

    const kind = this._mediaQuery.matches ? 'desktop' : 'mobile';
    const template = kind === 'desktop' ? this._desktopTemplate : this._mobileTemplate;
    if (!template?.content || this._mountedFor === kind) {
      this.querySelector('video')?.play().catch(() => {});
      return;
    }

    this._mount.replaceChildren(template.content.cloneNode(true));
    this._mountedFor = kind;
    this.querySelector('video')?.play().catch(() => {});
  }
}

class MtWhyModularHero extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      if (this.isConnected) this._connect();
    });
  }

  _connect() {
    this._abortController?.abort();
    this._abortController = new AbortController();
    this._slides = Array.from(this.querySelectorAll('[data-slide]'));
    this._controls = Array.from(this.querySelectorAll('[data-slide-to]'));
    this._liveStatus = this.querySelector('[data-live-status]');
    this._activeIndex = Math.max(0, this._slides.findIndex((slide) => slide.classList.contains('is-active')));
    this._pointerStartX = null;

    this.querySelector('[data-previous]')?.addEventListener('click', () => this._setActive(this._activeIndex - 1), { signal: this._abortController.signal });
    this.querySelector('[data-next]')?.addEventListener('click', () => this._setActive(this._activeIndex + 1), { signal: this._abortController.signal });
    this._controls.forEach((control) => control.addEventListener('click', () => this._setActive(Number(control.dataset.slideTo)), { signal: this._abortController.signal }));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this._setActive(this._activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this._setActive(this._activeIndex + 1);
      }
    }, { signal: this._abortController.signal });
    this.addEventListener('pointerdown', (event) => {
      this._pointerStartX = event.clientX;
    }, { signal: this._abortController.signal });
    this.addEventListener('pointerup', (event) => {
      if (this._pointerStartX === null) return;
      const difference = event.clientX - this._pointerStartX;
      this._pointerStartX = null;
      if (Math.abs(difference) < 44) return;
      this._setActive(difference < 0 ? this._activeIndex + 1 : this._activeIndex - 1);
    }, { signal: this._abortController.signal });
    this.addEventListener('pointercancel', () => {
      this._pointerStartX = null;
    }, { signal: this._abortController.signal });

    const section = this.closest('.shopify-section');
    section?.addEventListener('shopify:block:select', (event) => {
      const index = this._slides.indexOf(event.target);
      if (index >= 0) this._setActive(index, false);
    }, { signal: this._abortController.signal });

    if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && this._slides.length > 1) {
      const interval = Math.max(4000, Number(this.dataset.interval) || 6000);
      this._autoplay = window.setInterval(() => this._setActive(this._activeIndex + 1), interval);
      this.addEventListener('pointerenter', () => this._pauseAutoplay(), { signal: this._abortController.signal });
      this.addEventListener('focusin', () => this._pauseAutoplay(), { signal: this._abortController.signal });
      this.addEventListener('pointerleave', () => this._startAutoplay(interval), { signal: this._abortController.signal });
      this.addEventListener('focusout', () => this._startAutoplay(interval), { signal: this._abortController.signal });
      document.addEventListener('visibilitychange', () => document.hidden ? this._pauseAutoplay() : this._startAutoplay(interval), { signal: this._abortController.signal });
    }

    this._setActive(this._activeIndex, false);
  }

  disconnectedCallback() {
    this._abortController?.abort();
    this._pauseAutoplay();
  }

  _pauseAutoplay() {
    if (this._autoplay) {
      window.clearInterval(this._autoplay);
      this._autoplay = null;
    }
  }

  _startAutoplay(interval) {
    if (this.dataset.autoplay !== 'true' || this._autoplay || document.hidden) return;
    this._autoplay = window.setInterval(() => this._setActive(this._activeIndex + 1), interval);
  }

  _setActive(requestedIndex, announce = true) {
    if (this._slides.length === 0) return;
    const total = this._slides.length;
    const nextIndex = (requestedIndex + total) % total;
    const nextSlide = this._slides[nextIndex];
    this._activeIndex = nextIndex;

    // Every native Shopify image/video contributes its own intrinsic ratio.
    // External embeds without a Shopify media object fall back to the stable
    // 16:9 ratio set in Liquid, because their URL settings expose no dimensions.
    this.style.setProperty('--mt-why-modular-hero-desktop-ratio', nextSlide.dataset.desktopMediaRatio);
    this.style.setProperty('--mt-why-modular-hero-mobile-ratio', nextSlide.dataset.mobileMediaRatio);

    this._slides.forEach((slide, index) => {
      const isActive = index === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.toggleAttribute('hidden', !isActive);
      slide.toggleAttribute('inert', !isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });
    this._controls.forEach((control, index) => control.setAttribute('aria-current', String(index === nextIndex)));
    if (announce && this._liveStatus) this._liveStatus.textContent = `Slide ${nextIndex + 1} of ${total}`;
    this.dispatchEvent(new CustomEvent('mt-why-modular-hero:change', { bubbles: true, detail: { index: nextIndex, slide: this._slides[nextIndex] } }));
  }
}

if (!window.customElements.get('mt-why-modular-hero-video')) {
  window.customElements.define('mt-why-modular-hero-video', MtWhyModularHeroVideo);
}

if (!window.customElements.get('mt-why-modular-hero')) {
  window.customElements.define('mt-why-modular-hero', MtWhyModularHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-why-modular-hotspots')) {
    class MtWhyModularHotspots extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.panel = this.querySelector('[data-hotspot-panel]');
        this.scrim = this.querySelector('[data-hotspot-scrim]');
        this.dots = Array.from(this.querySelectorAll('[data-hotspot-open]'));
        this.details = Array.from(this.querySelectorAll('[data-hotspot-detail]'));
        this.pagers = Array.from(this.querySelectorAll('[data-hotspot-pager]'));
        this.index = 0;
        this.count = this.details.length;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this._lastFocus = null;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = Number.parseInt(dot.getAttribute('data-index'), 10) || 0;
            if (this.classList.contains('is-open') && this.index === index) this.close();
            else this.open(index);
          });
        });

        const closeButton = this.querySelector('[data-hotspot-close]');
        if (closeButton) closeButton.addEventListener('click', () => this.close());
        if (this.scrim) this.scrim.addEventListener('click', () => this.close());

        this.querySelectorAll('[data-hotspot-prev]').forEach((button) => {
          button.addEventListener('click', () => this.open(this.index - 1));
        });
        this.querySelectorAll('[data-hotspot-next]').forEach((button) => {
          button.addEventListener('click', () => this.open(this.index + 1));
        });

        this._onKey = (event) => {
          if (!this.classList.contains('is-open')) return;
          if (event.key === 'Escape') this.close();
          if (event.key === 'ArrowLeft') this.open(this.index - 1);
          if (event.key === 'ArrowRight') this.open(this.index + 1);
        };
        document.addEventListener('keydown', this._onKey);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this._onKey);
        document.body.style.overflow = '';
      }

      pad(number) {
        return number < 10 ? `0${number}` : String(number);
      }

      open(index) {
        if (!this.count) return;
        this.index = ((index % this.count) + this.count) % this.count;
        this._lastFocus = document.activeElement;

        this.details.forEach((detail, detailIndex) => {
          if (detailIndex === this.index) detail.removeAttribute('hidden');
          else detail.setAttribute('hidden', '');
        });
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
        if (this.pagers.length) {
          const current = this.pad(this.index + 1);
          const total = ` / ${this.pad(this.count)}`;
          this.querySelectorAll('[data-hotspot-pager-current]').forEach((element) => { element.textContent = current; });
          this.querySelectorAll('[data-hotspot-pager-total]').forEach((element) => { element.textContent = total; });
        }

        if (this.panel) {
          this.panel.removeAttribute('hidden');
          this.panel.setAttribute('aria-hidden', 'false');
        }
        if (this.scrim) this.scrim.removeAttribute('hidden');
        this.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        this.querySelector('[data-hotspot-close]')?.focus();
      }

      close() {
        this.classList.remove('is-open');
        this.dots.forEach((dot) => {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-expanded', 'false');
        });
        if (this.panel) {
          this.panel.setAttribute('aria-hidden', 'true');
          const delay = this.reduceMotion ? 0 : 320;
          window.setTimeout(() => {
            if (!this.classList.contains('is-open') && this.panel) this.panel.setAttribute('hidden', '');
          }, delay);
        }
        if (this.scrim) {
          window.setTimeout(() => {
            if (!this.classList.contains('is-open') && this.scrim) this.scrim.setAttribute('hidden', '');
          }, this.reduceMotion ? 0 : 300);
        }
        document.body.style.overflow = '';
        if (this._lastFocus?.focus) this._lastFocus.focus();
      }
    }

    customElements.define('mt-why-modular-hotspots', MtWhyModularHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-recline-scroll-expand"] && !Shopify.designMode) return;
  try {
    
    if (!window.customElements.get('mt-why-modular-recline-scroll-expand')) {
      class MtWhyModularReclineScrollExpand extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.stages = Array.from(this.querySelectorAll('[data-recline-stage]'));
          this.pills = Array.from(this.querySelectorAll('[data-recline-pill]'));
          this.currentTagline = this.querySelector('[data-recline-current-tagline]');
          this.header = this.querySelector('[data-recline-header]');
          this.headingElement = this.querySelector('[data-recline-title]');
          this.mediaWrap = this.querySelector('[data-recline-media-wrap]');
          this.media = this.querySelector('[data-recline-media]');
          this.overlay = this.querySelector('[data-recline-overlay]');
          this.controls = this.querySelector('[data-recline-controls]');
          this.desktopQuery = window.matchMedia('(min-width: 700px)');
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.activeIndex = Math.max(this.stages.findIndex((stage) => stage.classList.contains('is-active')), 0);
          this.clickLockIndex = -1;
          this.frame = null;
          this.lockTimer = null;

          this.pills.forEach((pill, index) => {
            pill.addEventListener('click', () => this.activateFromControl(index), { signal: this.abortController.signal });
            pill.addEventListener('keydown', (event) => this.onPillKeydown(event, index), { signal: this.abortController.signal });
          });

          window.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal: this.abortController.signal });
          window.addEventListener('resize', () => this.scheduleLayout(), { passive: true, signal: this.abortController.signal });
          window.visualViewport?.addEventListener('resize', () => this.scheduleLayout(), { passive: true, signal: this.abortController.signal });
          this.desktopQuery.addEventListener('change', () => this.scheduleLayout(), { signal: this.abortController.signal });
          this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal: this.abortController.signal });

          this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
          if (this.header) this.resizeObserver.observe(this.header);

          this.updateLayout();
          this.switchStage(this.activeIndex);
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
          if (this.frame) window.cancelAnimationFrame(this.frame);
          if (this.lockTimer) window.clearTimeout(this.lockTimer);
        }

        scheduleLayout() {
          if (this.frame) return;
          this.frame = window.requestAnimationFrame(() => {
            this.updateLayout();
            this.frame = null;
          });
        }

        scheduleUpdate() {
          if (this.frame || !this.desktopQuery.matches) return;
          this.frame = window.requestAnimationFrame(() => {
            this.updateDesktopState();
            this.frame = null;
          });
        }

        updateLayout() {
          if (!this.mediaWrap || !this.media) return;

          if (!this.desktopQuery.matches) {
            this.style.height = '';
            this.resetInlineStyles();
            this.setControlsVisible(true);
            return;
          }

          const viewportHeight = window.innerHeight;
          const totalHeight = viewportHeight + (1.5 * viewportHeight) + (0.8 * viewportHeight * this.stages.length);
          this.style.height = `${totalHeight}px`;
          this.updateDesktopState();
        }

        updateDesktopState() {
          if (!this.desktopQuery.matches || !this.mediaWrap || !this.media) return;

          const viewportHeight = window.innerHeight;
          const navHeight = Number(this.dataset.desktopNavHeight || 75);
          const scrolled = -this.getBoundingClientRect().top;
          const expandRange = 1.5 * viewportHeight;
          const slideRange = 0.8 * viewportHeight;
          const rawExpand = Math.max(0, Math.min(1, scrolled / expandRange));
          const expandProgress = this.reducedMotionQuery.matches ? (rawExpand >= 1 ? 1 : 0) : rawExpand;
          const headerHeight = this.header?.offsetHeight || 0;

          if (this.headingElement) {
            const titleOpacity = Math.max(0, 1 - (expandProgress * 2.5));
            this.headingElement.style.opacity = String(titleOpacity);
            this.headingElement.style.pointerEvents = titleOpacity < 0.05 ? 'none' : '';
          }

          const horizontalPadding = this.lerp(8, 0, expandProgress);
          this.mediaWrap.style.paddingLeft = `${horizontalPadding}%`;
          this.mediaWrap.style.paddingRight = `${horizontalPadding}%`;
          this.mediaWrap.style.top = `${this.lerp(navHeight + headerHeight, navHeight, expandProgress)}px`;
          this.mediaWrap.style.height = `${this.lerp(620, viewportHeight - navHeight, expandProgress)}px`;
          this.media.style.borderRadius = `${this.lerp(20, 0, expandProgress)}px`;

          if (this.header) {
            this.header.style.backgroundColor = expandProgress >= 0.98 ? 'transparent' : '#ffffff';
            this.header.style.opacity = String(Math.max(0, 1 - (expandProgress * 3)));
          }

          if (this.clickLockIndex < 0) {
            const scrollIntoStages = scrolled - expandRange;
            const stageIndex = scrollIntoStages > 0
              ? Math.min(this.stages.length - 1, Math.floor(scrollIntoStages / slideRange))
              : 0;
            this.switchStage(stageIndex);
          }

          const controlsProgress = Math.max(0, Math.min(1, (expandProgress - 0.85) / 0.15));
          if (this.overlay) this.overlay.style.opacity = String(controlsProgress);
          this.setControlsVisible(controlsProgress > 0.05);
        }

        resetInlineStyles() {
          if (this.headingElement) {
            this.headingElement.style.opacity = '';
            this.headingElement.style.pointerEvents = '';
          }
          if (this.header) {
            this.header.style.backgroundColor = '';
            this.header.style.opacity = '';
          }
          if (this.mediaWrap) {
            this.mediaWrap.style.paddingLeft = '';
            this.mediaWrap.style.paddingRight = '';
            this.mediaWrap.style.top = '';
            this.mediaWrap.style.height = '';
          }
          if (this.media) this.media.style.borderRadius = '';
          if (this.overlay) this.overlay.style.opacity = '';
        }

        activateFromControl(index) {
          this.switchStage(index);
          this.lockToIndex(index);

          if (!this.desktopQuery.matches) return;

          const viewportHeight = window.innerHeight;
          const expandRange = 1.5 * viewportHeight;
          const slideRange = 0.8 * viewportHeight;
          const sectionTop = this.getBoundingClientRect().top + window.scrollY;
          const targetScroll = sectionTop + expandRange + (index * slideRange) + (slideRange * 0.5);
          window.scrollTo({
            top: targetScroll,
            behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth'
          });
        }

        lockToIndex(index) {
          this.clickLockIndex = index;
          if (this.lockTimer) window.clearTimeout(this.lockTimer);
          this.lockTimer = window.setTimeout(() => {
            this.clickLockIndex = -1;
            this.lockTimer = null;
          }, 800);
        }

        switchStage(index) {
          if (!this.stages[index]) return;
          this.activeIndex = index;

          this.stages.forEach((stage, stageIndex) => {
            const isActive = stageIndex === index;
            stage.classList.toggle('is-active', isActive);
            stage.setAttribute('aria-hidden', String(!isActive));
          });

          this.pills.forEach((pill, pillIndex) => {
            const isActive = pillIndex === index;
            pill.classList.toggle('is-active', isActive);
            pill.setAttribute('aria-pressed', String(isActive));
            pill.tabIndex = isActive && this.controls?.classList.contains('is-visible') ? 0 : -1;
          });

          if (this.currentTagline) {
            this.currentTagline.textContent = this.pills[index]?.dataset.reclineTaglineText || '';
          }
        }

        setControlsVisible(isVisible) {
          if (!this.controls) return;
          this.controls.classList.toggle('is-visible', isVisible);
          this.controls.toggleAttribute('inert', !isVisible);
          this.controls.setAttribute('aria-hidden', String(!isVisible));

          this.pills.forEach((pill, index) => {
            pill.tabIndex = isVisible && index === this.activeIndex ? 0 : -1;
          });
        }

        onPillKeydown(event, index) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = Math.max(index - 1, 0);
          if (event.key === 'ArrowRight') nextIndex = Math.min(index + 1, this.pills.length - 1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.pills.length - 1;

          this.activateFromControl(nextIndex);
          this.pills[nextIndex]?.focus();
        }

        onBlockSelect(event) {
          const selectedStage = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (!selectedStage) return;
          this.switchStage(Number(selectedStage.dataset.reclineStage));
        }

        lerp(start, end, progress) {
          const clamped = Math.max(0, Math.min(1, progress));
          return start + ((end - start) * clamped);
        }
      }

      window.customElements.define('mt-why-modular-recline-scroll-expand', MtWhyModularReclineScrollExpand);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-why-modular-story-panels"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('mt-why-modular-story-panel')) {
    class MtWhyModularStoryPanel extends HTMLElement {
      connectedCallback() {
        if (this.initialized || this.initializationFrame) return;

        this.initializationFrame = window.requestAnimationFrame(() => {
          this.initializationFrame = null;
          if (!this.isConnected || this.initialized) return;

          this.initialize();
        });
      }

      initialize() {
        if (this.initialized) return;

        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-mt-why-modular-story-slide]'));
        this.controls = Array.from(this.querySelectorAll('[data-mt-why-modular-story-select]'));
        this.videos = Array.from(this.querySelectorAll('.mt-why-modular-story-panels__video'));
        this.index = 0;
        this.isVisible = false;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion = this.motionQuery.matches;
        this.handleClick = this.handleClick.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleVideoReady = this.handleVideoReady.bind(this);

        this.addEventListener('click', this.handleClick);
        this.motionQuery.addEventListener('change', this.handleMotionChange);
        this.videos.forEach((video) => {
          video.addEventListener('loadedmetadata', this.handleVideoReady);
          video.addEventListener('canplay', this.handleVideoReady);
        });

        if (!('IntersectionObserver' in window)) {
          this.isVisible = true;
          this.syncVideos();
          return;
        }

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.isVisible = entry.isIntersecting;
          this.syncVideos();
        }, { rootMargin: '0px' });
        this.visibilityObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.initializationFrame) {
          window.cancelAnimationFrame(this.initializationFrame);
          this.initializationFrame = null;
        }
        this.visibilityObserver?.disconnect();
        this.removeEventListener('click', this.handleClick);
        this.motionQuery?.removeEventListener('change', this.handleMotionChange);
        this.videos?.forEach((video) => {
          video.removeEventListener('loadedmetadata', this.handleVideoReady);
          video.removeEventListener('canplay', this.handleVideoReady);
        });
        this.pauseAllVideos();
        this.visibilityObserver = null;
        this.videos = [];
        this.slides = [];
        this.controls = [];
        this.initialized = false;
      }

      handleClick(event) {
        const control = event.target.closest('[data-mt-why-modular-story-select]');
        if (!control || !this.contains(control)) return;

        this.show(Number(control.dataset.mtWhyModularStorySelect));
      }

      handleMotionChange(event) {
        this.reducedMotion = event.matches;
        this.syncVideos();
      }

      handleVideoReady() {
        this.syncVideos();
      }

      show(index) {
        if (!Number.isInteger(index) || index < 0 || index >= this.slides.length || index === this.index) return;

        this.index = index;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.controls.forEach((control, controlIndex) => {
          if (controlIndex === index) {
            control.setAttribute('aria-current', 'true');
          } else {
            control.removeAttribute('aria-current');
          }
        });
        this.syncVideos();
      }

      pauseAllVideos() {
        const videos = this.videos || this.querySelectorAll('.mt-why-modular-story-panels__video');
        videos.forEach((video) => video.pause());
      }

      syncVideos() {
        this.slides.forEach((slide, slideIndex) => {
          const video = slide.querySelector('.mt-why-modular-story-panels__video');
          if (!video) return;

          if (this.isVisible && !this.reducedMotion && slideIndex === this.index) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    }

    window.customElements.define('mt-why-modular-story-panel', MtWhyModularStoryPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-guarantee-scrolling-text"] && !Shopify.designMode) return;
  try {
    
  class PriceGuaranteeScrollingText extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('price-guarantee-scrolling-text--scroll')) return;
      this.updateProgress = this.updateProgress.bind(this);
      this.updateProgress();
      window.addEventListener('scroll', this.updateProgress, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateProgress);
    }

    updateProgress() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        const bounds = this.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (window.innerHeight - bounds.top) / (window.innerHeight + bounds.height)));
        this.style.setProperty('--price-guarantee-scroll-progress', progress);
        this.frame = null;
      });
    }
  }

  if (!customElements.get('price-guarantee-scrolling-text')) {
    customElements.define('price-guarantee-scrolling-text', PriceGuaranteeScrollingText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-guarantee-text-with-image"] && !Shopify.designMode) return;
  try {
    
  class PriceGuaranteeTextWithImage extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.price-guarantee-text-with-image__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.slide))));
      if (this.dataset.auto === 'true' && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = window.setInterval(() => this.show(this.index + 1), 6000);
      }
    }

    disconnectedCallback() { window.clearInterval(this.timer); }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== this.index; });
      this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === this.index)));
    }
  }

  if (!customElements.get('price-guarantee-text-with-image')) {
    customElements.define('price-guarantee-text-with-image', PriceGuaranteeTextWithImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-intro-content"] && !Shopify.designMode) return;
  try {
    
  class ProductIntroContent extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      if (!('IntersectionObserver' in window)) {
        this.mountMedia();
        return;
      }
      this.observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.mountMedia();
        this.observer.disconnect();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() { this.observer?.disconnect(); this.observer = undefined; this.initialized = false; }

    mountMedia() {
      this.querySelectorAll('[data-product-intro-content-media]').forEach((media) => {
        const template = media.querySelector('template');
        if (template) media.replaceChildren(template.content.cloneNode(true));
      });
    }
  }
  if (!customElements.get('product-intro-content')) customElements.define('product-intro-content', ProductIntroContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-intro-feature"] && !Shopify.designMode) return;
  try {
    
  class ProductIntroFeature extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.product-intro-feature__slide')];
      this.controls = [...this.querySelectorAll('[data-feature-slide]')];
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.deferredMedia = [...this.querySelectorAll('[data-product-intro-deferred-media]')];
      if (!('IntersectionObserver' in window)) {
        this.deferredMedia.forEach((media) => this.loadDeferredMedia(media));
        this.start();
        return;
      }
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) this.start();
        else this.stop();
      }, { rootMargin: '200px 0px' });
      this.visibilityObserver.observe(this);

      this.mediaObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.loadDeferredMedia(entry.target);
        });
        // Keep animated feature media near-view, but outside the initial page-load window.
      }, { rootMargin: '200px 0px' });
      this.deferredMedia.forEach((media) => this.mediaObserver.observe(media));
    }

    disconnectedCallback() {
      this.stop();
      this.visibilityObserver?.disconnect();
      this.mediaObserver?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.visibilityObserver = undefined;
      this.mediaObserver = undefined;
      this.initialized = false;
    }

    onClick(event) {
      const control = event.target.closest('[data-feature-slide]');
      if (!control || !this.contains(control)) return;
      this.show(Number(control.dataset.featureSlide));
    }

    loadDeferredMedia(media) {
      const template = media.querySelector('template');
      if (!template) return;
      media.replaceChildren(template.content.cloneNode(true));
      media.removeAttribute('data-product-intro-deferred-media');
      this.mediaObserver?.unobserve(media);
    }

    start() {
      if (this.timer || this.reducedMotion || this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), 6000);
    }

    stop() { window.clearInterval(this.timer); this.timer = undefined; }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      this.controls.forEach((control, controlIndex) => control.setAttribute('aria-current', String(controlIndex === index)));
    }
  }
  if (!customElements.get('product-intro-feature')) customElements.define('product-intro-feature', ProductIntroFeature);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-intro-hero"] && !Shopify.designMode) return;
  try {
    
  class ProductIntroHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-product-intro-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isVisible = false;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      if (this.dataset.allowTransparentHeader === 'true') document.dispatchEvent(new CustomEvent('header:transparent-mode'));
      if (!('IntersectionObserver' in window)) {
        this.isVisible = true;
        this.hydrateActiveMedia();
        this.startAutoplay();
        return;
      }
      this.observer = new IntersectionObserver(([entry]) => {
        this.isVisible = entry.isIntersecting;
        if (this.isVisible) {
          this.hydrateActiveMedia();
          this.startAutoplay();
        } else {
          this.stopAutoplay();
        }
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.observer = undefined;
      this.initialized = false;
    }

    onClick(event) {
      const dot = event.target.closest('[data-slide]');
      if (!dot || !this.contains(dot)) return;
      this.show(Number(dot.dataset.slide));
    }

    startAutoplay() {
      if (this.timer || this.reducedMotion || this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.cycleSpeed || 6) * 1000);
    }

    stopAutoplay() {
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    hydrateActiveMedia() {
      const slide = this.slides[this.index];
      if (!slide) return;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      slide.querySelectorAll('[data-product-intro-video], [data-src]').forEach((media) => {
        const isMobileMedia = media.classList.contains('product-intro-hero__video--mobile') || media.classList.contains('product-intro-hero__external--mobile');
        const isDesktopMedia = media.classList.contains('product-intro-hero__video--desktop') || media.classList.contains('product-intro-hero__external--desktop');
        if ((mobile && isDesktopMedia) || (!mobile && isMobileMedia)) return;
        if (media.tagName === 'IFRAME' && media.dataset.src && !media.src) media.src = media.dataset.src;
        if (media.tagName === 'VIDEO') {
          let changed = false;
          media.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; source.removeAttribute('data-src'); changed = true; });
          if (changed) media.load();
          if (this.dataset.autoplay === 'true' && !this.reducedMotion) media.play().catch(() => {});
        }
      });
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (this.isVisible) this.hydrateActiveMedia();
    }
  }
  if (!customElements.get('product-intro-hero')) customElements.define('product-intro-hero', ProductIntroHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-intro-standards"] && !Shopify.designMode) return;
  try {
    
  class ProductIntroStandards extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.product-intro-standards__track');
      this.buttons = [...this.querySelectorAll('[data-standard-index]')];
      this.mobileMedia = window.matchMedia('(max-width: 999px)');
      this.scrollFrame = 0;

      if (!this.track || this.buttons.length === 0) return;

      this.onScroll = this.onScroll.bind(this);
      this.updateActive = this.updateActive.bind(this);
      this.onClick = this.onClick.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('click', this.onClick);
      this.onScroll();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onClick);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.initialized = false;
    }

    onClick(event) {
      const button = event.target.closest('[data-standard-index]');
      if (!button || !this.contains(button)) return;
      this.goTo(Number(button.dataset.standardIndex));
    }

    goTo(index) {
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(index);
    }

    onScroll() {
      if (!this.mobileMedia.matches || this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(this.updateActive);
    }

    updateActive() {
      this.scrollFrame = 0;
      if (!this.mobileMedia.matches) return;
      const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      this.setActive(index);
    }

    setActive(index) {
      this.buttons.forEach((button, buttonIndex) => button.setAttribute('aria-current', String(buttonIndex === index)));
    }
  }

  if (!customElements.get('product-intro-standards')) customElements.define('product-intro-standards', ProductIntroStandards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-exchange-faq"] && !Shopify.designMode) return;
  try {
    
  class ReturnExchangeFaq extends HTMLElement {
    connectedCallback() { if (this.initialized) return; this.initialized = true; this.onClick = this.onClick.bind(this); this.addEventListener('click', this.onClick); }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); this.initialized = false; }
    onClick(event) { const button = event.target.closest('button[aria-controls]'); if (!button || !this.contains(button)) return; const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`); const expanded = button.getAttribute('aria-expanded') === 'true'; button.setAttribute('aria-expanded', String(!expanded)); if (panel) panel.hidden = expanded; }
  }
  if (!customElements.get('return-exchange-faq')) customElements.define('return-exchange-faq', ReturnExchangeFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-exchange-help"] && !Shopify.designMode) return;
  try {
    
  class ReturnExchangeHelp extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.setAttribute('data-enhanced', '');
      this.items = [...this.querySelectorAll('.return-exchange-help__item')];
      this.controls = [...this.querySelectorAll('[data-help-control]')];
      this.activeIndex = 0;
      this.pointerStartX = null;
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.querySelector('.return-exchange-help__items')?.addEventListener('pointerdown', this.handlePointerDown);
      this.querySelector('.return-exchange-help__items')?.addEventListener('pointerup', this.handlePointerUp);
    }
    disconnectedCallback() {
      this.querySelector('.return-exchange-help__items')?.removeEventListener('pointerdown', this.handlePointerDown);
      this.querySelector('.return-exchange-help__items')?.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('click', this.onClick);
      this.removeAttribute('data-enhanced');
      this.initialized = false;
    }
    onClick(event) {
      const control = event.target.closest('[data-help-control]');
      if (control && this.contains(control)) { this.select(Number(control.dataset.helpControl)); return; }
      const liveChat = event.target.closest('[data-open-live-chat]');
      if (liveChat && this.contains(liveChat) && window.tidioChatApi?.open) window.tidioChatApi.open();
    }
    handlePointerDown(event) { this.pointerStartX = event.clientX; }
    handlePointerUp(event) {
      if (this.pointerStartX === null) return;
      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;
      if (Math.abs(distance) < 40 || this.items.length < 2) return;
      const nextIndex = distance < 0 ? this.activeIndex + 1 : this.activeIndex - 1;
      this.select((nextIndex + this.items.length) % this.items.length);
    }
    select(index) { this.activeIndex = index; this.items.forEach((item, current) => { const active = current === index; item.classList.toggle('is-active', active); item.toggleAttribute('data-help-inactive', !active); }); this.controls.forEach((item, current) => { const active = current === index; item.classList.toggle('is-active', active); item.setAttribute('aria-current', String(active)); }); }
  }
  if (!customElements.get('return-exchange-help')) customElements.define('return-exchange-help', ReturnExchangeHelp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-exchange-steps"] && !Shopify.designMode) return;
  try {
    
  class ReturnExchangeSteps extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controls = [...this.querySelectorAll('[data-step-control]')];
      this.cards = [...this.querySelectorAll('[data-step-card]')];
      this.markers = [...this.querySelectorAll('[data-step-marker]')];
      this.onControlClick = this.onControlClick.bind(this);
      this.onCardEnter = this.onCardEnter.bind(this);
      this.controls.forEach((control) => control.addEventListener('click', this.onControlClick));
      this.cards.forEach((card) => card.addEventListener('mouseenter', this.onCardEnter));
    }
    disconnectedCallback() { this.controls?.forEach((control) => control.removeEventListener('click', this.onControlClick)); this.cards?.forEach((card) => card.removeEventListener('mouseenter', this.onCardEnter)); this.initialized = false; }
    onControlClick(event) { this.select(Number(event.currentTarget.dataset.stepControl)); }
    onCardEnter(event) { this.select(Number(event.currentTarget.dataset.stepCard)); }
    select(index) { this.controls.forEach((item, current) => { const active = current === index; item.classList.toggle('is-active', active); item.setAttribute('aria-current', String(active)); }); this.cards.forEach((item, current) => { const active = current === index; item.classList.toggle('is-active', active); item.toggleAttribute('data-mobile-inactive', !active); }); this.markers.forEach((item, current) => item.classList.toggle('is-active', current === index)); }
  }
  if (!customElements.get('return-exchange-steps')) customElements.define('return-exchange-steps', ReturnExchangeSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-video-list"] && !Shopify.designMode) return;
  try {
    
  class ReviewsVideoList extends HTMLElement {
    connectedCallback() {
      this.selectors = Array.from(this.querySelectorAll('[data-reviews-video-list-selector]'));
      this.panels = Array.from(this.querySelectorAll('[data-reviews-video-list-panel]'));
      this.previousButton = this.querySelector('[data-reviews-video-list-previous]');
      this.nextButton = this.querySelector('[data-reviews-video-list-next]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handleSelector = this.handleSelector.bind(this);
      this.handlePrevious = this.handlePrevious.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.selectors.forEach((button) => button.addEventListener('click', this.handleSelector));
      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.addEventListener('click', this.handlePlay);
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.hydrateAutoplay(entry.target);
        });
      }, { rootMargin: '200px 0px' });
      this.querySelectorAll('[data-reviews-video-autoplay]').forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      this.selectors?.forEach((button) => button.removeEventListener('click', this.handleSelector));
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.removeEventListener('click', this.handlePlay);
      this.observer?.disconnect();
    }

    handleSelector(event) {
      const index = event.currentTarget.dataset.reviewsVideoListSelector;
      this.selectors.forEach((button) => {
        const selected = button.dataset.reviewsVideoListSelector === index;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-selected', String(selected));
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.reviewsVideoListPanel !== index; });
      this.style.setProperty('--reviews-video-list-background', event.currentTarget.dataset.background);
      const activePanel = this.querySelector(`[data-reviews-video-list-panel="${index}"]`);
      activePanel?.querySelectorAll('[data-reviews-video-autoplay]').forEach((video) => this.hydrateAutoplay(video));
    }

    handlePrevious() { this.scrollActiveTrack(-1); }
    handleNext() { this.scrollActiveTrack(1); }

    scrollActiveTrack(direction) {
      const track = this.querySelector('[data-reviews-video-list-panel]:not([hidden]) [data-reviews-video-list-track]');
      if (!track) return;
      const amount = Math.max(track.clientWidth * 0.8, 240) * direction;
      track.scrollBy({ left: amount, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    handlePlay(event) {
      const button = event.target.closest('[data-reviews-video-play], [data-reviews-external-play]');
      if (!button) return;
      const card = button.closest('.reviews-video-list__card');
      const video = card?.querySelector('[data-reviews-video]');
      if (video) {
        this.hydrateVideo(video, true);
        return;
      }
      const host = button.dataset.videoHost;
      const id = button.dataset.videoId;
      if (!card || !host || !id || card.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = button.getAttribute('aria-label');
      iframe.src = host === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1&playsinline=1`
        : `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
      card.querySelector('.reviews-video-list__media')?.append(iframe);
      card.classList.add('is-playing');
    }

    hydrateAutoplay(video) { this.hydrateVideo(video, false); }

    hydrateVideo(video, shouldPlay) {
      if (video.dataset.loaded !== 'true') {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.dataset.loaded = 'true';
        video.load();
      }
      if (shouldPlay || video.hasAttribute('data-reviews-video-autoplay')) {
        video.play().catch(() => {});
      }
      video.closest('.reviews-video-list__card')?.classList.add('is-playing');
    }
  }

  if (!customElements.get('reviews-video-list')) {
    customElements.define('reviews-video-list', ReviewsVideoList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection-category-slider"] && !Shopify.designMode) return;
  try {
    
  class RsCollectionCategorySlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('[data-category-track]');
      this.previous = this.querySelector('[data-category-previous]');
      this.next = this.querySelector('[data-category-next]');
      if (!this.track) return;

      this.handlePrevious = () => this.track.scrollBy({ left: -this.step(), behavior: this.behavior() });
      this.handleNext = () => this.track.scrollBy({ left: this.step(), behavior: this.behavior() });
      this.handleScroll = () => this.updateControls();
      this.previous?.addEventListener('click', this.handlePrevious);
      this.next?.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.initialized = true;
      this.updateControls();
    }

    disconnectedCallback() {
      this.previous?.removeEventListener('click', this.handlePrevious);
      this.next?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.initialized = false;
    }
    behavior() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    step() { return this.track.querySelector('.rs-collection-category-slider__card')?.getBoundingClientRect().width + 8 || this.track.clientWidth; }
    updateControls() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      if (this.previous) this.previous.hidden = !scrollable || this.track.scrollLeft <= 2;
      if (this.next) this.next.hidden = !scrollable || this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
  }
  if (!customElements.get('rs-collection-category-slider')) customElements.define('rs-collection-category-slider', RsCollectionCategorySlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection-featured-product"] && !Shopify.designMode) return;
  try {
    
  class RsCollectionFeaturedProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-rs-variant-id]');
      this.addButton = this.querySelector('[data-rs-add]');
      this.status = this.querySelector('[data-rs-status]');
      this.mediaViewport = this.querySelector('[data-rs-media-viewport]');
      this.variants = JSON.parse(this.querySelector('[data-rs-variants]')?.textContent || '[]');
      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onMediaScroll = this.onMediaScroll.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.form?.addEventListener('submit', this.onSubmit);
      this.mediaViewport?.addEventListener('scroll', this.onMediaScroll, { passive: true });
      this.updateOptionAvailability();
    }

    disconnectedCallback() { this.removeEventListener('change', this.onChange); this.removeEventListener('click', this.onClick); this.form?.removeEventListener('submit', this.onSubmit); this.mediaViewport?.removeEventListener('scroll', this.onMediaScroll); window.cancelAnimationFrame(this.scrollFrame); this.initialized = false; }
    onChange(event) { if (event.target.matches('[data-rs-option], [data-rs-option-select]')) this.syncVariant(); }

    selectedOptions() {
      return Array.from(this.querySelectorAll('.rs-collection-featured-product__variant-group')).map((field) => {
        const control = field.querySelector('[data-rs-option]:checked, [data-rs-option-select]');
        return control?.value || '';
      });
    }
    syncVariant() {
      const selected = this.selectedOptions();
      this.querySelectorAll('[data-rs-selected-option]').forEach((node, index) => { node.textContent = selected[index] || ''; });
      const variant = this.variants.find((item) => JSON.stringify(item.options) === JSON.stringify(selected));
      if (!variant || !this.variantInput || !this.addButton) { this.setUnavailable(); return; }
      this.variantInput.value = variant.id;
      const variantUrl = new URL(this.dataset.productUrl || window.location.pathname, window.location.origin);
      variantUrl.searchParams.set('variant', variant.id);
      this.querySelectorAll('[data-rs-product-link]').forEach((link) => { link.href = `${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`; });
      this.addButton.disabled = !variant.available;
      const label = this.querySelector('[data-rs-add-label]');
      if (label) label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      const price = this.querySelector('[data-rs-price]');
      if (price && variant.price_html) price.innerHTML = variant.price_html;
      const saving = this.querySelector('[data-rs-saving]');
      if (saving) { saving.textContent = variant.saving_html || ''; saving.hidden = !variant.saving_html; }
      this.updatePickup(variant.id);
      this.updateOptionAvailability();
      if (variant.featured_media_id) this.showMedia(String(variant.featured_media_id));
    }

    setUnavailable() { if (this.variantInput) this.variantInput.value = ''; if (this.addButton) this.addButton.disabled = true; const label = this.querySelector('[data-rs-add-label]'); if (label) label.textContent = this.dataset.unavailableLabel; this.updateOptionAvailability(); }
    onClick(event) {
      const target = event.target.closest('[data-rs-media-target]');
      if (target) { this.showMedia(target.dataset.rsMediaTarget); return; }
      const quantity = event.target.closest('[data-rs-quantity]');
      if (quantity) { this.changeQuantity(quantity.dataset.rsQuantity); return; }
      if (event.target.closest('[data-rs-zoom]')) { this.openDialog(); return; }
      if (event.target.closest('[data-rs-dialog-close]')) { const dialog = this.querySelector('[data-rs-dialog]'); dialog?.classList.remove('is-zoomed'); dialog?.close(); return; }
      if (event.target.closest('[data-rs-dialog-content]')) { this.querySelector('[data-rs-dialog]')?.classList.toggle('is-zoomed'); return; }
      if (event.target.closest('[data-rs-size-chart-open]')) { this.querySelector('[data-rs-size-chart]')?.showModal(); return; }
      if (event.target.closest('[data-rs-size-chart-close]')) this.querySelector('[data-rs-size-chart]')?.close();
    }
    showMedia(id) {
      const mobileCarousel = window.matchMedia('(max-width: 999px)').matches;
      const activeSlide = [...this.querySelectorAll('[data-rs-media-id]')].find((node) => node.dataset.rsMediaId === id);
      this.syncActiveMedia(id);
      if (activeSlide && mobileCarousel) this.mediaViewport?.scrollTo({ left: activeSlide.offsetLeft, behavior: 'auto' });
    }
    syncActiveMedia(id) {
      this.querySelectorAll('[data-rs-media-id]').forEach((node) => { const active = node.dataset.rsMediaId === id; node.classList.toggle('is-active', active); node.toggleAttribute('data-rs-media-inactive', !active); });
      this.querySelectorAll('[data-rs-media-target]').forEach((node) => { const active = node.dataset.rsMediaTarget === id; node.classList.toggle('is-active', active); node.setAttribute('aria-pressed', String(active)); });
    }
    onMediaScroll() {
      if (!window.matchMedia('(max-width: 999px)').matches || this.scrollFrame) return;
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = 0;
        const slides = [...this.querySelectorAll('[data-rs-media-id]')];
        if (!slides.length || !this.mediaViewport?.clientWidth) return;
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(this.mediaViewport.scrollLeft / this.mediaViewport.clientWidth)));
        const activeId = slides[index]?.dataset.rsMediaId;
        this.syncActiveMedia(activeId);
      });
    }
    updateOptionAvailability() {
      const picker = this.querySelector('[data-rs-variant-picker]');
      if (!picker) return;
      const selected = this.selectedOptions();
      const hideSoldOut = picker.dataset.hideSoldOut === 'true';
      picker.querySelectorAll('[data-rs-option]').forEach((input) => {
        const index = Number(input.dataset.rsOptionIndex);
        const candidate = [...selected];
        candidate[index] = input.value;
        const available = this.variants.some((variant) => variant.available && variant.options.every((value, optionIndex) => optionIndex === index || !candidate[optionIndex] || value === candidate[optionIndex]) && variant.options[index] === input.value);
        input.disabled = !available;
        const label = input.nextElementSibling;
        if (label) label.hidden = hideSoldOut && !available && !input.checked;
      });
      picker.querySelectorAll('[data-rs-option-select]').forEach((select) => {
        const index = Number(select.dataset.rsOptionPosition) - 1;
        [...select.options].forEach((option) => {
          const candidate = [...selected];
          candidate[index] = option.value;
          const available = this.variants.some((variant) => variant.available && variant.options.every((value, optionIndex) => optionIndex === index || !candidate[optionIndex] || value === candidate[optionIndex]) && variant.options[index] === option.value);
          option.disabled = !available;
          option.hidden = hideSoldOut && !available && !option.selected;
        });
      });
    }
    updatePickup(variantId) {
      const target = this.querySelector('[data-rs-pickup-content]');
      const template = this.querySelector(`[data-rs-pickup-template="${CSS.escape(String(variantId))}"]`);
      if (target && template) target.replaceChildren(template.content.cloneNode(true));
    }
    changeQuantity(direction) { const input = this.querySelector('[name="quantity"]'); if (!input) return; const current = Number.parseInt(input.value, 10) || 1; input.value = direction === 'increase' ? current + 1 : Math.max(1, current - 1); }
    openDialog() { const dialog = this.querySelector('[data-rs-dialog]'); const activeMedia = this.querySelector('.rs-collection-featured-product__slide.is-active picture'); const content = this.querySelector('[data-rs-dialog-content]'); if (!dialog || !activeMedia || !content) return; dialog.classList.remove('is-zoomed'); content.replaceChildren(activeMedia.cloneNode(true)); dialog.showModal(); }
    async onSubmit(event) {
      if (!event.submitter?.matches('[data-rs-add]')) return;
      event.preventDefault();
      if (!this.variantInput || !this.addButton) return;
      this.addButton.disabled = true;
      try {
        const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Cart error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', origin: 'rs-featured-product' } }));
        this.setStatus(this.dataset.addedLabel, false);
      } catch (error) { this.setStatus(error.message, true); } finally { this.syncVariant(); }
    }
    setStatus(message, isError) { if (!this.status) return; this.status.textContent = message; this.status.hidden = false; this.status.classList.toggle('is-error', isError); }
  }
  if (!customElements.get('rs-collection-featured-product')) customElements.define('rs-collection-featured-product', RsCollectionFeaturedProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s800-collection-banner"] && !Shopify.designMode) return;
  try {
    
  class S800CollectionBanner extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-s800-banner-parallax') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.media = this.querySelector('[data-s800-banner-media]');
      if (!this.media) return;
      this.visible = false;
      this.frame = null;
      this.update = this.update.bind(this);
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; if (this.visible) this.update(); }, { rootMargin: '160px 0px' });
      this.observer.observe(this);
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
    }
    disconnectedCallback() { this.observer?.disconnect(); window.removeEventListener('scroll', this.update); window.removeEventListener('resize', this.update); cancelAnimationFrame(this.frame); }
    update() {
      if (!this.visible || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const bounds = this.getBoundingClientRect();
        this.style.setProperty('--s800-banner-parallax-offset', `${Math.max(-48, Math.min(48, bounds.top * -.08))}px`);
      });
    }
  }
  if (!customElements.get('s800-collection-banner')) customElements.define('s800-collection-banner', S800CollectionBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s800-collection-hotspots"] && !Shopify.designMode) return;
  try {
    
  class S800CollectionHotspots extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.triggers = Array.from(this.querySelectorAll('[data-s800-hotspot-trigger]'));
      this.closeTimers = new Map();
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onDocumentPointerDown);
    }
    disconnectedCallback() {
      this.closeAll(false, true);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      this.closeTimers?.forEach((timer) => clearTimeout(timer));
      this.closeTimers?.clear();
      this.initialized = false;
    }
    onClick(event) {
      const trigger = event.target.closest('[data-s800-hotspot-trigger]');
      if (trigger && this.contains(trigger)) this.toggle(trigger);
    }
    onKeydown(event) {
      if (event.key === 'Escape') this.closeAll(true);
    }
    onDocumentPointerDown(event) {
      if (!this.contains(event.target)) this.closeAll(false);
    }
    getPopover(trigger) { return document.getElementById(trigger.getAttribute('aria-controls')); }
    toggle(trigger) {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      this.closeAll(false);
      if (!expanded) this.open(trigger);
    }
    open(trigger) {
      const popover = this.getPopover(trigger);
      if (!popover) return;
      const closeTimer = this.closeTimers.get(popover);
      if (closeTimer) clearTimeout(closeTimer);
      this.closeTimers.delete(popover);
      trigger.setAttribute('aria-expanded', 'true');
      popover.hidden = false;
      popover.setAttribute('aria-hidden', 'false');
      this.positionPopover(trigger, popover);
      requestAnimationFrame(() => { if (trigger.getAttribute('aria-expanded') === 'true') popover.classList.add('is-open'); });
    }
    positionPopover(trigger, popover) {
      const rootRect = this.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      const width = popover.offsetWidth;
      const height = popover.offsetHeight;
      const relativeTop = triggerRect.top - rootRect.top;
      const relativeLeft = triggerRect.left - rootRect.left;
      popover.style.top = `${relativeTop > height ? -height : triggerRect.height}px`;
      popover.style.left = `${relativeLeft > width ? -width : triggerRect.width}px`;
    }
    closeAll(restoreFocus = false, immediate = false) {
      let focusTarget;
      this.triggers?.forEach((trigger) => {
        if (trigger.getAttribute('aria-expanded') !== 'true') return;
        focusTarget = trigger;
        trigger.setAttribute('aria-expanded', 'false');
        const popover = this.getPopover(trigger);
        if (!popover) return;
        popover.classList.remove('is-open');
        popover.setAttribute('aria-hidden', 'true');
        const pendingTimer = this.closeTimers.get(popover);
        if (pendingTimer) clearTimeout(pendingTimer);
        const finish = () => { popover.hidden = true; this.closeTimers.delete(popover); };
        if (immediate) finish(); else this.closeTimers.set(popover, setTimeout(finish, 300));
      });
      if (restoreFocus && focusTarget?.isConnected) focusTarget.focus();
    }
  }
  if (!customElements.get('s800-collection-hotspots')) customElements.define('s800-collection-hotspots', S800CollectionHotspots);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s800-collection-story-panels"] && !Shopify.designMode) return;
  try {
    
  class S800StoryPanel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-s800-story-slide]'));
      this.controls = Array.from(this.querySelectorAll('[data-s800-story-select]'));
      this.media = this.querySelector('[data-s800-story-media]');
      this.index = 0;
      this.visible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onClick = this.onClick.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.addEventListener('click', this.onClick);
      if (this.slides.length > 1 && this.media) {
        this.media.addEventListener('pointerdown', this.onPointerDown);
        this.media.addEventListener('pointerup', this.onPointerUp);
      }
      if (!('IntersectionObserver' in window)) { this.visible = true; this.syncVideos(); return; }
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.syncVideos(); }, { rootMargin: '160px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.removeEventListener('click', this.onClick); this.media?.removeEventListener('pointerdown', this.onPointerDown); this.media?.removeEventListener('pointerup', this.onPointerUp); this.observer = undefined; this.media = undefined; this.initialized = false; }
    onClick(event) { const control = event.target.closest('[data-s800-story-select]'); if (control && this.contains(control)) this.show(Number(control.dataset.s800StorySelect)); }
    onPointerDown(event) { this.pointerStartX = event.clientX; }
    onPointerUp(event) { const delta = event.clientX - this.pointerStartX; if (Math.abs(delta) < 40) return; const next = delta < 0 ? this.index + 1 : this.index - 1; this.show((next + this.slides.length) % this.slides.length); }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => { const active = slideIndex === index; slide.hidden = !active; slide.classList.toggle('is-active', active); });
      this.controls.forEach((control, controlIndex) => control.setAttribute('aria-current', String(controlIndex === index)));
      this.syncVideos();
    }
    syncVideos() {
      this.slides.forEach((slide, slideIndex) => {
        const video = slide.querySelector('.s800-story-panel__video');
        if (!video) return;
        if (this.visible && slideIndex === this.index && !this.reducedMotion) video.play().catch(() => {}); else video.pause();
      });
    }
  }
  if (!customElements.get('s800-story-panel')) customElements.define('s800-story-panel', S800StoryPanel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
  class ScrollingText extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scrolling-track]');
      this.mode = this.dataset.mode;
      this.frame = null;
      this.isObservingViewport = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleScroll = this.scheduleUpdate.bind(this);
      this.handleMotionChange = this.syncMotionPreference.bind(this);

      if (!this.track || this.mode !== 'scroll') return;

      this.reduceMotion.addEventListener('change', this.handleMotionChange);
      this.syncMotionPreference();
    }

    disconnectedCallback() {
      this.stopViewportUpdates();
      if (this.observer) this.observer.disconnect();
      if (this.reduceMotion && this.handleMotionChange) {
        this.reduceMotion.removeEventListener('change', this.handleMotionChange);
      }
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    syncMotionPreference() {
      if (this.reduceMotion.matches) {
        this.stopViewportUpdates();
        if (this.observer) this.observer.disconnect();
        this.track.style.transform = '';
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.startViewportUpdates();
        return;
      }

      if (this.observer) this.observer.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startViewportUpdates();
          } else {
            this.stopViewportUpdates();
          }
        });
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }

    startViewportUpdates() {
      if (this.isObservingViewport) return;
      this.isObservingViewport = true;
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);
      this.scheduleUpdate();
    }

    stopViewportUpdates() {
      if (!this.isObservingViewport) return;
      this.isObservingViewport = false;
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }

    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateProgress();
      });
    }

    updateProgress() {
      if (!this.isObservingViewport || !this.track) return;

      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const travel = viewportHeight + rect.height;
      const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / travel));
      const translate = progress * -20;

      this.track.style.transform = `translate3d(${translate}%, 0, 0)`;
    }
  }

  if (!customElements.get('scrolling-text')) {
    customElements.define('scrolling-text', ScrollingText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-hero-pro"] && !Shopify.designMode) return;
  try {
    
  class SlideshowHeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.interval = Number.parseInt(this.dataset.interval, 10) || 5000;
      this.autoplayTimer = null;
      this.startX = 0;
      this.isDragging = false;
      this.isVisible = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.slideshow__dot'));
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobileMedia = matchMedia('(max-width: 767px)');
      this.onClick = this.onClick.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onMouseEnter = () => this.stopAutoplay();
      this.onMouseLeave = () => this.startAutoplay();
      this.onMediaChange = () => this.hydrateActiveMedia();
      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd, { passive: true });
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.mobileMedia.addEventListener?.('change', this.onMediaChange);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.isVisible = entry.isIntersecting;
          if (this.isVisible) {
            this.hydrateActiveMedia();
            this.startAutoplay();
          } else {
            this.stopAutoplay();
            this.pauseVideos();
          }
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);
      } else {
        this.isVisible = true;
        this.hydrateActiveMedia();
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.pauseVideos();
      this.observer?.disconnect();
      this.mobileMedia?.removeEventListener?.('change', this.onMediaChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchend', this.onTouchEnd);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.observer = undefined;
      this.initialized = false;
    }

    onClick(event) {
      if (event.target.closest('.slideshow__arrow--prev')) return this.prev();
      if (event.target.closest('.slideshow__arrow--next')) return this.next();
      const dot = event.target.closest('.slideshow__dot');
      if (dot && this.contains(dot)) this.goTo(Number(dot.dataset.index));
    }

    onTouchStart(event) {
      this.startX = event.touches[0].clientX;
      this.isDragging = true;
    }

    onTouchEnd(event) {
      if (!this.isDragging) return;
      const diff = this.startX - event.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
      this.isDragging = false;
    }

    goTo(index) {
      if (!this.slides.length || index === this.currentIndex) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      this.pauseVideos();
      if (this.isVisible) this.hydrateActiveMedia();
      this.startAutoplay();
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goTo(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goTo(prevIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.autoplay && this.isVisible) this.autoplayTimer = setInterval(() => this.next(), this.interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    isCurrentBreakpoint(container) {
      if (container.classList.contains('slideshow__video--desktop')) return !this.mobileMedia.matches;
      if (container.classList.contains('slideshow__video--mobile')) return this.mobileMedia.matches;
      return true;
    }

    hydrateActiveMedia() {
      const slide = this.slides[this.currentIndex];
      if (!slide) return;
      slide.querySelectorAll('.slideshow__video').forEach((container) => {
        if (!this.isCurrentBreakpoint(container)) return;
        const video = container.querySelector('[data-slideshow-video]');
        if (video) {
          let changed = false;
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
            changed = true;
          });
          if (changed) video.load();
          video.play().catch(() => {});
        }
        const embed = container.querySelector('[data-slideshow-embed][data-src]');
        if (embed) {
          embed.src = embed.dataset.src;
          embed.removeAttribute('data-src');
        }
      });
    }

    pauseVideos() {
      this.querySelectorAll('[data-slideshow-video]').forEach((video) => video.pause());
    }
  }

  if (!customElements.get('slideshow-hero-carousel')) {
    customElements.define('slideshow-hero-carousel', SlideshowHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class LazySlideVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.poster = this.querySelector('[data-video-poster]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.active = false;
      this.loadedMode = null;
      this.handleViewportChange = () => {
        if (this.active) this.loadForViewport(true);
      };
      this.mobileQuery.addEventListener('change', this.handleViewportChange);
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
      this.pause();
      this.initialized = false;
    }

    setActive(active) {
      this.active = active;
      if (active) {
        this.loadForViewport();
      } else {
        this.pause();
      }
    }

    loadForViewport(force = false) {
      const requestedMode = this.mobileQuery.matches && this.querySelector('template[data-video-template="mobile"]')
        ? 'mobile'
        : 'desktop';

      if (!force && this.loadedMode === requestedMode && this.player) {
        this.play();
        return;
      }

      const template = this.querySelector(`template[data-video-template="${requestedMode}"]`);
      if (!template) return;

      this.poster?.classList.remove('is-hidden');
      this.player?.remove();
      const fragment = template.content.cloneNode(true);
      this.player = document.createElement('div');
      this.player.className = 'metry-slideshow__video-player';
      this.player.append(fragment);
      this.append(this.player);
      this.loadedMode = requestedMode;

      const video = this.player.querySelector('video');
      const iframe = this.player.querySelector('iframe');
      if (video) {
        video.preload = 'none';
        video.addEventListener('playing', () => this.hidePoster(), { once: true });
        video.load();
        this.play();
      } else if (iframe) {
        iframe.addEventListener('load', () => this.hidePoster(), { once: true });
      }
    }

    play() {
      const video = this.player?.querySelector('video');
      if (video) video.play().catch(() => {});
    }

    pause() {
      const video = this.player?.querySelector('video');
      if (video) video.pause();
    }

    hidePoster() {
      this.poster?.classList.add('is-hidden');
    }
  }

  class MetrySlideshow extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
      this.status = this.querySelector('[data-status]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.interval = Number.parseInt(this.dataset.interval, 10) || 6000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseReasons = new Set(['viewport']);
      this.pointerStart = null;
      this.timer = null;

      this.handleClick = this.onClick.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handlePointerDown = this.onPointerDown.bind(this);
      this.handlePointerUp = this.onPointerUp.bind(this);
      this.handleVisibility = this.onVisibilityChange.bind(this);
      this.handleMotion = this.onMotionChange.bind(this);
      this.handleMouseEnter = () => this.pause('hover');
      this.handleMouseLeave = () => this.resume('hover');
      this.handleFocusIn = () => this.pause('focus');
      this.handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.resume('focus');
      };

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.addEventListener('pointercancel', this.handlePointerUp);
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.reduceMotion.addEventListener('change', this.handleMotion);

      if (this.dataset.transparentHeader === 'true') {
        document.dispatchEvent(new CustomEvent('header:transparent-mode'));
      }

      this.observeViewport();
      this.onMotionChange();
      this.updateSlides(false);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.observer?.disconnect();
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('pointercancel', this.handlePointerUp);
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      document.removeEventListener('visibilitychange', this.handleVisibility);
      this.reduceMotion?.removeEventListener('change', this.handleMotion);
      this.initialized = false;
    }

    observeViewport() {
      if (!('IntersectionObserver' in window)) {
        this.resume('viewport');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.resume('viewport');
          } else {
            this.pause('viewport');
          }
          this.updateMedia();
        });
      }, { rootMargin: '150px 0px' });
      this.observer.observe(this);
    }

    onClick(event) {
      if (event.target.closest('[data-previous]')) {
        this.previous(true);
        return;
      }
      if (event.target.closest('[data-next]')) {
        this.next(true);
        return;
      }
      const dot = event.target.closest('[data-go-to]');
      if (dot) this.goTo(Number.parseInt(dot.dataset.goTo, 10), true);
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.previous(true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.next(true);
      }
    }

    onPointerDown(event) {
      if (!event.isPrimary || event.target.closest('a, button')) return;
      this.pointerStart = event.clientX;
      this.pause('pointer');
    }

    onPointerUp(event) {
      if (this.pointerStart === null) return;
      const distance = event.clientX - this.pointerStart;
      this.pointerStart = null;
      if (event.type !== 'pointercancel' && Math.abs(distance) > 50) {
        if (distance < 0) this.next(true);
        else this.previous(true);
      }
      this.resume('pointer');
    }

    goTo(index, userInitiated = false) {
      if (!Number.isInteger(index) || index < 0 || index >= this.slides.length || index === this.currentIndex) return;
      this.currentIndex = index;
      this.updateSlides(userInitiated);
      if (userInitiated) this.restartAutoplay();
    }

    next(userInitiated = false) {
      if (this.slides.length < 2) return;
      this.goTo((this.currentIndex + 1) % this.slides.length, userInitiated);
    }

    previous(userInitiated = false) {
      if (this.slides.length < 2) return;
      this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length, userInitiated);
    }

    updateSlides(announce = true) {
      this.slides.forEach((slide, index) => {
        const active = index === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
      });
      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
      });
      if (announce && this.status) {
        this.status.textContent = this.slides[this.currentIndex]?.getAttribute('aria-label') || '';
      }
      this.updateMedia();
    }

    updateMedia() {
      const canPlay = !this.pauseReasons.has('viewport') && !this.reduceMotion.matches && !document.hidden;
      this.slides.forEach((slide, index) => {
        slide.querySelector('[data-slide-video]')?.setActive(canPlay && index === this.currentIndex);
      });
    }

    onVisibilityChange() {
      if (document.hidden) this.pause('document');
      else this.resume('document');
      this.updateMedia();
    }

    onMotionChange() {
      if (this.reduceMotion.matches) this.pause('motion');
      else this.resume('motion');
      this.updateMedia();
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.stopAutoplay();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.startAutoplay();
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.slides.length < 2 || this.pauseReasons.size > 0 || this.timer) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('lazy-slide-video')) {
    customElements.define('lazy-slide-video', LazySlideVideo);
  }
  if (!customElements.get('metry-slideshow')) {
    customElements.define('metry-slideshow', MetrySlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-icons-pro"] && !Shopify.designMode) return;
  try {
    
  class SocialIconsPro extends HTMLElement { connectedCallback() { this.items = [...this.querySelectorAll('[data-social-icon-item]')]; this.controls = [...this.querySelectorAll('[data-social-icon-control]')]; this.controls.forEach((button) => button.addEventListener('click', () => this.select(Number(button.dataset.socialIconControl)))); this.select(0); } select(index) { this.items.forEach((item, current) => item.classList.toggle('is-active', current === index)); this.controls.forEach((item, current) => item.classList.toggle('is-active', current === index)); } }
  if (!customElements.get('social-icons-pro')) customElements.define('social-icons-pro', SocialIconsPro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media-pro"] && !Shopify.designMode) return;
  try {
    
  class SocialMediaPro extends HTMLElement { connectedCallback() { this.items = [...this.querySelectorAll('[data-social-media-item]')]; this.controls = [...this.querySelectorAll('[data-social-media-control]')]; this.index = 0; this.controls.forEach((button) => button.addEventListener('click', () => this.select(Number(button.dataset.socialMediaControl)))); this.select(0); if (this.dataset.auto === 'true' && this.items.length > 1) this.timer = window.setInterval(() => this.select(this.index + 1), 6000); } disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); } select(index) { this.index = (index + this.items.length) % this.items.length; this.items.forEach((item, current) => item.classList.toggle('is-active', current === this.index)); this.controls.forEach((item, current) => item.classList.toggle('is-active', current === this.index)); } }
  if (!customElements.get('social-media-pro')) customElements.define('social-media-pro', SocialMediaPro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-swiper-pro"] && !Shopify.designMode) return;
  try {
    
  class SocialSwiperPro extends HTMLElement { connectedCallback() { this.items = [...this.querySelectorAll('[data-social-slide]')]; this.status = this.querySelector('[data-social-status]'); this.index = 0; this.querySelector('[data-social-prev]').addEventListener('click', () => this.select(this.index - 1)); this.querySelector('[data-social-next]').addEventListener('click', () => this.select(this.index + 1)); this.select(0); } select(index) { this.index = (index + this.items.length) % this.items.length; this.items.forEach((item, current) => item.classList.toggle('is-active', current === this.index)); if (this.status) this.status.textContent = `${this.index + 1} / ${this.items.length}`; } }
  if (!customElements.get('social-swiper-pro')) customElements.define('social-swiper-pro', SocialSwiperPro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class BgVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.load(); this.observer.disconnect(); }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    load() {
      const src = this.video.getAttribute('data-src');
      if (src && !this.video.src) {
        var host = this;
        var revealed = false;
        var reveal = function () {
          if (!revealed) { revealed = true; host.classList.add('is-playing'); }
        };
        if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
          this.video.requestVideoFrameCallback(reveal);
        } else {
          this.video.addEventListener('playing', function () { setTimeout(reveal, 500); }, { once: true });
        }
        this.video.src = src;
        this.video.play().catch(function () {});
      }
    }
  }
  if (!customElements.get('bg-video')) customElements.define('bg-video', BgVideo);

  } catch(e) { console.error(e); }
})();
})();
